/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/vector-apps/part1/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 189);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(6);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMProperty = __webpack_require__(13);
var ReactDOMComponentFlags = __webpack_require__(55);

var invariant = __webpack_require__(0);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var CallbackQueue = __webpack_require__(53);
var PooledClass = __webpack_require__(11);
var ReactFeatureFlags = __webpack_require__(58);
var ReactReconciler = __webpack_require__(14);
var Transaction = __webpack_require__(26);

var invariant = __webpack_require__(0);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(11);

var emptyFunction = __webpack_require__(6);
var warning = __webpack_require__(1);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(31);
var setInnerHTML = __webpack_require__(28);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(39);
var setTextContent = __webpack_require__(71);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(147);
var ReactInstrumentation = __webpack_require__(7);

var warning = __webpack_require__(1);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var ReactBaseClasses = __webpack_require__(73);
var ReactChildren = __webpack_require__(177);
var ReactDOMFactories = __webpack_require__(178);
var ReactElement = __webpack_require__(16);
var ReactPropTypes = __webpack_require__(179);
var ReactVersion = __webpack_require__(180);

var createReactClass = __webpack_require__(181);
var onlyChild = __webpack_require__(185);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var ReactCurrentOwner = __webpack_require__(10);

var warning = __webpack_require__(1);
var canDefineProperty = __webpack_require__(77);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(75);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(15);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var EventPluginRegistry = __webpack_require__(32);
var EventPluginUtils = __webpack_require__(33);
var ReactErrorUtils = __webpack_require__(37);

var accumulateInto = __webpack_require__(64);
var forEachAccumulated = __webpack_require__(65);
var invariant = __webpack_require__(0);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(18);
var EventPluginUtils = __webpack_require__(33);

var accumulateInto = __webpack_require__(64);
var forEachAccumulated = __webpack_require__(65);
var warning = __webpack_require__(1);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(9);

var getEventTarget = __webpack_require__(42);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var EventPluginRegistry = __webpack_require__(32);
var ReactEventEmitterMixin = __webpack_require__(139);
var ViewportMetrics = __webpack_require__(63);

var getVendorPrefixedEventName = __webpack_require__(171);
var isEventSupported = __webpack_require__(43);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(21);
var ViewportMetrics = __webpack_require__(63);

var getEventModifierState = __webpack_require__(41);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);
var DOMNamespaces = __webpack_require__(31);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(39);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(12);
var Danger = __webpack_require__(116);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInstrumentation = __webpack_require__(7);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(39);
var setInnerHTML = __webpack_require__(28);
var setTextContent = __webpack_require__(71);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactErrorUtils = __webpack_require__(37);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactPropTypesSecret = __webpack_require__(145);
var propTypesFactory = __webpack_require__(51);

var React = __webpack_require__(15);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(10);
var ReactInstanceMap = __webpack_require__(20);
var ReactInstrumentation = __webpack_require__(7);
var ReactUpdates = __webpack_require__(8);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var emptyFunction = __webpack_require__(6);
var warning = __webpack_require__(1);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(6);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(80);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(108);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(11);

var invariant = __webpack_require__(0);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(13);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInstrumentation = __webpack_require__(7);

var quoteAttributeValueForBrowser = __webpack_require__(172);
var warning = __webpack_require__(1);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var LinkedValueUtils = __webpack_require__(35);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(8);

var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(132);

var containsNode = __webpack_require__(94);
var focusNode = __webpack_require__(47);
var getActiveElement = __webpack_require__(48);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMLazyTree = __webpack_require__(12);
var DOMProperty = __webpack_require__(13);
var React = __webpack_require__(15);
var ReactBrowserEventEmitter = __webpack_require__(24);
var ReactCurrentOwner = __webpack_require__(10);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMContainerInfo = __webpack_require__(126);
var ReactDOMFeatureFlags = __webpack_require__(128);
var ReactFeatureFlags = __webpack_require__(58);
var ReactInstanceMap = __webpack_require__(20);
var ReactInstrumentation = __webpack_require__(7);
var ReactMarkupChecksum = __webpack_require__(142);
var ReactReconciler = __webpack_require__(14);
var ReactUpdateQueue = __webpack_require__(38);
var ReactUpdates = __webpack_require__(8);

var emptyObject = __webpack_require__(23);
var instantiateReactComponent = __webpack_require__(69);
var invariant = __webpack_require__(0);
var setInnerHTML = __webpack_require__(28);
var shouldUpdateReactComponent = __webpack_require__(44);
var warning = __webpack_require__(1);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var React = __webpack_require__(15);

var invariant = __webpack_require__(0);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(62);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(4);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var ReactCompositeComponent = __webpack_require__(123);
var ReactEmptyComponent = __webpack_require__(57);
var ReactHostComponent = __webpack_require__(59);

var getNextDebugID = __webpack_require__(183);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);
var escapeTextContentForBrowser = __webpack_require__(27);
var setInnerHTML = __webpack_require__(28);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(10);
var REACT_ELEMENT_TYPE = __webpack_require__(138);

var getIteratorFn = __webpack_require__(169);
var invariant = __webpack_require__(0);
var KeyEscapeUtils = __webpack_require__(34);
var warning = __webpack_require__(1);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22),
    _assign = __webpack_require__(3);

var ReactNoopUpdateQueue = __webpack_require__(76);

var canDefineProperty = __webpack_require__(77);
var emptyObject = __webpack_require__(23);
var invariant = __webpack_require__(0);
var lowPriorityWarning = __webpack_require__(184);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

var ReactCurrentOwner = __webpack_require__(10);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(1);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tachyons_css_tachyons_min_css__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tachyons_css_tachyons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tachyons_css_tachyons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_App__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(86);
__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_App__["a" /* default */],null),document.getElementById('root'));__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(106).enable();
  window.Promise = __webpack_require__(105);
}

// fetch() polyfill for making API calls.
__webpack_require__(188);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(3);


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchPage__ = __webpack_require__(83);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SearchPage__["a" /* default */],null));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_Component){_inherits(Header,_Component);function Header(){_classCallCheck(this,Header);return _possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).apply(this,arguments));}_createClass(Header,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tl  pa2 pa4-ns bg-light-green black"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"f4 fw6 f1-ns lh-title measure mt0 mb0"},"Search"));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchResultItem__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_companies__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_companies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_companies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lunr__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lunr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lunr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debounce__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debounce__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchPage=function(_Component){_inherits(SearchPage,_Component);function SearchPage(props){_classCallCheck(this,SearchPage);var _this=_possibleConstructorReturn(this,(SearchPage.__proto__||Object.getPrototypeOf(SearchPage)).call(this,props));var companiesBySymbol=__WEBPACK_IMPORTED_MODULE_2__data_companies___default.a.reduce(function(obj,item){obj[item.Symbol]=item;return obj;},{});_this.state={searchText:'',companies:__WEBPACK_IMPORTED_MODULE_2__data_companies___default.a,companiesBySymbol:companiesBySymbol,searchResults:[]};_this.handleChange=_this.handleChange.bind(_this);_this.doSearch=_this.doSearch.bind(_this);_this.doSearch=__WEBPACK_IMPORTED_MODULE_4_debounce___default()(_this.doSearch,250);_this.searchIdx=__WEBPACK_IMPORTED_MODULE_3_lunr___default()(function(){var _this2=this;this.ref("Symbol");this.field("Name");this.field("Description");__WEBPACK_IMPORTED_MODULE_2__data_companies___default.a.forEach(function(doc){_this2.add(doc);});});/*
    this.state['searchText'] = 'test';
    setTimeout( () => {
      this.doSearch('test');
    }, 100);
    */return _this;}_createClass(SearchPage,[{key:'componentDidMount',value:function componentDidMount(){this.inputSearch.focus();}},{key:'handleChange',value:function handleChange(event){var searchText=event.target.value;this.setState({searchText:searchText});this.doSearch(searchText);}},{key:'doSearch',value:function doSearch(searchText){var searchResults=this.searchIdx.search(searchText);this.setState({searchResults:searchResults});}/*
    +    "Symbol": "MMM",
    +    "Name": "3M Company",
    +    "Sector": "Industrials",
    +    "Description": "3M Company (3M) is a diversified technology company. The Company operates in six segments: industrial and transportation; hea
    */},{key:'render',value:function render(){var _this3=this;var searchText=this.state.searchText;var _state=this.state,searchResults=_state.searchResults,companiesBySymbol=_state.companiesBySymbol;var searchResultSymbols=searchResults.map(function(x){return x.ref;});//console.log({companies});
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bt b--black-10 black-70 pa2 pa4-ns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'black-80'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'measure center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:function ref(x){return _this3.inputSearch=x;},onChange:this.handleChange,value:searchText,type:'text',placeholder:'search...',className:'input-reset f3 ba b--black-20 pa2 mb2 db w-100'})))),searchText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'black-70 pa2 pa4-ns'},'Found ',searchResults.length,' results.',searchResultSymbols.map(function(symbol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SearchResultItem__["a" /* default */],{key:symbol,company:companiesBySymbol[symbol],searchWords:[searchText]});})));}}]);return SearchPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SearchPage);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_highlight_words__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_highlight_words___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_highlight_words__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchResultItem=function(_Component){_inherits(SearchResultItem,_Component);function SearchResultItem(){_classCallCheck(this,SearchResultItem);var _this=_possibleConstructorReturn(this,(SearchResultItem.__proto__||Object.getPrototypeOf(SearchResultItem)).call(this));_this.state={hover:false};return _this;}_createClass(SearchResultItem,[{key:'render',value:function render(){var _this2=this;var _props=this.props,company=_props.company,searchWords=_props.searchWords;var hover=this.state.hover;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tl ba pa2 pa3-ns ma2 ma3-ns bg-light-green black measure-wide',onMouseOver:function onMouseOver(){return _this2.setState({hover:true});},onMouseOut:function onMouseOut(){return _this2.setState({hover:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'f3 mb2'},company.Name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f5 measure-wide lh-copy'},hover&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_highlight_words___default.a,{searchWords:searchWords,textToHighlight:company.Description}),!hover&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,company.Description)));}}]);return SearchResultItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SearchResultItem);

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports=[{"Symbol":"MMM","Name":"3M Company","Sector":"Industrials","Description":"3M Company (3M) is a diversified technology company. The Company operates in six segments: industrial and transportation; healthcare; consumer and office; safety, security and protection services; display and graphics, and electro and communications businesses. 3M products are sold through a number of distribution channels, including directly to users and through wholesalers, retailers, jobbers, distributors and dealers in a range of trades in a number of countries worldwide. In April 2012, it acquired CodeRyte Inc. In September 2012, it acquired the business of Federal Signal Technologies Group (FSTech) from Federal Signal Corporation. On November 28, 2012, the Company acquired Ceradyne, Inc."},{"Symbol":"ABT","Name":"Abbott Laboratories","Sector":"Health Care","Description":"Abbott Laboratories (Abbott) is engaged in the discovery, development, manufacture, and sale of a portfolio of science-based health care products. Abbott operates in four business segments: diagnostics, medical devices, nutritionals and generic pharmaceuticals. Geographically, 30% of its revenue is generated in the United States; 30% in Western Europe, Canada, Japan and Australia, and 40% in the economies, including India, China, Russia and Brazil. In January 2013, the Company completed the separation of its research-based pharmaceuticals business, which became AbbVie, a new independent biopharmaceutical company. In August 2013, Abbott Laboratories completed its acquisition of OptiMedica Corporation. In August 2013, Abbott Laboratories completed its acquisition of IDEV Technologies."},{"Symbol":"ABBV","Name":"AbbVie","Sector":"Health Care","Description":"AbbVie Inc. (AbbVie) is a research-based pharmaceuticals company. The Company discovers, develops, and commercializes advanced therapies. AbbVie's portfolio of products include a line of adult and pediatric pharmaceuticals, which includes HUMIRA, metabolics/hormones products, virology products, endocrinology products, dyslipidemia products and other products. AbbVie products are used to treat rheumatoid arthritis, psoriasis, Crohn's disease, human immunodeficiency virus (HIV), cystic fibrosis complications, low testosterone, thyroid disease, Parkinson's disease and complications associated with chronic kidney disease, among other indications. In October 2012, AbbVie initiated a comprehensive Phase III program for hepatitis C virus (HCV) genotype one."},{"Symbol":"ACN","Name":"Accenture plc","Sector":"Information Technology","Description":"Accenture plc (Accenture), is engaged in providing management consulting, technology and outsourcing services. The Company's business is structured around five operating groups, which together consists of 19 industry groups serving clients in industries globally. The Company's segment includes Communications, Media & Technology, Financial Services, Health & Public Service, Products and Resources. In September 2013, its Accenture Federal Services completed its acquisition of ASM Research. Effective September 4, 2013, Accenture PLC acquired a 51% interest in GPIT Ltd, a provider of information technology services, from Grameenphone Ltd. In October 2013, the Company acquired PRION Group, a consulting and systems integrator that specializes in Siemens Product Lifecycle Management (PLM) Software. Effective November 1, 2013, Accenture PLC acquired an undisclosed majority interest in Vivere Brasil Servicos e Solucoes SA. Effective December 5, 2013, the Company acquired Procurian Inc."},{"Symbol":"ATVI","Name":"Activision Blizzard","Sector":"Information Technology","Description":"Activision Blizzard, Inc. publishes online, personal computer (PC), video game console, handheld, mobile, and tablet games. The company operates through three segments: Activision, Blizzard, and Distribution. The Activision segment develops and publishes interactive software products and content, as well as sells through retail channels and digital downloads. The Blizzard segment develops, hosts, and supports subscription-based massively multi-player online role-playing game; and develops, markets, and sells role-playing action and strategy games for the PC and iPad. It also maintains a proprietary online-game related service, Battle.net. The Distribution segment provides warehousing, logistical, and sales distribution services to third-party publishers of interactive entertainment software; its own publishing operations; and manufacturers of interactive entertainment hardware. The company serves retailers and distributors, including mass-market retailers, consumer electronics stores, discount warehouses, and game specialty stores through third-party distribution, licensing arrangements, and direct digital purchases. It operates primarily in the United States, Canada, the United Kingdom, France, Germany, Ireland, Italy, Sweden, Spain, the Netherlands, Australia, South Korea, and China. The company is headquartered in Santa Monica, California."},{"Symbol":"AYI","Name":"Acuity Brands Inc","Sector":"Industrials","Description":"Acuity Brands, Inc. (Acuity Brands), incorporated on September 20, 2007, is the parent company of Acuity Brands Lighting, Inc. (ABL), and other subsidiaries. Acuity Brands is a provider of lighting solutions for commercial, institutional, industrial, infrastructure, and residential applications throughout North America and select international markets. The Company's lighting solutions include devices, such as luminaires, lighting controls, power supplies, prismatic skylights, light-emitting diode (LED) lamps, and integrated lighting systems for indoor and outdoor applications utilizing a combination of light sources, including daylight, and other devices controlled by software that monitors and manages light levels while optimizing energy consumption (collectively referred to herein as lighting solutions). Effective March 14, 2013, the Company acquired eldoLED Europe BV."},{"Symbol":"ADBE","Name":"Adobe Systems Inc","Sector":"Information Technology","Description":"Adobe Systems Incorporated (Adobe) is a diversified software company. The Company offers a line of software and services used by professionals, marketers, knowledge workers, application developers, enterprises and consumers for creating, managing, delivering, measuring and engaging with content and experiences across multiple operating systems, devices and media. The Company markets and licenses its software directly to enterprise customers through its sales force and to end users through application stores and its Website at www.adobe.com. Adobe also distributes its products through a network of distributors, value-added resellers (VARs), systems integrators, independent software vendors (ISVs), retailers and original equipment manufacturers (OEMs). In May 2013, Adobe Systems Inc acquired Ideacodes LLC. In July 2013, Adobe Systems Inc announced the completion of acquisition of privately held Neolane."},{"Symbol":"AAP","Name":"Advance Auto Parts","Sector":"Consumer Discretionary","Description":"Advance Auto Parts, Inc. (Advance) is a specialty retailer of automotive aftermarket parts, accessories, batteries and maintenance items primarily operating within the United States. The Company operates in two segments: Advance Auto Parts (AAP), and Autopart International (AI). The AAP segment is comprised of its store operations, which operate under the trade names Advance Auto Parts and Advance Discount Auto Parts. The AI segment consists of the operations of Autopart International, Inc. which operates under the Autopart International trade name. The Company's stores carry a product line for cars, vans, sport utility vehicles and light trucks. The Company serves both do-it-yourself (DIY), and do-it-for-me (Commercial), customers. On December 31, 2012, the Company acquired B.W.P. Distributors, Inc."},{"Symbol":"AES","Name":"AES Corp","Sector":"Utilities","Description":"The AES Corporation (AES) owns a portfolio of electricity generation and distribution businesses on five continents in 27 countries, with total capacity of approximately 44,200 megawatts and distribution networks. It owns and operates two types of businesses. In its Generation business, it owns and/or operates power plants to generate and sell power to wholesale customers, such as utilities and other intermediaries. In its Utilities business, it owns and/or operates utilities to generate, distribute, transmit and sell electricity to end-user customers in the residential, commercial, industrial and governmental sectors within a defined service area. Its six segments include Latin America-Generation, Latin America-Utilities, North America-Generation, North America-Utilities, Europe-Generation and Asia-Generation. On November 28, 2011, it acquired DPL Inc. In September 2012, Sembcorp Industries Ltd acquired power assets in China from AES."},{"Symbol":"AET","Name":"Aetna Inc","Sector":"Health Care","Description":"Aetna Inc. (Aetna) is a diversified healthcare benefits company. The Company offers a range of traditional and consumer-directed health insurance products and related services, including medical, pharmacy, dental, behavioral health, group life and disability plans, medical management capabilities, Medicaid healthcare management services and health information exchange technology services. The Company's operations are conducted in three business segments: Health Care, Group Insurance and Large Case Pensions. Its customers include employer groups, individuals, college students, part-time and hourly workers, health plans, healthcare providers, governmental units, government-sponsored plans, labor groups and expatriates. As of December 31, 2011, the Company served approximately 36.4 million people. In May 2013, the Company announced it has completed its acquisition of Coventry Health Care Inc."},{"Symbol":"AMG","Name":"Affiliated Managers Group Inc","Sector":"Financials","Description":"Affiliated Managers Group, Inc. (AMG) is a global asset management company with equity investments in a diverse group of boutique investment management firms (Affiliates). As of December 31, 2012, the Company manages assets through its Affiliates across a broad range of asset classes and investment styles in three principal distribution channels: Institutional, Mutual Fund and High Net Worth. On June 29, 2012, it completed its investment in Veritable, LP (Veritable) through AMG Wealth Partners. Veritable manages assets for ultra-high net worth individuals and provides comprehensive, objective and tax-sensitive investment consultation through an approach customized for each client's specific needs. On June 29, 2012, it completed its investment in Yacktman Asset Management LP (Yacktman)."},{"Symbol":"AFL","Name":"AFLAC Inc","Sector":"Financials","Description":"Aflac Incorporated (Aflac) is a general business holding company and acts as a management company, overseeing the operations of its subsidiaries by providing management services. Its business is supplemental health and life insurance, through its subsidiary, American Family Life Assurance Company of Columbus, which operates in the United States and as a branch in Japan. Aflac's insurance business consists of two segments: Aflac Japan and Aflac U.S. Aflac Japan sells voluntary supplemental insurance products, including cancer plans, general medical indemnity plans, medical/sickness riders, care plans, living benefit life plans, ordinary life insurance plans and annuities. Aflac U.S. sells voluntary supplemental insurance products including loss-of-income products and products designed to protect individuals from depletion of assets (hospital indemnity, fixed-benefit dental, vision care, accident, cancer, critical illness/ critical care, and hospital intensive care plans)."},{"Symbol":"A","Name":"Agilent Technologies Inc","Sector":"Health Care","Description":"Agilent Technologies, Inc. provides bio-analytical solutions and services to the life sciences, chemical analysis, diagnostics and genomics, communications, and electronics industries worldwide. The companys Life Sciences and Diagnostics segment offers liquid chromatography systems, columns, and components; liquid chromatography mass spectrometry systems; laboratory software and informatics systems; laboratory automation and robotic systems; dissolution testing; nucleic acid solutions; nuclear magnetic resonance, magnetic resonance imaging, and X-ray diffraction systems; immunohistochemistry; in situ hybridization; hematoxylin and eosin staining; DNA mutation detection; genotyping; gene copy number determination; identification of gene rearrangements; DNA methylation and gene expression profiling; next generation sequencing target enrichment; and automated gel electrophoresis-based sample analysis systems. Its Chemical Analysis segment provides gas chromatography systems, columns, and components; gas chromatography mass spectrometry systems; inductively coupled plasma mass spectrometry instruments; atomic absorption instruments; inductively coupled plasma optical emission spectrometry instruments; molecular spectroscopy instruments; software and data systems; and vacuum pumps and measurement technologies. Agilent Technologies, Inc. sells its products through direct sales; and distributors, resellers, manufacturer's representatives, telesales, and electronic commerce. The company was founded in 1999 and is headquartered in Santa Clara, California."},{"Symbol":"APD","Name":"Air Products & Chemicals Inc","Sector":"Materials","Description":"Air Products and Chemicals, Inc. has a portfolio of products, services, and solutions that include atmospheric gases, process and specialty gases, performance materials, equipment, and services. It is a supplier of hydrogen and helium and operates in markets, such as semiconductor materials, refinery hydrogen and natural gas liquefaction. Its segments include Merchant Gases, Tonnage Gases, Electronics and Performance Materials, and Equipment and Energy. In November 2011, Fluor Corporation acquired Goar, Allison & Associates, a unit of Air Products. In February 2012, it acquired ROVI Cosmetics International GmbH. In March 2012, it acquired advanced adsorption technology assets for its Generated Gases product lines. In March 2012, it brought a new hydrogen selenide (H2Se) plant. In September 2012, it acquired an air separation unit (ASU) and integrated gases liquefier in Guiyang, China from Guizhou Kaiyang Chemical Co., Ltd."},{"Symbol":"AKAM","Name":"Akamai Technologies Inc","Sector":"Information Technology","Description":"Akamai Technologies, Inc. (Akamai) provides content delivery and cloud infrastructure services for the delivery of content and applications over the Internet. The Company's solutions range from delivery of conventional content on Websites, to tools that support the delivery and operation of cloud-based applications, to live and on-demand streaming video capabilities all designed to help its customers interact with people accessing the Internet from myriad devices and locations around the world. The Company offers five solutions designed to meet the online business needs of its customers: Terra, Aqua, Sola, Kona and Aura. In December 2012, the Company acquired Verivue, Inc. In September 2012, the Company acquired FastSoft, Inc. In March 2012, the Company acquired Cotendo, Inc. In February 2012, the Company acquired Blaze Software, Inc. Effective November 11, 2013, Akamai Technologies Inc acquired Velocius Networks."},{"Symbol":"ALK","Name":"Alaska Air Group Inc","Sector":"Industrials","Description":"Alaska Air Group, Inc. (Air Group) is the holding company for Alaska Airlines and Horizon Air. The Company has two principal subsidiaries: Alaska Airlines, Inc. (Alaska) and Horizon Air Industries, Inc. (Horizon), which provides scheduled air transportation for passengers and cargo throughout the United States, Canada and Mexico. During the year ended December 31, 2011, it provided air service to approximately 24 million passengers and flew to approximately 100 destinations. Air Group has two operating airlines: Alaska Airlines and Horizon Air. It offers frequent flyer program, the Alaska Airlines Mileage Plan. Members can earn and redeem miles on Alaska, Horizon, and a network of 15 airline partners around the globe, including Delta Air Lines and American Airlines in the United States. The Company launched mobile applications for Android and iPhone smart phones. During 2011, the Company terminated the underlying subleases and sold the remaining Q200 aircraft."},{"Symbol":"ALB","Name":"Albemarle Corp","Sector":"Materials","Description":"Albemarle Corporation (Albemarle) is a developer, manufacturer and marketer of specialty chemicals, which meet customer needs across a range of end markets, including the petroleum refining, consumer electronics, plastics/packaging, construction, automotive, lubricants, pharmaceuticals, crop protection, food-safety and custom chemistry services markets. As of December 31, 2011, the Company and its joint ventures operated 50 facilities, encompassing production, research and development facilities, and administrative and sales offices in North and South America, Europe, the Middle East, Asia, Africa and Australia. It serves approximately 3,000 customers in over 100 countries. It operates in three segments: Polymer Solutions, Catalysts and Fine Chemistry. On May 11, 2011, the Company acquired Catilin Inc. In October 2013, Albemarle Corp acquired Cambridge Chemical Co Ltd."},{"Symbol":"ALXN","Name":"Alexion Pharmaceuticals","Sector":"Health Care","Description":"Alexion Pharmaceuticals, Inc. (Alexion) is a biopharmaceutical company focused on serving patients with severe and ultra-rare disorders through the development and commercialization of life-transforming therapeutic products. Its marketed product Soliris (eculizumab) is the first and only therapeutic approved for patients with two ultra-rare and severe disorders resulting from chronic uncontrolled activation of the complement component of the immune system: paroxysmal nocturnal hemoglobinuria (PNH), an ultra-rare and life-threatening blood disorder, and atypical hemolytic uremic syndrome (aHUS), an ultra-rare and life-threatening genetic disease. On February 7, 2012, it acquired Enobia Pharma Corp. (Enobia). On February 8, 2011, it acquired patents and assets from Orphatec Pharmaceuticals GmbH (Orphatec). On January 28, 2011, it acquired Taligen Therapeutics, Inc. (Taligen). It acquired Asfotase alfa in February 2012."},{"Symbol":"ALLE","Name":"Allegion","Sector":"Industrials","Description":"Allegion plc is a global provider of security products and solutions. The Company offers a portfolio of mechanical and electronic security products across a range of brands. The Company operates in three geographic regions: Americas; Europe, Middle East, India and Africa (EMEIA), and Asia Pacific. As of November 15, 2013, the Company was selling its security products and solutions under 23 brands in 120 countries, including Schlage, Von Duprin, LCN, CISA and Interflex. It sell a range of security products and solutions for end-users in commercial, institutional and residential facilities worldwide, including into the education, healthcare, government, commercial office and single- and multi-family residential markets. In April 2014, the Company acquired Fire & Security Hardware Pty Ltd."},{"Symbol":"AGN","Name":"Allergan, Plc","Sector":"Health Care","Description":"Allergan, Inc. is a multi-specialty health care Company focused on developing and commercializing pharmaceuticals, biologics, medical devices and over-the-counter products. The Company's segments include specialty pharmaceuticals, which produces a range of pharmaceutical products, including ophthalmic products for dry eye, glaucoma, inflammation, infection, allergy and retinal disease; Botox for certain therapeutic and aesthetic indications; skin care products for acne, psoriasis, eyelash growth and other prescription and over-the-counter skin care products; and urologic products and the medical devices segment, which produces a range of medical devices, including breast implants for augmentation, revision and reconstructive surgery and tissue expanders; obesity intervention products, and facial aesthetics products. In December 2013, Allergan Inc completed the sale of its obesity intervention business to Apollo Endosurgery."},{"Symbol":"ADS","Name":"Alliance Data Systems","Sector":"Information Technology","Description":"Alliance Data Systems Corporation is a provider of transaction-based, data-driven marketing and loyalty solutions serving consumer-based businesses in a variety of industries. The Company offers a portfolio of integrated outsourced marketing solutions, including customer loyalty programs, database marketing services, marketing strategy consulting, analytics and creative services, direct marketing services and private label and co-brand retail credit card programs. It focuses on facilitating and managing interactions between its clients and their customers through all consumer marketing channels, including in-store, on-line, catalog, mail, telephone and email, and emerging channels, such as mobile and social media. Its products and services operate under three segments: LoyaltyOne, Epsilon and Private Label Services and Credit."},{"Symbol":"LNT","Name":"Alliant Energy Corp","Sector":"Utilities","Description":"Alliant Energy Corporation (Alliant Energy) operates as a regulated investor-owned public utility holding company. Alliant Energy's primary focus is to provide regulated electricity and natural gas service to approximately one million electric and approximately 415,000 natural gas customers in the Midwest through its two public utility subsidiaries. The primary first tier subsidiaries of Alliant Energy are: Interstate Power and Light Company (IPL), Wisconsin Power and Light Company (WPL), Resources and Corporate Services. IPL is a public utility engaged principally in the generation and distribution of electricity and the distribution and transportation of natural gas in selective markets in Iowa and southern Minnesota. WPL is a public utility engaged principally in the generation and distribution of electricity and the distribution and transportation of natural gas in selective markets in southern and central Wisconsin. On February 1, 2013, it sold RMT, Inc."},{"Symbol":"ALL","Name":"Allstate Corp","Sector":"Financials","Description":"The Allstate Corporation (Allstate) is a holding company for Allstate Insurance Company. The Company's business is conducted principally through Allstate Insurance Company, Allstate Life Insurance Company and their affiliates. It is engaged, principally in the United States, in the property-liability insurance, life insurance, retirement and investment product business. Allstate's primary business is the sale of private passenger auto and homeowners insurance. The Company also sells several other personal property and casualty insurance products, select commercial property and casualty coverages, life insurance, annuities, voluntary accident and health insurance and funding agreements. It conducts its business primarily in the United States. Allstate has four business segments: Allstate Protection, Allstate Financial, Discontinued Lines and Coverages and Corporate and Other. In October 2011, the Company acquired Esurance and Answer Financial from White Mountains Insurance Group."},{"Symbol":"GOOGL","Name":"Alphabet Inc Class A","Sector":"Information Technology","Description":"Google Inc. (Google) is a global technology company. The Company's business is primarily focused around key areas, such as search, advertising, operating systems and platforms, enterprise and hardware products. The Company generates revenue primarily by delivering online advertising. The Company also generates revenues from Motorola by selling hardware products. The Company provides its products and services in more than 100 languages and in more than 50 countries, regions, and territories. Effective May 16, 2014, Google Inc acquired Quest Visual Inc. Effective May 20, 2014, Google Inc acquired Enterproid Inc, doing business as Divide. In June 2014, Google Inc acquired mDialog Corp. Effective June 25, 2014, Google Inc acquired Appurify Inc, a San Francisco-based developer of mobile bugging application software."},{"Symbol":"GOOG","Name":"Alphabet Inc Class C","Sector":"Information Technology","Description":"Google Inc. (Google) is a global technology company. The Company's business is primarily focused around key areas, such as search, advertising, operating systems and platforms, enterprise and hardware products. The Company generates revenue primarily by delivering online advertising. The Company also generates revenues from Motorola by selling hardware products. The Company provides its products and services in more than 100 languages and in more than 50 countries, regions, and territories. Effective May 16, 2014, Google Inc acquired Quest Visual Inc. Effective May 20, 2014, Google Inc acquired Enterproid Inc, doing business as Divide. In June 2014, Google Inc acquired mDialog Corp. Effective June 25, 2014, Google Inc acquired Appurify Inc, a San Francisco-based developer of mobile bugging application software."},{"Symbol":"MO","Name":"Altria Group Inc","Sector":"Consumer Staples","Description":"Altria Group, Inc. is a holding company. At December 31, 2012, Altria Group, Inc.'s direct and indirect wholly owned subsidiaries included Philip Morris USA Inc. (PM USA), which is engaged in the manufacture and sale of cigarettes and certain smokeless products in the United States; John Middleton Co. (Middleton), which is engaged in the manufacture and sale of machine-made cigars and pipe tobacco, and is a wholly owned subsidiary of PM USA; and UST LLC (UST), which through its direct and indirect wholly owned subsidiaries, including U.S. Smokeless Tobacco Company LLC (USSTC) and Ste. Michelle Wine Estates Ltd. (Ste. Michelle), is engaged in the manufacture and sale of smokeless products and wine. Philip Morris Capital Corporation (PMCC), another wholly owned subsidiary of Altria Group, Inc., maintains a portfolio of leveraged and direct finance leases. In addition, Altria Group, Inc. held approximately 26.9% of the economic and voting interest of SABMiller plc (SABMiller)."},{"Symbol":"AMZN","Name":"Amazon.com Inc","Sector":"Consumer Discretionary","Description":"Amazon.com, Inc. (Amazon.com) serves consumers through its retail websites and focus on selection, price, and convenience. The Company offers programs that enables sellers to sell their products on its websites and their own branded websites and to fulfill orders through them , and programs that allow authors, musicians, filmmakers, application developers, and others to publish and sell content. The Company operates in two segments: North America and International. The Company serves consumers through its retail websites, and focus on selection, price, and convenience. The Company designs its websites to enable millions of products to be sold by the Company and by third parties across dozens of product categories. Customers access its websites directly and through its mobile websites and apps. It also manufactures and sells Kindle devices. In October 2013, Amazon.com Inc acquired TenMarks Education Inc."},{"Symbol":"AEE","Name":"Ameren Corp","Sector":"Utilities","Description":"Ameren Corporation (Ameren) is a utility holding company. The Company's principal subsidiaries are Union Electric Company (Ameren Missouri), Ameren Illinois Company (Ameren Illinois) and Ameren Energy Resources Company, LLC (AER). The Company operates in three segments: Ameren Missouri, Ameren Illinois, and Merchant Generation. Ameren Missouri operates a rate-regulated electric generation, transmission and distribution business, and a rate-regulated natural gas transmission and distribution business in Missouri. Ameren Illinois operates a rate-regulated electric and natural gas transmission and distribution business in Illinois. In December 2013, Dynegy Inc announced that its subsidiary, Illinois Power Holdings (IPH) completed its acquisition of New Ameren Energy Resources (AER), an Ameren subsidiary."},{"Symbol":"AAL","Name":"American Airlines Group","Sector":"Industrials","Description":"American Airlines Group Inc., through its subsidiaries, operates in the airline industry. As of December 31, 2014, the company operated 983 mainline jets, as well as 566 regional aircrafts through regional airline subsidiaries and third-party regional carriers. It serves 339 destinations in 54 countries. The company was formerly known as AMR Corporation and changed its name to American Airlines Group Inc. in December 2013. American Airlines Group Inc. was founded in 1934 and is headquartered in Fort Worth, Texas."},{"Symbol":"AEP","Name":"American Electric Power","Sector":"Utilities","Description":"American Electric Power Company, Inc. (AEP) is a utility holding company that owns, directly or indirectly, all of the outstanding common stock of its public utility subsidiaries and varying percentages of other subsidiaries. The service areas of AEP's public utility subsidiaries cover portions of the states of Arkansas, Indiana, Kentucky, Louisiana, Michigan, Ohio, Oklahoma, Tennessee, Texas, Virginia and West Virginia. The generating and transmission facilities of AEP's public utility subsidiaries are interconnected and their operations are coordinated. Transmission networks are interconnected with distribution facilities in the territories served. On December 31, 2011, Columbus Southern Power Company (CSPCo) merged with and into Ohio Power Company (OPCo) with OPCo being the surviving entity. In March 2012, the Company's subsidiary, AEP Retail Energy acquired BlueStar Energy Holdings Inc. and its independent retail electric supplier BlueStar Energy Solutions."},{"Symbol":"AXP","Name":"American Express Co","Sector":"Financials","Description":"American Express Company (American Express) is a global service company. The Company's range of products and services includes Charge and credit card products, Expense management products and services, Consumer and business travel services, Stored value products, such as travelers cheques and other prepaid products, Network services, merchant acquisition and processing, servicing and settlement, and point-of-sale, marketing and information products and services for merchants, and fee services, including market and trend analyses and related consulting services, fraud prevention services, and the design of customized customer loyalty and rewards programs. It operates in four segments: U.S. Card Services, International Card Services, Global Commercial Services (GCS) and Global Network & Merchant Services (GNMS). American Express and its principal operating subsidiary, American Express Travel Related Services Company, Inc. (TRS), are bank holding companies."},{"Symbol":"AIG","Name":"American International Group, Inc.","Sector":"Financials","Description":"American International Group, Inc. (AIG) is a global insurance company. The Company provides a range of property casualty insurance, life insurance, retirement products, mortgage insurance and other financial services to customers in more than 130 countries. It diverse offerings include products and services that help businesses and individuals protect their assets, manage risks and provide for retirement security. It earns revenues primarily from insurance premiums, policy fees from universal life insurance and investment products, and income from investments. Its segments include AIG Property Casualty and AIG Life and Retirement. During the year ended December 31, 2012, the Chartis segment was renamed AIG Property Casualty and the SunAmerica segment was renamed AIG Life and Retirement."},{"Symbol":"AMT","Name":"American Tower Corp A","Sector":"Real Estate","Description":"American Tower Corporation is a holding company. The Company conducts its operations through its directly and indirectly owned subsidiaries and joint ventures. It is a wireless and broadcast communications infrastructure company that owns, operates and develops communications sites. Its primary business includes leasing antenna space on multi-tenant communications sites to wireless service providers, radio and television broadcast companies, wireless data providers, government agencies and municipalities and tenants in a number of other industries. This business is its rental and management operations, which accounted for approximately 98% of its total revenues during the year ended December 31, 2011. In January 2012, the Company merged with and into American Tower REIT, Inc. In October 2013, the Company acquired MIP Tower Holdings LLC. In November2013, NII Holdings, Inc sold 1,483 communications sites in Mexico to American Tower Corporation."},{"Symbol":"AWK","Name":"American Water Works Company Inc","Sector":"Utilities","Description":"American Water Works Company, Inc. (American Water) is a water and wastewater utility company. American Water provides drinking water, wastewater and other water related services to an estimated 15 million people in more than 30 states and in two Canadian provinces. The Company operates in two segments: the Regulated Businesses and the Market-Based Operations. During the year ended December 31, 2011, its Regulated Businesses segment accounted for 88.8% of its total consolidated operating revenue. During 2011, its Market-Based Operations segment accounted for 12.3% of total consolidated operating revenue. In November 2013, American Water Works Company, Inc announced that its Virginia American Water subsidiary has completed its acquisition of Dale Service Corporation. In November 2013, American Water Works Company Inc's West Virginia American Water announced that it has completed the purchase of the Town of Pratt's water system."},{"Symbol":"AMP","Name":"Ameriprise Financial","Sector":"Financials","Description":"Ameriprise Financial, Inc. (Ameriprise Financial) is a holding company primarily engaged in business through its subsidiaries. The Company is a diversified financial services company. Ameriprise Financial operates in five segments: Advice & Wealth Management, Asset Management, Annuities, Protection and Corporate & Other. As of December 31, 2012, the Company had a network of more than 9,700 affiliated advisors. Ameriprise Financial offers its branded advisors training, tools, leadership, marketing programs and other field and centralized support to assist them in delivering advice and product solutions to clients. It uses three principal brands for its businesses in the United States: Ameriprise Financial, Columbia Management and RiverSource. The Company uses its Threadneedle brand for its international asset manager's products."},{"Symbol":"ABC","Name":"AmerisourceBergen Corp","Sector":"Health Care","Description":"AmerisourceBergen Corporation (AmerisourceBergenis) is a pharmaceutical services company serving the United States, Canada and select global markets. The Company distributes a range of pharmaceuticalsgeneric pharmaceuticals, over-the-counter healthcare products, home healthcare supplies and equipment, and related services to a range of healthcare providers located in the United States, Canada and selected global markets, including acute care hospitals and health systems, independent and chain retail pharmacies, mail order pharmacies, medical and dialysis clinics, physicians and physician group practices, long-term care and other alternate site pharmacies, and other customers. In May 2013, the Company completed the divestiture of its contract packaging business, AndersonBrecon. In June 2013, the Company announced that has completed the divestiture of AmerisourceBergen Canada Corporation (ABCC)."},{"Symbol":"AME","Name":"AMETEK Inc","Sector":"Industrials","Description":"AMETEK, Inc. (AMETEK) is a global manufacturer of electronic instruments and electromechanical devices with operations in North America, Europe, Asia and South America. The Company markets its products worldwide through two groups: the Electronic Instruments Group (EIG) and the Electromechanical Group (EMG). EIG builds monitoring, testing, calibration and display devices for the process, aerospace, industrial, power and medical markets. EMG produces engineered electromechanical connectors for hermetic (moisture-proof) applications, specialty metals for niche markets and brushless air-moving motors, blowers and heat exchangers. End markets include aerospace, defense, mass transit, medical, office products and other industrial markets. In December 2013, the Company announced that it has acquired Powervar, a provider of power management systems and uninterruptible power supply (UPS) systems."},{"Symbol":"AMGN","Name":"Amgen Inc","Sector":"Health Care","Description":"Amgen Inc. is a global biotechnology pioneer that discovers, develops, manufactures and delivers human therapeutics. Its medicines help millions of patients in the fight against cancer, kidney disease, rheumatoid arthritis (RA), bone disease, and other serious illnesses. On December 10, 2012, the Company acquired all of the outstanding stock of deCODE Genetics (deCODE). In July 5, 2012, the Company acquired KAI Pharmaceuticals, a privately held company based in South San Francisco. In September 2013, Swedish Orphan Biovitrum AB (publ) (Sobi) announced that they have acquired the full rights to develop and commercialize Kineret (anakinra) from Amgen Inc for all therapeutic indications."},{"Symbol":"APH","Name":"Amphenol Corp","Sector":"Information Technology","Description":"Amphenol Corporation (Amphenol) is a designer, manufacturer and marketer of electrical, electronic and fiber optic connectors, interconnect systems and coaxial and high-speed specialty cable. Amphenol designs and manufactures connectors and interconnect systems, which are used primarily to conduct electrical and optical signals for a range of electronic applications. It has developed a range of connector and interconnect products for information technology and communications equipment applications, including the converging voice, video and data communications markets. The Company offers a range of interconnect products for factory automation and motion control systems, machine tools, instrumentation and medical systems, mass transportation applications and automotive safety systems and a diverse range of on-board electronics. In addition, Amphenol is a supplier of high performance, military-specification, circular environmental connectors."},{"Symbol":"APC","Name":"Anadarko Petroleum Corp","Sector":"Energy","Description":"Anadarko Petroleum Corporation (Anadarko) is an independent exploration and production company. As of December 31, 2011, the Company had over 2.5 billion barrels of oil equivalent (BOE) of proved reserves. Anadarko's asset portfolio includes positions in onshore resource plays in the Rocky Mountains region, the southern United States, and the Appalachian basin. The Company is also independent producers in the deepwater Gulf of Mexico, and has production and exploration activities globally, including positions in high-potential basins located in East and West Africa, Algeria, China, Alaska, and New Zealand. The Company operates in three segments: Oil and gas exploration and production, Midstream, and Marketing. In August 2012, Western Gas Partners, LP acquired an additional 24% membership interest in Chipeta Processing LLC from Anadarko."},{"Symbol":"ADI","Name":"Analog Devices, Inc.","Sector":"Information Technology","Description":"Analog Devices, Inc. (Analog Devices) is engaged in the design, manufacture and marketing of a range of analog, mixed-signal and digital signal processing integrated circuits (ICs). The Company produces a range of products, including data converters, amplifiers and linear products, radio frequency (RF) ICs, power management products, sensors based on micro-electro mechanical systems (MEMS) technology and other sensors, and processing products, including DSP and other processors, which are designed to meet the needs of a base of customers. The Company's products are embedded inside many different types of electronic equipment, including industrial process control systems; instrumentation and measurement systems; wireless infrastructure equipment, and aerospace and defense electronics. In November 2013, Analog Devices, Inc completed the sale of the assets of its microphone product line to InvenSense, Inc."},{"Symbol":"ANTM","Name":"Anthem Inc.","Sector":"Health Care","Description":"Anthem, Inc., a health benefits company, through its subsidiaries, provides a range of medical products in the United States. The company offers a spectrum of network-based managed care health benefit plans to large and small employer, individual, Medicaid, and senior markets. Its managed care plans include preferred provider organizations; health maintenance organizations; point-of-service plans; traditional indemnity plans and other hybrid plans, such as consumer-driven health plans; and hospital only and limited benefit products. The company also provides a range of managed care services to self-funded customers, including claims processing, underwriting, stop loss insurance, actuarial services, provider network access, medical cost management, disease management, wellness programs, and other administrative services. In addition, it offers an array of specialty and other insurance products and services, such as behavioral health benefit services, dental, vision, life and disability insurance benefits, radiology benefit management, analytics-driven personal health care guidance, and long-term care insurance. Further, the company provides services to the federal Government in connection with the federal Employee Program and various medicare programs; and operates as a licensee of the Blue Cross and Blue Shield Association. As of December 31, 2013, it served 35.7 million medical members through its affiliated health plans; and approximately 67.8 million individuals. The company was founded in WellPoint, Inc. and changed its name to Anthem, Inc. in December 2014. Anthem, Inc. is headquartered in Indianapolis, Indiana."},{"Symbol":"AON","Name":"Aon plc","Sector":"Financials","Description":"Aon plc provides risk management services, insurance and reinsurance brokerage, and human resource consulting and outsourcing services worldwide. It operates through two segments, Risk Solutions and HR Solutions. The Risk Solutions segment offers retail brokerage services, including affinity products, managing general underwriting, placement, captive management services, and data and analytics; risk management solutions for property liability, general liability, professional liability, directors' and officers' liability, workers' compensation, and various healthcare products; and health and benefits consulting services comprising structuring, funding, and administering employee benefit programs. This segment also provides advisory services to technology, financial services, agribusiness, aviation, construction, health care, energy, and other industries. In addition, this segment offers reinsurance brokerage services for treaty and facultative reinsurance, as well as specialty lines, such as professional liability, workers' compensation, accident, life, and health; actuarial, enterprise risk management, catastrophe management, and rating agency advisory services; and capital management transaction and advisory services for insurance and reinsurance clients. The HR Solutions segment offers human capital services in the areas of retirement, compensation, strategic human capital, investment consulting, benefits administration, exchanges, and human resource business process outsourcing. Aon plc was founded in 1919 and is headquartered in London, the United Kingdom."},{"Symbol":"APA","Name":"Apache Corporation","Sector":"Energy","Description":"Apache Corporation (Apache) is an independent energy company, which explores for, develops, and produces natural gas, crude oil, and natural gas liquids. As of December 31, 2011, Apache had exploration and production interests in six countries: the United States, Canada, Egypt, Australia, offshore the United Kingdom in the North Sea, and Argentina. During the year ended December 31, 2011, it participated in drilling 1,087 gross wells, with 1,005 completed as producers. As of December 31, 2011, in addition to its completed wells, several wells had not reached completion: 39 in the United States (28.44 net); 50 in Canada (42.69 net); 23 in Egypt (21.75 net); six in the North Sea (4.91 net); one in Australia (0.33 net), and three in Argentina (3.00 net). In November 2013, the Company sold one-third minority participation in its Egypt oil and gas business to Sinopec International Petroleum Exploration and Production Corporation."},{"Symbol":"AIV","Name":"Apartment Investment & Mgmt","Sector":"Real Estate","Description":"Apartment Investment and Management Company (Aimco) is a self-administered and self-managed real estate investment trust (REIT). AIMCO Properties, L.P. (the Aimco Operating Partnership), is a partnership formed to conduct the Company's business, which is focused on the ownership, management and redevelopment of apartment communities located in the United States. Aimco, through its wholly owned subsidiaries, AIMCO-GP, Inc. and AIMCO-LP Trust, owns an ownership interests in the Aimco Operating Partnership. Aimco conducts all of its business and owns all of its assets through the Aimco Operating Partnership. As of December 31, 2012 , the Company's portfolio of owned properties consisted of 265 properties with 67,977 apartment units. The Company's business is organized around two activities: Property Operations and Portfolio Management. During the year ended December 31, 2012, the Company acquired 84 properties in San Diego, 42 in Manhattan and 488 in Phoenix."},{"Symbol":"AAPL","Name":"Apple Inc.","Sector":"Information Technology","Description":"Apple Inc. (Apple) designs, manufactures and markets mobile communication and media devices, personal computers, and portable digital music players, and a variety of related software, services, peripherals, networking solutions, and third-party digital content and applications. The Company's products and services include iPhone, iPad, Mac, iPod, Apple TV, a portfolio of consumer and professional software applications, the iOS and OS X operating systems, iCloud, and a variety of accessory, service and support offerings. The Company also delivers digital content and applications through the iTunes Store, App StoreSM, iBookstoreSM, and Mac App Store. The Company distributes its products worldwide through its retail stores, online stores, and direct sales force, as well as through third-party cellular network carriers, wholesalers, retailers, and value-added resellers. In February 2012, the Company acquired app-search engine Chomp."},{"Symbol":"AMAT","Name":"Applied Materials Inc","Sector":"Information Technology","Description":"Applied Materials, Inc. (Applied) provides manufacturing equipment, services and software to the global semiconductor, flat panel display, solar photovoltaic (PV) and related industries. Applied's customers include manufacturers of semiconductor wafers and chips, flat panel liquid crystal displays (LCDs), solar PV cells and modules, and other electronic devices. These customers may use what they manufacture in their own end products or sell the items to other companies for use in advanced electronic components. Applied operates in four segments: Silicon Systems Group, Applied Global Services, Display, and Energy and Environmental Solutions. In November 2011, the Company acquired Varian Semiconductor Associates, Inc."},{"Symbol":"ADM","Name":"Archer-Daniels-Midland Co","Sector":"Consumer Staples","Description":"Archer-Daniels-Midland-Company, is engaged in the processing of oilseeds, corn, wheat, cocoa, and other agricultural commodities. The Company manufactures protein meal, vegetable oil, corn sweeteners, flour, biodiesel, ethanol, and other value-added food and feed ingredients. The Company also has a grain elevator and transportation network to procure, store, clean, and transport agricultural commodities, such as oilseeds, corn, wheat, milo, oats, and barley, as well as processed agricultural commodities. Its operations are classified into three business segments: Oilseeds Processing, Corn Processing, and Agricultural Services. In January 2012, the Company acquired three grain elevators in Slovakia from the companies Palma Group a.s. and Polnonakup Hont a.s. In October 2012, the Company acquired 10% interest in GrainCorp Ltd."},{"Symbol":"ARNC","Name":"Arconic Inc","Sector":"Industrials","Description":""},{"Symbol":"AJG","Name":"Arthur J. Gallagher & Co.","Sector":"Financials","Description":"Arthur J. Gallagher & Co. (Gallagher) along with its subsidiaries, provides insurance brokerage and third-party claims settlement, and administration services to entities in the United States and abroad. It operates in three segments: brokerage, risk management and corporate. The Brokerage segment primarily consists of retail and wholesale insurance brokerage operations. The Company's risk management segment provides contract claim settlement and administration services for enterprises that choose to self-insure some or all of their property/casualty coverages and for insurance companies that choose to outsource some or all of their property/casualty claims departments. In November 2013, Arthur J. Gallagher & Co. announced the acquisition of The Parks Johnson Agency. In November 2013, the Company acquired the Giles Group of Companies. Effective November 14, 2013, the Company acquired Giles Insurance Brokers Ltd."},{"Symbol":"AIZ","Name":"Assurant Inc","Sector":"Financials","Description":"Assurant, Inc. (Assurant) is a provider of specialized insurance products and related services in North America and select worldwide markets. The Company operates in four segments: Assurant Solutions, Assurant Specialty Property, Assurant Health, and Assurant Employee Benefits. The products offered by the segments include warranties and service contracts, pre-funded funeral insurance, lender-placed homeowners insurance, manufactured housing homeowners insurance, individual health and small employer group health insurance, group dental, disability, and life insurance and employee-funded voluntary benefits. On June 21, 2011, the Company acquired the SureDeposit business, the provider of security deposit alternatives to the multifamily housing industry. In October 2013, FirstService Corporation completed the sale of its Field Asset Services business to Assurant, Inc. In October 2013, Assurant Inc acquired Lifestyle Services Group Ltd."},{"Symbol":"T","Name":"AT&T Inc","Sector":"Telecommunications Services","Description":"AT&T Inc. provides telecommunications services to consumers and businesses in the United States and internationally. Its Wireless segment offers various wireless voice, data, text, and other services, including local wireless communications services, long-distance services, and roaming services. This segment also sells various handsets, wirelessly enabled computers, and personal computer wireless data cards through its owned stores, agents, or third-party retail stores; and accessories comprising carrying cases, hands-free devices, batteries, battery chargers, and other items to consumers, as well as to agents and third-party distributors. As of December 31, 2013, this segment served approximately 110 million wireless subscribers. The companys Wireline segment provides data services, such as switched and dedicated transport, DSL Internet access, network integration, managed Web-hosting, packet, and enterprise networking services, as well as local, interstate, and international wholesale networking capacity to other service providers. This segment also offers voice services consisting of local and long-distance services; wholesale switched access services to other service providers; and outsourcing services, integration services and customer premises equipment, and government-related services. This segment served approximately 12 million retail consumer access lines, 10 million retail business access lines, and 2 million wholesale access lines. The company has strategic relationship with IBM to provide businesses with a source for network security and threat management. The company was formerly known as SBC Communications Inc. and changed its name to AT&T Inc. in November 2005. AT&T, Inc. was founded in 1983 and is based in Dallas, Texas."},{"Symbol":"ADSK","Name":"Autodesk Inc","Sector":"Information Technology","Description":"Autodesk, Inc. (Autodesk) is a design software and services company. The Company operates in four operating segments: Platform Solutions and Emerging Business (PSEB), Architecture, Engineering and Construction (AEC), Manufacturing (MFG) and Media and Entertainment (M&E). The Company serves customers in the architecture, engineering and construction; manufacturing, and digital media and entertainment industries. The Company's software products enable its customers to experience their ideas before they are real by allowing them to imagine, design, and create their ideas and to visualize, simulate and analyze real-world performance early in the design process by creating digital prototypes. In August 2012, the Company acquired certain assets of Inforbix, LLC. In October 2012, it acquired certain assets of HSMWorks Aps. In October 2012, it acquired Qontext. In January 2013, the Company acquired PI-VR. Effective March 19, 2013, it acquired Firehole Technologies Inc."},{"Symbol":"ADP","Name":"Automatic Data Processing","Sector":"Information Technology","Description":"Automatic Data Processing, Inc. (ADP) is a provider of business outsourcing solutions. ADP offers a wide range of human resource, payroll, tax and benefits administration solutions from a single source. ADP is also a provider of integrated computing solutions to auto, truck, motorcycle, marine, recreational vehicle, and heavy equipment dealers throughout the world. The Company's operating segments include: Employer Services, professional employer organization (PEO) Services, and Dealer Services. In October 2011, the Company acquired WALLACE - The Training Tax Credit Company. In January 2012, the Company acquired Indian payroll business of Randstad Holding NV. In April 2012, it acquired the human resource solutions subsidiary of SHPS, Inc. In June 2013, Automatic Data Processing, Inc. announced that it has acquired Payroll S.A."},{"Symbol":"AN","Name":"AutoNation Inc","Sector":"Consumer Discretionary","Description":"AutoNation, Inc., through its subsidiaries, operates as an automotive retailer in the United States. The company operates in three segments: Domestic, Import, and Premium Luxury. It offers a range of automotive products and services, including new and used vehicles, parts and service comprising automotive repair and maintenance services, and wholesale parts and collision businesses; and automotive finance and insurance products that include arranging financing for vehicle purchases through third-party finance sources. The company also provides a range of vehicle maintenance, repair, and collision repair services, such as warranty and customer-pay service work. In addition, it offers various vehicle protection products, such as extended service contracts, maintenance programs, guaranteed auto protection, tire and wheel protection, and theft protection products. As of November 4, 2014, the company owned and operated 277 new vehicle franchises, which sell 34 brands in 15 states. AutoNation, Inc. was founded in 1991 and is headquartered in Fort Lauderdale, Florida."},{"Symbol":"AZO","Name":"AutoZone Inc","Sector":"Consumer Discretionary","Description":"AutoZone, Inc. (AutoZone) is a retailer and a distributor of automotive replacement parts and accessories in the United States. As of August 25, 2012, AutoZone operated 4,685 stores in the United States, including Puerto Rico, and 321 in Mexico. The Company operates in two segments: Auto Parts Stores and Other. The Auto Parts Stores segment is a retailer and distributor of automotive parts and accessories through the Company's 5,006 stores in the United States, Puerto Rico, and Mexico. The Other category reflects business activities that are not separately reportable, including ALLDATA which produces, sells and maintains diagnostic and repair information software used in the automotive repair industry, and e-Commerce, which includes direct sales to customers through www.autozone.com. During the fiscal year ended August 25, 2012 (fiscal 2012), the Company opened 193 stores and relocated 10 stores."},{"Symbol":"AVB","Name":"AvalonBay Communities, Inc.","Sector":"Real Estate","Description":"AvalonBay Communities, Inc. is a real estate investment trust (REIT) . It is engaged in developing, acquiring, owning and operating apartment communities in high barrier to entry markets of the United States. As of January 31, 2013, it owned a direct or indirect ownership interest in 178 operating apartment communities containing 52,427 apartment homes in nine states and the District of Columbia, of which 155 communities containing 45,056 apartment homes were consolidated for financial reporting purposes, two communities containing 674 apartment homes were held by joint ventures in which it holds an ownership interest, and 21 communities containing 6,697 apartment homes were owned by the Funds.The Company's real estate investments consist of the segments include Established Communities, Other Stabilized Communities and Development/Redevelopment Communities."},{"Symbol":"AVY","Name":"Avery Dennison Corp","Sector":"Materials","Description":"Avery Dennison Corporation (Avery Dennison), is engaged in the production of pressure-sensitive materials, and a variety of tickets, tags, labels other converted products, and office and consumer products through embossing, printing, stamping and die-cutting. The Company operates in two segments: Pressure-sensitive Materials and Retail Branding and Information Solutions. In addition to its reportable segments, the Company has other specialty converting businesses comprised of Vancive Medical Technologies (Vancive) and Designed and Engineered Solutions (DES). Some are sold by the Company in converted form as printable media, tapes and reflective sheeting. In July 2013, Avery Dennison Corp completed the sale of its Office and Consumer Products and Designed and Engineered Solutions businesses to CCL Industries Inc."},{"Symbol":"BHI","Name":"Baker Hughes Inc","Sector":"Energy","Description":"DELISTED - Baker Hughes Incorporated (Baker Hughes) is engaged in the oilfield services industry. Baker Hughes is a supplier of oilfield services, products, technology and systems to the worldwide oil and natural gas industry. It also provides industrial and other products and services to the downstream refining, and the process and pipeline industries. The Company may conduct its operations through subsidiaries, affiliates, ventures and alliances. It operates in more than 80 countries worldwide. The Company operates in five segments. Four of these segments represent its oilfield operations and their geographic organization: North America (U.S. Land, Gulf of Mexico and Canada), Latin America, Europe/Africa/Russia Caspian and Middle East/Asia Pacific. Its Industrial Services and Other segment includes downstream chemicals, process and pipeline services, and the reservoir development services group."},{"Symbol":"BLL","Name":"Ball Corp","Sector":"Materials","Description":"Ball Corporation (Ball) is a supplier of metal packaging to the beverage, food, personal care and household products industries. The Company operates in four segments: metal beverage packaging, Americas and Asia; metal beverage packaging, Europe; metal food and household products packaging, Americas, and aerospace and technologies. Ball also provides aerospace and other technologies and services to governmental and commercial customers within its aerospace and technologies segment. Its product lines are aluminum and steel beverage containers. Ball also produces steel food containers and steel and aluminum aerosol containers for beverages, food, personal care and household products, as well as steel paint cans, decorative steel tins and aluminum slugs. In December 2012, the Company acquired Envases del Plata S.A. de C.V. During the year ended December 31, 2012, the Company acquired Tubettificio Europeo S.p.A. (Tubettificio)."},{"Symbol":"BAC","Name":"Bank of America Corp","Sector":"Financials","Description":"Bank of America Corporation (Bank of America) is a bank holding company, and a financial holding company. Bank of America is a financial institution, serving individual consumers, small and middle market businesses, corporations and Governments with a range of banking, investing, asset management and other financial and risk management products and services. Through its banking and various nonbanking subsidiaries throughout the United States and in international markets, the Company provides a range of banking and nonbanking financial services and products through five business segments: Consumer & Business Banking (CBB), Consumer Real Estate Services (CRES), Global Banking, Global Markets and Global Wealth & Investment Management (GWIM), with the remaining operations recorded in all Other. In October 2013, Bank of America Corporation announced the completion of the merger of its Merrill Lynch & Co., Inc. subsidiary into Bank of America Corporation."},{"Symbol":"BCR","Name":"Bard (C.R.) Inc.","Sector":"Health Care","Description":"C. R. Bard, Inc. (Bard) is engaged in the design, manufacture, packaging, distribution and sale of medical, surgical, diagnostic and patient care devices. As of December 31, 2011, the Company sold a range of products to hospitals, individual healthcare professionals, extended care facilities and alternate site facilities on a global basis. The Company participates in the markets for vascular, urology, oncology and surgical specialty products. Bard also has a product group of other products. Through subsidiaries and a joint venture, Bard markets its products to customers in over 100 countries outside the United States. The Company's principal international markets were in Europe and Japan as of December 31, 2011. On November 10, 2011, Bard acquired Medivance, Inc. On December 16, 2011, the Company acquired Lutonix, Inc."},{"Symbol":"BAX","Name":"Baxter International Inc.","Sector":"Health Care","Description":"Baxter International Inc. (Baxter,) is a global, diversified healthcare company. Baxter, through its subsidiaries, develops, manufactures and markets products that save and sustain the lives of people with hemophilia, immune disorders, infectious diseases, kidney disease, trauma, and other chronic and acute medical conditions. The Company operated in two segments: BioScience and Medication Delivery. It is engaged in the medical devices, pharmaceuticals and biotechnology to create products that advance patient care worldwide. These products are used by hospitals, kidney dialysis centers, nursing homes, rehabilitation centers, doctors' offices, clinical and medical research laboratories, and by patients at home under physician supervision. Baxter manufactures products in 27 countries and sells the products in more than 100 countries. In September 2013, Baxter International Inc completed the acquisition of Gambro AB."},{"Symbol":"BBT","Name":"BB&T Corporation","Sector":"Financials","Description":"BB&T Corporation (BB&T) is a financial holding company. BB&T conducts its business operations primarily through its commercial bank subsidiary, Branch Bank, and other nonbank subsidiaries. The Company's principal operating subsidiaries include Branch Banking and Trust Company, Winston-Salem, North Carolina; BB&T Securities, LLC, Richmond, Virginia; Regional Acceptance Corporation, Greenville, North Carolina; American Coastal Insurance Company, Davie, Florida, and Sterling Capital Management, LLC, Charlotte, North Carolina. BB&T's operations are divided into six reportable business segments: Community Banking, Residential Mortgage Banking, Dealer Financial Services, Specialized Lending, Insurance Services and Financial Services. In April 2012, it acquired the life and property and casualty insurance operating divisions of Roseland, New Jersey - based Crump Group Inc. On July 31, 2012, it acquired BankAtlantic."},{"Symbol":"BDX","Name":"Becton Dickinson","Sector":"Health Care","Description":"Becton Dickinson and Co, formerly Becton Dickinson & Co is a global medical technology company engaged in the development, manufacture and sale of medical devices, instrument systems and reagents used by healthcare institutions, life science researchers, clinical laboratories, the pharmaceutical industry and the general public. The Company' s operations consist of three business segments: BD Medical, BD Diagnostics and BD Biosciences. On February 9, 2012, the Company acquired a 100% interest in KIESTRA Lab Automation BV. On August 24, 2012, the Company acquired a 100% interest in Sirigen Group Limited. On October 31, 2012, the Company sold its BD Biosciences -Discovery Labware unit. In December 2012, the Company acquired Safety Syringes, Inc. Effective March 12, 2013, the Company acquired Cato Software Solutions GmbH."},{"Symbol":"BBBY","Name":"Bed Bath & Beyond","Sector":"Consumer Discretionary","Description":"Bed Bath & Beyond Inc. is a chain of retail stores, operating under the names Bed Bath & Beyond (BBB), Christmas Tree Shops (CTS), Harmon and Harmon Face Values (Harmon), buybuy BABY and World Market or Cost Plus World Market (World Market). In addition, it is a partner in a joint venture, which operates three stores in the Mexico City market under the name Bed Bath & Beyond. The Company sells a range of domestics merchandise and home furnishings. Domestics merchandise includes categories, such as bed linens and related items, bath items and kitchen textiles. Home furnishings include categories, such as kitchen and tabletop items, fine tabletop, basic housewares and general home. During fiscal year ended March 2, 2013 (fiscal 2012), the Company opened a total of 38 stores, including 12 BBB stores throughout the United States and Canada, five CTS stores, one Harmon store and 18 buybuy BABY stores, and six World Market stores throughout the United States and closed one BBB store."},{"Symbol":"BRK.B","Name":"Berkshire Hathaway","Sector":"Financials","Description":""},{"Symbol":"BBY","Name":"Best Buy Co. Inc.","Sector":"Consumer Discretionary","Description":"Best Buy Co., Inc. is a multinational retailer of consumer electronics, computing and mobile phone products, entertainment products, appliances and related services. The Company operates retail stores and call centers, and conducts online retail operations under a range of brand names, such as Best Buy (BestBuy.com, BestBuy.ca), Best Buy Mobile (BestBuyMobile.com), The Carphone Warehouse (CarphoneWarehouse.com), Five Star, Future Shop (FutureShop.ca), Geek Squad, Magnolia Audio Video, Pacific Sales and The Phone House (PhoneHouse.com). During the fiscal year ended March 3, 2012 (fiscal 2012), it operated in two segments: Domestic and International. During fiscal 2012, it opened 135 new stores and closed five stores in its Domestic segment. During fiscal 2012, it opened 219 new stores, within its Best Buy Europe and Five Star operations, and closed 114 stores in its International segment, within its Best Buy Europe business."},{"Symbol":"BIIB","Name":"BIOGEN IDEC Inc.","Sector":"Health Care","Description":"Biogen Idec Inc. (Biogen Idec) is a global biotechnology company. The Company discovers, develops, manufactures and markets therapies for the treatment of neurodegenerative diseases, hemophilia and autoimmune disorders. The Company's products include AVONEX, TYSABRI, FAMPYRA, FUMADERM and RITUXAN. In September 2011, the Company acquired from the Dompe Group the noncontrolling interests in its joint venture sales affiliates in Italy and Switzerland. In April 2013, Elan Corporation, plc closed the TYSABRI (natalizumab) Collaboration Transaction with Biogen Idec."},{"Symbol":"BLK","Name":"BlackRock","Sector":"Financials","Description":"BlackRock, Inc. (BlackRock) is an investment management firm. The Company provides a range of investment and risks management services. The Company's clients include retail, high net worth (HNW) and institutional investors, consists of pension funds, official institutions, endowments, insurance companies, corporations, financial institutions, central banks and sovereign wealth funds. The Company's platform enables the Company to offer active (alpha) investments with index (beta) products and risk management to develop tailored solutions for clients. Its product range includes single- and multi-asset class portfolios investing in equities, fixed income, alternatives and/or money market instruments. On February 14, 2013, BlackRock Inc sold its entire interest in Avocet Mining plc. In July 2013, it announced that it has completed the acquisition of Credit Suisse's exchange traded funds (ETF) business. In October 2013, BlackRock Inc acquired Macquarie Global Property Advisors Ltd."},{"Symbol":"HRB","Name":"Block H&R","Sector":"Financials","Description":"H&R Block, Inc. (H&R Block) through its subsidiaries provides tax preparation and banking services. The Company's Tax Services segment provides assisted income tax return preparation, digital tax solutions and other services and products related to income tax return preparation to the general public primarily in the United States and its territories, Canada and Australia. This segment also offers financial services through H&R Block Bank (HRB Bank). In addition to the Company's Tax Services segment, the Company separately reports corporate operations which include net interest margin and gains or losses relating to mortgage loans held for investment, real estate owned and residual interests in securitizations, along with interest expense on borrowings, other corporate expenses and eliminations of intercompany activities. Through ownership of HRB Bank, the Company is a savings and loans holding company (SLHC)."},{"Symbol":"BA","Name":"Boeing Company","Sector":"Industrials","Description":"The Boeing Company (Boeing) is an aerospace company. The Company operates in five segments: Commercial Airplanes, Boeing Military Aircraft (BMA), Network & Space Systems (N&SS), Global Services & Support (GS&S) and Boeing Capital Corporation (BCC). Boeing Defence, Space & Security (BDS) consists of three capabilities-driven businesses: BMA, N&SS and GS&S. Its Other segment includes the unallocated activities of engineering, operations and technology (EO&T) and Shared Services Group (SSG), as well as intercompany guarantees provided to BCC. EO&T provides Boeing with technical and functional capabilities, including information technology, research and development, test and evaluation, technology strategy development, environmental remediation management and intellectual property management. In February 2013, the Company acquired CPU Technology Inc.'s Acalis business."},{"Symbol":"BWA","Name":"BorgWarner","Sector":"Consumer Discretionary","Description":"BorgWarner Inc. is a global supplier of engineered automotive systems and components primarily for powertrain applications. The Company's products are manufactured and sold worldwide, primarily to original equipment manufacturers (OEMs) of light vehicles (passenger cars, sport-utility vehicles (SUVs), vans and light-trucks). The Company's products are also sold to other OEMs of commercial vehicles (medium-duty trucks, heavy-duty trucks and buses) and off-highway vehicles (agricultural and construction machinery and marine applications). It also manufactures and sells its products to certain Tier One vehicle systems suppliers and into the aftermarket for light, commercial and off-highway vehicles. On January 31, 2011, the Company acquired 100% of the stock of Haldex Traction Holding AB (Haldex Traction Systems) of Haldex Group. In July 2012, the Company sold its spark plug business to Federal-Mogul Corporation."},{"Symbol":"BXP","Name":"Boston Properties","Sector":"Real Estate","Description":"Boston Properties, Inc. is an integrated, self-administered and self-managed real estate investment trust (REIT). The Company is an owner and developer of office properties in the United States. The Company's properties are concentrated in five markets: Boston, New York, Princeton, San Francisco and Washington, DC. As of December 31, 2012, the Company owned or had interests in 157 properties, totaling approximately 44.4 million net rentable square feet, including seven properties under construction totaling approximately 2.8 million net rentable square feet. In March 2012, the Company acquired 100 Federal Street in Boston, Massachusetts from an affiliate of Bank of America, N.A. On March 1, 2012, the Company acquired 453 Ravendale Drive. On October 4, 2012, the Company acquired Fountain Square. In June 2013, Sungate Fifth Avenue LLC and 767 LLC, acquired a 40% interest in the General Motors Building located in New York, from joint venture partners of Boston Properties Inc."},{"Symbol":"BSX","Name":"Boston Scientific","Sector":"Health Care","Description":"Boston Scientific Corporation is a developer, manufacturer and marketer of medical devices that are used in a range of interventional medical specialties. During the year ended December 31, 2011, its products were offered for sale by seven core businesses: Interventional Cardiology, CRM, Endoscopy, Peripheral Interventions, Urology/Women's Health, Neuromodulation, and Electrophysiology. In January 2011, it completed the acquisition of Intelect Medical, Inc. In June 2012, the Company acquired Cameron Health, Inc. of San Clemente, California and, as a result, added to its product portfolio subcutaneous implantable cardioverter defibrillator, called the S-ICD System. In November 2013, the Company announced that it has acquired Bard EP, the electrophysiology (EP) business of C.R. Bard, Inc."},{"Symbol":"BMY","Name":"Bristol-Myers Squibb","Sector":"Health Care","Description":"Bristol-Myers Squibb Company (BMS) is engaged in the discovery, development, licensing, manufacturing, marketing, distribution and sale of biopharmaceutical products on a global basis. It operates in BioPharmaceuticals. Its products are sold worldwide, primarily to wholesalers, retail pharmacies, hospitals, government entities and the medical profession. It manufactures products in the United States (U.S.), Puerto Rico and in 6 foreign countries. In February 2012, it acquired Inhibitex, Inc. (Inhibitex). In August 2012, the Company announced the acquisition of Amylin Pharmaceuticals, Inc. In August 2012, Synergy Pharmaceuticals Inc announced that it signed an Asset Purchase Agreement with the Company and acquired the assets related to FV-100, an orally available nucleoside analogue, being developed for the treatment of shingles."},{"Symbol":"AVGO","Name":"Broadcom","Sector":"Information Technology","Description":"Avago Technologies Limited (Avago) is a designer, developer and global supplier of a range of analog semiconductor devices with a focus on III-V based products. Its product portfolio is extensive and includes over 6,500 products that it sells into four primary target markets: wireless communications, wired infrastructure, industrial and automotive electronics, and consumer and computing peripherals. Applications for its products in these target markets include cellular phones, consumer appliances, data networking and telecommunications equipment, enterprise storage and servers, renewable energy and smart power grid applications, factory automation, displays, optical mice and printers. In April 2013, Avago Technologies Ltd acquired Javelin Semiconductor Inc. In June 2013, Avago Technologies Ltd announced that it has completed its acquisition of CyOptics, Inc."},{"Symbol":"BF.B","Name":"Brown-Forman Corp.","Sector":"Consumer Staples","Description":""},{"Symbol":"CHRW","Name":"C. H. Robinson Worldwide","Sector":"Industrials","Description":"C.H. Robinson Worldwide, Inc. (C.H. Robinson) is a third party logistics company. The Company provides freight transportation services and logistics solutions to companies of all sizes, in a range of industries. The Company operates through a network of 276 offices, which the Company calls branches, in North America, Europe, Asia, South America, and Australia. The Company has developed global transportation and distribution networks to provide transportation and supply chain services worldwide. In addition to transportation, the Company provides sourcing services (Sourcing). The Company's Sourcing business is primarily the buying, selling, and marketing of fresh produce. The Company supplies fresh produce through its network of independent produce growers and suppliers. The Company's customers include grocery retailers and restaurants, produce wholesalers, and foodservice distributors."},{"Symbol":"CA","Name":"CA, Inc.","Sector":"Information Technology","Description":"CA, Inc. (CA) is an independent enterprise information technology (IT) management software and solutions company. CA develops and delivers software and services. The Company operates in three segments: Mainframe Solutions, Enterprise Solutions and Services. The Company addresses components of the computing environment, including people, information, processes, systems, networks, applications and databases, across hardware and software platforms and programs. It offers a portfolio of software solutions, including mainframe; service assurance; security (identity and access management); service and portfolio management, and virtualization and service automation. It delivers its products on-premises or, for certain products, using Software-as-a-Service (SaaS). In June 2013, the Company announced it has completed the acquisition of privately-held Layer 7 Technologies."},{"Symbol":"COG","Name":"Cabot Oil & Gas","Sector":"Energy","Description":"Cabot Oil & Gas Corporation is an independent oil and gas company engaged in the development, exploitation and exploration of oil and gas properties. The Company's exploration, development and production operations are primarily concentrated in three plays: the Marcellus Shale in Pennsylvania, the Eagle Ford in south Texas and the Marmaton oil play in Oklahoma. The Company also has non-core operations in various other unconventional and conventional plays throughout the continental United States. The Company's assets are concentrated in areas with hydrocarbon resources, which are conducive to multi-well, repeatable drilling programs. In December 2012, the Company sold certain proved oil and gas properties located in south Texas. In June 2012, the Company sold a 35% non-operated working interest associated with certain of its Pearsall Shale undeveloped leaseholds in south Texas."},{"Symbol":"CPB","Name":"Campbell Soup","Sector":"Consumer Staples","Description":"Campbell Soup Company (Campbell) together with its subsidiaries, is a manufacturer and marketer of branded convenience food products. The Company operates in five segments: U.S. Simple Meals; Global Baking and Snacking; International Simple Meals and Beverages; U.S. Beverages; and North America Foodservice. In June 2012, the Company purchased 1300 Admiral Wilson Boulevard in Camden. On August 6, 2012, the Company completed the acquisition of BF Bolthouse Holdco LLC (Bolthouse Farms). In September 2012, Vilmorin & Cie SA acquired the tomato and pepper breeding and sales business of the Company. In June 2013, Campbell Soup Co completed the acquisition of Plum Organics. In August 2013, Campbell Soup Company completed the acquisition of Kelsen Group A/S. In October 2013, it completed the sale of its European simple meals business to CVC Capital Partners."},{"Symbol":"COF","Name":"Capital One Financial","Sector":"Financials","Description":"Capital One Financial Corporation is a diversified financial services holding company with banking and non-banking subsidiaries. Capital One Financial Corporation and its subsidiaries offer an array of financial products and services to consumers, small businesses and commercial clients through branches, the Internet and other distribution channels. As of December 31, 2012, the Company's principal subsidiaries included Capital One Bank (USA), National Association (COBN), which offers credit and debit card products, other lending products and deposit products, and Capital One, National Association (CONA), which offers a spectrum of banking products and financial services to consumers, small businesses and commercial clients. On February 17, 2012, the Company acquired ING Direct business in the United States (ING Direct) from ING Groep N.V., ING Bank N.V., ING Direct N.V. and ING Direct Bancorp. In November 2013, Capital One Financial Corp acquired Beech Street Capital LLC."},{"Symbol":"CAH","Name":"Cardinal Health Inc.","Sector":"Health Care","Description":"Cardinal Health, Inc. is a healthcare services company providing products and services that help pharmacies, hospitals, surgery centers, physician offices and other healthcare providers. During the fiscal year ended June 30, 2012 (fiscal 2012), the Company operated in two segments: Pharmaceutical and Medical. The Pharmaceutical segment distributes branded and generic pharmaceutical, over-the-counter healthcare, and consumer products through its pharmaceutical distribution business to retailers. The Medical segment distributes a range of medical, surgical and laboratory products to hospitals, surgery centers, laboratories, physician offices and other healthcare providers. Effective March 18, 2013, it merged with AssuraMed Holding Inc."},{"Symbol":"KMX","Name":"Carmax Inc","Sector":"Consumer Discretionary","Description":"CarMax, Inc. (CarMax) is a holding company and its operations are conducted through its subsidiaries. CarMax also wholesales used vehicles. The Company is a retailer of used cars, based on the 408,080 used vehicles it retailed during the fiscal year ended February 29, 2012 (fiscal 2012). As of February 29, 2012, it operated 108 used car superstores in 53 metropolitan markets. In addition, it is a wholesale vehicle auction operator. It sold 316,649 wholesale vehicles through its on-site auctions in fiscal 2012. As of February 29, 2012, the Company conducted weekly or bi-weekly auctions at 52 of its 108 used car superstores. In addition, it sells new vehicles at four locations under franchise agreements with three new car manufacturers. In fiscal 2012, new vehicles comprised only 2% of its total retail vehicle unit sales."},{"Symbol":"CCL","Name":"Carnival Corp.","Sector":"Consumer Discretionary","Description":"Carnival Corporation is a cruise company. The Company operates in two segments: North America and Europe, Australia & Asia (EAA). Its North America segment cruise brands include Carnival Cruise Lines, Holland America Line, Princess Cruises (Princess) and Seabourn. Its EAA segment cruise brands include AIDA Cruises (AIDA), Costa Cruises (Costa), Cunard, Ibero Cruises (Ibero), P&O Cruises (Australia) and P&O Cruises (United Kingdom). In addition to its cruise brands, it has a Cruise Support segment that includes its cruise port and related facilities located in Cozumel, Mexico; Grand Turk, Turks and Caicos Islands and Roatn, Honduras. In addition to its cruise operations, it owns Holland America Princess Alaska Tours, a tour company in Alaska and the Canadian Yukon. As of November 30, 2012, tour company owned and operated, among other things, 12 hotels or lodges, over 300 motorcoaches and 20 domed rail cars."},{"Symbol":"CAT","Name":"Caterpillar Inc.","Sector":"Industrials","Description":"Caterpillar Inc. (Caterpillar) is a manufacturer of construction and mining equipment, diesel and natural gas engines, industrial gas turbines and diesel-electric locomotives. It operates in two segments: Machinery and Power Systems, and Financial Products. Machinery and Power Systems represents a total of Construction Industries, Resource Industries, Power Systems and All Other segments and related corporate items and eliminations. Financial Products includes the Company's Financial Products Segment. This category includes Cat Financial and Caterpillar Insurance Holdings Inc. Effective March 1, 2012, it announced that Caterpillar Japan Ltd. acquired Caterpillar Tohoku Ltd. In August 2012, Platinum Equity, LLC. acquired a majority interest in Caterpillar Logistics Services. Caterpillar will retain a 35% interest in the business. In October 2012, Finning International Inc acquired from Caterpillar of the former Bucyrus distribution and support business in its dealership territory."},{"Symbol":"CBOE","Name":"CBOE Holdings","Sector":"Financials","Description":"CBOE Holdings, Inc. (CBOE Holdings) is the holding company. The primary business of the Company is the operation of markets for the trading of listed, or exchange-traded, options contracts on three broad product categories: the stocks of individual corporations (equity options), various market indexes (index options) and other exchange-traded products (ETP options), such as exchange-traded funds (ETF options) and exchange-traded notes (ETN options). The Company offers futures products through its futures market. In 2012, the Company introduced S&P 500 Range options on CBOE, and the CBOE NASDAQ-100 Volatility Index futures and S&P 500 Variance futures, all traded on CFE. Security futures and options on the CBOE Emerging Markets ETF Volatility Index, the CBOE Brazil ETF Volatility Index and the CBOE Crude Oil ETF Volatility Index were also launched on CFE and CBOE, respectively."},{"Symbol":"CBG","Name":"CBRE Group","Sector":"Real Estate","Description":"CBRE Group, Inc, is a holding company that conducts all of its operations through its indirect subsidiaries. The Company is a commercial real estate services firm. The Company offers a range of services to occupiers, owners, lenders and investors in office, retail, industrial, multi-family and other types of commercial real estate.The Company operates in five segments: Americas, Europe, Middle East and Africa (EMEA), Asia Pacific, Global Investment Management and Development Services. In June 2013, the Company acquired SOGESMAINT-CBRE. Effective September 2, 2013, CBRE Group Inc acquired an undisclosed majority interest in Basale Sverige AB, from Basale Gruppen AS, In September 2013, CBRE Group Inc acquired Fameco. In November 2013, CBRE Group Inc acquired Alan Selby & Partners LLP. In December 2013, CBRE Group Inc acquired The CAC Group."},{"Symbol":"CBS","Name":"CBS Corp.","Sector":"Consumer Discretionary","Description":"CBS Corporation is a mass media company. The Company has operations in segments, which include Entertainment, Cable Networks, Publishing, Local Broadcasting and Outdoor. During the year ended December 31, 2011, contributions to the Company's consolidated revenues from its segments were Entertainment 52%, Cable Networks 11%, Publishing 6%, Local Broadcasting 19% and Outdoor 13%. During 2011, it generated approximately 15% of its total revenues from international regions. Effective March 26, 2013, the Company acquired 50% interest in The TV Guide Network from Lions Gate Entertainment Corp. In June 2013, the Company acquired TV Guide Digital, which includes the popular TVGuide.com and TV Guide Mobile properties. In October 2013, Platinum Equity and CBS Corporation announced that an affiliate of Platinum Equity acquired the assets of CBS Outdoor International (CBSO International)."},{"Symbol":"CELG","Name":"Celgene Corp.","Sector":"Health Care","Description":"Celgene Corporation is a global biopharmaceutical company engaged in the discovery, development and commercialization of therapies designed to treat cancer and immune-inflammatory related diseases. It is engaged in the research and development, which is designed to bring new therapies to market, and is engaged in research in several scientific areas that may deliver therapies, focusing areas, such as intracellular signaling pathways in cancer and immune cells, immunomodulation in cancer and autoimmune diseases, and therapeutic application of cell therapies. Its primary commercial stage products include REVLIMID, VIDAZA, THALOMID, ABRAXANE and ISTODAX. Additional sources of revenue include a licensing agreement with Novartis, which entitles it to royalties on FOCALIN XR and the entire RITALIN family of drugs, the sale of services through its Cellular Therapeutics subsidiary and other miscellaneous licensing agreements. In March 2012, it acquired Avila Therapeutics."},{"Symbol":"CNC","Name":"Centene Corporation","Sector":"Health Care","Description":"Centene Corporation is a multi-line healthcare enterprise, which provides programs and services to the number of under-insured and uninsured individuals. The Company provides member-focused services through locally based staff by assisting in accessing care, coordinating referrals to related health and social services and addressing member concerns and questions. It also provides education and outreach programs to inform and assist members in accessing appropriate healthcare services. It combines its decentralized local approach for care with a centralized infrastructure of support functions, such as finance, information systems and claims processing. The Company operates in two segments: Medicaid Managed Care and Specialty Services. Effective April 1, 2013, it acquired Specialty Therapeutic Care Holdings Inc doing business as AcariaHealth."},{"Symbol":"CNP","Name":"CenterPoint Energy","Sector":"Utilities","Description":"CenterPoint Energy, Inc. is a domestic energy delivery company. The Company's business segments include Electric Transmission and Distribution, Natural Gas Distribution, Competitive Natural Gas Sales and Services, Interstate Pipelines, Field Services and Other Operations. The Company serves metered customers primarily in Arkansas, Louisiana, Minnesota, Mississippi, Oklahoma and Texas. The company also owns a 58.3% interest in a midstream partnership it jointly controls with OGE Energy Corp. with operations in natural gas and liquids-rich producing areas of Oklahoma, Texas, Arkansas and Louisiana."},{"Symbol":"CTL","Name":"CenturyLink Inc","Sector":"Telecommunications Services","Description":"CenturyLink, Inc. (CenturyLink) is an integrated communications company. The Company is engaged primarily in providing a range of communications services to its residential, business, governmental and wholesale customers. The Company's communications services include local and long-distance, network access, private line, public access, broadband, data, managed hosting (including cloud hosting), colocation, Wireless and video services. In certain local and regional markets, the Company also provides local access and fiber transport services to competitive local exchange carriers (CLECs) and security monitoring. The Company operates in four segments: Regional markets, Wholesale markets, Enterprise markets-network and Enterprise markets-data hosting. In November 2013, CenturyLink Inc acquired Tier 3 LLC."},{"Symbol":"CERN","Name":"Cerner","Sector":"Health Care","Description":"Cerner Corporation is a supplier of healthcare information technology solutions, services, devices and hardware. Cerner solutions optimize processes for healthcare organizations. These solutions are licensed by 9,300 facilities globally, including more than 2,650 hospitals; 3,750 physician practices 40,000 physicians; 500 ambulatory facilities, such as laboratories, ambulatory centers, cardiac facilities, radiology clinics and surgery centers; 800 home health facilities; 40 employer sites and 1,600 retail pharmacies. It operates in two segments: domestic, which includes revenue contributions and expenditures associated with business activity in the United States, and global, which includes revenue contributions and expenditures linked to business activity in Argentina, Aruba, Canada, Cayman Islands, Chile, Puerto Rico, Saudi Arabia, Singapore, Spain and the United Arab Emirates. Effective March 18, 2013, it acquired Labotix Automation Inc."},{"Symbol":"CF","Name":"CF Industries Holdings Inc","Sector":"Materials","Description":"CF Industries Holdings, Inc. is a manufacturer and distributor of nitrogen and phosphate fertilizer products worldwide. The Company operates in two segments: the nitrogen segment and the phosphate segment. The Company's principal products in the nitrogen segment are ammonia, granular urea, urea ammonium nitrate solution (UAN) and ammonium nitrate (AN).Its other nitrogen products include urea liquor, diesel exhaust fluid (DEF) and aqua ammonia, which are sold primarily to its industrial customers. Its principal products in the phosphate segment are diammonium phosphate (DAP) and monoammonium phosphate (MAP). During the year ended December 31, 2012, the Company sold 13.0 million tons of nitrogen fertilizers and 2.0 million tons of phosphate fertilizers. In May 2013, CF Industries Holdings Inc acquired 34% stake in Canadian Fertilizers Ltd."},{"Symbol":"SCHW","Name":"Charles Schwab Corporation","Sector":"Financials","Description":"The Charles Schwab Corporation (CSC) is a savings and loan holding company. The Company engages, through its subsidiaries, in securities brokerage, banking, and related financial services. The Company provides financial services to individuals and institutional clients through two segments: Investor Services and Institutional Services. The Investor Services segment provides retail brokerage and banking services to individual investors. The Institutional Services segment provides custodial, trading and support services to independent investment advisors (IAs). Its business subsidiaries include Charles Schwab & Co., Inc. (Schwab), Charles Schwab Bank and Charles Schwab Investment Management, Inc. (CSIM), which is the investment advisor for Schwab's mutual funds. In November 2011, the Company acquired Compliance11, Inc. In September 2012, GAIN Capital Holdings Inc. acquired Open E Cry, LLC. In December 2012, the Company acquired ThomasPartners, Inc."},{"Symbol":"CHTR","Name":"Charter Communications","Sector":"Consumer Discretionary","Description":"Charter Communications, Inc. (Charter) provides cable services in the United States, offering a range of entertainment, information and communications solutions to residential and commercial customers. Its infrastructure consists of a hybrid fiber coaxial cable plant passing approximately 12 million homes, with 98% of homes passed at 550 megahertz or greater and 98% of plant miles two-way active. A national Internet protocol (IP) infrastructure interconnects Charter markets. During the year ended December 31, 2011, it generated 50% revenue from its residential video service. During 2011, it also generated revenue from Internet, telephone service and advertising. As of December 31, 2011, it served approximately 5.2 million residential and commercial customers. In July 2013, Charter Communications Inc and Cablevision Systems Corp announced the completion of acquisition of Cablevision's Bresnan Broadband Holdings, LLC (Optimum West)."},{"Symbol":"CHK","Name":"Chesapeake Energy","Sector":"Energy","Description":"Chesapeake Energy Corporation (Chesapeake) is a natural gas and oil exploration and production company. Chesapeake is engaged in the exploration, development and acquisition of properties for the production of natural gas and oil from underground reservoirs. It also provides substantial marketing, midstream, drilling and other oilfield services. Its operations are located onshore and in the continental United States. As of December 31, 2011, the Company owned interests in approximately 45,700 producing natural gas and oil wells that produced approximately 3.5 billion cubic feet of natural gas equivalent per day, net to its interest. The Company operates in three segments: exploration and production; marketing, gathering and compression, and oilfield services. In June 2011, the Company acquired Bronco Drilling Company, Inc. In August 2013, SemGroup Corporation completed acquisition of the gas gathering and processing assets owned by Chesapeake Energy Corporation."},{"Symbol":"CVX","Name":"Chevron Corp.","Sector":"Energy","Description":"Chevron Corporation (Chevron) manages its investments in subsidiaries and affiliates and provides administrative, financial, management and technology support to the United States and international subsidiaries that engage in fully integrated petroleum operations, chemicals operations, mining activities, power generation and energy services. Upstream operations consist primarily of exploring for, developing and producing crude oil and natural gas; processing, transportation and regasification associated with liquefied natural gas; transporting crude oil by international oil export pipelines; transporting, storage and marketing of natural gas, and a gas-to-liquids project. Downstream operations consist primarily of refining crude oil into petroleum products; transporting crude oil and refined products by pipeline, marine vessel, motor equipment and rail car, and manufacturing and marketing of commodity petrochemicals, plastics for industrial uses and fuel and lubricant additives."},{"Symbol":"CMG","Name":"Chipotle Mexican Grill","Sector":"Consumer Discretionary","Description":"Chipotle Mexican Grill, Inc. (Chipotle) operates Chipotle Mexican Grill restaurants. Chipotle Mexican Grill restaurants serve a menu of burritos, tacos, burrito bowls (a burrito without the tortilla) and salads. As of December 31, 2012, the Company operated 1,410 restaurants, including Chipotle restaurants throughout the United States, as well as five in Canada, five in London, England, and one in Paris, France, and also one ShopHouse Southeast Asian Kitchen, a restaurant in Washington, D.C. Chipotle categorizes its restaurants as either end-caps (at the end of a line of retail outlets), in-lines (in a line of retail outlets), free-standing or other. As of December 31, 2012, of its restaurants in operation, the Company had 258 free-standing units, 861 end-cap locations, 233 in-line locations and 58 other. The average restaurant size is about 2,535 square feet and seats about 56 people. Most of its restaurants also feature outdoor patio space."},{"Symbol":"CB","Name":"Chubb Limited","Sector":"Financials","Description":"The Chubb Corporation (Chubb) is a holding company for a family of property and casualty insurance companies known as the Chubb Group of Insurance Companies (the P&C Group). The P&C Group provides property and casualty insurance to businesses and individuals worldwide. The P&C Group is divided into three business units: Chubb Personal Insurance, Chubb Commercial Insurance and Chubb Specialty Insurance. Chubb Personal Insurance offers coverage of fine homes, automobiles and other personal possessions along with options for high limits of personal liability coverage. Chubb Commercial Insurance offers a range of commercial insurance products, including coverage for multiple peril, casualty, workers' compensation and property and marine. Chubb Specialty Insurance offers a variety of professional liability products for privately and publicly owned companies, financial institutions, professional firms and healthcare organizations. Chubb Specialty Insurance also includes its surety business."},{"Symbol":"CHD","Name":"Church & Dwight","Sector":"Consumer Staples","Description":"Church & Dwight Co., Inc. develops, manufactures and markets a range of household, personal care and specialty products. The Company's brands include ARM & HAMMER, (used in multiple product categories, such as baking soda, carpet deodorization and laundry detergent), TROJAN Condoms, XTRA laundry detergent, OXICLEAN pre-wash laundry additive, NAIR depilatories, FIRST RESPONSE home pregnancy and ovulation test kits, ORAJEL oral analgesics and SPINBRUSH battery-operated toothbrushes. The Company operates in three segments: Consumer Domestic, Consumer International and Specialty Products. During the year ended December 31, 2011, the Consumer Domestic, Consumer International and Specialty Products segments represented approximately 72%, 19% and 9%, respectively, of the Company's net sales. On June 28, 2011, the Company acquired the BATISTE dry shampoo brand from Vivalis, Limited. In October 2012, it acquired Avid Health, Inc. (Avid)."},{"Symbol":"CI","Name":"CIGNA Corp.","Sector":"Health Care","Description":"Cigna Corporation (Cigna) is a holding company. Cigna is a global health service company, with insurance subsidiaries that are providers of medical, dental, disability, life and accident insurance and related products and services. In the United States, these products and services are offered through employers and other groups, and in selected international markets, Cigna offers supplemental health, life and accident insurance products and international health care coverage and services to businesses, governmental and non-governmental organizations and individuals. Cigna operates in five segments: Health Care, Disability and Life, International, Run-off Reinsurance, and Other Operations, including Corporate-owned Life Insurance. September 2013, Cigna Corporation completed its acquisition of Alegis Care, a portfolio company of Triton Pacific Capital Partners. Effective September 3, 2013, Cigna Corp acquired Home Physicians Management LLC."},{"Symbol":"XEC","Name":"Cimarex Energy","Sector":"Energy","Description":"Cimarex Energy Co. is an oil and gas exploration and production company. Its operations are focused in two main areas: the Mid-Continent region and the Permian Basin. The Mid-Continent region consists of Oklahoma, the Texas Panhandle, and southwest Kansas. Its Permian Basin region encompasses west Texas and southeast New Mexico. It also has operations in the Gulf Coast area, primarily in southeast Texas. As of December 31, 2012, its proved oil and gas reserves totaled 2.3 trillion cubic feet equivalent, consisting of 1.3 trillion cubic feet of gas and 168 million barrels of oil and natural gas liquids (liquids). Of total proved reserves, 45% are liquids and 80% are classified as proved developed. During the year ended December 31, 2012, its production averaged 626.5 million cubic feet equivalent per day, consisted of 323.8 million cubic feet of gas and 50,457 barrels of liquids. The wells it operates account for 68% of total proved reserves and approximately 80% of production."},{"Symbol":"CINF","Name":"Cincinnati Financial","Sector":"Financials","Description":"Cincinnati Financial Corporation is engaged in property casualty insurance marketed through independent insurance agents in 39 states. During the year ended December 31, 2012, the Company owned 100% of three subsidiaries: The Cincinnati Insurance Company, CSU Producer Resources Inc., and CFC Investment Company. The Company operates in five segments: Commercial lines property casualty insurance, Personal lines property casualty insurance, Excess and surplus lines property casualty insurance, Life insurance and Investments. Its standard market property casualty insurance group includes two subsidiaries: The Cincinnati Casualty Company and The Cincinnati Indemnity Company. This group writes a range of business, homeowner and auto policies."},{"Symbol":"CTAS","Name":"Cintas Corporation","Sector":"Industrials","Description":"Cintas Corporation (Cintas) provides specialized products and services to businesses of all types throughout the North America, Latin America, Europe and Asia. The Company operates in four segments: Rental Uniforms and Ancillary Products, Uniform Direct Sales, First Aid, Safety and Fire Protection Services, and Document Management Services. As of May 31, 2013, the Company provided products and services to over one million businesses. As of May 31, 2013, Cintas had approximately 8,200 local delivery routes, 446 operational facilities and eight distribution centers."},{"Symbol":"CSCO","Name":"Cisco Systems","Sector":"Information Technology","Description":"Cisco Systems, Inc. (Cisco) designs, manufactures, and sells Internet protocol (IP)-based networking and other products related to the communications and information technology (IT) industry and provide services associated with these products and their use. The Company provides a line of products for transporting data, voice, and video within buildings, across campuses, and worldwide. Its products are designed to transform how people connect, communicate, and collaborate. Its products are installed at enterprise businesses, public institutions, telecommunications companies, commercial businesses, and personal residences. The Company operates in three segments: The Americas; Europe, Middle East, and Africa (EMEA), and Asia Pacific, Japan, and China (APJC). In October 2013, Cisco Systems Inc completed the acquisition of Sourcefire, Inc. In October 2013, the Company announced that it has completed the acquisition of privately held WHIPTAIL."},{"Symbol":"C","Name":"Citigroup Inc.","Sector":"Financials","Description":"Citigroup Inc. (Citigroup) is a global diversified financial services holding company whose businesses provide consumers, corporations, governments and institutions with a broad range of financial products and services, including consumer banking and credit, corporate and investment banking, securities brokerage, transaction services and wealth management. The Company operates in two segments: Citicorp, consisting of the Company's Global Consumer Banking businesses and Institutional Clients Group, and Citi Holdings, consisting of Brokerage and Asset Management, Local Consumer Lending and Special Asset Pool. In February 2012, it sold its 9.85% interest in Housing Development Finance Corporation Ltd. In May 2012, it sold 10.1% interest in Akbank T.A.S. In September 2012, the Company sold EMI Group's recorded music division, EMI Music, to Vivendi and subsidiary, Universal Music Group. In August 2013, Pershing Square Capital Management sold 18% interest to Citigroup Inc."},{"Symbol":"CFG","Name":"Citizens Financial Group","Sector":"Financials","Description":"Citizens Financial Group, Inc. operates as the bank holding company for Citizens Bank, N.A. and Citizens Bank of Pennsylvania that provide retail and commercial banking products and services in the United States. It operates through two segments, Consumer Banking and Commercial Banking. The Consumer Banking segment focuses on retail customers and small businesses with traditional banking products and services, including checking, savings, home loans, student loans, credit cards, business loans, and financial management services. This segment also provides indirect auto finance for new and used vehicles through automotive dealerships. The Commercial Banking segment provides various financial products and solutions, including loans, leases, trade financing, deposits, cash management, foreign exchange, interest rate risk management, corporate finance, and capital markets advisory capabilities. It focuses on small and middle-market companies, and serves government banking, not-for-profit, healthcare, technology, asset finance, franchise finance, asset-based lending, commercial real estate, private equity, and sponsor finance industries. As of December 31, 2014, the company operated 1,200 branches in 11 states across the New England, Mid-Atlantic, and Midwest regions, as well as online, telephone, and mobile banking platforms. It also maintains approximately 100 retail and commercial non-branch offices located in 11 other states and the District of Columbia outside its branch footprint. The company was formerly known as RBS Citizens Financial Group, Inc. and changed its name to Citizens Financial Group, Inc. in April 2014. The company was founded in 1828 and is headquartered in Providence, Rhode Island."},{"Symbol":"CTXS","Name":"Citrix Systems","Sector":"Information Technology","Description":"Citrix Systems, Inc. is a cloud computing company. The Company designs, develops and markets technology solutions that enable information technology (IT) services. The Enterprise division and the Online Services division constitute its two segments. Its revenues are derived from sales of Enterprise division products, which include its Desktop Solutions, Datacenter and Cloud Solutions, Cloud-based Data Solutions and related technical services and from its Online Services division's Web collaboration, remote access and support services. It markets and licenses its products directly to enterprise customers, over the Web, and through systems integrators (Sis) in addition to indirectly through value-added resellers (VARs), value-added distributors (VADs) and original equipment manufacturers (OEMs). In January 2013, the Company acquired Zenprise."},{"Symbol":"CME","Name":"CME Group Inc.","Sector":"Financials","Description":"CME Group Inc. (CME Group) offer a range of global products across all asset classes based on interest rates, equity indexes, foreign exchange, energy, agricultural commodities, metals, weather and real estate. The Company's products include both exchange-traded and over-the-counter derivatives. CME Group also provides clearing and settlement services for exchange-traded contracts, as well as for cleared over-the-counter derivatives transactions. In April 2012, it acquired a 100% interest in GreenX Holdings LLC. On July 2, 2012, S&P Capital IQ, a business line of The McGraw-Hill Companies acquired London-based Credit Market Analysis Limited (CMA) from CME Group. In November 2013, CME Group Inc announced the sale of the NYMEX Building located at One North End Avenue to Brookfield Office Properties."},{"Symbol":"CMS","Name":"CMS Energy","Sector":"Utilities","Description":"CMS Energy Corporation (CMS Energy) is an energy company operating primarily in Michigan. CMS Energy is the parent holding company of several subsidiaries, including Consumers Energy Company (Consumers) and CMS Enterprises Company (CMS Enterprises). Consumers is an electric and gas utility, and CMS Enterprises, primarily a domestic independent power producer. Consumers serves individuals and businesses operating in the alternative energy, automotive, chemical, metal, and food products industries, as well as a diversified group of other industries. CMS Enterprises, through its subsidiaries and equity investments, is engaged primarily in independent power production and owns power generation facilities fueled mostly by natural gas and biomass. CMS Energy operates in three business segments: electric utility, gas utility and enterprises, its non-utility operations and investments."},{"Symbol":"COH","Name":"Coach Inc.","Sector":"Consumer Discretionary","Description":"Coach, Inc. (Coach) is a marketer of accessories and gifts for women and men. The Company offers a range of modern, fashionable handbags and accessories. Its product offerings include women's and men's bags, accessories, footwear, wearables, jewelry, travel bags, sunwear, watches and fragrance. The Company operates in two segments: North America, which includes sales to North American consumers through Company-operated stores, including the Internet, and sales to wholesale customers and distributors and International, which includes sales to consumers through Company-operated stores in Japan and mainland China, including the Internet, Hong Kong, Macau, Singapore, Taiwan, Malaysia and Korea and sales to wholesale customers and distributors in 25 countries."},{"Symbol":"KO","Name":"Coca Cola Company","Sector":"Consumer Staples","Description":"The Coca-Cola Company is a beverage company. The Company owns or licenses and markets more than 500 nonalcoholic beverage brands, primarily sparkling beverages but also a variety of still beverages, such as waters, enhanced waters, juices and juice drinks, ready-to-drink teas and coffees, and energy and sports drinks. It owns and markets a range of nonalcoholic sparkling beverage brands, which includes Coca-Cola, Diet Coke, Fanta and Sprite. The Company's segments include Eurasia and Africa, Europe, Latin America, North America, Pacific, Bottling Investments and Corporate. In January 2013, Sacramento Coca-Cola Bottling Company announced that it had been acquired by the Company. Effective February 22, 2013, Coca-Cola Co acquired interest in Fresh Trading Ltd. In November 2013, Coca-Cola Company and ZICO Beverages LLC announced that Coca-Cola has acquired the ownership interest in ZICO."},{"Symbol":"CTSH","Name":"Cognizant Technology Solutions","Sector":"Information Technology","Description":"Cognizant Technology Solutions Corporation (Cognizant) is a provider of custom information technology, consulting and business process outsourcing services. The Company is engaged in Business, Process, Operations and Information Technology Consulting, Application Development and Systems Integration, Enterprise Information Management (EIM), Application Testing, Application Maintenance, Information Technology Infrastructure Services, and Business and Knowledge Process Outsourcing, or BPO and KPO. The Company operates in four segments: Financial Services; Healthcare; Manufacturing, Retail and Logistics, and Other, which includes communications, information, media and entertainment, and high technology. In October 2013, Cognizant Technology Solutions of India acquired Equinox Consulting SAS."},{"Symbol":"CL","Name":"Colgate-Palmolive","Sector":"Consumer Staples","Description":"Colgate-Palmolive Company (Colgate) is a consumer products company whose products are marketed in over 200 countries and territories throughout the world. It operates in two segments: Oral, Personal and Home Care and Pet Nutrition. Oral Care business products include Colgate Total, Colgate Sensitive Pro-Relief, Colgate Max Fresh, Colgate Optic White and Colgate Luminous White toothpastes, Colgate 360' manual toothbrushes and Colgate and Colgate Plax mouth rinses. Colgate's Oral Care business also includes dental floss and pharmaceutical products for dentists and oral health professionals. Its Personal Care products also include Palmolive, Softsoap and Sanex brand shower gels, Palmolive, Irish Spring and Protex bar soaps and Speed Stick, Lady Speed Stick and Sanex deodorants and antiperspirants. It sells liquid hand soap under the Palmolive, Protex and Softsoap brands. Colgate, through its Hill's Pet Nutrition segment (Hill's), manufactures pet nutrition products for dogs and cats."},{"Symbol":"CMCSA","Name":"Comcast Corp.","Sector":"Consumer Discretionary","Description":"Comcast Corporation (Comcast) is a provider of entertainment, information and communications products and services. The Company operates in five segments: Cable Communications provides video, high-speed Internet and voice services (cable services) to residential and business customers; Cable Networks consists primarily of its national cable television networks, its regional sports and news networks, its international cable networks, its cable television production studio, and its related digital media properties; Broadcast Television consists primarily of its NBC and Telemundo broadcast networks, its NBC and Telemundo owned local television stations, its broadcast television production operations, and its related digital media properties; Filmed Entertainment consists of the operations of Universal Pictures., and Theme Parks consists primarily of its Universal theme parks in Orlando and Hollywood. Effective March 19, 2013, it acquired a 49% interest in NBCUniversal Media LLC."},{"Symbol":"CMA","Name":"Comerica Inc.","Sector":"Financials","Description":"Comerica Incorporated (Comerica) is a financial services company. The Company has three business segments: the Business Bank, the Retail Bank, and Wealth Management. Comerica operates in three primary geographic markets: Texas, California and Michigan. The Company's business bank meets the needs of middle market businesses, multinational corporations and governmental entities by offering various products and services, including commercial loans and lines of credit, deposits, cash management, capital market products, international trade finance, letters of credit, foreign exchange management services and loan syndication services. As of December 31, 2012, Comerica owned directly or indirectly all the stock of two active banking and 49 non-banking subsidiaries."},{"Symbol":"CAG","Name":"ConAgra Foods Inc.","Sector":"Consumer Staples","Description":"ConAgra Foods, Inc. is a packaged food company. The Company operates in four segments: Consumer Foods, Commercial Foods, Ralcorp Food Group, and Ralcorp Frozen Bakery Products. Consumers can find recognized brands such as Banquet, Chef Boyarde, Egg Beaters, Healthy Choice, Hebrew National, Hunt's, Marie Callender's, Odom's Tennessee Pride, Orville Redenbacher's, PAM, Peter Pan, Reddi-wip, Slim Jim, Snack Pack, and many other ConAgra Foods brands and products, along with food sold by ConAgra Foods under private brands, in grocery, convenience, mass merchandise, club stores, and drugstores. In January 2013, it acquired Ralcorp. Ralcorp manufactures private brand products. In September 2013, Brynwood Partners VI L.P. announced that its portfolio company, Lightlife Foods, Inc., had acquired Lightlife, one of ConAgra Foods' brands with product lines that include vegetarian-based burgers, hotdogs and other meatless frozen and refrigerated items."},{"Symbol":"CXO","Name":"Concho Resources","Sector":"Energy","Description":"Concho Resources Inc.( Concho) is an independent oil and natural gas company engaged in the acquisition, development and exploration of oil and natural gas properties. The Company's core operating areas are located in the Permian Basin region of Southeast New Mexico and West Texas, an onshore oil and natural gas basin in the United States. The Permian Basin is one of the oil and natural gas producing regions in the United States. In July 2012, it completed an acquisition of producing and non-producing assets from Three Rivers Operating Company LLC and certain affiliated entities. In February 2012, the Company sold its remaining Permian Basin assets to Concho Resources Inc.In December 2012, Concho Resources Inc closed its divestiture of certain non-core producing properties located in the Permian Basin of West Texas and Southeast New Mexico to Legacy Reserves LP."},{"Symbol":"COP","Name":"ConocoPhillips","Sector":"Energy","Description":"ConocoPhillips explores for, produces, transports and markets crude oil, natural gas, natural gas liquids, liquefied natural gas and bitumen on a worldwide basis. The portfolio includes assets in North America, Europe, Asia and Australia; growing North American shale and oil sands businesses; a number of international development projects, and a global exploration program. On May 1, 2012, the Company spun off the downstream portion of its operations to Phillips 66. In August 2012, it closed a transaction with LUKOIL for the sale of ConocoPhillips' indirect 30% interest in NaryanMarNefteGaz (NMNG) and certain related assets. In August 2013, the Company announced that it has closed a transaction with the National Gas Company of Trinidad and Tobago Limited (NGC) for the sale of its wholly owned subsidiary, Trinidad and Tobago Holdings LLC. In November 2013, the Company completed the transaction with Pertamina for the sale of its Algeria business."},{"Symbol":"ED","Name":"Consolidated Edison","Sector":"Utilities","Description":"Consolidated Edison, Inc. (Con Edison) is a holding company, which owns Consolidated Edison Company of New York, Inc. (CECONY), which delivers electricity, natural gas and steam to customers in New York City and Westchester County; Orange and Rockland Utilities, Inc. (O&R) (together with CECONY referred to as the Utilities), which delivers electricity and natural gas to customers primarily located in southeastern New York, and northern New Jersey and northeastern Pennsylvania, and competitive energy businesses, which provide retail and wholesale electricity supply and energy services. CECONY's business operations are its regulated electric, gas and steam delivery businesses. O&R's business operations are its regulated electric and gas delivery businesses. In July 2012, Consolidated Edison Development, a wholly owned subsidiary of Con Edison, and GCL Solar Energy Inc., a wholly owned subsidiary of GCL-Poly Energy Holdings Limited, acquired two solar photovoltaic projects."},{"Symbol":"STZ","Name":"Constellation Brands","Sector":"Consumer Staples","Description":"Constellation Brands, Inc., is a wine company. The Company is a marketer of imported beer in the United States. through its investment in Crown Imports, LLC (Crown Imports), a joint venture with Grupo Modelo, S.A.B. de C.V. (Modelo) pursuant to which Modelo's Mexican beer portfolio (the Modelo Brands) are imported, marketed and sold by the joint venture in the United States. The Company operates in three business segments: Constellation Wines North America (wine and spirits) (CWNA), Corporate Operations and Other, and Crown Imports.In October 5, 2011, the Company acquired the remaining 50.1% equity interest in Ruffino S.r.l. (Ruffino). In June 2013, Constellation Brands Inc completed its acquisition of Grupo Modelo's U.S. beer business from Anheuser-Busch InBev. In June 2013, Constellation Brands Inc acquired the remaining 50% interest in Crown Imports LLC."},{"Symbol":"GLW","Name":"Corning Inc.","Sector":"Information Technology","Description":"Corning Incorporated (Corning) is a global, technology-based corporation. The Company operates in five segments: Display Technologies, Telecommunications, Environmental Technologies, Specialty Materials and Life Sciences. During the year ended December 31, 2011, Corning launched Corning Lotus Glass, an environmentally friendly, display glass developed to enable technologies, including organic light-emitting diode (OLED) displays and next generation liquid crystal displays (LCD). Corning Lotus Glass helps support the demanding manufacturing processes of both OLED and liquid crystal displays for portable devices, such as smart phones, tablets, and notebook computers. In March 2011, the Company acquired all outstanding shares from the shareholders of MobileAccess. In December 2011, it acquired Mediatech, Inc. In November 2012, Corning acquired the majority of the Discovery Labware business from Becton, Dickinson and Company. In May 2013, the Company acquired Bargoa SA."},{"Symbol":"COST","Name":"Costco Co.","Sector":"Consumer Staples","Description":"Costco Wholesale Corporation (Costco) with its subsidiaries is engaged in the operation of membership warehouses in the United States and Puerto Rico, Canada, the United Kingdom, Mexico, Japan, Australia, and through majority owned subsidiaries in Taiwan and Korea. Costco buys the majority of its merchandise directly from manufacturers and route it to a cross-docking consolidation point (depot) or directly to its warehouses. The Company's depots receive container-based shipments from manufacturers and reallocate these goods for shipment to its individual warehouses, generally in less than 24hours. Costco's typical warehouse format averages approximately 143,000 square feet. The Company's warehouses generally operate on a seven-day, 69-hour week. The Company carries an average of approximately 3,300 to 3,800 active stock keeping units (SKUs) per warehouse in its core warehouse business. Many consumable products are offered for sale in case, carton, or multiple-pack quantities only."},{"Symbol":"COTY","Name":"Coty, Inc","Sector":"Consumer Staples","Description":"Coty Inc. is engage in the manufacturing, marketing and distribution of women's and men's fragrances, color cosmetics and skin and body care related products globally. The Company operates in three segments: Fragrances, Color Cosmetics and Skin & Body Care. The Company's power brands consists of adidas, Calvin Klein, Chloe, Davidoff, Marc Jacobs, OPI, philosophy, Playboy, Rimmel and Sally Hansen. The Company sells products in each of its segments through retailers, including hypermarkets, supermarkets, independent and chain drug stores and pharmacies, upscale perfumeries, upscale and mid-tier department stores, nail salons, specialty retailers, duty-free shops and traditional food, drug and mass retailers."},{"Symbol":"CCI","Name":"Crown Castle International Corp.","Sector":"Real Estate","Description":"Crown Castle International Corp. (CCIC) owns, operates and leases shared wireless infrastructure, including towers and other structures, such as rooftops (towers); distributed antenna systems (DAS)(each such system is a network of antennas for the benefit of wireless carriers and is connected by fiber to communication hubs designed to facilitate wireless communications), and interests in land under third party towers in various forms (third party land interests) (unless the context otherwise suggests or requires, references herein to wireless infrastructure include towers, DAS and third party land interests). Its core business is renting space or physical capacity (collectively, space) on its towers, DAS and, to a lesser extent, third party land interests (collectively, site rental business) through long-term contracts in various forms, including license, sublease and lease agreements (collectively, contracts). In April 2012, it acquired NextG Networks, Inc."},{"Symbol":"CSRA","Name":"CSRA Inc.","Sector":"Information Technology","Description":""},{"Symbol":"CSX","Name":"CSX Corp.","Sector":"Industrials","Description":"CSX Corporation (CSX), together with its subsidiaries, is a transportation supplier. The Company provides rail-based transportation services, including traditional rail service and the transport of intermodal containers and trailers. CSX's operating subsidiary, CSX Transportation, Inc. (CSXT), provides link to the transportation supply chain through its approximately 21,000 route mile rail network, which serves centers in 23 states east of the Mississippi River, the District of Columbia and the Canadian provinces of Ontario and Quebec. It has access to over 70 ocean, river and lake port terminals along the Atlantic and Gulf Coasts, the Mississippi River, the Great Lakes and the St. Lawrence Seaway. The Company's intermodal business links customers to railroads through trucks and terminals. CSXT also serves production and distribution facilities through track connections to approximately 240 short-line and regional railroads."},{"Symbol":"CMI","Name":"Cummins Inc.","Sector":"Industrials","Description":"Cummins Inc. is a diesel engine manufacturer. The Company designs, manufactures, distributes and services diesel and natural gas engines, electric power generation systems and engine-related component products, including filtration, exhaust aftertreatment, fuel systems, fuel systems, controls systems, air handling systems and electric power. The Company sells its products to original equipment manufacturers (OEMs), distributors and other customers worldwide. It serves its customers through a network of more than 600 company owned and independent distributor locations and more than 6,500 dealer locations in more than 190 countries and territories. It has four segments: Engine, Power Generation, Components and Distribution. In April 2011, the Company sold its exhaust business to Global Tube. In July 2012, the Company acquired the emission control assets of Hilite International in Marktheidenfeld. The Hilite assets are part of Cummins Emission Solution (CES)."},{"Symbol":"CVS","Name":"CVS Health","Sector":"Consumer Staples","Description":"CVS Caremark Corporation (CVS Caremark), together with its subsidiaries, is a pharmacy health care provider in the United States. CVS Caremark provides pharmacy services through its pharmacy benefit management (PBM), mail order and specialty pharmacy division, CVS Caremark Pharmacy Services; approximately 7,300 CVS/pharmacy retail stores; retail-based health clinic subsidiary, MinuteClinic, and its online retail pharmacy, CVS.com. The Company operates in three business segments: Pharmacy Services, Retail Pharmacy and Corporate. Its corporate segment provides management and administrative services to support the overall operations of the Company. In April 2012, Health Net, Inc.'s subsidiary, Health Net Life Insurance Company, sold its Medicare stand-alone Prescription Drug Plan (Medicare PDP) business to a subsidiary of CVS Caremark. In February 2013, it bought Drogaria Onofre."},{"Symbol":"DHI","Name":"D. R. Horton","Sector":"Consumer Discretionary","Description":"D.R. Horton, Inc. is the homebuilding companies in the United States. The Company constructs and sells homes through its operating divisions in 26 states and 77 metropolitan markets of the United States, primarily under the name of D.R. Horton, America's Builder. During the fiscal year ended September 30, 2012 (fiscal 2012), the Company closed 18,890 homes. Through its financial services operations, the Company provides mortgages financing and title agency services to homebuyers in many of its homebuilding markets. DHI Mortgage, its 100% owned subsidiary, provides mortgage financing services primarily to the Company's homebuilding customers and generally sells the mortgages it originates and the related servicing rights to third-party purchasers. In August 2012, it acquired the homebuilding operations of Breland Homes."},{"Symbol":"DHR","Name":"Danaher Corp.","Sector":"Health Care","Description":"Danaher Corporation (Danaher) designs, manufactures and markets professional, medical, industrial and commercial products and services. The Company's research and development, manufacturing, sales, distribution, service and administrative facilities are located in more than 50 countries. It operates in five segments: Test & Measurement; Environmental; Life Sciences & Diagnostics; Dental; and Industrial Technologies. In April 2011, the Company sold its Pacific Scientific Aerospace (PSA) business. On June 30, 2011, the Company acquired Beckman Coulter, Inc. (Beckman Coulter). In January 2012, the Company sold its Accu-Sort businesses. In February 2012, the Company sold its Kollmorgen Electro-Optical (KEO) business. In January 2013, the Company acquired Navman Wireless. Effective August 2, 2013, Danaher Corp acquired Teletrac Inc, a developer of transportation software, from Vector Capital."},{"Symbol":"DRI","Name":"Darden Restaurants","Sector":"Consumer Discretionary","Description":"Darden Restaurants, Inc. is a full service restaurant company. As of May 26, 2013, the Company operated through subsidiaries 2,138 restaurants in the United States and Canada. In the United States, it operated 2,105 restaurants in all 50 states, including 822 Olive Garden, 678 Red Lobster, 430 LongHorn Steakhouse, 49 The Capital Grille, 44 Yard House, 33 Bahama Breeze, 31 Seasons 52, nine Eddie V's Prime Seafood, six test synergy restaurants (which house both a Red Lobster and Olive Garden restaurant in the same building) and three Wildfish Seafood Grille restaurants. As of May 26, 2013, it operated 33 restaurants, including 27 Red Lobster and six Olive Garden restaurants in Canada. Through subsidiaries, the Company owns and operates all of its restaurants in the United States and Canada, except for three restaurants located in Florida and three restaurants in California."},{"Symbol":"DVA","Name":"DaVita Inc.","Sector":"Health Care","Description":"DaVita HealthCare Partners Inc., formerly DaVita Inc., is a provider of dialysis services in the United States for patients suffering from chronic kidney failure, also known as end stage renal disease (ESRD). As of December 31, 2011, the Company provided dialysis and administrative services through a network of 1,809 outpatient dialysis centers located in the United States throughout 43 states and the District of Columbia, serving a total of approximately 142,000 patients. It also provides acute inpatient dialysis services in approximately 900 hospitals and related laboratory services throughout the United States. In July 2013, DaVita, a division of DaVita HealthCare Partners Inc announced the acquisition of the dialysis operations of Malaysia's Caring Dialysis Centre Group (CDC Group) by DVA (Malaysia) Sdn Bhd."},{"Symbol":"DE","Name":"Deere & Co.","Sector":"Industrials","Description":"Deere & Company (John Deere) along with its subsidiaries, operates in three segments: agriculture and turf, construction and forestry and financial services. The John Deere agriculture and turf segment manufactures and distributes a line of agricultural and turf equipment and related service parts. John Deere construction, earthmoving, material handling and forestry equipment includes a broad range of backhoe loaders, crawler dozers and loaders, four-wheel-drive loaders, excavators, motor graders, articulated dump trucks, landscape loaders, skid-steer loaders, log skidders, log feller bunchers, log loaders, log forwarders, log harvesters and a range of attachments. The financial services segment primarily finances sales and leases by John Deere dealers of new and used agriculture and turf equipment and construction and forestry equipment."},{"Symbol":"DLPH","Name":"Delphi Automotive","Sector":"Consumer Discretionary","Description":"Delphi Automotive PLC (Delphi) is a global vehicle components manufacturer and provides electrical and electronic, powertrain, safety and thermal technology solutions to the global automotive and commercial vehicle markets. As of December 31, 2012, the Company operated 126 manufacturing facilities and 15 technical centers utilizing a regional service model that enables it to serve its global customers. The Company operates through four segments: Electrical / Electronic Architecture; Powertrain Systems; Electronics and Safety and Thermal Systems. In October 2012, the Company acquired FCI Group's Motorized Vehicles Division."},{"Symbol":"DAL","Name":"Delta Air Lines","Sector":"Industrials","Description":"Delta Air Lines, Inc. (Delta) provides scheduled air transportation for passengers and cargo throughout the United States and around the world. The Company's route network gives it a presence in every domestic and international market. Delta's route network is centered around the hub system it operate at airports in Amsterdam, Atlanta, Cincinnati, Detroit, Memphis, Minneapolis-St. Paul, New York-JFK, Paris-Charles de Gaulle, Salt Lake City and Tokyo-Narita. Each of these hub operations includes flights that gather and distribute traffic from markets in the geographic region surrounding the hub to domestic and international cities and to other hubs. The Company's network is supported by a fleet of aircraft that is varied in terms of size and capabilities. In June 2013, Delta Air Lines Inc acquired a 49% stake in Virgin Atlantic Airways Ltd."},{"Symbol":"XRAY","Name":"Dentsply Sirona","Sector":"Health Care","Description":"DENTSPLY International Inc. (DENTSPLY) is a designer, developer, manufacturer and marketer of a range of dental products. The Company operates in four segments, all of which are primarily engaged in the design, manufacture and distribution of dental products in four principal categories: dental consumables, dental laboratory products, dental specialty products and consumable medical device products. DENTSPLY conducts its business in over 120 foreign countries, principally through its foreign subsidiaries. It operates in Canada, the European market, which includes Germany, Switzerland, France, Italy, and the United Kingdom. It also has a market presence in Central and South America, South Africa and Pacific Rim. It has also established marketing activities in Moscow, Russia. On August 31, 2011, the Company acquired Astra Tech AB. In November 2013, the Company acquired QAHR, a direct dental selling organization with headquarters in Hong Kong and operations also in mainland China."},{"Symbol":"DVN","Name":"Devon Energy Corp.","Sector":"Energy","Description":"Devon Energy Corporation (Devon) is an independent energy company engaged primarily in the exploration, development and production of oil, natural gas and natural gas liquids (NGLs). The Company's operations are concentrated in various North American onshore areas in the United States and Canada. The Company also owns natural gas pipelines, plants and treatment facilities in many of its producing areas. The Company holds 14 million net acres, of which roughly two-thirds are undeveloped. The Company's properties in the United States include Barnett Shale, Cana-Woodford Shale, Permian Basin , Gulf Coast/East Texas, Granite Wash , and Mississippian. Its properties in Canada include Jackfish, Pike, Lloydminster. In August 2013, Meritage Midstream Services II, LLC acquired Thunder Creek Gas Services, LLC (Thunder Creek) from Devon and PVR Partners, L.P (PVR). In November 2013, the Company acquired GeoSouthern Energy's assets in the Eagle Ford oil play."},{"Symbol":"DLR","Name":"Digital Realty Trust","Sector":"Real Estate","Description":"Digital Realty Trust, Inc. is a real estate investment trust (REIT). The Company owns, acquires, develops, redevelops and manages technology-related real estate. The Company's operates through Digital Realty Trust, L.P. and owns a 97.8% common general partnership interest. Digital Realty Trust, L.P. holds substantially all the assets of the Company and holds the ownership interests in the Company's joint ventures. As of December 31, 2012, it owned 117 properties, excluding three properties held as investments in unconsolidated joint ventures, of which 92 are located throughout North America, 21 are located in Europe and one is located in Asia. In March 2013, it completed the acquisition of 371 Gough Road in Markham, Ontario (Canada), a 120,000 square foot data center development property. In September 2013, the Company announced the completion of the acquisition of a 15,000 square meter site in Osaka."},{"Symbol":"DFS","Name":"Discover Financial Services","Sector":"Financials","Description":"Discover Financial Services is a direct banking and payment services company. The Company is a bank holding company and a financial holding company. The Company offer credit cards, student loans, personal loans and deposit products through its Discover Bank subsidiary and home loans through its Discover Home Loans, Inc. subsidiary (Discover Home Loans). The Company operates the Discover Network, its credit card payments network; the PULSE network (PULSE), its automated teller machine (ATM), debit and electronic funds transfer network, and Diners Club International (Diners Club), its global payments network. The Company operates in two segments: Direct Banking and Payment Services. In June 2012, Tree.Com Inc sold the operating assets of its Home Loan Center, Inc. business to a wholly owned subsidiary of Discover Financial Services."},{"Symbol":"DISCA","Name":"Discovery Communications-A","Sector":"Consumer Discretionary","Description":"Discovery Communications, Inc. (Discovery) is a global nonfiction media and entertainment company that provide programming across multiple distribution platforms worldwide. Discovery operates in three segments: U.S. Networks, International Networks and Education and Other. The Company's U.S. Networks, consists principally of domestic cable and satellite television networks, Websites and other digital media services. Its International Networks consists primarily of international cable and satellite television networks and Websites. It's Education and other consists principally of curriculum-based education product and service offerings and postproduction audio services. In November 2013, the Company announced it has acquired Espresso Group Limited, provider of primary school digital education content in the United Kingdom."},{"Symbol":"DISCK","Name":"Discovery Communications-C","Sector":"Consumer Discretionary","Description":"Discovery Communications, Inc. (Discovery) is a global nonfiction media and entertainment company that provide programming across multiple distribution platforms worldwide. Discovery operates in three segments: U.S. Networks, International Networks and Education and Other. The Company's U.S. Networks, consists principally of domestic cable and satellite television networks, Websites and other digital media services. Its International Networks consists primarily of international cable and satellite television networks and Websites. It's Education and other consists principally of curriculum-based education product and service offerings and postproduction audio services. In November 2013, the Company announced it has acquired Espresso Group Limited, provider of primary school digital education content in the United Kingdom."},{"Symbol":"DG","Name":"Dollar General","Sector":"Consumer Discretionary","Description":"Dollar General Corporation is a discount retailer in the United States by number of stores, with 9,961 stores located in 39 states as of March 2, 2012, primarily in the southern, southwestern, midwestern and eastern United States. The Company offers a selection of merchandise, including consumables, seasonal, home products and apparel. The Company's merchandise includes national brands from manufacturers, as well as private brand selections with prices at substantial discounts to national brands. It offers its merchandise at everyday low prices through its convenient small-box (approximately 7,200 square feet) locations. During the fiscal year ended February 3, 2012 (fiscal 2011), it opened 625 stores and remodeled or relocated 575 stores, and closed 60 stores. Its small box stores offer consumable items, including packaged and refrigerated foods."},{"Symbol":"DLTR","Name":"Dollar Tree","Sector":"Consumer Discretionary","Description":"Dollar Tree, Inc. (Dollar Tree) is an operator of discount variety stores offering merchandise at the fixed price. As of January 28, 2012, the Company operated 4,351 discount variety retail stores. Its stores operate under the names of Dollar Tree, Deal$, Dollar Tree Deal$, Dollar Giant and Dollar Bills. As of January 28, 2012, it operated 4,252 stores in 48 states and the District of Columbia, as well as 99 stores in Canada. It buys approximately 58% to 60% of its merchandise domestically and imports the remaining 40% to 42%. Its domestic purchases include basic, seasonal, closeouts and promotional merchandise. It maintains a selection of products within variety store categories. During the fiscal year ended January 28, 2012 (fiscal 2011), the Company opened 278 new stores."},{"Symbol":"D","Name":"Dominion Resources","Sector":"Utilities","Description":"Dominion Resources, Inc. (Dominion), is a producer and transporter of energy. The Company is a provider of electricity, natural gas and related services to customers primarily in the eastern region of the United States Dominion's portfolio of assets includes approximately 27,500 megawatts of generating capacity, 6,300 miles of electric transmission lines, 56,900 miles of electric distribution lines, 11,000 miles of natural gas transmission, gathering and storage pipeline and 21,800 miles of gas distribution pipeline, exclusive of service lines of two inches in diameter or less. Dominion also operates one of the underground natural gas storage systems, with approximately 947 billion cubic feet of storage capacity, and serves nearly six million utility and retail energy customers in 15 states. In July 2013, Dominion Resources Inc acquired three solar-power development projects near Indianapolis, Ind., from Sunrise Energy Ventures."},{"Symbol":"DOV","Name":"Dover Corp.","Sector":"Industrials","Description":"Dover Corporation (Dover) manufactures a range of specialized products and components and also offers related services and consumables. The Company operates in four segments: Communication Technologies, Energy, Engineered Systems, and Printing & Identification. In July 2014, the Company announced that it has completed the sale of DEK Printing Machines unit (DEK). In July 2014, Dover acquired The WellMark Company. In August 2014, the Company acquired Liquip International."},{"Symbol":"DOW","Name":"Dow Chemical","Sector":"Materials","Description":"The Dow Chemical Company combines the power of science and technology to passionately innovate what is essential to human progress. The Company connects chemistry and innovation with the principles of sustainability to help address many of the problems, such as the need for clean water, renewable energy generation and conservation, and increasing agricultural productivity. The Company conducts its worldwide operations through global businesses, which are reported in six operating segments: Electronic and Functional Materials, Coatings and Infrastructure Solutions, Agricultural Sciences, Performance Materials, Performance Plastics, and Feedstocks and Energy. In December 2013, W. R. Grace & Co announced that it has completed the acquisition of the assets of the Polypropylene Licensing and Catalysts business of The Dow Chemical Company."},{"Symbol":"DPS","Name":"Dr Pepper Snapple Group","Sector":"Consumer Staples","Description":"Dr Pepper Snapple Group, Inc. (DPS) is an integrated brand owner, manufacturer and distributor of non-alcoholic beverages in the United States, Canada and Mexico with a diverse portfolio of flavored (non-cola) carbonated soft drinks (CSDs) and non-carbonated beverages (NCBs), including ready-to-drink teas, juices, juice drinks and mixers. The Company operates in three segments: Beverage Concentrates, Packaged Beverages and Latin America Beverages. The Company primarily serves two groups of customers: bottlers and distributors and retailers. As of December 31, 2011, it operated 20 manufacturing facilities across the United States and Mexico, excluding its manufacturing facility for its joint venture with Acqua Minerale San Benedetto. Effective March 1, 2013, it acquired Dr. Pepper/7-UP Bottling Co of the West, a producer and wholesaler of bottled soft drinks."},{"Symbol":"DTE","Name":"DTE Energy Co.","Sector":"Utilities","Description":"DTE Energy Company (DTE Energy) , is a diversified energy company. The Company is engaged in utility operations consist primarily of Detroit Edison and MichCon. The Electric Utility segment consists principally of Detroit Edison. The Gas Utility segment consists of MichCon and Citizens. Its non-utility operations include Gas Storage and Pipelines. Unconventional Gas Production is engaged in unconventional gas and oil project development and production. Power and Industrial Projects consists of projects that deliver energy and utility-type products and services to industrial, commercial and institutional customers; provide coal transportation and marketing, and sell electricity from biomass-fired energy projects. Energy Trading consists of energy marketing and trading operations. Corporate and Other includes various holding company activities and holds certain non-utility debt and energy-related investments."},{"Symbol":"DD","Name":"Du Pont (E.I.)","Sector":"Materials","Description":"Dupont E I De Nemours & Co, formerly E. I. du Pont de Nemours and Company, manufacturing, seed production or selling activities and some are distributors of products manufactured by the Company. The Company's segments are Agriculture, Electronics & Communications, Industrial Biosciences, Nutrition & Health, Performance Chemicals, Performance Coatings, Performance Materials, Safety & Protection and Pharmaceuticals. During the year ended December 31, 2011, the Electronics & Communications segment completed the acquisition of Innovalight, Inc., a company specializing in advanced silicon inks and process technologies that increase the efficiency of crystalline silicon solar cells. As of September 22, 2011, it acquired Danisco A/S (Danisco), a global enzyme and specialty food ingredients company. In May 2012, it acquired from Bunge full ownership of the Solae, LLC joint venture. In February 2013, the Company sold DuPont Performance Coatings."},{"Symbol":"DUK","Name":"Duke Energy","Sector":"Utilities","Description":"Duke Energy Corporation (Duke Energy) is an energy company. Duke Energy operates in the United States primarily through its direct and indirect wholly owned subsidiaries, Duke Energy Carolinas, LLC (Duke Energy Carolinas), Carolina Power & Light Company d/b/a Progress Energy Carolinas, Inc. (Progress Energy Carolinas), Florida Power Corporation d/b/a Progress Energy Florida, Inc. (Progress Energy Florida), Duke Energy Ohio, Inc. (Duke Energy Ohio), and Duke Energy Indiana, Inc. (Duke Energy Indiana), as well as in Latin America through Duke Energy International, LLC (DEI). Duke Energy's segment includes U.S. Franchised Electric and Gas (USFE&G), Commercial Power and International Energy. In December 2012, the Company's subsidiary acquired CGE Group's Iberoamericana de Energia Ibener S.A. (Ibener) subsidiary in Chile. In June 2013, Duke Energy Corp acquired an undisclosed minority stake in Clean Power Finance Inc."},{"Symbol":"DNB","Name":"Dun & Bradstreet","Sector":"Industrials","Description":"The Dun & Bradstreet Corporation (D&B) is the source of commercial information and insight on businesses, enabling customers to Decide with Confidence. As of December 31, 2012, the Company's global commercial database contained more than 220 million business records. The database is enhanced by its DUNSRight Quality Process, which transforms commercial data into valuable insight which is the foundation of its global solutions. Customers use D&B Risk Management Solutions to mitigate credit and supplier risk, increase cash flow and drive profitability; D&B Sales & Marketing Solutions to provide data management capabilities that provide marketing solutions to increase revenue from new and existing customers, and D&B Internet Solutions to convert prospects into clients by enabling business professionals to research companies, executives and industries."},{"Symbol":"ETFC","Name":"E*Trade","Sector":"Financials","Description":"E*TRADE Financial Corporation (E*TRADE) is a financial services company, which provides online brokerage and related products and services primarily to individual retail investors under the brand E*TRADE Financial. The Company also provides investor-focused banking products, primarily sweep deposits and savings products, to retail investors. E*TRADE operates in two segments: trading and investing and balance sheet management. Trading and investing includes retail brokerage products and services; investor-focused banking products; market making, and corporate services. Balance sheet management includes the management of asset allocation and credit, liquidity and interest rate risk; loans previously originated or purchased from third parties, and customer cash and deposits. The Company's subsidiaries include E*TRADE Bank, E*TRADE Securities LLC, E*TRADE Clearing LLC and E*TRADE Capital Markets, LLC."},{"Symbol":"EMN","Name":"Eastman Chemical","Sector":"Materials","Description":"Eastman Chemical Company (Eastman) is a global specialty chemicals company that produces a range of advanced materials, chemicals and fibers that are found in products people use every day. Eastman has over 40 manufacturing sites in 16 countries and equity interests in joint ventures that supply chemicals, plastics, and fibers products to customers throughout the world. Eastman has a portfolio of specialty businesses that hold positions and provide products that enhance performance in a variety of end markets such as transportation, building and construction, and consumables. Eastman management believes that the Company's end-market diversity is a source of strength, as these markets are benefiting from longer-term global trends such as energy efficiency, a rising middle class in emerging economies, and increased health and wellness. On July 2, 2012, the Company completed its acquisition of Solutia Inc. (Solutia)."},{"Symbol":"ETN","Name":"Eaton Corporation","Sector":"Industrials","Description":"No Description Available"},{"Symbol":"EBAY","Name":"eBay Inc.","Sector":"Information Technology","Description":"eBay Inc is a global technology company that enables commerce through three reportable segments: Marketplaces, Payments, and GSI. The Company by providing online platforms, tools and services to help individuals and small, medium and merchants around the globe engage in online and mobile commerce and payments, the Company can facilitate transactions. The company also generates revenue through marketing services, classifieds and advertising. The Company has also created an open source platform that provides software developers and merchants access to its applications programming interfaces, or APIs, to develop software and solutions for commerce. Its developer community includes more than 800,000 members. Effective July 4, 2013, eBay Inc acquired 2ememain.be and 2dehands.be, providers of e-commerce retail services. Effective September 6, 2013, eBay Inc acquired Decide Inc. Effective September 27, 2013, eBay Inc acquired Bureau of Trade."},{"Symbol":"ECL","Name":"Ecolab Inc.","Sector":"Materials","Description":"Ecolab Inc. (Ecolab) develops and markets products and services for the hospitality, foodservice, healthcare and industrial markets. The Company provides cleaning and sanitizing products and programs, as well as pest elimination, equipment maintenance and repair services primarily to customers in the foodservice, food and beverage processing, hospitality, healthcare, government and education, retail, textile care, commercial facilities management and vehicle wash sectors. The Company business segments include United States Cleaning & Sanitizing segment, United States Other Services segment, International segment, Water Services segment, Paper Services segment and Energy Services segment. In April 2013, it acquired Champion Technologies and its related company Corsicana Technologies. In August 2013, Ecolab Inc. sold all the capital equipment design and build business of its Mobotec air emissions control business to The Power Industrial Group."},{"Symbol":"EIX","Name":"Edison Int'l","Sector":"Utilities","Description":"Edison International, is a holding company of Southern California Edison Company (SCE). SCE is a public utility primarily engaged in the business of supplying electricity to an approximately 50,000 square-mile area of southern California. The SCE service territory contains a population of nearly 14 million people and SCE serves the population through approximately 5 million customer accounts. In August 2013, Edison International completed the acquisition of SoCore Energy, LLC."},{"Symbol":"EW","Name":"Edwards Lifesciences","Sector":"Health Care","Description":"Edwards Lifesciences Corporation (Edwards Lifesciences) is focused on technologies that treat structural heart disease and critically ill patients. A pioneer in the development and commercialization of heart valve products, Edwards Lifesciences is the manufacturer of tissue heart valves and repair products used to replace or repair a patient's diseased or defective heart valve. The Company also provides hemodynamic monitoring systems used to measure a patient's cardiovascular function in the hospital setting. The products and technologies provided by Edwards Lifesciences to treat advanced cardiovascular disease or critically ill patients are categorized into three main areas: Surgical Heart Valve Therapy, which combines surgical heart valves and Cardiac Surgery Systems; Transcatheter Heart Valves; and Critical Care, which includes Vascular. In October 2012, it acquired BMEYE B.V."},{"Symbol":"EA","Name":"Electronic Arts","Sector":"Information Technology","Description":"Electronic Arts Inc. develops, markets, publishes and distributes game software content and services that can be played by consumers on a variety of video game machines and electronic devices. The Company provides games for mobile devices and Internet-only games, such as its free-to-play offerings that are available only through online and wireless delivery and also offers multi-player online games and game services on a free-to-play and subscription basis. The Company's portfolio of brands includes wholly owned brands, such as Battlefield, Mass Effect, Need for Speed, The Sims, Bejeweled, and Plants v. Zombies. Its portfolio also includes brands based on licensed intellectual property, including sports-based brands, such as Madden NFL and FIFA. The Company operates development studios (which develop products and perform other related functions) in North America, Europe, Asia and Australia."},{"Symbol":"EMR","Name":"Emerson Electric Company","Sector":"Industrials","Description":"Emerson Electric Co. (Emerson) is a diversified global technology company. The Company is engaged in designing and supplying products and technology, and delivering engineering services and solutions in a range of industrial, commercial and consumer markets globally. The Company operates in five business segments: Process Management, Industrial Automation, Network Power, Commercial and Residential Solutions, and Climate Technologies. The Company's production operations are electronics assembly, metal stamping, forming, casting, machining, welding, plating, heat treating, painting and assembly. In April 2012, it acquired the Marine Container and Boiler business of Johnson Controls, Inc. In September 2012, it sold Knaack, L.L.C. to Werner Co. In October 2013, Emerson Electric Co acquired Enardo LLC. In November 2013, the Company sold 51% interest in its computing and power business to Platinum Equity."},{"Symbol":"ETR","Name":"Entergy Corp.","Sector":"Utilities","Description":"Entergy Corporation (Entergy) is an integrated energy company engaged primarily in electric power production and retail distribution operations. It owns and operates power plants with approximately 30,000 megawatts of electric generating capacity, including more than 10,000 megawatts of nuclear power. Entergy delivers electricity to 2.8 million utility customers in Arkansas, Louisiana, Mississippi and Texas. Entergy operates through two business segments: Utility and Entergy Wholesale Commodities. The Utility business segment includes the generation, transmission, distribution, and sale of electric power in portions of Arkansas, Mississippi, Texas, and Louisiana, including the City of New Orleans; and operates a small natural gas distribution business. The Entergy Wholesale Commodities business segment includes the ownership and operation of six nuclear power plants located in the northern United States and the sale of the electric power produced by those plants to wholesale customers."},{"Symbol":"EVHC","Name":"Envision Healthcare","Sector":"Health Care","Description":"Envision Healthcare Holdings, Inc., is a provider of physician-led, outsourced medical services in the United States. The Company offers a range of clinically-based and coordinated care solutions across the patient continuum from medical transportation to hospital encounters to comprehensive care alternatives in various settings. The Company conduts its business primarily through two operating subsidiaries, EmCare Holdings, Inc. (EmCare) and American Medical Response, Inc. (AMR). The Company markets its services primarily under the EmCare and AMR brands. EmCareis a provider of integrated facility-based physician services, including emergency, anesthesiology, hospitalist/inpatient care, radiology, tele-radiology and surgery. EmCare also offers physician-led care management solutions outside the hospital. AMR is a provider and manager of community-based medical transportation services, including emergency (911), non-emergency, and managed transportation."},{"Symbol":"EOG","Name":"EOG Resources","Sector":"Energy","Description":"EOG Resources, Inc.(EOG) explores , develops, produces and markets crude oil and natural gas primarily in producing basins in the United States of America , Canada, The Republic of Trinidad and Tobago (Trinidad), the United Kingdom , The People's Republic of China (China), the Argentine Republic (Argentina) and, from time to time, select other international areas. As of December 31, 2012, EOG's total estimated net proved reserves were 1,811 million barrels of oil equivalent, of which 701 million barrels were crude oil and condensate reserves, 320 million barrels were natural gas liquids (NGLs) reserves and 4,740 billion cubic feet, or 790 million barrels of oil equivalent, were natural gas. EOG's operations are all crude oil and natural gas exploration and production related."},{"Symbol":"EQT","Name":"EQT Corporation","Sector":"Energy","Description":"EQT Corporation (EQT) conducts its business through three business segments: EQT Production, EQT Midstream and Distribution. EQT Production is a natural gas producer in the Appalachian Basin with 5.4 trillion cubic feet equivalent of proved reserves across 3.5 million acres, as of December 31, 2011. EQT Midstream provides gathering, transmission and storage services for the Company's produced gas and to independent third parties in the Appalachian Basin. Distribution, through its regulated natural gas distribution subsidiary, Equitable Gas Company, LLC (Equitable Gas), distributes and sells natural gas to residential, commercial and industrial customers in southwestern Pennsylvania, West Virginia and eastern Kentucky; operates a small gathering system in Pennsylvania, and provides off-system sales activities, which include the purchase and delivery of gas to customers. On February 1, 2011, EQT Midstream sold Langley and the associated NGL pipeline to MarkWest Energy Partners, L.P."},{"Symbol":"EFX","Name":"Equifax Inc.","Sector":"Industrials","Description":"Equifax Inc. is a provider of information solutions for businesses and consumers. The Company's clients and customers include financial institutions, corporations, governments and individuals. Its products and services are based on databases of consumer and business information derived from various types of credit, financial, employment, income, public record, demographic and marketing data. The Company operates in five segments: U.S. Consumer Information Solutions (USCIS), International, TALX Workforce Solutions, North America Personal Solutions and North America Commercial Solutions. On May 31, 2011, the Company completed the merger of its Brazilian business with Boa Vista Servicos S.A. On February 6, 2013, Nationstar Mortgage Holdings Inc acquired Equifax Settlement Services Holding, LLC from the Company. In July 2013, Equifax Inc. announced it has acquired TrustedID."},{"Symbol":"EQIX","Name":"Equinix","Sector":"Real Estate","Description":"Equinix, Inc. (Equinix) connects businesses with partners and customers worldwide through a global platform of data centers. The Company connects approximately 4000 customers, across the Americas, Europe, Middle East and Africa (EMEA) and Asia-Pacific. Platform Equinix combines international business exchange (IBX) data centers, a global footprint and ecosystems. The Company offers each customer a choice of business partners and solutions based on their colocation, interconnection and managed IT service needs. Equinix offers customers direct interconnection to an aggregation of bandwidth providers, including the Internet Service Providers (ISPs), broadband access networks and international carriers. Its customers include carriers and other bandwidth providers, cloud and information technology services providers, content providers, financial companies and global enterprises. On July 2, 2012, (the ancotel Acquisition Date), the Company acquired a privately-held company in Germany."},{"Symbol":"EQR","Name":"Equity Residential","Sector":"Real Estate","Description":"Equity Residential (EQR) is a real estate investment trust (REIT). The Company is focused on the acquisition, development and management of multi-family residential properties, which includes the generation of rental and other related income through the leasing of apartment units to residents, in United States. ERP Operating Limited Partnership (or Operating Partnership), which is an Illinois limited partnership, conducts the multifamily residential property business of EQR. All of the Company's property ownership, development and related business operations are conducted through the Operating Partnership. The Operating Partnership holds all of the assets of the Company, including the Company's ownership interests in its joint ventures. In December 2012, it acquired four multifamily properties totaling 1,134 units."},{"Symbol":"ESS","Name":"Essex Property Trust, Inc.","Sector":"Real Estate","Description":"Essex Property Trust, Inc. (Essex) operates as a self-administered and self-managed real estate investment trust (REIT). The Company is engaged primarily in the ownership, operation, management, acquisition, development and redevelopment of apartment communities. As of December 31, 2012, the Company owned or held an interest in 163 communities, aggregating 33,468 units, located along the West Coast, as well as five commercial buildings (totaling approximately 315,900 square feet), and five active development projects with 2,495 units in various stages of development (collectively, the Portfolio). The Company owns all of its interest in its real estate investments directly or indirectly through Essex Portfolio, L.P. (the Operating Partnership). The Company is the sole general partner of the Operating Partnership and as of December 31, 2012 owns a 94.5% general partnership interest. During the year ended December 31, 2012, the Company acquired 15 communities."},{"Symbol":"EL","Name":"Estee Lauder Cos.","Sector":"Consumer Staples","Description":"The Estee Lauder Companies Inc. is a manufacturer and marketer of skin care, makeup, fragrance and hair care products. The Company's products are sold in over 150 countries and territories under a number of brand names, including Estee Lauder, Aramis, Clinique, Origins, M.A.C, Bobbi Brown, La Mer and Aveda. It is also the global licensee for fragrances and/or cosmetics sold under brand names, such as Tommy Hilfiger, Donna Karan, Michael Kors, Tom Ford and Coach. It sells its products principally through limited distribution channels to complement the images associated with its brands. These channels include over 30,000 points of sale, consisting of upscale department stores, specialty retailers, upscale perfumeries and pharmacies and prestige salons and spas."},{"Symbol":"ES","Name":"Eversource Energy","Sector":"Utilities","Description":"EnergySolutions, Inc. (EnergySolutions) is a provider of a range of nuclear services to government and commercial customers. The Company's range of nuclear services includes engineering, in-plant support services, spent nuclear fuel management, decontamination and decommissioning (D&D), operation of nuclear reactors, logistics, transportation, processing and low-level radioactive waste (LLRW) disposal. The Company also owns and operates strategic processing and disposal facilities. The Global Commercial Group includes three business divisions: Commercial Services, Logistics, Processing and Disposal (LP&D) and International. In May 2013, Energy Capital Partners II LLC, a unit of Energy Capital Partners, through its wholly owned subsidiary, acquired the entire share capital of EnergySolutions Inc."},{"Symbol":"EXC","Name":"Exelon Corp.","Sector":"Utilities","Description":"Exelon Corporation (Exelon) is an energy provider and holding company for several energy businesses. Exelon is engaged in the energy generation business through its Exelon Generation Company, LLC (Generation) subsidiary; wholesale and retail energy sales through its Constellation business unit, and the energy delivery business through its Baltimore Gas and Electric (BGE), Commonwealth Edison Company (ComEd) and PECO Energy Company (PECO) subsidiaries. It operates in 47 states, the District of Columbia and Canada. Exelon Generation has approximately 35,000 megawatts of owned capacity. Constellation provides energy products and services to approximately 100,000 business and public sector customers and approximately 1 million residential customers. Exelon's utilities deliver electricity and natural gas to more than 6.6 million customers in central Maryland, northern Illinois and southeastern Pennsylvania. On March 12, 2012, Constellation Energy Group, Inc. merged into Exelon."},{"Symbol":"EXPE","Name":"Expedia Inc.","Sector":"Consumer Discretionary","Description":"Expedia, Inc. (Expedia) is an online travel company. As of December 31, 2011, the Company's portfolio of travel brands featuring supply portfolio, including over 145,000 hotels in 200 countries, 300 airlines, packages, rental cars, cruises, as well as destination services and activities. Its portfolio of brands includes Expedia.com, a service online travel agency with sites in over 25 countries; luxury travel specialist, Classic Vacations; destination services and concierge services provider Expedia Local Expert (ELE); Expedia CruiseShipCenters; Egencia, the corporate travel management company; eLong, Inc. (eLong). In November 2011, Renren Inc. sold eLong, Inc. to Expedia, Inc. On December 20, 2011, the Company completed the spin-off of TripAdvisor, Inc., which includes its brand, as well as 18 other travel media brands. During the year ended December 31, 2011, the Company acquired Travelforce and Traveldoo."},{"Symbol":"EXPD","Name":"Expeditors Int'l","Sector":"Industrials","Description":"Expeditors International of Washington, Inc. is engaged in the business of providing global logistics services. The Company offers its customers a seamless international network supporting the movement and strategic positioning of goods. The Company's services include the consolidation or forwarding of air and ocean freight. In each United States office, and in many overseas offices, the Company acts as a customs broker. The Company also provides additional services including value-added distribution, vendor consolidation, cargo insurance, domestic time definite transportation services, purchase order management and customized logistics solutions."},{"Symbol":"ESRX","Name":"Express Scripts","Sector":"Health Care","Description":"No Description Available"},{"Symbol":"EXR","Name":"Extra Space Storage","Sector":"Real Estate","Description":"Extra Space Storage Inc. is a self-administered and self-managed real estate investment trust (REIT). The Company owns, operates, manages, acquires, develops and redevelops professionally managed self-storage facilities. As of December 31, 2011, Extra Space Storage Inc. held ownership interests in 697 operating properties. Of these operating properties, 356 are wholly owned, and 341 are owned in joint venture partnerships. An additional 185 operating properties that are owned by franchisees or third-parties in exchange for a management fee, bringing the total number of operating properties, which it owns and/or manages to 882. The Company operates in three segments: property management, acquisition and development; rental operations, and tenant reinsurance."},{"Symbol":"XOM","Name":"Exxon Mobil Corp.","Sector":"Energy","Description":"Exxon Mobil Corporation (Exxon Mobil) is a manufacturer and marketer of commodity petrochemicals, including olefins, aromatics, polyethylene and polypropylene plastics and a range of specialty products. The Company has a number of divisions and affiliates with names that include ExxonMobil, Exxon, Esso or Mobil. Divisions and affiliated companies of ExxonMobil operate or market products in the United States and other countries of the world. Their principal business is energy, involving exploration for, and production of, crude oil and natural gas, manufacture of petroleum products and transportation and sale of crude oil, natural gas and petroleum products. In January 2012, Apache Corporation acquired Exxon Mobil's Mobil North Sea Limited assets including the Beryl field and related properties. In April 2013, BNK Petroleum (US) Inc. sold Tishomingo Field, Oklahoma assets other than the Caney and upper Sycamore formations to XTO Energy Inc., a subsidiary of Exxon Mobil Corporation."},{"Symbol":"FFIV","Name":"F5 Networks","Sector":"Information Technology","Description":"F5 Networks, Inc. is a provider of Application Delivery Networking (ADN) technology that secures and optimizes the delivery of network-based applications and the security, performance and availability of servers, and other network resources. The Company's principal products are application delivery controllers (ADCs) that include the Company's BIG-IP family of appliances and its line of scalable VIPRION systems. These products are deployed in front of Web and application servers, balancing traffic and performing compute-intensive functions, such as encrypting and un-encrypting transmissions, screening traffic for security threats, maintaining open connections with servers, speeding the flow of traffic, managing access to applications and data and a range of other functions that improve the security, performance, and availability of applications. In February 2012, the Company acquired Traffix Systems."},{"Symbol":"FB","Name":"Facebook, Inc.","Sector":"Information Technology","Description":"Facebook, Inc. (Facebook) is engaged in building products to create utility for users, developers, and advertisers. People use Facebook to stay connected with their friends and family, to discover what is going on in the world around them, and to share and express what matters to them to the people they care about. Developers can use the Facebook Platform to build applications and Websites that integrate with Facebook to reach its global network of users and to build personalized and social products. Advertisers can engage with more than 900 million monthly active users (MAUs) on Facebook or subsets of its users based on information they have chosen to share with the Company, such as their age, location, gender, or interests. In September 2013, Mail.Ru Group Limited sold its remaining shares in Facebook Inc. Effective September 25, 2013, Facebook Inc acquired Mobile Technologies, a developer of online applications. In October 2013, Facebook Inc acquired Onavo Inc."},{"Symbol":"FAST","Name":"Fastenal Co","Sector":"Industrials","Description":"Fastenal Company is engaged in selling industrial and construction supplies in a wholesale and retail fashion. The industrial and construction supplies are grouped into eleven product lines. The Company distributes the supplies through a network of approximately 2,600 company owned stores. Most of its customers are in the manufacturing and non-residential construction markets. The manufacturing market includes both original equipment manufacturers (OEM) and maintenance and repair operations (MRO). The non-residential construction market includes general, electrical, plumbing, sheet metal, and road contractors. Other users of its product include farmers, truckers, railroads, mining companies, federal, state, and local governmental entities, schools, and certain retail trades. Geographically, its stores and customers are primarily located in North America. As of December 31, 2011, the Company had 2,585 store locations."},{"Symbol":"FRT","Name":"Federal Realty Investment Trust","Sector":"Real Estate","Description":"Federal Realty Investment Trust (the Trust) is an equity real estate investment trust (REIT) specializing in the ownership, management, and redevelopment of retail and mixed-use properties located in metropolitan markets in the Northeast and Mid-Atlantic regions of the United States, as well as in California. As of December 31, 2011, the Trust owned or had interest in community and neighborhood shopping centers and mixed-use properties, which are operated as 87 retail real estate projects, consisting approximately 19.3 million square feet. On December 30, 2011, it acquired an 8.1 acre land parcel adjacent to Plaza El Segundo. In January 2012, the Company acquired 89.9% interest in Montrose Crossing. In January 2013, the Company acquired East Bay Bridge shopping center. In April 2013, it acquired a shopping center on 9 acres directly across from the Noroton Heights train station."},{"Symbol":"FDX","Name":"FedEx Corporation","Sector":"Industrials","Description":"FedEx Corporation (FedEx) is a holding company. The Company provides a portfolio of transportation, e-commerce and business services under the FedEx brand. Federal Express Corporation (FedEx Express) is an express transportation company, offering time-certain delivery within one to three business days and serving markets. FedEx Ground Package System, Inc. (FedEx Ground) is a provider of small-package ground delivery service. FedEx Freight Inc (FedEx Freight) is a provider of less-than-truckload (LTL) freight services. FedEx Corporate Services, Inc. (FedEx Services) provides the Company's other companies with sales, marketing, information technology, communications and back-office support. In June 2012, the Company acquired polish courier company Opek Sp. z o.o. In July 2012, the Company acquired TATEX. In July 2012, the Company's, FedEx Express business unit, acquired Rapidao Cometa, a transportation and logistics company."},{"Symbol":"FIS","Name":"Fidelity National Information Services","Sector":"Information Technology","Description":"Fidelity National Information Services, Inc. (FIS) is a global provider of banking and payments technologies. The Company operates in four segments: Financial Solutions Group (FSG), Payment Solutions Group (PSG), International Solutions Group (ISG) and Corporate and Other Segment. The Company is engaged in payment processing and banking solutions, providing software, services and outsourcing of the technology. The Company offers financial institution core processing, card issuer and transaction processing services, including the NYCE Network, a national electronic funds transfer (EFT) network. FIS serves more than 14,000 institutions in over 100 countries. In April 2012, it acquired ICS Risk Advisors and Memento, Inc. In August 2012, the Company completed the sale of its Healthcare Solutions business to an investment fund affiliated with Lightyear Capital LLC. In March 2013, it announced the acquisition of mFoundry."},{"Symbol":"FITB","Name":"Fifth Third Bancorp","Sector":"Financials","Description":"Fifth Third Bancorp (the Bancorp) is a diversified financial services company. As of December 31, 2011, the Bancorp had $117 billion in assets, operated 15 affiliates with 1,316 full-service Banking Centers, including 104 Bank Mart locations open seven days a week inside select grocery stores, and 2,425 automated teller machines (ATMs) in 12 states throughout the Midwestern and Southeastern regions of the United States. The Bancorp operates in four business segments: Commercial Banking, Branch Banking, Consumer Lending and Investment Advisors. The Bancorp also has a 49% interest in Vantiv Holding, LLC."},{"Symbol":"FSLR","Name":"First Solar Inc","Sector":"Information Technology","Description":"First Solar, Inc. manufactures and sells photovoltaic (PV) solar modules with an advanced thin-film semiconductor technology, and it designs, constructs, and sells PV solar power systems. The Company is a thin-film PV solar module manufacturer and a PV solar module manufacturer. It operates its business in two segments: components segment and systems segment. Its components segment involves the design, manufacture, and sale of solar modules, which convert sunlight into electricity. Its systems business involves the sale of its solar modules coupled with the engineering, procurement and construction of the solar PV power plant. In September 2013, First Solar, Inc and K Road Power Holdings LLC announced that First Solar acquired from K Road the 250 megawatt (MW)AC photovoltaic Moapa Solar Project in Nevada."},{"Symbol":"FE","Name":"FirstEnergy Corp","Sector":"Utilities","Description":"FirstEnergy Corp. (FirstEnergy) is engaged in the holding, directly or indirectly, of its subsidiaries: Ohio Edison Company (OE), The Cleveland Electric Illuminating Company (CEI), The Toledo Edison Company (TE), Pennsylvania Power Company (Penn) (a wholly owned subsidiary of OE), American Transmission Systems, Incorporated (ATSI), Jersey Central Power & Light Company (JCP&L), Metropolitan Edison Company (Met-Ed), Pennsylvania Electric Company (Penelec). FirstEnergy operates in three segments: Regulated Distribution, Regulated Independent Transmission and Competitive Energy Services. On February 25, 2011, AE merged with a subsidiary of FirstEnergy and becoming a wholly owned subsidiary of FirstEnergy. On July 28, 2011, FirstEnergy completed the sale of the Fremont Energy Center. On October 18, 2011, FirstEnergy sold its Richland (432 mega-watts) and Stryker (18 mega-watts) Peaking Facilities. On October 18, 2011, Gunvor Group, Ltd. purchased a 33% in Global Holding, a joint venture."},{"Symbol":"FISV","Name":"Fiserv Inc","Sector":"Information Technology","Description":"Fiserv, Inc. (Fiserv) is a global provider of financial services technology. The Company serves approximately 16,000 clients worldwide, including banks, thrifts, credit unions, investment management firms, leasing and finance companies, retailers, merchants and government agencies. The Company's operations are reported in the Payments and Industry Products (Payments) and Financial Institution Services (Financial) business segments. The Company provides account processing systems; electronic payments processing products and services , such as electronic bills payment and presentment, card-based transaction processing and network services, ACH transaction processing, account-to-account transfer products and person-to-person payments; Internet and mobile banking systems, and related services including document and payment card production and distribution, check processing and imaging, source capture systems, and lending and risk management products and services."},{"Symbol":"FLIR","Name":"FLIR Systems","Sector":"Information Technology","Description":"FLIR Systems, Inc. (FLIR), is a designer, manufacturer, and marketer of thermal imaging systems. The Company's advanced sensors and integrated sensor systems enable the gathering and analysis of critical information through a range of applications in commercial, industrial, and government markets worldwide. Its business is organized into two divisions: Commercial Systems and Government Systems. Commercial Systems division includes Thermal Vision & Measurement and Raymarine. Government Systems division include Surveillance, Detection, and Integrated Systems. It offers a range of sensor products, including infrared imaging cameras and systems, detector cores, CBRNE threat detectors, test and measurement instruments, radars, maritime electronics, and related products and solutions. In August 2013, Tessera Technologies Inc announced that FLIR Systems, Inc. acquired a portion of the assets of Tessera's Micro-Optics business based in Charlotte, North Carolina."},{"Symbol":"FLS","Name":"Flowserve Corporation","Sector":"Industrials","Description":"Flowserve Corporation is a manufacturer and aftermarket service provider of flow control systems. The Company develops and manufacture precision-engineered flows control equipment integral to the movement, control and protection of the flow of materials in its customers' critical processes. The Company operates in three segments: Engineered Product Division (EPD), which includes long leads time, custom and other engineered pumps and pump systems, mechanical seals, auxiliary systems and replacement parts and related services, Industrial Product Division (IPD), which includes pre-configured engineered pumps and pump systems and related products and services, and Flow Control Division (FCD), which includes engineered and industrial valves, control valves, actuators and controls and related services."},{"Symbol":"FLR","Name":"Fluor Corp.","Sector":"Industrials","Description":"Fluor Corporation (Fluor) is a holding company. It is a professional services company providing engineering, procurement, construction and maintenance, as well as project management services on a global basis. Fluor serves a diverse set of industries worldwide, including oil and gas, chemicals and petrochemicals, transportation, mining and metals, power, life sciences and manufacturing. It is also a primary service provider to the United Services federal government. Fluor operates in five principal segments: Oil & Gas, Industrial & Infrastructure, Government, Global Services and Power. Fluor Constructors International, Inc., which is organized and operates separately from the rest of its business, provides management and construction services in the United States and Canada, both independently and as a subcontractor on projects in each of its segments. In November 2011, it acquired a sulfur technology company, Goar, Allison & Associates, a unit of Air Products."},{"Symbol":"FMC","Name":"FMC Corporation","Sector":"Materials","Description":"FMC Corporation (FMC), is a diversified chemical company. FMC serves agricultural, consumer and industrial markets with solutions, applications and products. It operates in three business segments: Agricultural Products, Specialty Chemicals and Industrial Chemicals. Agricultural Products segment develops, markets and sells all three classes of crop protection chemicals, such as insecticides, herbicides, and fungicides, with particular strength in insecticides and herbicides. Specialty Chemicals consists of its BioPolymer and lithium businesses and focuses on food ingredients that are used to enhance texture, color, structure and physical stability; pharmaceutical additives for binding, encapsulation and disintegrate applications, specialty polymers and pharmaceutical synthesis. In October 2013, FMC Corporation announced the acquisition of the Center for Agricultural and Environmental Biosolutions (CAEB)."},{"Symbol":"FTI","Name":"FMC Technologies Inc.","Sector":"Energy","Description":"FMC Technologies, Inc. designs, manufactures and services systems and products, including subsea production and processing systems, surface wellhead production systems, high pressure fluid control equipment, measurement solutions and marine loading systems for the energy industry. Its segments are Subsea Technologies, which designs and manufactures products and systems and provides services used by oil and gas companies; Surface Technologies, which designs and manufactures products and systems and provides services used by oil and gas companies involved in land and offshore exploration and production of crude oil and natural gas, and Energy Infrastructure, which offers Measurement Solutions, Loading Systems and Material Handling Solutions. In April 2012, it acquired the remaining 55% interest in Schilling Robotics LLC. In October 2012, it acquired Pure Energy Services Ltd. In January 2013, it purchased a 173-acre parcel of land in Houston, Texas."},{"Symbol":"FL","Name":"Foot Locker Inc","Sector":"Consumer Discretionary","Description":"Foot Locker Inc."},{"Symbol":"F","Name":"Ford Motor","Sector":"Consumer Discretionary","Description":"Ford Motor Company (Ford) is a producer of automobiles. The Company together with its subsidiaries is engaged in other businesses, including financing vehicles. The Company operates in two segments: Automotive and Financial Services. Automotive includes Ford North America, Ford South America, Ford Europe, and Ford Asia Pacific Africa region. Financial services include Ford Motor Credit Company and Other Financial Service. The Company manufactures or distributes automobiles across six continents. Its automotive brands include Ford and Lincoln. Other Financial Services includes a range of businesses, including holding companies and real estate. Effective September 26, 2013, Ford Motor Company acquired Livio, a developer of software."},{"Symbol":"FTV","Name":"Fortive Corp","Sector":"Industrials","Description":"Fortive will be a diversified industrial growth company comprised of Professional Instrumentation and Industrial Technologies businesses that are recognized leaders in attractive markets. With 2015 revenues of $6.2 billion, Fortive's well-known brands hold leading positions in field instrumentation, transportation, sensing, product realization, automation and specialty, and franchise distribution. Fortive will be headquartered in Everett, Washington and employ a team of more than 24,000 research and development, manufacturing, sales, distribution, service and administrative employees in more than 40 countries around the world. With a culture rooted in continuous improvement, the core of our company's operating model will be the Fortive Business System. For more information please visit: www.fortive.com."},{"Symbol":"FBHS","Name":"Fortune Brands Home & Security","Sector":"Industrials","Description":"Fortune Brands Home & Security, Inc. is engaged in home and security products with companies focused on the design, manufacture and sale of products in Kitchen & Bath Cabinetry, Plumbing & Accessories, advanced material windows & entry door Systems, and security and storage products. The Company operates through four business segments: Kitchen & Bath Cabinetry, Plumbing & Accessories, Advanced Material Windows & Door Systems, and Security & Storage. The Kitchen & Bath Cabinetry segment manufactures custom, semi-custom, and stock cabinetry for the kitchen, bath, and other areas of the home. Plumbing & Accessories segment manufactures and assembles faucets, accessories, and kitchen sinks The Advanced Material Windows & Door Systems segment manufactures and sells fiberglass and steel entry door systems. In June 2013, Fortune Brands Home & Security Inc completed the acquisition of WoodCrafters Home Products."},{"Symbol":"BEN","Name":"Franklin Resources","Sector":"Financials","Description":"Franklin Resources, Inc. (Franklin) is a holding company. Franklin together with its various subsidiaries (collectively, the Company), is referred to as Franklin Templeton Investments, is a global investment management organization offering investment choices under the Franklin, Templeton, Mutual Series, Bissett, Fiduciary and Darby brand names. The Company operates in two segments: investment management and related services, and banking/finance. Its investment management and related services provides services to investment funds in jurisdictions globally, which include the United States- and non-the United States-registered open-end and closed-end funds, unregistered funds, and institutional, high net-worth and separately-managed accounts. Its banking/finance segment provides clients with select retail banking, private banking and consumer lending services through its banking and finance subsidiaries. In November 2012, it acquired a majority stake in K2 Advisors Holdings LLC."},{"Symbol":"FCX","Name":"Freeport-McMoRan Inc.","Sector":"Materials","Description":"Freeport-McMoRan Copper & Gold Inc. (FCX) is an international mining company. FCX is one of the copper, gold and molybdenum mining companies in terms of reserves and production. Its portfolio of assets includes the Grasberg minerals district in Indonesia, mining operations in North and South America, and the Tenke Fungurume (Tenke) minerals district in the Democratic Republic of Congo (DRC). The Grasberg minerals district contains the recoverable copper reserve and the gold reserve. It also operates Atlantic Copper, its wholly owned copper smelting and refining unit in Spain. FCX has its operations into five primary divisions: North America copper mines, South America mining, Indonesia mining, Africa mining and Molybdenum operations. In May 2013, the Company completes acquisition of Plains Exploration & Production Company. In June 2013, FCX acquired the remaining 64% interest in McMoRan Exploration Co."},{"Symbol":"FTR","Name":"Frontier Communications","Sector":"Telecommunications Services","Description":"Frontier Communications Corporation (Frontier) is a communications company providing services primarily to rural areas and small and medium-sized towns and cities in the United States. The Company offers a range of voice, data, Internet, and television services and products, some that are available a la carte, and others that are available as bundled or packaged solutions. It operated in 27 states, and was the Incumbent Local Exchange Carrier (ILEC), with approximately 5.3 million access lines and 1.8 million broadband connections as of December 31, 2011. During the year ended December 31, 2011, the Company added approximately 45,200 new High-Speed Internet (HSI) subscribers, net. At December 31, 2011, it had approximately 1,764,200 HSI customers. Throughout its properties, Frontier offers a video product through DISH Network (DISH) and, in addition, it offers fiber optic video services in three states. It added approximately 26,100 video subscribers, net during 2011."},{"Symbol":"GPS","Name":"Gap (The)","Sector":"Consumer Discretionary","Description":"The Gap, Inc. (Gap Inc.),is a global specialty apparel company. Gap Inc. offers apparel, accessories, and personal care products for men, women, children, and babies under the Gap, Old Navy, Banana Republic, Piperlime, and Athleta brands. The Company operates in two segments: Stores, which includes the operations of the retail stores for Gap, Old Navy, and Banana Republic, and Direct, which includes the operations for its online brands, both domestic and international. It has Company-operated stores in the United States, Canada, the United Kingdom, France, Ireland, Japan, China, and Italy. It also has franchise agreements with unaffiliated franchisees to operate Gap and Banana Republic stores. Under these agreements, third parties operate or will operate stores that sell apparel and related products under its brand names. In February 2014, GAP Inc announced the Old Navy's opening of the brand's first store in China."},{"Symbol":"GRMN","Name":"Garmin Ltd.","Sector":"Consumer Discretionary","Description":"Garmin Ltd. (Garmin) is a provider of navigation, communication and information devices and applications, which are enabled by global positioning system (GPS) technology. Garmin designs, develops, manufactures and markets a diverse family of hand-held, portable and fixed-mount GPS-enabled products and other navigation, communications and information products for the automotive/mobile, outdoor, fitness, marine, and general aviation markets. Garmin has four segments: Automotive/Mobile, Aviation, Marine, Outdoor and Fitness. In September 2012, its subsidiary acquired Nexus Marine AB, a designer and manufacturer of instrumentation for the sailing and yachting market."},{"Symbol":"GD","Name":"General Dynamics","Sector":"Industrials","Description":"General Dynamics Corporation is an aerospace and defense company that offers a portfolio of products and services in business aviation; combat vehicles, weapons systems and munitions; military and commercial shipbuilding, and communications and information technology. The Company operates through four business groups: Aerospace, Combat Systems, Marine Systems and Information Systems and Technology. In December 2011, it acquired Force Protection, Inc. In February 2012, the Company acquired the Enterprise Jet Center FBO at Hobby Airport in Houston, Texas. In June 8, 2012, the Company acquired IPW Holdings, Inc. In August 2012, it acquired Ship Repair and Coatings Division of Earl Industries. In August 2012, the Company acquired the defense operations of Gayston Corporation. In August 2012, the Company acquired Fidelis Security Systems, Inc. In September 2012, it acquired Open Kernel Labs, Inc. In December 2012, the Company acquired Applied Physical Sciences Corp."},{"Symbol":"GE","Name":"General Electric","Sector":"Industrials","Description":"General Electric Company (GE) is a diversified technology and financial services company. The products and services of the Company range from aircraft engines, power generation, water processing, and household appliances to medical imaging, business and consumer financing and industrial products. It serves customers in more than 100 countries. In June 2013, American Realty Capital Trust IV Inc announced that it has closed on the acquisition of 377 primarily net lease retail properties as part of its previously announced portfolio acquisition from certain affiliates of General Electric Co's GE Capital. In July 2013, General Electric Co's GE Oil & Gas completed its acquisition of Lufkin Industries, Inc. In August 2013, General Electric Company completed the acquisition of the aviation business of Ario S.p.A."},{"Symbol":"GGP","Name":"General Growth Properties Inc.","Sector":"Real Estate","Description":"General Growth Properties, Inc. is a real estate investment trust (REIT). The Company owns or with joint venture partners 144 regional malls (126 domestic and 18 in Brazil) consists of approximately 135 million square feet. The Company is engaged in ownership, operation, management and selective re-development of its Consolidated Properties and Unconsolidated Properties, which are primarily regional malls. As of December 31, 2012, the Company's segment was consists of 126 regional malls in the United States and 18 malls in Brazil, eight strip centers totaling 1.6 million square feet, primarily in the Western region of the United States, as well as seven stand-alone office buildings totaling 0.9 million square feet, concentrated in Columbia, Maryland."},{"Symbol":"GIS","Name":"General Mills","Sector":"Consumer Staples","Description":"General Mills, Inc. (General Mills) is a manufacturer and marketer of branded consumer foods sold through retail stores. The Company is also a supplier of branded and unbranded food products to the foodservice and commercial baking industries. The Company manufactures its products in 15 countries and markets them in more than 100 countries. The Company's joint ventures manufacture and market products in more than 130 countries and republics worldwide. General Mills operates in three segments: U.S. Retail, International, and Bakeries and Foodservice. In addition, the Company sells ready-to-eat cereals through its Cereal Partners Worldwide (CPW) joint venture. In February 2012, General Mills acquired Food Should Taste Good, a natural snack foods company based in Needham Heights, Mass. During the fiscal year ended May 27, 2012, the Company acquired a 51% interest in Yoplait S.A.S. and a 50% interest in Yoplait Marques S.A.S. In August 2012, it acquired Yoki Alimentos SA."},{"Symbol":"GM","Name":"General Motors","Sector":"Consumer Discretionary","Description":"General Motors Corporation (General Motors) designs, build and sell cars, trucks and automobiles parts globally. The Company also provides automotive financing services through General Motors Financial Company, Inc. (GM Financial). The Company's automotive operations meet the demands of the Company's customers through its four automotive segments: GM North America (GMNA), GM Europe (GME), GM International Operations (GMIO) and GM South America (GMSA). During the year ended December 31, 2012, the Company's total worldwide vehicle sales were 9.3 million. As of December 31, 2012 the Company had ownership stakes directly or indirectly in entities through various regional subsidiaries, including GM Korea Company (GM Korea), and Shanghai General Motors Co., Ltd. (SGM). In March 2012, the Company acquired from Ally Financial 100% interest of GMAC South America LLC. In October 2013, Fiat SpA's Fiat Group Automobiles completes acquisition of 50% stake in VM Motori SpA Held by the Company."},{"Symbol":"GPC","Name":"Genuine Parts","Sector":"Consumer Discretionary","Description":"Genuine Parts Company is a service organization engaged in the distribution of automotive replacement parts, industrial replacement parts, office products and electrical/electronic materials. The Company operates in four: Automotive Parts Group, Industrial Parts Group, Office Products Group and Electrical/Electronic Materials Group. The Automotive Parts Group distributes automotive parts and accessory items. In addition to over 427,000 available part numbers, the Company offers inventory, cataloging, marketing, training and other programs in the automotive aftermarket. The Industrial Parts Group is operated as Motion Industries, Inc. (Motion), a wholly owned subsidiary of the Company. During the year ended December 31, 2012, the Company's business were conducted throughout the United States, in Canada and in Mexico from approximately 2,000 locations. On February 1, 2012, the Company acquired Light Fabrications Inc."},{"Symbol":"GILD","Name":"Gilead Sciences","Sector":"Health Care","Description":"Gilead Sciences, Inc. (Gilead) is a research-based biopharmaceutical company that discovers, develops and commercializes medicines. Gilead's primary areas of focus include human immunodeficiency virus (HIV)/AIDS, liver diseases, such as hepatitis B and C and cardiovascular/metabolic and respiratory conditions. The Company has operations in North America, Europe and Asia Pacific. The Company's products include Atripla, Truvada, Viread, Complera/Eviplera, Emtriva, Hepsera, Letairis, Ranexa, Lexiscan/Rapiscan, AmBisome, Vistide, Macugen, Cayston and Tamiflu. In January 2012, the Company acquired Pharmasset, Inc. On February 8, 2013, its subsidiary, acquired YM BioSciences Inc."},{"Symbol":"GPN","Name":"Global Payments Inc","Sector":"Information Technology","Description":"Global Payments Inc. (Global Payments) is a provider of electronic payments transaction processing services for consumers, merchants, independent sales organizations (ISOs), financial institutions, government agencies and multi-national corporations located throughout the United States, Canada, the United Kingdom, Spain, the Asia-Pacific region, the Czech Republic, and the Russian Federation. The Company serves as an intermediary to facilitate electronic payment transactions and operates in two business segments: North America Merchant Services and International Merchant Services. On October 1, 2012, the Company completed the acquisition of Accelerated Payment Technologies (APT). The Company accepts a range of card and electronic based payments at the point of sale. The Company's business model provides payment products and services directly to merchants as its end customers."},{"Symbol":"GS","Name":"Goldman Sachs Group","Sector":"Financials","Description":"The Goldman Sachs Group, Inc. (Goldman Sachs) is a global investment banking, securities and investment management firm that provides a range of financial services to a substantial and diversified client base that includes corporations, financial institutions, governments and high-net-worth individuals. Goldman Sachs operates in four segments: Investment Banking, Institutional Client Services, Investing & Lending and Investment Management. In July 2013, Suncorp Group Ltd announced the completion of the Non-core portfolio sale to the Company. Effective August 6, 2013, Goldman Sachs Group Inc (Goldman) increased its interest by acquiring an 18.7% interest in Red de Carreteras de Occidente SAB de CV, a unit of Goldman's Goldman Sachs Infrastructure Partners fund, from Empresas ICA SAB de CV. In October 2013, Goldman Sachs Group Inc's unit bought a 50% stake in privately-held British motor insurer Hastings."},{"Symbol":"GT","Name":"Goodyear Tire & Rubber","Sector":"Consumer Discretionary","Description":"The Goodyear Tire & Rubber Company is a manufacturer of tires. The Company, together with subsidiaries and joint ventures, develops, manufactures, markets and distributes tires for a range of applications. The Company also manufactures and markets rubber-related chemicals for various applications. The Company is an operator of commercial truck service and tire retreading centers. During the year ended December 31, 2011, the Company operated approximately 1,400 tire and auto service center outlets where it offered its products for retail sale and provided automotive repair and other services. The Company manufactures its products in 53 manufacturing facilities in 22 countries, including the United States. It operates through four operating segments representing its regional tire businesses: North American Tire; Europe, Middle East and Africa Tire (EMEA); Latin American Tire, and Asia Pacific Tire."},{"Symbol":"GWW","Name":"Grainger (W.W.) Inc.","Sector":"Industrials","Description":"Grainger W W Inc., formerly W.W. Grainger, Inc., is a distributor of maintenance, repair and operating (MRO) supplies and other related products and services used by businesses and institutions primarily in the United States and Canada . The Company operates in two segments: United States and Canada. Other businesses include operations in Europe, Asia, Latin America and other United States operations. In August 2013, W.W. Grainger Inc acquired E&R Industrial Sales, Inc. In December 2013, the Company announced that it has completed the acquisition of Safety Solutions Inc."},{"Symbol":"HAL","Name":"Halliburton Co.","Sector":"Energy","Description":"Halliburton Company is an oilfield services company. The Company is provider of services and products to the energy industry related to the exploration, development, and production of oil and natural gas. It serves national, and independent oil and natural gas companies worldwide and operates in two segments: Completion and Production segment and Drilling and Evaluation segment. The Company conducts business worldwide in approximately 80 countries. The business operations of its divisions are organized around four primary geographic regions: North America, Latin America, Europe/Africa/CIS, and Middle East/Asia. During the year ended December 31, 2011, based on the location of services provided and products sold, 55% of its consolidated revenue was from the United States. In October 2011, the Company completed the acquisition of Multi-Chem Group, LLC. In August 2012, its Landmark Software and Services acquired Petris Technology Inc."},{"Symbol":"HBI","Name":"Hanesbrands Inc","Sector":"Consumer Discretionary","Description":"Hanesbrands Inc. is a consumer goods company with a portfolio of apparel brands, including Hanes, Champion, Bali, Playtex, Just My Size, L'eggs, barely there, Wonderbra, Gear for Sports, Stedman, Zorba, Rinbros, Sol y Oro, Outer Banks and Duofold. The Company designs, manufactures, sources and sells a range of basic apparel, such as T-shirts, bras, panties, men's underwear, kids' underwear, casualwear, activewear, socks and hosiery. The Company operates in five segments: Innerwear, Outerwear, Hosiery, Direct to Consumer and International. The Hanes brand covers all of its product categories, including men's underwear, kids' underwear, bras, panties, socks, T-shirts, fleece and sheer hosiery. Bali is the brand within its portfolio, offering a range of bras, panties and shapewear sold in the department store channel. In October 2013, the Company announced that it has closed the acquisition of Maidenform Brands, Inc."},{"Symbol":"HOG","Name":"Harley-Davidson","Sector":"Consumer Discretionary","Description":"Harley-Davidson, Inc. is the parent company for the groups of companies doing business as Harley-Davidson Motor Company (HDMC) and Harley-Davidson Financial Services (HDFS). The Company operates in the Motorcycles and Related Products (Motorcycles) segment and the Financial Services (Financial Services) segment. The Motorcycles segment designs, manufactures and sells at wholesale heavyweight (street legal with engine displacement of 651+cc) Harley-Davidson motorcycles, as well as a line of motorcycle parts, accessories, general merchandise and related services. The Company conducts business on a global basis, with sales in North America, Europe/Middle East/Africa (EMEA), Asia-Pacific and Latin America. The Financial Services segment consists of HDFS, which provides wholesale and retail financing and provides insurance and insurance-related programs primarily to Harley-Davidson dealers and their retail customers. HDFS conducts business principally in the United States and Canada."},{"Symbol":"HAR","Name":"Harman Int'l Industries","Sector":"Consumer Discretionary","Description":"DELISTED - Harman International Industries, Incorporated (Harman International) is engaged in the developing, manufacturing and marketing of audio products and electronic systems. The Company has developed a range of product offerings, which are sold under brand names like AKG, Crown, JBL, Infinity, Harman/Kardon, Lexicon, dbx, Digitec, BSS, Studer, Soundcraft, Mark Levinson, Becker, Revel, Logic 7 and Selenium. The Company has four segments: Infotainment, Lifestyle, Professional, and Other. On February 28, 2013, the Company acquired Martin Professional A/S from A/S Schouw & Co. In October 2013, the Company announced the acquisition of privately-held Duran Audio BV."},{"Symbol":"HRS","Name":"Harris Corporation","Sector":"Information Technology","Description":"Harris Corporation (Harris), together with its subsidiaries, is an international communications and information technology (IT) company serving government and commercial markets in more than 125 countries. The Company operates in three segments: RF Communications segment, Integrated Network Solutions segment and Government Communications Systems. Its RF Communications segment consists of United States Department of Defense and international tactical communications, and public safety and professional communications. Its Integrated Network Solutions segment consists of IT services, Harris CapRock Communications and Healthcare Solutions. During the fiscal year ended June 29, 2012, the Company discontinued its cyber integrated solutions operation (CIS) and broadcast communications operations (Broadcast Communications) which were part of its Integrated Network Solutions segment. In February 2013, the Company sold Broadcast Communications business to an affiliate of The Gores Group, LLC."},{"Symbol":"HIG","Name":"Hartford Financial Svc.Gp.","Sector":"Financials","Description":"Hartford Financial Services Group Inc., formerly The Hartford Financial Services Group, Inc., is an insurance and financial services company. The Company is a provider of investment products and life, property, and casualty insurance to both individual and business customers in the United States of America. The Company maintains a retail mutual fund operation, whereby the Company, through wholly owned subsidiaries, provides investment management and administrative services to The Hartford Mutual Funds, Inc. and The Hartford Mutual Funds II, Inc. (collectively, mutual funds), consisting of 57 mutual funds, as of December 31, 2011. The Company operates in four segments: Commercial Markets, Consumer Markets, Wealth Management and Runoff Operations. In October 2011, the Company sold Trumbull Services, LLC to ExlService Holdings, Inc."},{"Symbol":"HAS","Name":"Hasbro Inc.","Sector":"Consumer Discretionary","Description":"Hasbro, Inc., engaged in providing children's and family leisure time products with a range of portfolio of brands and entertainment properties. The Company's brand architecture identifies franchise brands, challenger brands, key partner brands and new brands. Franchise and challenger brands include many well-known brand names such as TRANSFORMERS, NERF, LITTLEST PET SHOP, MY LITTLE PONY, BABY ALIVE, G.I. JOE, MONOPOLY, MAGIC: THE GATHERING, PLAY-DOH and PLAYSKOOL. In addition to product offerings under Hasbro-owned brands or brands which if not entirely owned are broadly controlled by the Company, offerings may also include products branded and developed under key licenses. The licensed brands include BEYBLADE, SPIDER-MAN and THE AVENGERS from MARVEL, SESAME STREET, STAR WARS and ZYNGA product offerings. In July 2013, Hasbro Inc announced the acquisition of a majority stake in Backflip Studios."},{"Symbol":"HCA","Name":"HCA Holdings","Sector":"Health Care","Description":"HCA Holdings, Inc. (HCA) is a holding company whose affiliates owns and operates hospitals and related health care entities. HCA is a health care services companies in the United States. At December 31, 2011, it operated 163 hospitals, comprised of 157 general, acute care hospitals; five psychiatric hospitals, and one rehabilitation hospital. In addition, it operated 108 freestanding surgery centers. Its operations are structured into three geographically organized groups: the National, Southwest and Central Groups. At December 31, 2011, the National Group includes 64 hospitals located in Florida, South Carolina, southern Georgia, Alaska, California, Nevada, Utah and Idaho, the Southwest Group includes 46 hospitals located in Colorado, Texas, Oklahoma and the Wichita, Kansas market, and the Central Group includes 47 hospitals. During October 2011, the Company acquired the Colorado Health Foundation's (Foundation).In December 2011, it sold Palmyra Medical Center in Albany, Ga."},{"Symbol":"HCP","Name":"HCP Inc.","Sector":"Real Estate","Description":"HCP, Inc. (HCP) is a real estate investment trust (REIT). The Company invests primarily in real estate serving the healthcare industry in the United States. HCP acquires, develops, leases, manages and disposes of healthcare real estate and provides financing to healthcare providers. The Company's portfolio consists of investments in the five healthcare segments: senior housing, life science, medical office, post-acute/skilled nursing and hospital. The Company makes investments within its healthcare segments using the five investment products: properties under lease, debt investments, developments and redevelopments, investment management and RIDEA, which represents investments in senior housing operations. During the year ended December 31, 2011, the Company sold three senior housing facilities. In October 2012, Emeritus Corp announced that HCP closed the acquisition of 127 of the 133 senior housing communities."},{"Symbol":"HP","Name":"Helmerich & Payne","Sector":"Energy","Description":"Helmerich & Payne, Inc. is engaged in contract drilling of oil and gases wells for others and this business. The Company's contract drilling business is composed of three reportable business segments: U.S. Land, Offshore and International Land. During the fiscal year ended September 30, 2012 (fiscal 2012), the Company's U.S. Land operations drilled in Oklahoma, California, Texas, Wyoming, Colorado, Louisiana, Pennsylvania, Ohio, Utah, Arkansas, New Mexico, Montana, North Dakota and West Virginia. Offshore operations were conducted in the Gulf of Mexico, and offshore of California, Trinidad and Equatorial Guinea. During fiscal 2012, the Company's International Land segment operated in six international locations: Ecuador, Colombia, Argentina, Tunisia, Bahrain and United Arab Emirates. The Company is also engaged in the ownership, development and operation of commercial real estate and the research and development of rotary steerable technology."},{"Symbol":"HSIC","Name":"Henry Schein","Sector":"Health Care","Description":"Henry Schein, Inc. is a provider of health care products and services to office-based practitioners. The Company conducts its business through two segments: healthcare distribution and technology. The healthcare distribution segment aggregates its dental, medical, animal health and international operating segments. This segment consists of consumable products, small equipment, laboratory products, large dental equipment, equipment repair services, branded and generic pharmaceuticals, vaccines, surgical products, diagnostic tests, infection-control products and vitamins. Its technology group provides software, technology and other services to healthcare practitioners, primarily in the United States, Canada, the United Kingdom, Australia and New Zealand. In July 2013, Henry Schein Inc divested an unprofitable non controlling stake in a dental wholesale business in the Middle East."},{"Symbol":"HES","Name":"Hess Corporation","Sector":"Energy","Description":"Hess Corporation (Hess) is a global integrated energy company that operates in two segments: Exploration and Production (E&P) and Marketing and Refining (M&R). The E&P segment explores for, develops, produces, purchases, transports and sells crude oil and natural gas. These exploration and production activities take place principally in Algeria, Australia, Azerbaijan, Brazil, Brunei, China, Denmark, Egypt, Equatorial Guinea, France, Ghana, Indonesia, the Kurdistan region of Iraq, Libya, Malaysia, Norway, Peru, Russia, Thailand, the United Kingdom and the United States. The M&R segment manufactures refined petroleum products and purchases, markets and trades refined petroleum products, natural gas and electricity. In December 2013, the Company sold its Natuna A asset, located off the coast of Indonesia to PT Pertamina and PTT Exploration and Production company Limited."},{"Symbol":"HPE","Name":"Hewlett Packard Enterprise","Sector":"Information Technology","Description":"Hewlett Packard Enterprise Company offers IT consulting and technology services. The company was founded in 2014 and is based in Palo Alto, California. Hewlett Packard Enterprise Company operates as a subsidiary of Hewlett-Packard Company."},{"Symbol":"HOLX","Name":"Hologic","Sector":"Health Care","Description":"Hologic, Inc. is a developer, manufacturer and supplier of diagnostics products, medical imaging systems and surgical products to serving the healthcare needs of women. The Company operates in four segments: Breast Health, Diagnostics, GYN Surgical and Skeletal Health. The Company sells and services its products through a combination of direct sales and service forces and a network of independent distributors and sales representatives. On August 1, 2012, the Company acquired Gen-Probe Incorporated (Gen-Probe). Gen-Probe is engaged in molecular diagnostics products and services, which are used to diagnose human diseases, screen donated human blood and test transplant compatibility. In March 2013, it announced that it has completed its sale of the LIFECODES business unit to Immucor, Inc."},{"Symbol":"HD","Name":"Home Depot","Sector":"Consumer Discretionary","Description":"The Home Depot, Inc. (The Home Depot) is a home improvement retailer. The Company operates The Home Depot stores, which are full-service, warehouse-style stores. The Home Depot stores sell an assortment of building materials, home improvement and lawn and garden products and provide a number of services. The Home Depot stores average approximately 104,000 square feet of enclosed space, with approximately 24,000 additional square feet of outside garden area. The Home Depot stores serve three primary customer groups: do-it-yourself (D-I-Y) customers, do-it-for-me (D-I-F-M) customers and professional customers. As of February 3, 2013, the Company was operating 2,256 The Home Depot stores located throughout the United States, including the Commonwealth of Puerto Rico and the territories of the United States Virgin Islands and Guam, Canada and Mexico. In February 2013, it acquired Measurecomp LLC and HD Components LLC."},{"Symbol":"HON","Name":"Honeywell Int'l Inc.","Sector":"Industrials","Description":"Honeywell International Inc. (Honeywell) is a diversified technology and manufacturing company, serving customers worldwide with aerospace products and services, control, sensing and security technologies for buildings, homes and industry, turbochargers, automotive products, specialty chemicals, electronic and advanced materials, process technology for refining and petrochemicals, and energy efficient products and solutions for homes, business and transportation. Honeywell operates four business segments: Aerospace, Automation and Control Solutions, Performance Materials and Technologies, and Transportation Systems. In June 2013, the Company acquired RAE Systems, Inc. In September 2013, Honeywell International Inc announced that it has completed its acquisition of Intermec Inc, a provider of mobile computing, radio frequency identification solutions (RFID), voice-enabled workflow and data-collection solutions, and printing solutions."},{"Symbol":"HRL","Name":"Hormel Foods Corp.","Sector":"Consumer Staples","Description":"Hormel Foods Corporation is primarily engaged in the production of a variety of meat and food products and the marketing of those products throughout the United States and internationally. The Company markets its products through Hormel Foods International Corporation (HFIC), a wholly owned subsidiary. The Company's operates in five segments: grocery products, refrigerated foods, Jennie-O Turkey Store (JOTS), specialty foods, and all other. The meat products are sold fresh, frozen, cured, smoked, cooked, and canned. Perishable meat includes fresh meats, refrigerated meal solutions, sausages, hams, wieners, and bacon (excluding JOTS products). Shelf-stable includes canned luncheon meats, shelf-stable microwaveable entrees, stews, chilies, hash, meat spreads, flour and corn tortillas, salsas, tortilla chips, and other items that do not require refrigeration. The Other category primarily consists of nutritional food products and supplements, and industrial gelatin products."},{"Symbol":"HST","Name":"Host Hotels & Resorts","Sector":"Real Estate","Description":"Host Hotels & Resorts, Inc (Host Inc), incorporated on September 28, 1998 operates as a self-managed and self-administered REIT. Host Inc. owns properties and conducts operations through Host Hotels & Resorts, L.P. (Host L.P.) of which Host Inc. is the sole general partner and in which it holds approximately 98.6% of the partnership interests (OP units) as of December 31, 2012. As of February 25, 2013, the Company had 118 primarily luxury and upper-upscale hotels containing approximately 62,600 rooms, with the majority located in the United States of America, and 15 properties located outside of the United States of America, in Canada, New Zealand, Chile, Australia, Mexico and Brazil. In June 2013, the Company announced that it acquired the fee-simple interest in the 426-room Hyatt Place Waikiki Beach in Honolulu. In July 2013, the Company sold the 336-room Ritz-Carlton, San Francisco to an investment vehicle sponsored by Thayer Lodging Group."},{"Symbol":"HPQ","Name":"HP Inc.","Sector":"Information Technology","Description":"Hewlett-Packard Company (HP) is a provider of products, technologies, software, solutions and services to individual consumers, small- and medium-sized businesses (SMBs) and large enterprises, including customers in the Government, health and education sectors. Its operations are organized into seven segments: the Personal Systems Group (PSG), Services, the Imaging and Printing Group (IPG), Enterprise Servers, Storage and Networking (ESSN), HP Software, HP Financial Services (HPFS) and Corporate Investments. In March 2012, HP had consolidated PSG and IPG into a Printing and Personal Systems Group. HP continues to report the results of IPG and PSG separately. HP's offerings include personal computing and other access devices; multi-vendor customer services, including infrastructure technology and business process outsourcing, application development and support services, and imaging and printing-related products and services. In December 2011, the Company acquired Hiflex Software GmbH."},{"Symbol":"HUM","Name":"Humana Inc.","Sector":"Health Care","Description":"Humana Inc. (Humana) is a health care company. Humana operates in three segments: Retail, Employer Group, and Health and Well-Being Services. The Company offers a range of insurance products and health and wellness services that incorporate an integrated approach to lifelong well-being. As of December 31, 2011, it had approximately 11.2 million members in its medical benefit plans, as well as approximately 7.3 million members in its specialty products. During the year ended December, 31, 2011, 76% of its premiums and services revenue were derived from contracts with the federal government, including 16% related to its Medicare Advantage contracts in Florida with the Centers for Medicare and Medicaid Services (CMS). In August 2012, the Company acquired Harris, Rothenberg International, Inc. In November 2012, the Company acquired Certify Data Systems. In December 2012, the Company acquired Metropolitan Health Networks, Inc."},{"Symbol":"HBAN","Name":"Huntington Bancshares","Sector":"Financials","Description":"Huntington Bancshares Incorporated (Huntington) is a multi-state diversified regional bank holding company. Through its subsidiaries, including its bank subsidiary, The Huntington National Bank (the Bank), Huntington is engaged in providing full-service commercial, small business, consumer banking services, mortgage banking services, automobile financing, equipment leasing, investment management, trust services, brokerage services, customized insurance programs, and other financial products and services. The Company operates in four segments: Retail and Business Banking , Regional and Commercial Banking, Automobile Finance and Commercial Real Estate and Wealth Advisors, Government Finance, and Home Lending . At December 31, 2011, the Bank had 652 branches. A Treasury/Other function includes its insurance brokerage business, which specializes in commercial property and casualty, employee benefits, personal lines, life and disability and specialty lines of insurance."},{"Symbol":"IDXX","Name":"IDEXX Laboratories","Sector":"Health Care","Description":"IDEXX Laboratories, Inc. develops, manufactures and distributes products and provides services primarily for the companion animal veterinary, livestock and poultry, water testing and dairy markets. The Company operates through three segments: diagnostic and information technology-based products and services for the veterinary market, which it refers to as the Companion Animal Group (CAG), water quality products (Water) and products for livestock and poultry health, which it refer to as Livestock and Poultry Diagnostics (LPD). It also operates two smaller segments that consist of products for milk quality and safety (Dairy) and products for the human point-of-care medical diagnostics market (OPTI Medical). In November 2011, the Company acquired the research and diagnostic laboratory (RADIL) business of the College of Veterinary Medicine from the University of Missouri. In August 2013, IDEXX Laboratories, Inc. announced that it has acquired Madasa do Brasil Ltda."},{"Symbol":"ITW","Name":"Illinois Tool Works","Sector":"Industrials","Description":"Illinois Tool Works Inc. (ITW) is a multinational manufacturer of a diversified range of industrial products and equipment with operations in 58 countries. The Company operates in eight business segments: Transportation, Power Systems & Electronics, Industrial Packaging, Food Equipment; Construction Products, Polymers & Fluids, Decorative Surfaces, and All Other. The Company primarily serves the construction, general industrial, automotive, food institutional/restaurant and service, food and beverage, electronics, consumer durables, primary metals, and others markets. In March 2011, the Company acquired SOPUS Products' Car Care business. In July 2011, the Company acquired Despatch Industries. In July 2013, Illinois Tool Works Inc acquired Gold Pattern Holdings."},{"Symbol":"ILMN","Name":"Illumina Inc","Sector":"Health Care","Description":"Illumina, Inc. provides sequencing and array-based solutions for genetic analysis in North America, Europe, Latin America, the Asia-Pacific, the Middle East, and South Africa. The companys products include sequencing platforms that are based on its SBS technology, which provides researchers with various ranges of applications and the ability to sequence mammalian genomes; and array platforms consist of HiScan and iScan systems, as well as NextSeq 550 system that are array scanners for DNA and RNA analysis applications, including single nucleotide polymorphism genotyping, copy number variations analysis, gene expression analysis, and methylation analysis. It also offers various library preparation and sequencing kits to simplify workflows and accelerate analysis. In addition, the company provides genotyping, noninvasive prenatal test, and whole-genome sequencing services. It serves genomic research centers, academic institutions, government laboratories, hospitals, and reference laboratories, as well as pharmaceutical, biotechnology, agrigenomics, commercial molecular diagnostic, and consumer genomics companies. The company sells its products directly, as well as through distributors. It has a collaboration agreement with Merck Serono to develop a sequencing-based oncology diagnostic. Illumina, Inc. was founded in 1998 and is headquartered in San Diego, California."},{"Symbol":"INCY","Name":"Incyte","Sector":"Health Care","Description":"Incyte Corporation (Incyte) is a biopharmaceutical company focused on the discovery, development and commercialization of small molecule drugs to treat serious unmet medical needs. Its advanced compound, JAKAFI (ruxolitinib), also known as INCB18424 and INC424, is an oral Janus associated kinase (JAK) inhibitor used for the treatment for patients with intermediate or high-risk myelofibrosis (MF), including primary MF, post-polycythemia vera MF and post-essential thrombocythemia MF. The Company has a second oral JAK1 and JAK2 inhibitor, LY3009104 (INCB28050), which is subject to a collaboration agreement with Eli Lilly and Company in which Lilly received worldwide development and commercialization rights for the compound for inflammatory and autoimmune diseases. In November 2011, JAKAFI became commercially available in the United States and is being marketed in the United States."},{"Symbol":"IR","Name":"Ingersoll-Rand PLC","Sector":"Industrials","Description":"Ingersoll-Rand plc (IR-Ireland) is a diversified, global company that provides products, services and solutions to enhance the comfort of air in homes and buildings, transport and protect food and perishables, secure homes and commercial properties. IR-Ireland operates in four business segments: Climate Solutions, Residential Solutions, Industrial Technologies and Security Technologies. It generates revenue and cash primarily through the design, manufacture, sale and service of a diverse portfolio of industrial and commercial products that include Club Car, Ingersoll-Rand, Schlage, Thermo King and Trane. On September 30, 2011, IR-Ireland completed the transaction to sell 60% in the Hussmann business. In December 2013, the Company announced that it has completed the spinoff of the Company's commercial and residential security businesses named Allegion."},{"Symbol":"INTC","Name":"Intel Corp.","Sector":"Information Technology","Description":"Intel Corporation designs and manufactures integrated digital technology platforms. A platform consists of a microprocessor and chipset. The Company's platforms are used in a range of applications, such as personal computers (PCs) (including Ultrabook systems), data centers, tablets, smartphones, automobiles, automated factory systems and medical devices. In February 2013, it acquired ProFUSION-Comercio e Prestacao de Servicos em Tecnologia da Informacao Ltda. In April 2013, Intel Corp acquired Aepona Ltd. Effective July 16, 2013, Intel Corp acquired Omek Interactive Ltd. Effective August 15, 2013, Intel Corp acquired Fujitsu Semiconductor Wireless Products Inc, from Fujitsu Semiconductor Ltd, a wholly owned subsidiary of Fujitsu Ltd. Effective November 8, 2013, Intel Corp acquired Kno Inc, a developer of educational software.."},{"Symbol":"ICE","Name":"Intercontinental Exchange","Sector":"Financials","Description":"No Description Available"},{"Symbol":"IBM","Name":"International Business Machines","Sector":"Information Technology","Description":"International Business Machines Corporation (IBM) is an information technology (IT) company. IBM operates in five segments: Global Technology Services (GTS), Global Business Services (GBS), Software, Systems and Technology and Global Financing. GTS primarily provides IT infrastructure services and business process services. GBS provides professional services and application management services. Software consists primarily of middleware and operating systems software. Systems and Technology provides clients with business solutions requiring advanced computing power and storage capabilities. In October 2013, International Business Machines Corporation acquired Xtify Inc. In October 2013, the Company announced that it has completed the acquisition of The Now Factory, a privately held provider of analytics software that helps communications service providers (CSPs) deliver better customer experiences and drive new revenue opportunities."},{"Symbol":"IP","Name":"International Paper","Sector":"Materials","Description":"International Paper Company (International Paper) is a global paper and packaging company, with primary markets and manufacturing operations in North America, Europe, Latin America, Russia, Asia and North Africa. The Company operates in four segments: Industrial Packaging, Printing Papers, Consumer Packaging and Distribution. As of December 31, 2012, in the United States, the Company operated 28 pulp, paper and packaging mills, 187 converting and packaging plants, 18 recycling plants and three bag facilities. Production facilities as of December 31, 2012 in Europe, Asia, Latin America and South America included 11 pulp, paper and packaging mills, 65 converting and packaging plants, and two recycling plants. On July 2, 2012, it sold Ontario and Oxnard (Hueneme), California containerboard mills to New-Indy Containerboard LLC, and its New Johnsonville, Tennessee containerboard mill to Hood Container Corporation. On January 3, 2013, it acquired joint venture partner, Sabanci Holding."},{"Symbol":"IPG","Name":"Interpublic Group","Sector":"Consumer Discretionary","Description":"The Interpublic Group of Companies, Inc. (Interpublic) is a global advertising and marketing services companies. Interpublic's companies specialize in consumer advertising, digital marketing, communications planning and media buying, public relations and specialized communications disciplines. The Company has two segments: Integrated Agency Networks (IAN) and Constituency Management Group (CMG). IAN is comprised of McCann, Draftfcb, Lowe, Mediabrands and its domestic integrated agencies. CMG is comprised of a number of its specialist marketing services offerings. During the year ended December, 31, 2011, it completed 22 acquisitions, which included purchases of controlling interests in previously unconsolidated subsidiaries. In November 2013, Interpublic Group of Companies Inc's MRM, a global digital and direct agency within McCann Worldgroup, a unit of the Interpublic Group of Companies, acquired the Brazilian agency E/OU."},{"Symbol":"IFF","Name":"Intl Flavors & Fragrances","Sector":"Materials","Description":"International Flavors & Fragrances Inc. (IFF) creates, manufactures and supplies flavors and fragrances for the food, beverage, personal care and household products industries. The Company operates in two business segments: Flavors and Fragrances. Its Flavors business includes four categories of products: Savory, Beverages, Sweet, pharmaceutical and oral care (Sweet), and Dairy. Its Fragrances business consists of Fragrance Compounds and Fragrance Ingredients. Its manufacturing facilities are located in the United States, the Netherlands, Spain, Great Britain, Argentina, Brazil, Mexico, Australia, China, India, Indonesia, Japan and Singapore."},{"Symbol":"INTU","Name":"Intuit Inc.","Sector":"Information Technology","Description":"Intuit Inc. (Intuit) is a provider of business and financial management solutions for small businesses, consumers, accounting professionals and financial institutions. The Company organizes its portfolio of businesses into four principal categories: Small Business Group, Tax, Financial Services and Other Businesses. Small Business Group include seven segments: financial management solutions, employee management solutions, payment solutions, consumer tax, accounting professionals, financial services and other businesses. Tax include two segment: Consumer Tax and Accounting Professionals. Financial Services: This segment consists of digital (online and mobile) banking solutions and Other Businesse segment includes its global businesses. In June 2013, Intuit Inc acquired Elastic Intelligence Inc. Effective August 8, 2013, Intuit Inc acquired GoodApril, a provider of online tax planning services. Effective October 24, 2013, Intuit Inc acquired Level Up Analytics Inc."},{"Symbol":"ISRG","Name":"Intuitive Surgical Inc.","Sector":"Health Care","Description":"Intuitive Surgical, Inc. (Intuitive) designs, manufactures and markets da Vinci Surgical Systems and related instruments and accessories. A da Vinci Surgical System consists of a surgeon's console, a patient-side cart and a high performance vision system. The da Vinci Surgical System translates a surgeon's natural hand movements, which are performed on instrument controls at a console, into corresponding micro-movements of instruments positioned inside the patient through small incisions, or ports. The da Vinci Surgical System is designed to provide its operating surgeon with intuitive control, range of motion, fine tissue manipulation capability and three dimensional (3-D), high-definition (HD) vision while simultaneously allowing the surgeon to work through the small ports of MIS. On January 11, 2012, the Company acquired its Korean distributor."},{"Symbol":"IVZ","Name":"Invesco Ltd.","Sector":"Financials","Description":"Invesco Ltd. (Invesco) is an investment manager, dedicated to helping investors worldwide achieve their financial objectives. By delivering the combined power of its distinctive investment management capabilities, Invesco provides a comprehensive range of investment strategies and vehicles to its retail, institutional and high-net-worth clients around the world. It seeks to generate investment results, positive net flows, increased AUM and associated revenues. It measure relative investment performance by comparing its investment capabilities to competitors' products, industry benchmarks and client investment objectives. Generally, distributors, investment advisors and consultants take into consideration longer-term investment performance (e.g., three-year and five-year performance) in their selection of investment products and manager recommendations to their clients, although shorter-term performance may also be an important consideration."},{"Symbol":"IRM","Name":"Iron Mountain Incorporated","Sector":"Real Estate","Description":"Iron Mountain Incorporated (Iron Mountain) is engaged in storing records, primarily paper documents and data backup media, and provide information management services. The Company offers records management services, data protection and recovery services and information destruction services. Its information management services are divided into three categories: records management services, data protection and recovery services, and information destruction services. In May 2012, the Company acquired records storage firms File House Offsite Record Storage in Fredericksburg, Va., and Document Systems Inc. in Columbia, S.C. and offsite data protection provider First National Safe Deposit in the Philadelphia area. In May 2013, Iron Mountain Inc acquired Information Storage Consolidation Co LLC. In June 2013, Iron Mountain Inc announced that it has acquired Brazilian document storage firm Archivum. In October 2013, the Company announced that it has acquired Cornerstone Records Management."},{"Symbol":"JBHT","Name":"J. B. Hunt Transport Services","Sector":"Industrials","Description":"J B Hunt Transport Services Inc.(JBHT) is a holding company. The Company together with its wholly owned subsidiaries, operates as a surface transportation and delivery services to a diverse group of customers and consumers throughout the continental United States, Canada and Mexico. The Company operates in four segments: Intermodal (JBI), Dedicated Contract Services (DCS), Integrated Capacity Solutions (ICS), and full-load dry-van (JBT).The Company's service offerings include transportation of full-truckload containerized freight, which the Company directly transports utilizing its company-controlled revenue equipment and company drivers or independent contractors. The Company also provides customized freight movement, revenue equipment, labor, systems and delivery services that are tailored to meet individual customers' requirements and typically involve long-term contracts."},{"Symbol":"JEC","Name":"Jacobs Engineering Group","Sector":"Industrials","Description":"Jacobs Engineering Group Inc. is a technical professional services firm. The Company provides a diverse range of technical, professional, and construction services to a number of industrial, commercial, and governmental clients. The Company provides four categories of services: Project Services, Process, Scientific, and Systems Consulting services, Construction services, and Operations and Maintenance services. In June 2013, Jacobs Engineering Group Inc., announced that it has acquired Compass Technology Services, Inc. In October 2013, Jacobs Engineering Group Inc announced that its South African joint venture, Jacobs Matasis (Proprietary) Limited acquired the business and assets of Ilitha Projects and Ilitha Staffing, two South African professional services companies. In November 2013, Jacobs Engineering Group Inc acquired an undisclosed majority interest in Guimar Engenharia SA. In November 2013, the Company acquired MARMAC Field Services, Inc."},{"Symbol":"SJM","Name":"JM Smucker","Sector":"Consumer Staples","Description":"Smucker J M Co, formerly The J. M. Smucker Company, operates principally in the manufacturing and marketing of branded food products. Majority of the Company's sales are in the United States. The Company's operations outside the United States are principally in Canada, although products are exported to other countries as well. The Company operates in three segments: U.S. Retail Coffee, U.S. Retail Consumer Foods, and International, Foodservice and Natural Foods. In August 2013, the Company completed an acquisition of Enray Inc."},{"Symbol":"JNJ","Name":"Johnson & Johnson","Sector":"Health Care","Description":"Johnson & Johnson is a holding company. The Company is engaged in the research and development, manufacture and sale of a broad range of products in the health care field. The business of Johnson & Johnson is conducted by more than 275 operating companies located in 60 countries, including the United States, which sell products in virtually all countries throughout the world. In March 2013, Johnson & Johnson's Cordis Corporation announced the acquisition of Flexible Stenting Solutions, Inc. In June 2013, Johnson & Johnson announced the opening of the Johnson & Johnson Innovation center in Boston. In August 2013, Johnson & Johnson announced it has completed its acquisition of Aragon Pharmaceuticals, Inc., a pharmaceutical discovery and development company focused on drugs to treat hormonally driven cancers."},{"Symbol":"JCI","Name":"Johnson Controls International","Sector":"Industrials","Description":"Johnson Controls, Inc. (Johnson Controls) manufactures, installs and services automatic temperature regulation systems for buildings. The Building Efficiency business is engaged in designing, producing, marketing and installing integrated heating, ventilating and air conditioning (HVAC) systems, building management systems, controls, security and mechanical equipment. The Power Solutions business is a global supplier of lead-acid automotive batteries for virtually every type of passenger car, light truck and utility vehicle. The Automotive Experience business is an automotive supplier, providing interior systems. In May 2013, Johnson Controls Inc acquired the remaining 50% interest in Tata Johnson Controls Automotive Ltd from its joint-venture partner Tata Autocomp Systems Ltd, a unit of Tata Sons Ltd. On September 27, 2013, the Company sold its HomeLink business to Gentex Corporation. Effective November 8, 2013, Johnson Controls Inc acquired a 90% interest in MAC SA."},{"Symbol":"JPM","Name":"JPMorgan Chase & Co.","Sector":"Financials","Description":"JPMorgan Chase & Co. (JPMorgan Chase) is a financial holding company. The Company is a global financial services firm and a banking institution in the United States, with global operations. The Company is engaged in investment banking, financial services for consumers and small businesses, commercial banking, financial transaction processing, asset management and private equity. JPMorgan Chase's principal bank subsidiaries are JPMorgan Chase Bank, National Association (JPMorgan Chase Bank, N.A.), and Chase Bank USA, National Association (Chase Bank USA, N.A.). JPMorgan Chase's activities are organized into four business segments, as well as Corporate/Private Equity. The Company's consumer business is the Consumer & Community Banking segment. The Company's wholesale businesses consists of Corporate & Investment Bank, Commercial Banking, and Asset Management segments."},{"Symbol":"JNPR","Name":"Juniper Networks","Sector":"Information Technology","Description":"Juniper Networks, Inc. (Juniper Networks) designs, develops, and sells products and services that together provide its customers with network infrastructure. It operates in two segments: Infrastructure and Service Layer Technologies (SLT). The Company's Infrastructure segment primarily offers routing and switching products that are used to control and direct network traffic from the core, through the edge, aggregation, and the customer premise equipment level. Infrastructure products include its Internet protocol (IP) routing, carrier Ethernet routing portfolio, and Ethernet switching portfolio. Its SLT segment offers solutions that meet a range of its customers' priorities, from protecting the users, applications and data on the network itself to providing network services across a distributed infrastructure. Effective September 13, 2013, Juniper Networks, Inc. acquired Contrail Networks Inc."},{"Symbol":"KSU","Name":"Kansas City Southern","Sector":"Industrials","Description":"Kansas City Southern (KCS) is a transportation holding company with domestic and international rail operations in North America that are strategically focused on the growing north/south freight corridor connecting key commercial and industrial markets in the central United States with industrial cities in Mexico. The KCS coordinated rail network (KCSR, KCSM and Tex-Mex) comprises approximately 6,300 route miles extending from the mid west and southeast portions of the United States south into Mexico and connects with all other Class I railroads, providing shippers with an effective alternative to other railroad routes and giving direct access to Mexico and the southeast and southwest United States through alternate interchange hubs."},{"Symbol":"K","Name":"Kellogg Co.","Sector":"Consumer Staples","Description":"Kellogg Company (Kellogg) is engaged in the manufacture and marketing of ready-to-eat cereal and convenience foods. The Company's principal products are ready-to-eat cereals and convenience foods, such as cookies, crackers, savory snacks, toaster pastries, cereal bars, fruit-flavored snacks, frozen waffles and veggie foods. As of February 26, 2013, these products were manufactured by the Company in 18 countries and marketed in more than 180 countries. Kellogg also market cookies, crackers, crisps, and other convenience foods, under brands, such as Kellogg's, Keebler, Cheez-It, Murray, Austin and Famous Amos, to supermarkets in the United States. The Company's cereal products are generally marketed under the Kellogg's name and are sold to the grocery trade through direct sales forces for resale to consumers. Effective June 1, 2012, Procter & Gamble Co announced that it has completed the sale of its Pringles business to Kellogg."},{"Symbol":"KEY","Name":"KeyCorp","Sector":"Financials","Description":"KeyCorp, is a bank holding company. It is a bank-based financial services company. KeyCorp is the parent holding company for KeyBank National Association (KeyBank), its principal subsidiary, through which most of its banking services are provided. Through KeyBank and certain other subsidiaries, the Company provides a range of retail and commercial banking, commercial leasing, investment management, consumer finance and investment banking products and services to individual, corporate and institutional clients through two major business segments: Key Community Bank and Key Corporate Bank. In August 2013, KeyCorp closed on its agreement to sell Victory Capital Management and its broker dealer affiliate Victory Capital Advisers."},{"Symbol":"KMB","Name":"Kimberly-Clark","Sector":"Consumer Staples","Description":"Kimberly-Clark Corporation (Kimberly Clark) is a global company focused on the world in essentials for a better life through product innovation and building its personal care, consumer tissue, K C professional and health care brands. The Company is principally engaged in the manufacturing and marketing of a wide ranges of products made from natural or synthetic fibers using advanced technologies in fibers, nonwovens and absorbency. Its operating segments include Personal Care , Consumer Tissue K C Professional and HealthCare. The Company operates and markets its products globally in Asia, Latin America, Eastern Europe, the Middle East and Africa, with a particular emphasis in China, Russia and Latin America. In April 2013, it announced the acquisition of the anesthesia business of Life-Tech, Inc."},{"Symbol":"KIM","Name":"Kimco Realty","Sector":"Real Estate","Description":"Kimco Realty Corp. is a real estate investment trust (REIT) that owns and operates North America's largest portfolio of neighborhood and community shopping centers. As of December 31, 2012, the Company owned interests in 896 shopping centers comprising 131 million square feet of leasable space across 44 states, Puerto Rico, Canada, Mexico and South America. The Company is specialized in shopping center acquisitions, development and management. In December 2012, the Company acquired City Heights Retail Village in San Diego. In June 2013, Skyway Development Group LLC announced that it has closed on the acquisition of 30 West 21st Street from Kimco Realty Corporation. In October 2013, Terrafina SA de CV completed the acquisition of the industrial portfolio of Kimco Realty Corp and its partner American Industries. In November 2013, the Company purchased a three-property, 189,000-square-foot grocery-anchored portfolio in the New York City metropolitan statistical area (MSA)."},{"Symbol":"KMI","Name":"Kinder Morgan","Sector":"Energy","Description":"Kinder Morgan, Inc. (KMI) owns and manages a diversified portfolio of energy transportation and storage assets. The Company operates in five business segments: Products Pipelines-KPM, Natural Gas Pipelines-KMP, CO2-KMP, Terminals-KMP and Kinder Morgan Canada-KMP. The Company through Kinder Morgan Energy Partners, L.P. (KMP) operates or owns an interest in approximately 37,000 miles of pipelines and approximately 180 terminals. These pipelines transport natural gas, refined petroleum products, crude oil, carbon dioxide and other products, and its terminals store petroleum products and chemicals, and handle such products as ethanol, coal, petroleum coke and steel. The Company is a provider of carbon dioxide (CO2), for enhanced oil recovery projects in North America. On May 25, 2012, KMI acquired El Paso Corporation. In August 2012, Kinder Morgan Energy Partners, L.P. acquired Tennessee Gas Pipeline (TGP) and a 50% interest in El Paso Natural Gas (EPNG) pipeline from KMI."},{"Symbol":"KLAC","Name":"KLA-Tencor Corp.","Sector":"Information Technology","Description":"KLA-Tencor Corporation (KLA-Tencor) is engaged in the design, manufacture and marketing of process control and yield management solutions for the semiconductor and related nanoelectronics industries. KLA-Tencor's offerings include the Chip Manufacturing, Wafer Manufacturing, Reticle Manufacturing, Complementary Metal-Oxide-Semiconductor (CMOS) Image Sensors Manufacturing, Solar Manufacturing, light emitting diode (LED) Manufacturing, Data Storage Media/Head Manufacturing, Microelectromechanical Systems (MEMS) Manufacturing, and General Purpose/Lab Applications. It also provides refurbished KLA-Tencor tools as part of its K-T Certified program for customers manufacturing larger design-rule devices, as well as service and support for its products. The Company's products are used in a number of other industries, including the LED, data storage and photovoltaic industries, as well as general materials research."},{"Symbol":"KSS","Name":"Kohl's Corp.","Sector":"Consumer Discretionary","Description":"Kohl's Corporation (Kohl's) operate family-oriented department stores that sell apparel, footwear and accessories for women, men and children; soft home products, such as sheets and pillows, and housewares. Kohl's apparel and home fashions appeal to classic, modern classic and contemporary customers. As of January 28, 2012, the Company operated 1,127 stores in 49 states. In addition, Kohl's offers on-line shopping on its Website at www.Kohls.com. Originally designed as an added service for customers who prefer to shop using the Internet, the Website include a selection of items and categories beyond what is available in stores, with a primary focus on sizes, product line extensions, and Web-exclusive product lines. Only at Kohl's is a brand of the Company. In March 2012, the Company opened eight new stores. In March 2013, it announced the openings of nine new stores, bringing the Company's store count to 1,155 stores."},{"Symbol":"KHC","Name":"Kraft Heinz Co","Sector":"Consumer Staples","Description":"The Kraft Heinz Company, through its subsidiaries, operates as a food and beverage company in North America and internationally. It primarily offers food and beverage products, including cheese, meats, refreshment beverages, coffee, packaged dinners, refrigerated meals, snack nuts, dressings, ketchup, condiments and sauces, frozen food, soups, beans and pasta meals, infant nutrition, and other food and grocery products. The company offers its products under the brands, including Kraft, Heinz, ABC, Capri Sun, Classico, Jell-O, Kool-Aid, Lunchables, Maxwell House, Ore-Ida, Oscar Mayer, Philadelphia, Planters, Plasmon, Quero, Weight Watchers Smart Ones, and Velveeta. The company was formerly known as H.J. Heinz Holding Corporation and changed its name to The Kraft Heinz Company in July 2015. The Kraft Heinz Company is based in Pittsburgh, Pennsylvania."},{"Symbol":"KR","Name":"Kroger Co.","Sector":"Consumer Staples","Description":"The Kroger Co. is a retailer in the United States. The Company also manufactures and processes some of the food for sale in its supermarkets. As of January 28, 2012, it operated, either directly or through its subsidiaries, 2,435 supermarkets and multi-department stores, 1,090 of which had fuel centers. As of January 28, 2012, it operated 2,435 supermarket and multi-department stores under banners, including Kroger, City Market, Dillons, Jay C, Food 4 Less, Fred Meyer, Fry's, King Soopers, QFC, Ralphs and Smith's. Of these stores, 1,090 have fuel centers. It also operates 791 convenience stores, either directly or through franchisees, and 348 jewelry stores. In addition to the supermarkets, as of January 28, 2012, it operated through subsidiaries 791 convenience stores and 348 jewelry stores. All of its jewelry stores located in malls is operated in leased locations. All of its jewelry stores located in malls is operated in leased locations."},{"Symbol":"LB","Name":"L Brands Inc.","Sector":"Consumer Discretionary","Description":"L Brands, Inc., formerly Limited Brands, Inc operates in the specialty retail business. The Company is a specialty retailer of women's intimate and other apparel, beauty and personal care products and accessories. It operates in two segments: Victoria's Secret and Bath & Body Works. It sells its merchandise through Company-owned specialty retail stores in the United States, Canada and the United Kingdom, which are primarily mall-based, and through Websites, catalogue and international franchise, license and wholesale partners. It operates in brands, such as Victoria's Secret, Victoria's Secret Pink, Bath & Body Works, La Senza, and Henri Bendel. Its business for both the Victoria's Secret and Bath & Body Works segments is principally conducted from office, distribution and shipping facilities located in the Columbus, Ohio area. As of February 2, 2013, it operated 2,619 retail stores located in leased facilities, primarily in malls and shopping centers, throughout United States."},{"Symbol":"LLL","Name":"L-3 Communications Holdings","Sector":"Industrials","Description":"L-3 Communications Holdings, Inc. (L-3 Holdings) is a prime contractor in Command, Control, Communications, Intelligence, Surveillance and Reconnaissance (C3ISR) systems, aircraft modernization and maintenance, and government services. It is also a provider of a range of electronic systems used on military and commercial platforms. Its customers include the United States Department of Defense and its prime contractors, United States Government intelligence agencies, the United States Department of Homeland Security, United States Department of State, United States Department of Justice, and allied foreign governments, domestic and foreign commercial customers. It operates in four segments: C3ISR, Government Services, Aircraft Modernization and Maintenance and Electronic Systems. On February 6, 2012, it acquired Kollmorgen Electro-Optical unit of Danaher Corporation. On August 6, 2012, it acquired Thales Training & Simulation Ltd's civil aircraft simulation and training business."},{"Symbol":"LH","Name":"Laboratory Corp. of America Holding","Sector":"Health Care","Description":"Laboratory Corporation of America Holdings is a clinical laboratory company in the United States. Through a national network of laboratories, the Company offers a range of testing services used by the medical profession in routine testing, patient diagnosis, and in the monitoring and treatment of disease. In addition, it has developed specialty and niche operations based on certain types of specialized testing capabilities and client requirements, such as oncology testing, human immunodeficiency virus (HIV) genotyping and phenotyping, diagnostic genetics and clinical research trials. It processes tests on approximately 470,000 patient specimens daily and provides clinical laboratory testing services in all 50 states, the District of Columbia, Puerto Rico, Belgium, Japan, the United Kingdom, China, Singapore and three provinces in Canada."},{"Symbol":"LRCX","Name":"Lam Research","Sector":"Information Technology","Description":"Lam Research Corporation (Lam Research), is a supplier of wafer fabrication equipment and services to the worldwide semiconductor industry. Lam Research designs, manufactures, markets, refurbish, and services semiconductor processing equipment used in the fabrication of integrated circuit. In addition, it offers a broad portfolio of single-wafer clean technologies. Its Customer Support Business Group (CSBG) provides products and services to maximize installed equipment performance and operational efficiency. It offers a range of services including customer service, spares, upgrades, refurbishment of its etch, deposition, photoresist strip, and clean products. The Company also develops manufactures, sells and supports equipment used in grinding, lapping and polishing precision parts used in a spectrum of industrial applications.In June 2012, Lam Research completed its merger with Novellus Systems, Inc."},{"Symbol":"LEG","Name":"Leggett & Platt","Sector":"Consumer Discretionary","Description":"Leggett & Platt, Incorporated is an international manufacturer that conceives, designs and produces a range of engineered components and products found in many homes, offices, retail stores, automobiles and commercial aircraft. The Company's operations are organized into 20 business units, which are divided into 10 groups under its four segments: Residential Furnishings; Commercial Fixturing & Components; Industrial Materials, and Specialized Products. On January 12, 2012, the Company completed the acquisition of Western Pneumatic Tube Holding, LLC. In Leggett & Platt Inc acquired Specitubes SAS from PFW Aerospace AG."},{"Symbol":"LEN","Name":"Lennar Corp.","Sector":"Consumer Discretionary","Description":"Lennar Corporation is a homebuilder and a provider of financial services and through its Rialto Investments (Rialto) segment, an investor, and manager of funds that invest in real estate assets. The Company's homebuilding operations include the construction and sale of single-family attached and detached homes, as well as the purchase, development and sale of residential land directly and through unconsolidated entities in which it has investments. Its homebuilding activities have five segments: Homebuilding East, Homebuilding Central, Homebuilding West, Homebuilding Southeast Florida, and Homebuilding Houston. It has two other segments: financial services and rialto. Its financial services reportable segment provides mortgage financing, title insurance and closing services for both buyers of its homes and others. Rialto segment focuses on real estate investments and asset management."},{"Symbol":"LUK","Name":"Leucadia National Corp.","Sector":"Financials","Description":"Leucadia National Corporation is a diversified holding company. Leucadia's largest business is Jefferies, a global, full service investment banking firm. Leucadia also owns and holds investments in a range of other businesses, including beef processing, manufacturing, telecommunications, gaming, real estate, and energy."},{"Symbol":"LVLT","Name":"Level 3 Communications","Sector":"Telecommunications Services","Description":"Level 3 Communications, Inc. (Level 3) is a facilities-based provider of a range of integrated communications services. It has created its communications network by constructing its own assets and through a combination of purchasing other companies and purchasing or leasing facilities from others. Its network is an international, facilities-based communications network. Level 3 provides communications services to a range of wholesale and enterprise customers. Wholesale customers may use its services as a component in their own offering of telecommunications services to their customers. Enterprise customers use its services for their own needs. It further subdivides enterprise customers into four subgroups: large enterprise customers, which consist of its roughly 1,000 largest enterprise customers other than content customers; government customers; mid-market customers, which are enterprise customers other than large enterprise customers, and content customers."},{"Symbol":"LLY","Name":"Lilly (Eli) & Co.","Sector":"Health Care","Description":"Eli Lilly and Company discovers, develops, manufactures, and sells products, in one business segment, pharmaceutical products. The Company also has an animal health business segment. It manufactures and distributes its products through facilities in the United States, Puerto Rico, and 15 other countries. Its products are sold in approximately 130 countries. The Company's products include neuroscience products, endocrinology products, oncology products, cardiovascular products, animal health products and other pharmaceuticals. The Company's new molecular entities (NMEs), which are in Phase III clinical trial testing include Dulaglutide, Edivoxetine, Ixekizumab, Necitumumab, New insulin glargine product, Novel basal insulin analog, Pomaglumetad Methionil, Ramucirumab, Solanezumab and Tabalumab. In February 2012, the Company acquired ChemGen Corp. On July 7, 2011, it acquired the animal health business of Janssen, a Johnson & Johnson company."},{"Symbol":"LNC","Name":"Lincoln National","Sector":"Financials","Description":"Lincoln National Corporation, through its subsidiaries, engages in multiple insurance and retirement businesses in the United States. It operates through Annuities, Retirement Plan Services, Life Insurance, and Group Protection segments. The company sells a range of wealth protection, accumulation, and retirement income products and solutions. Its products include fixed and indexed annuities, variable annuities, universal life insurance (UL), variable universal life insurance (VUL), linked-benefit UL, term life insurance, indexed universal life insurance, and employer-sponsored retirement plans and services, as well as group life, disability, and dental products. Lincoln National Corporation also provides various plan investment vehicles, including individual and group variable annuities, group fixed annuities, and mutual fund-based programs; single and survivorship versions of UL and VUL, including corporate-owned UL and VUL, as well as bank-owned UL and VUL insurance products; and group non-medical insurance products, principally term life, universal life, disability, dental, vision, accident, and critical illness insurance to the employer market place through various forms of contributory and non-contributory plans. The company distributes its products through consultants, brokers, planners, agents, financial advisors, third-party administrators, and other intermediaries. Lincoln National Corporation was founded in 1904 and is headquartered in Radnor, Pennsylvania."},{"Symbol":"LLTC","Name":"Linear Technology Corp.","Sector":"Information Technology","Description":"Linear Technology Corporation (Linear Technology) is designing, manufacturing and marketing a range of analog integrated circuits for companies globally. The Company's products provide a bridge between its analog world and the digital electronics in communications, networking, industrial, automotive, computer, medical, instrumentation, consumer, and military and aerospace systems. Linear Technology produces power management, data conversion, signal conditioning, radio frequency (RF) and interface integrated circuits (ICs), Module subsystems, and wireless sensor network products."},{"Symbol":"LKQ","Name":"LKQ Corporation","Sector":"Consumer Discretionary","Description":"LKQ Corporation (LKQ) provides replacement parts, components and systems needed to repair vehicles (cars and trucks). The Company operates in four segments: Wholesale-North America Wholesale-Europe, Self Service and Heavy-Duty Truck. Buyers of vehicle replacement products have the option to purchase from primarily five sources: new products produced by original equipment manufacturers (OEMs), which are known as OEM products; new products produced by companies other than the OEMs, which are sometimes referred to as aftermarket products; recycled products originally produced by OEMs, which it refers to as recycled products; used products that have been refurbished; and used products that have been remanufactured. Effective August 6, 2013, LKQ Corp acquired Premier Paints Ltd, a manufacturer of motor vehicle parts, form Iris Coatings Ltd, and concurrently, LKQ acquired Bee Bee Refinishing Supplies Halstead, JCA Coatings, Milton Keynes Paint & Equipment and Sinemaster Motor Factors Ltd."},{"Symbol":"LMT","Name":"Lockheed Martin Corp.","Sector":"Industrials","Description":"Lockheed Martin Corporation is a global security and aerospace company principally engaged in the research, design, development, manufacture, integration, and sustainment of technology systems and products. The Company also provides a range of management, engineering, technical, scientific, logistic, and information services. It serves both domestic and international customers with products and services that have defense, civil, and commercial applications, with its principal customers being agencies of the United States Government. It operates in five business segments: Aeronautics, Information Systems & Global Solutions (IS&GS), Missiles and Fire Control (MFC), Mission Systems and Training (MST), and Space Systems. In July 2013, Lockheed Martin Corporation launched Lockheed Martin International. In September 2013, Lockheed Martin Corporation announced the acquisition of Amor Group."},{"Symbol":"L","Name":"Loews Corp.","Sector":"Financials","Description":"Loews Corporation, through its subsidiaries, operates as a commercial property and casualty insurance company primarily in the United States. The company offers management and professional liability insurance and risk management services, and other specialized property and casualty coverages; commercial surety and fidelity bonds; and warranty and alternative risk services primarily for vehicles and portable electronic communication devices. Its commercials property insurance products include standard and excess property, marine, and boiler and machinery coverages; and casualty insurance products comprise workers compensation, general and product liability, commercial auto, and umbrella coverages. The company also provides loss-sensitive insurance programs; and risk management, information, warranty, and claims administration services, as well as underwrites primarily short-tail exposures in marine and aviation, non-marine property, property treaty reinsurance, and specialty lines products. It markets its insurance products and services primarily through independent agents, brokers, and managing general underwriters to various customers. In addition, the company owns and operates 38 offshore drilling rigs consisting of 27 semisubmersible rigs, 6 jack-ups, and 5 drillships for companies engaged in the exploration and production of hydrocarbons. Further, it is involved in the transportation and storage of natural gas and natural gas liquids (NGLs), and gathering and processing of natural gas. It owns and operates natural gas pipelines covering approximately 14,190 miles of interconnected pipelines transporting approximately 2.5 trillion cubic feet of natural gas and approximately 34.4 million barrels of NGLs; and underground storage fields with aggregate working gas capacity of approximately 208.0 billion cubic feet of natural gas. Additionally, it operates 21 upper and upscale hotels. The company was founded in 1954 and is headquartered in New York, New York."},{"Symbol":"LOW","Name":"Lowe's Cos.","Sector":"Consumer Discretionary","Description":"Lowe's Companies, Inc. (Lowe's) is a home improvement retailer. As of February 3, 2012, Lowe's operated 1,745 stores, consisted of 1,712 stores across 50 United States, 31 stores in Canada and two stores in Mexico. Its 1,745 stores represent approximately 197 million square feet of retail selling space. The Company serves homeowners, renters and commercial business customers. Individual homeowners and renters complete an array of projects and vary along the spectrum of do-it-yourself (DIY) and do-it-for-me (DIFM). Commercial business customers include those who work in construction, repair/remodel, commercial and residential property management, or business maintenance professions. During the fiscal year ended February 3, 2012 (fiscal 2011), it opened 25 stores, which included the relocation of two existing stores. Seven of the stores were opened in Canada. In August 2013, the Company acquired the majority of assets of Orchard Supply Hardware, including 72 Orchard stores."},{"Symbol":"LYB","Name":"LyondellBasell","Sector":"Materials","Description":"LyondellBasell Industries N.V. is an independent chemical company. The Company's chemicals businesses consist of processing plants that convert volumes of liquid and gaseous hydrocarbon feedstock into plastic resins and other chemicals. Its Houston refinery processes crude oil into fuels, such as gasoline, diesel and jet fuel. Its segments include Olefins and Polyolefins-Americas (O&P-Americas), Olefins and Polyolefins-Europe, Asia, International (O&P-EAI), Intermediates and Derivatives (I&D), Refining & Oxyfuels and Technology. It's O&P-Americas and O&P-EAI products include olefins, polyolefins and polypropylene (PP) compounds. I&D products include acetyls and ethylene derivatives. Refining & Oxyfuels include gasoline and alkylate. Technology include PP process technologies land polyolefin catalysts. On January 4, 2012, refinery operations were suspended at its Berre refinery in France."},{"Symbol":"MTB","Name":"M&T Bank Corp.","Sector":"Financials","Description":"M&T Bank Corporation (M&T) is a bank holding company. As of December 31, 2012, M&T had two wholly owned bank subsidiaries: M&T Bank and Wilmington Trust, National Association (Wilmington Trust, N.A.). The banks collectively offer a range of retail and commercial banking, trust, wealth management and investment services to their customers. The Company conducts lending activities in various states through other subsidiaries. M&T Bank and certain of its subsidiaries also offer commercial mortgage loans secured by income producing properties or properties used by borrowers in a trade or business. Additional financial services are provided through other operating subsidiaries of the Company. Its segments include Business Banking, Commercial Banking, Commercial Real Estate, Discretionary Portfolio, Residential Mortgage Banking and Retail Banking."},{"Symbol":"MAC","Name":"Macerich","Sector":"Real Estate","Description":"The Macerich Company is a fully integrated self-managed and self-administered real estate investment trust (REIT). The Company focuses on the acquisition, leasing, management, development and redevelopment of regional malls throughout the United States. Macerich focuses on retail properties in California, Arizona, Chicago, Greater New York Metro and Washington, DC. As of September 30, 2013, the Company owned approximately 61 million square feet of real estate consisted of primarily of interests in 58 regional shopping centers. The Company's properties include Queens Center, Kings Plaza Shopping Center and Green Acres Mall in New York City."},{"Symbol":"M","Name":"Macy's Inc.","Sector":"Consumer Discretionary","Description":"Macy's, Inc. (Macy's) is a retail organization operating stores and Internet Websites under two brands (Macy's and Bloomingdale's) that sell a range of merchandise, including apparel and accessories (men's, women's and children's), cosmetics, home furnishings and other consumer goods in 45 states, the District of Columbia, Guam and Puerto Rico. As of January 28, 2012, the Company's operations were conducted through Macy's, macys.com, Bloomingdale's, bloomingdales.com and Bloomingdale's Outlet. During the year ended December 31, 2011, the Company opened three new Bloomingdale's Outlet stores and re-opened one Macy's store. On February 25, 2011, the Company sold its investment in The Knot, Inc."},{"Symbol":"MNK","Name":"Mallinckrodt Plc","Sector":"Health Care","Description":"Mallinckrodt public limited company develops, manufactures, markets, and distributes specialty pharmaceutical products and medical imaging agents worldwide. The company operates through two segments, Specialty Pharmaceuticals and Global Medical Imaging. The Specialty Pharmaceuticals segment provides Acthar, an injectable biopharmaceutical drug for use in various indications, including neurology, rheumatology, nephrology, and pulmonology; Ofirmev and Xartemis XR for pain indications; EXALGO extended-release tablets to treat chronic pain; and GABLOFEN injections for use in the management of spasticity of cerebral or spinal origin. It also offers generics and active pharmaceutical ingredients (API), such as hydrocodone and hydrocodone-containing tablets, oxycodone and oxycodone-containing tablets, and methylphenidate HCl extended-release tablets, as well as biologics, medicinal opioids, synthetic controlled substances, acetaminophen products, and other active ingredients. The Global Medical Imaging segment provides contrast media and delivery systems comprising ioversol and gadoversetamide injections for diagnostic imaging applications under the Optiray and Optimark brand names with pre-filled syringes and power injectors to the hospitals and imaging centers. It also offers nuclear imaging products consisting of technetium-99m generators under the Ultra-Technekow DTE brand; cold kits; and Octreoscan kits for localization of tumors. The company markets its products to physicians, pharmacists, pharmacy buyers, specialty pharmacies, radiologists, and radiology technicians, as well as distributes its products to drug wholesalers, retail pharmacy chains, hospital networks, ambulatory surgical centers, and governmental agencies; sells and distributes APIs directly or through distributors to other pharmaceutical companies; and markets and distributes nuclear imaging products to radiopharmacies and hospitals. Mallinckrodt public limited company is based in Dublin, Ireland."},{"Symbol":"MRO","Name":"Marathon Oil Corp.","Sector":"Energy","Description":"Marathon Oil Corporation (Marathon Oil) is an international energy company engaged in exploration and production, oil sands mining and integrated gas with operations in the United States, Angola, Canada, Equatorial Guinea.(E.G.), Ethiopia, Gabon, Kenya, the Kurdistan Region of Iraq, Libya, Norway, Poland and the United Kingdom. The Company operates in three business segments: Exploration and Production Segment, explores for, produces and markets liquid hydrocarbons and natural gas on a worldwide basis; Oil sands mining segment, mines, extracts and transports bitumen from oil sands deposits in Alberta, Canada, and upgrades the bitumen to produce and market synthetic crude oil and vacuum gas oil, and integrated gas, produces and markets products manufactured from natural gas, such as LNG and methanol, in E.G. During the year ended December 31, 2012 , the Company Company acquired approximately 25,000 net acres in the core of the Eagle Ford shale."},{"Symbol":"MPC","Name":"Marathon Petroleum","Sector":"Energy","Description":"Marathon Petroleum Corporation (Marathon Petroleum) is engaged in refining, transporting and marketing petroleum products in the United States. The Company's refining, marketing and transportation operations are concentrated in the Midwest, Gulf Coast and Southeast regions of the United States. These include a six-plant refining network, a terminal and transportation system, and wholesale and retail marketing operations. This includes both the Marathon Brand and Marathon Petroleum's wholly owned retail marketing subsidiary, Speedway LLC and operated retail gasoline and convenience stores. As of December 31, 2012, the Company leased or owned approximately 1,944 leased and 27 owned railcars of various sizes and capacities for movement and storage of refined products."},{"Symbol":"MAR","Name":"Marriott Int'l.","Sector":"Consumer Discretionary","Description":"Marriott International, Inc. is a diversified hospitality company. It is a lodging company with more than 3,700 properties in 73 countries and territories. It operates and franchises hotels, including Marriott, The Ritz-Carlton, JW Marriott, Bulgari, EDITION, Renaissance, Autograph Collection, AC Hotels by Marriott, Courtyard, Fairfield Inn & Suites, SpringHill Suites, Residence Inn, TownePlace Suites, ExecuStay, and Marriott Executive Apartments brand names. It operates in four segments: North American Full-Service Lodging, which includes the Marriott Hotels & Resorts; North American Limited-Service Lodging, which includes the Courtyard; International Lodging, which includes the Marriott Hotels & Resorts, and Luxury Lodging, which includes The Ritz-Carlton. In September 2012, its JW Marriott hotel brand opened JW Marriott Essex House New York. In October 2012, Gaylord Entertainment Company sold the Gaylord Hotels brand and the rights to manage its four hotels to the Company."},{"Symbol":"MMC","Name":"Marsh & McLennan","Sector":"Financials","Description":"Marsh & McLennan Companies, Inc. is a global professional services firm providing advice and solutions in the areas of risk, strategy and human capital. It is the parent company of a number of risk experts and specialty consultants, including Marsh, the insurance broker, intermediary and risk advisor; Guy Carpenter, the risk and reinsurance specialist; Mercer, the provider of human resource (HR) and related financial advice and services, and Oliver Wyman Group, the management and economic consultancy. The Company provides analysis, advice and transactional capabilities to clients in more than 100 countries. In November 2013, the Company acquired Elsey & Associates. In December 2013, the Company announced that its Marsh & McLennan Agency LLC, a subsidiary of insurance broker Marsh Inc., announced the acquisition of Cambridge Property & Casualty, one of the property/casualty insurance agencies in Michigan."},{"Symbol":"MLM","Name":"Martin Marietta Materials","Sector":"Materials","Description":"Martin Marietta Materials, Inc. is the producer of aggregates products (crushed stone, sand, and gravel) for the construction industry, including infrastructure, nonresidential, residential, railroad ballast, agricultural, and chemical grade stone used in environmental applications. The Company operates in four business segments: the Mideast Group, Southeast Group, and West Group and the Specialty Products segment. The Specialty Products segment includes the magnesia-based chemicals and dolomitic lime businesses. The Company's aggregates business also includes asphalt products, ready mixed concrete, and road paving operations. The Company also has a Specialty Products segment that manufactures and markets magnesia-based chemical products used in industrial, agricultural, and environmental applications, and dolomitic lime sold primarily to customers in the steel industry."},{"Symbol":"MAS","Name":"Masco Corp.","Sector":"Industrials","Description":"Masco Corporation manufactures, distributes and installs home improvement and building products. The Company is a manufacturer of a number of home improvements and building products, including faucets, cabinets, architectural coatings and windows, and the installer of insulation for the new home construction market. The Company provides a range of product offerings and distribute products through multiple channels, including directly to homebuilders and wholesale and retail channels. Approximately 76% of the Company's sales were generated by its North American operations during the year ended December 31, 2011."},{"Symbol":"MA","Name":"Mastercard Inc.","Sector":"Information Technology","Description":"MasterCard Incorporated (MasterCard) is a global payments and technology company that connects consumers, financial institutions, merchants, Governments and businesses worldwide, enabling them to use electronic forms of payment instead of cash and checks. The Company offers a range of payment solutions that enable its customers and partners to develop and implement credit, debit, prepaid and related payment programs for their customers. Its customers and partners include financial institutions and other entities that act as issuers and acquirers, merchants, Government entities, telecommunications companies and other businesses. MasterCard manages a family of payment brands, including MasterCard, Maestro and Cirrus, which the Company license to its customers for use in their payment programs and solutions. On April 15, 2011, MasterCard acquired the prepaid card program management operations of Travelex Holdings Ltd., since renamed Access Prepaid Worldwide."},{"Symbol":"MAT","Name":"Mattel Inc.","Sector":"Consumer Discretionary","Description":"Mattel, Inc. (Mattel) designs, manufactures and markets a variety of toy products worldwide which are sold to its customers and directly to consumers. Mattel's portfolio of brands and products are grouped in categories, such as Mattel Girls & Boys Brands, including Barbie fashion dolls and accessories (Barbie), Polly Pocket, Little Mommy, Disney Classics, and Monster High (collectively Other Girls Brands), Hot Wheels, Matchbox, and Tyco R/C vehicles and play sets, and CARS, Radica, Toy Story, Max Steel, WWE Wrestling, and Batman, and games and puzzles; Fisher-Price Brands-including Fisher-Price, Little People, BabyGear, Imaginext, and View-Master, Dora the Explorer, Go Diego Go!, Thomas and Friends, Mickey Mouse Clubhouse, Sing-a-ma-jigs, and See 'N Say, and Power Wheels, and American Girl Brands, including My American Girl, the historical collection, and Bitty Baby. American Girl Brands products are sold directly to consumers via its catalogue, Website, and retail stores."},{"Symbol":"MKC","Name":"McCormick & Co.","Sector":"Consumer Staples","Description":"McCormick & Company, Incorporated manufactures, markets and distributes spices, seasoning mixes, condiments and other flavorful products to the entire food industry, retail outlets, food manufacturers and foodservice businesses. The Company operates in two business segments: consumer and industrial. The Company's sales, distribution and production facilities are located in North America and Europe. Additional facilities are based in China, Australia, Mexico, India, Singapore, Central America, Thailand and South Africa. The Company operates in two business segments: consumer and industrial. Its products are sold directly to customers and also through brokers, wholesalers and distributors. In May 2013, the Company has completed its purchase of China's Wuhan Asia-Pacific Condiments Co."},{"Symbol":"MCD","Name":"McDonald's Corp.","Sector":"Consumer Discretionary","Description":"McDonald's Corporation franchises and operates McDonald's restaurants in the global restaurant industry. These restaurants serve menu at various price points providing value in 119 countries globally. All restaurants are operated either by the Company or by franchisees, including conventional franchisees under franchise arrangements, and developmental licensees and foreign affiliated markets under license agreements. Under the conventional franchise arrangement, franchisees provide a portion of the capital required by initially investing in the equipment, signs, seating and decor of their restaurant businesses, and by reinvesting in the business over time."},{"Symbol":"MCK","Name":"McKesson Corp.","Sector":"Health Care","Description":"McKesson Corporation delivers pharmaceuticals, medical supplies and healthcare information technologies. The Company operates in two segments: McKesson Distribution Solutions segment and McKesson Technology Solutions segment. The McKesson Distribution Solutions segment distributes drugs, medical-surgical supplies and equipment and health and beauty care products throughout North America. The McKesson Technology Solutions segment delivers enterprise clinical, patient care, financial, supply chain, strategic management software solutions, pharmacy automation for hospitals, as well as connectivity, outsourcing and other services, including remote hosting and managed services, to healthcare organizations. In February 2013, the Company completed acquisition of Pss World Medical Inc."},{"Symbol":"MJN","Name":"Mead Johnson","Sector":"Consumer Staples","Description":"Mead Johnson Nutrition Company (Mead Johnson) is a global pediatric nutrition company. The Company manufactures, distributes and sells infant formulas, children's nutrition and other nutritional products. Its Enfa family of brands, including Enfamil infant formula, is the global brand franchise in pediatric nutrition. Its product portfolio addresses a range of nutritional needs for infants, children and expectant and nursing mothers. The Company markets its portfolio of more than 70 products to mothers, health care professionals and retailers in more than 50 countries in Asia, North America, Latin America and Europe. During the year ended December 31, 2011, it operated two segments: Asia/Latin America and North America/Europe, which consisted of 66% and 34%, respectively, of its net sales. In addition to the Enfa family of brands, the Company markets several other brands on a local, regional or global basis."},{"Symbol":"MDT","Name":"Medtronic plc","Sector":"Health Care","Description":"Medtronic, Inc. (Medtronic), is engaged in medical technology. As of April, 27, 2012, the Company functions in two operating segments that manufacture and sells device-based medical therapies. The Company's operating segments include Cardiac and Vascular Group, which consists of Cardiac Rhythm Disease Management (CRDM) and CardioVascular, and Restorative Therapies Group, which consists of Spinal, Neuromodulation, Diabetes and Surgical Technologies. Medtronic serves hospitals, physicians, clinicians, and patients in more than 120 countries worldwide. The Company's primary customers include hospitals, clinics, third-party health care providers, distributors, and other institutions, including governmental health care programs and group purchasing organizations. In August 2013, Medtronic, Inc. announced the closing of the acquisition of Cardiocom. Effective September 3, 2013, Medtronic Inc acquired a 30% stake in NGC Medical SpA."},{"Symbol":"MRK","Name":"Merck & Co.","Sector":"Health Care","Description":"Merck & Co., Inc. (Merck) is a global health care company that delivers health solutions through its prescription medicines, vaccines, biologic therapies, animal health, and consumer care products, which it markets directly and through its joint ventures. The Company consists of four operating segments, which are the Pharmaceutical, Animal Health, Consumer Care and Alliances segments, and one reportable segment, which is the Pharmaceutical segment. The Pharmaceutical segment includes human health pharmaceutical and vaccine products marketed either directly by the Company or through joint ventures. Human health pharmaceutical products consist of therapeutic and preventive agents, generally sold by prescription, for the treatment of human disorders. Effective February 25, 2013, Dashtag, a unit of Merck & Co Inc's Schering Plough Corp subsidiary acquired 17.95% interest in Fulford (India) Ltd."},{"Symbol":"MET","Name":"MetLife Inc.","Sector":"Financials","Description":"MetLife, Inc. (MetLife) is a provider of insurance, annuities and employee benefit programs, serving 90 million customers in over 50 countries. Through its subsidiaries and affiliates, MetLife operates in the United States, Japan, Latin America, Asia Pacific, Europe and the Middle East. It is organized into six segments: Insurance Products, Retirement Products, Corporate Benefit Funding and Auto & Home (collectively, U.S. Business), and Japan and Other International Regions (collectively, International). U.S. Business provides insurance and financial services products, including life, dental, disability, auto and homeowner insurance. In September 2013, MetLife Inc and Thayer Lodging Group acquired the 365-room Hilton Los Cabos Beach & Golf Resort in Cabo San Lucas, Mexico in a joint venture. In October 2013, Banco Bilbao Vizcaya Argentaria SA sold its entire 64.3% interest in Administradora de Fondos de Pensiones Provida SA (AFP Provida) to Metlife Inc's subsidiaries."},{"Symbol":"MTD","Name":"Mettler Toledo","Sector":"Health Care","Description":"Mettler-Toledo International Inc. supplies precision instruments and services worldwide. The company operates in five segments: U.S. Operations, Swiss Operations, Western European Operations, Chinese Operations, and Other. It offers weighing instruments for use in laboratory, industrial, packaging, logistics, and food retailing applications; analytical instruments for use in life science; reaction engineering and real-time analytic systems used in drug and chemical compound development; automated chemistry solutions used in drug and chemical compound discovery and development; and metal detection and other end-of-line inspection systems used in production and packaging for food, pharmaceutical, and other industries. Its laboratory instruments include laboratory balances, liquid pipetting solutions, titrators, thermal analysis and analyzers systems; and other analytical instruments comprising pH meters, density and refractometry instruments, and moisture analyzers, as well as laboratory software, automated chemistry solutions, and process analytic instruments. The companys industrial solutions comprise industrial weighing instruments and terminals, automatic identification and data capture solutions, vehicle scale systems, industrial software, and product inspection systems. Its retail solutions consist of multiple weighing and food labeling solutions, such as stand-alone scales, and networked scales and software for handling fresh goods, such as meats, vegetables, fruits, and cheeses. The company serves the life science industry covering pharmaceutical and biotechnology companies, and independent research organizations; food and beverage producers; food retailers; chemical, specialty chemical, and cosmetics companies; transportation and logistics, metals, and electronics industries; and the academic community. It markets its products through its direct sales force and indirect distribution channels. The company was founded in 1991 and is based in Columbus, Ohio."},{"Symbol":"KORS","Name":"Michael Kors Holdings","Sector":"Consumer Discretionary","Description":"Michael Kors Holdings Limited is a global lifestyle brand . The Company designs, materials and craftsmanship with a jet-set aesthetic that combines stylish elegance and a sporty attitude. The Company is an American sportswear house to a global accessories, footwear and apparel company with a presence in over 85 countries. Its segments include retail, wholesale and licensing. It is focused on retail stores, department stores, specialty stores and select licensing partners. As of March 30, 2013, its retail segment included 231 North American retail stores, including concessions, and 73 international retail stores, including concessions, in Europe and Japan. As of March 30, 2013, its wholesale segment included wholesale sales through approximately 2,215 department store and specialty store doors in North America and wholesale sales through approximately 1,034 department store and specialty store doors internationally."},{"Symbol":"MCHP","Name":"Microchip Technology","Sector":"Information Technology","Description":"Microchip Technology Incorporated develops and manufactures specialized semiconductor products used by its customers for a variety of embedded control applications. The Company's portfolio consists of specialized 8-bit, 16-bit, and 32-bit PIC microcontrollers and 16-bit dsPIC digital signal controllers, which feature on-board Flash (reprogrammable) memory technology. In addition, the Company offers a broad spectrum of high-performance linear, mixed-signal, power management, thermal management, RF, safety and security, and interface devices, as well as serial EEPROMs, Serial Flash memories and Parallel Flash memories. The Company also licenses Flash-IP solutions that are incorporated in a broad range of products. In November 2013, Microchip Technology Inc announced the acquisition of EqcoLogic."},{"Symbol":"MU","Name":"Micron Technology","Sector":"Information Technology","Description":"Micron Technology, Inc., is a global manufacturer and marketer of semiconductor devices, principally NAND Flash, DRAM and NOR Flash memory, as well as other memory technologies, packaging solutions and semiconductor systems for use in computing, consumer, networking, automotive, industrial, embedded and mobile products. In addition, the Company manufactures semiconductor components for CMOS images sensors and other semiconductor products. The Company operates in four segments: NAND Solutions Group (NSG), DRAM Solutions Group (DSG), Wireless Solutions Group (WSG) and Embedded Solutions Group (ESG). The Company's product include NAND Flash Memory, Dynamic Random Access Memory (DRAM) and NOR Flash Memory. The Company's manufacturing facilities are located in the United States, China, Israel, Italy, Malaysia, Puerto Rico and Singapore."},{"Symbol":"MSFT","Name":"Microsoft Corp.","Sector":"Information Technology","Description":"Microsoft Corporation is engaged in developing, licensing and supporting a range of software products and services. The Company operates in five segments: Windows & Windows Live Division (Windows Division), Server and Tools, Online Services Division (OSD), Microsoft Business Division (MBD), and Entertainment and Devices Division (EDD). The Company's products include operating systems for personal computers (PCs), servers, phones, and other intelligent devices; server applications for distributed computing environments; productivity applications; business solution applications; desktop and server management tools; software development tools; video games, and online advertising. It also designs and sells hardware, including the Xbox 360 gaming and entertainment console. In September 2013, Ericsson completed the acquisition of Microsoft's Mediaroom business and TV solution. Effective October 23, 2013, Microsoft Corp acquired Apiphany Inc."},{"Symbol":"MAA","Name":"Mid-America Apartments","Sector":"Real Estate","Description":"Mid-America Apartment Communities, Inc. (MAA) is a self-administered and self-managed real estate investment trust (REIT). It focuses on acquiring, owning and operating apartment communities in the Sunbelt region of the United States. As of December 31, 2011, it owned 100% of 160 properties representing 46,872 apartment units. Three properties include retail components with approximately 93,000 square feet of gross leasable area. It operates in three segments: large market same store communities, secondary market same store communities and non same store communities and other. In May 2013, the Company acquired Station Square at Cosner's Corner. In October 2013, Mid-America Apartment Communities Inc merged with Colonial Properties Trust. In October 2013, Mid America Apartment Communities Inc and Colonial Properties Trust announced the completion of the merger of the two companies."},{"Symbol":"MHK","Name":"Mohawk Industries","Sector":"Consumer Discretionary","Description":"Mohawk Industries, Inc. (Mohawk) is a producer of floor covering products for residential and commercial applications in the United States and residential applications in Europe. The Company is a carpet and rug manufacturer and manufacturers, marketers and distributors of ceramic tile, natural stone and hardwood flooring in the United States, as well as a producer of laminate flooring in the United States and Europe. The Company has three reporting segments: the Mohawk segment, the Dal-Tile segment and the Unilin segment. The Company has recently expanded its international presence through investments in Australia, Brazil, China, France, Mexico and Russia. In January 2013, the Company acquired Pergo. In April 2013, it completed the acquisition of the Marazzi Group. In May 2013, the Company acquired Spano Group."},{"Symbol":"TAP","Name":"Molson Coors Brewing Company","Sector":"Consumer Staples","Description":"Molson Coors Brewing Company (MCBC) is a holding company. The Company operates in five business segments: Canada, the U.S., Central Europe, the U.K., and MCI. The Company is a brewer and has a portfolio of owned and partner brands, including signature brands Coors Light, Molson Canadian, Carling and Staropramen, as well as craft and specialty beers such as Blue Moon, Creemore Springs, Cobra and Doom Bar. Its other subsidiaries include: Molson Coors Canada (MCC), operating in Canada; MillerCoors LLC (MillerCoors), which is accounted for by the Company under the equity method of accounting, operating in the United States (U.S.); Molson Coors Brewing Company (UK) Limited (MCBC-UK, operating in the United Kingdom (U.K.) and the Republic of Ireland; Molson Coors International (MCI) operating in various other countries; and its other non-operating subsidiaries. In June 15, 2012, the Company acquired StarBev. In January 2013, it acquired Ireland's Franciscan Well brewery."},{"Symbol":"MDLZ","Name":"Mondelez International","Sector":"Consumer Staples","Description":"Mondelez International, Inc. (Mondelez International), is a snack manufacturing company. The Company manufactures and markets food and beverage products for consumers in approximately 165 countries around the world. The Company produces biscuits, chocolate, candy and powdered beverages as well as gum and coffee. The Company's portfolio includes nine brands including Oreo, Nabisco and LU biscuits; Milka, Cadbury Dairy Milk and Cadbury chocolates; Trident gum; Jacobs coffee; and Tang powdered beverage. In addition, the Company's portfolio of snack foods and refreshments includes 52 brands. The Company manages its global business and through three geographic units: Developing Markets, Europe and North America. On October 1, 2012 the Company completed the spin-off of its North American grocery business, Kraft Foods Group, Inc. (Kraft Foods Group)."},{"Symbol":"MON","Name":"Monsanto Co.","Sector":"Materials","Description":"Monsanto Company (Monsanto) along with its subsidiaries, is a provider of agricultural products for farmers. The Company's seeds, biotechnology trait products, and herbicides provide farmers with solutions that improve productivity, reduce the costs of farming, and produce better foods for consumers and better feed for animals. It manages business in two segments: Seeds and Genomics, and Agricultural Productivity. In April 2010, the Company completed the acquisition of a corn and soybean processing plant located in Paine, Chile from Anasac, a company that provides seed processing services. In November 2013, the Company announced that it has completed the acquisition of The Climate Corporation."},{"Symbol":"MNST","Name":"Monster Beverage","Sector":"Consumer Staples","Description":"Monster Beverage Corporation is a holding company. The Company develops, markets, sells and distributes alternative beverage, such as non-carbonated ready-to-drink iced teas, lemonades, juice cocktails, single-serve juices and fruit beverages, ready-to-drink dairy and coffee drinks, energy drinks, sports drinks, and single-serve still water (flavored and unflavored) with beverages, including sodas that are considered natural, sparkling juices and flavored sparkling beverages. It has two reportable segments, namely Direct Store Delivery (DSD), whose principal products comprise energy drinks, and Warehouse (Warehouse), whose principal products comprise juice-based and soda beverages. The DSD segment develops, markets and sells products primarily through an exclusive distributor network. The Warehouse segment develops, markets and sells products directly to retailers."},{"Symbol":"MCO","Name":"Moody's Corp","Sector":"Financials","Description":"Moody's Corporation (Moody's) is a provider of credit ratings; credit and economic related research, data and analytical tools; software solutions and related risk management services; quantitative credit risk measures, credit portfolio management solutions, training and financial credentialing and certification services, and outsourced research and analytical services to institutional customers. The Company operates in two segments: Moody's Investors Service (MIS) and Moody's Analytics (MA). The MIS segment consists of all credit rating activity. All of Moody's other non-rating commercial activities are included within the MA segment. As of December 31, 2012, MIS had ratings relationships with approximately 10,000 corporate issuers and approximately 22,000 public finance issuers. During the year ended December 31, 2012, the Company had rated and monitored ratings on approximately 82,000 structured finance obligations (representing approximately 13,000 transactions)."},{"Symbol":"MS","Name":"Morgan Stanley","Sector":"Financials","Description":"Morgan Stanley is a global financial services company that, through its subsidiaries and affiliates, provides its products and services to a range of clients and customers, including corporations, governments, financial institutions and individuals. The Company is a financial holding company. The Company operates in three segments: Institutional Securities, Global Wealth Management Group and Asset Management. The Company provides financial advisory and capital-raising services to a group of corporate and other institutional clients worldwide. As of December 31, 2011, the Company's Global Wealth Management Group had $1,649 billion in client assets. The Company's Asset Management business segment offers clients an array of equity, fixed income and alternative investments and merchant banking services. On February 17, 2011, the Company completed the sale of Revel Entertainment Group, LLC (Revel). Effective March 14, 2013, Morgan Stanley acquired interest in Auerbach Grayson & Co."},{"Symbol":"MSI","Name":"Motorola Solutions Inc.","Sector":"Information Technology","Description":"Motorola Solutions, Inc. (Motorola Solutions) provides mission-critical communication infrastructure, devices, software and services. The Company provides these products and services for enterprise and government customers worldwide. The Company operates in two segments: Government and Enterprise. The Government segment includes sales of public safety mission-critical communications systems, commercial two-way radio systems and devices, software and services. The Enterprise segment includes sales of rugged and enterprise-grade mobile computers and tablets, laser/imaging/RFID-based data capture products, wireless local area network (WLAN) and integrated digital enhanced network (iDEN) infrastructure, software and services. In June 2013, AirWatch, provider of Enterprise Mobility Management (EMM) solutions announced that it has acquired Motorola Solutions Inc's Mobility Services Platform business."},{"Symbol":"MUR","Name":"Murphy Oil","Sector":"Energy","Description":"Murphy Oil Corporation is a worldwide oil and gas exploration and production company with retail and wholesale gasoline marketing operations in the United States and refining and marketing operations in the United Kingdom. In August 2013, the Company announced that it has completed the spin-off of its United States retail marketing business into an independent public company called Murphy USA Inc."},{"Symbol":"MYL","Name":"Mylan N.V.","Sector":"Health Care","Description":"Mylan Inc. (Mylan) is a fully integrated global pharmaceutical company that develops, licenses, manufactures, markets and distributes generic, branded generic and specialty pharmaceuticals. Mylan has two segments:Generics and Specialty. Its generic pharmaceutical business is conducted primarily in the United States and Canada (collectively, North America); Europe, the Middle East, and Africa (collectively, EMEA); and India, Australia, Japan and New Zealand (collectively, Asia Pacific). Its API business is conducted through Mylan Laboratories Limited (Mylan India), which is included within the Asia Pacific region in its Generics Segment. The Company's pharmaceutical business is conducted by Mylan Specialty L.P. (Mylan Specialty). Mylan provides products to customers in approximately 140 countries and territories. In December 2013, In December 2013, the Company announced that it has completed the acquisition of the Agila injectables businesses from Strides Arcolab Ltd."},{"Symbol":"NDAQ","Name":"NASDAQ OMX Group","Sector":"Financials","Description":"The NASDAQ OMX Group, Inc. (NASDAQ OMX) is a holding company. It is a global exchange group that delivers trading, clearing, exchange technology, regulatory, securities listing, and public company services across six continents. Its global offerings are diverse and include trading and clearing across multiple asset classes, market data products, financial indexes, capital formation solutions, financial services and market technology products and services. The Company operates in three segments: Market Services, Issuer Services and Market Technology. In June 2013, the Company announced the completion of its acquisition of Thomson Reuters Investor Relations, Public Relations and Multimedia Solutions businesses, which provide insight, analytics and communications solutions. In July 2013, BGC Partners Inc announced that it closed the sale of its on-the-run, 2-, 3-, 5-, 7-, 10-, and 30-year fully electronic trading platform for U.S. Treasury Notes and Bonds to NASDAQ OMX Group, Inc."},{"Symbol":"NOV","Name":"National Oilwell Varco Inc.","Sector":"Energy","Description":"National Oilwell Varco, Inc. is a provider of equipment and components used in oil and gas drilling and production operations, oilfield services, and supply chain integration services to the upstream oil and gas industry. The Company operates through three segments. Its Rig Technology segment designs, manufactures, sells and services complete systems for the drilling, completion, and servicing of oil and gas wells. Its Petroleum Services & Supplies segment provides a variety of consumable goods and services used to drill, complete, remediate and workover oil and gas wells and service drill pipe, tubing, casing, flowlines and other oilfield tubular goods. Its Distribution & Transmission segment provides maintenance, repair and operating supplies and spare parts to drill site and production locations worldwide. In July 2012, its subsidiary, NOV Distribution Services ULC, acquired CE Franklin Ltd. In February 2013, National Oilwell Varco Inc acquired Robbins & Myers Inc."},{"Symbol":"NAVI","Name":"Navient","Sector":"Financials","Description":"Navient Corporation holds the portfolio of education loans insured or guaranteed under the Federal Family Education Loan Program (FFELP Loans), as well as the portfolio of private education loans (Private Education Loans). FFELP Loans are insured or guaranteed by state or not-for-profit agencies and are also protected by contractual rights to recovery from the United States pursuant to guaranty agreements among the United States Department of Education(ED), and these agencies. The Company operates in four segments: Consumer Lending, Business Services, FFELP Loans and Other. At December 31, 2013, 84% of its FFELP Loan portfolio was funded to term with non-recourse, long-term securitization debt. The Company also sold its Campus Solution business and its 529 college-savings plan administration business in 2013 in connection with better aligning its core business. The results of both of these businesses are reported in discontinued operations for all periods presented."},{"Symbol":"NTAP","Name":"NetApp","Sector":"Information Technology","Description":"NetApp, Inc. (NetApp) is a provider of storage systems and data management solutions for information technology (IT) infrastructures. Its fabric-attached storage (FAS) platform offers the storage platform for business applications, shared infrastructures and cloud environments. NetApp is an original equipment manufacturer (OEM) storage provider and enables OEMs to offer IT and storage solutions that serve specific markets and customer requirements. It offers two storage platforms: FAS storage platform and E-Series platform. Its FAS storage systems offer integrated protection and data management for virtualized, shared infrastructures and business applications. NetApp offers storage solutions that incorporate its FAS platform and the functionality of its Data ONTAP data and storage resource management software. Its E-Series systems offer OEMs a modular storage platform."},{"Symbol":"NFLX","Name":"Netflix Inc.","Sector":"Information Technology","Description":"Netflix, Inc. is an Internet television network with more than 33 million members in over 40 countries. In the United States, the Company's subscribers can receive standard definition digital versatile disc (DVDs), and their high definition successor, Blu-ray discs (collectively DVD), delivered quickly to their homes. The Company operates in three segments: Domestic streaming, International streaming and Domestic DVD. Domestic and International streaming segments derive revenues from monthly subscription services consisting solely of streaming content. The Domestic DVD segment derives revenues from monthly subscription services consisting solely of DVD-by-mail."},{"Symbol":"NWL","Name":"Newell Brands","Sector":"Consumer Discretionary","Description":"Newell Rubbermaid Inc. is a global marketer of consumer and commercial products. The Company's products are marketed under a portfolio of brands, including Rubbermaid, Levolor, Goody, Calphalon, Sharpie, Paper Mate, Parker, Waterman, Irwin, Lenox, Graco, Aprica and Dymo. The Company's segments and the brands included in each of the six business segments includes Home Solutions, which includes Rubbermaid, Calphalon, Levolor, Kirsch and Goody; Writing, which includes Sharpie, Paper Mate, Expo, Prismacolor, Parker and Waterman; Tools, which include Irwin and Lenox tools, and Dymo Industrial; Commercial Products, which include Rubbermaid Commercial Products and Rubbermaid Healthcare; Baby & Parenting, which include Graco, Aprica and Teutonia, and Specialty, which include Dymo Office and Endicia. In September 2013, Newell Rubbermaid Inc closed the sale of its Hardware business, which includes the Amerock, Ashland, Bulldog and Shur-Line brands, to Nova Capital."},{"Symbol":"NFX","Name":"Newfield Exploration Co","Sector":"Energy","Description":"Newfield Exploration Company (Newfield) is an independent energy company engaged in the exploration, development and production of crude oil, natural gas and natural gas liquids. The Company's domestic areas of operation include the Mid-Continent, the Rocky Mountains and onshore Texas. Internationally, it focuses on offshore oil developments in Malaysia and China. As of December 31, 2011, it was in the process of drilling 16 gross (9.6 net) exploitation wells and 24 gross (19.7 net) development wells domestically. As of December 31, 2011, internationally, it was drilling one gross (0.6 net) exploratory well in Malaysia. In May 2011, the Company acquired assets in the Uinta Basin of Utah."},{"Symbol":"NEM","Name":"Newmont Mining Corp. (Hldg. Co.)","Sector":"Materials","Description":"Newmont Mining Corporation is primarily a gold producer with operations and/or assets in the United States, Australia, Peru, Indonesia, Ghana, New Zealand and Mexico. As of December 31, 2012, Newmont had attributable and probable gold reserves of 99.2 million ounces and an aggregate land position of approximately 29,000 square miles (75,000 square kilometers). Newmont is also engaged in the production of copper, principally through Batu Hijau in Indonesia and Boddington in Australia. Its operating segments include North America, South America, Asia Pacific and Africa. Its North America segment consists primarily of Nevada in the United States and La Herradura in Mexico. Its South America segment consists primarily of Yanacocha and Conga in Peru. Its Asia Pacific segment consists primarily of Boddington in Australia, Batu Hijau in Indonesia and other smaller operations in Australia and New Zealand. Its Africa segment consists primarily of Ahafo and Akyem in Ghana."},{"Symbol":"NWSA","Name":"News Corp. Class A","Sector":"Consumer Discretionary","Description":"News Corporation is a diversified media and information services company. The Company operates in five segments: News and Information Services, Cable Network Programming, Digital Real Estate Services, Book Publishing, and Other. The Company's business consists of range of media, including news and information services, sports programming in Australia, digital real estate services, book publishing, and pay-television (TV) distribution in Australia, that are distributed under the brands, including The Wall Street Journal, Dow Jones, Herald Sun, The Sun, The Times, HarperCollins Publishers, FOX SPORTS Australia and realestate.com.au. The Company is a developing provider of digital education content, assessment and delivery services. The Company's business component includes News and Information Services, Cable Network Programming, Digital Real Estate Services, Book Publishing, Amplify and Foxtel."},{"Symbol":"NWS","Name":"News Corp. Class B","Sector":"Consumer Discretionary","Description":"News Corporation is a diversified media and information services company. The Company operates in five segments: News and Information Services, Cable Network Programming, Digital Real Estate Services, Book Publishing, and Other. The Company's business consists of range of media, including news and information services, sports programming in Australia, digital real estate services, book publishing, and pay-television (TV) distribution in Australia, that are distributed under the brands, including The Wall Street Journal, Dow Jones, Herald Sun, The Sun, The Times, HarperCollins Publishers, FOX SPORTS Australia and realestate.com.au. The Company is a developing provider of digital education content, assessment and delivery services. The Company's business component includes News and Information Services, Cable Network Programming, Digital Real Estate Services, Book Publishing, Amplify and Foxtel."},{"Symbol":"NEE","Name":"NextEra Energy","Sector":"Utilities","Description":"NextEra Energy, Inc. (NEE) is an electric power company. The Company has over 42,000 megawatt of generating capacity in 26 states in the United States and four provinces in Canada. It also purchases electric power for resale to its customers and provides risk management services related to power and gas consumption for a limited number of customers. It is the generator in North America of renewable energy from the wind and sun. It owns and operates approximately 17% of the installed base of United States wind power production capacity and operates approximately 14% of the installed base of United States utility-scale solar power production capacity as of December 31, 2012. It also owns and operates one of the fleets of nuclear power stations in the United States, with eight reactors at five sites located in four states, representing approximately 6% of United States nuclear power electric generating capacity as of December 31, 2012."},{"Symbol":"NLSN","Name":"Nielsen Holdings","Sector":"Industrials","Description":"Nielsen Holdings NV is a Netherlands-based company engaged in information and measurement services. The Company, together with its subsidiaries, delivers media and marketing information, and analytics on a global and local basis. It operates in two segments: Buy segment and Watch segment. The Company's Buy segment provides retail transactional measurement data, consumer behavior information and analytics primarily to businesses in the consumer packaged goods industry. Its Watch segment provides viewership data and analytics primarily to the media and advertising industries across television, online and mobile screens. Nielsen Holdings NV operates in approximately 100 countries. In June 2013, the Company sold its Exposition's business segment. In September 2013, Nielsen Holdings NV completed its acquisition of Arbitron Inc."},{"Symbol":"NKE","Name":"Nike","Sector":"Consumer Discretionary","Description":"NIKE, Inc. (NIKE) is engaged in the design, development and worldwide marketing and selling of footwear, apparel, equipment, accessories and services. NIKE is a seller of athletic footwear and athletic apparel worldwide. The Company sells its products to retail accounts, through NIKE-owned retail stores and Internet sales, and through a mix of independent distributors and licensees, in approximately 190 countries around the world. The Company focuses its product offerings in seven key categories: Running, Basketball, Football (Soccer), Men's Training, Women's Training, NIKE Sportswear (its sports-inspired products) and Action Sports. It also markets products designed for kids, as well as for other athletic and recreational uses, such as baseball, cricket, golf, lacrosse, outdoor activities, football (American), tennis, volleyball, walking and wrestling. In February 2013, it sold its Cole Haan affiliate brand to APAX Partners LLP."},{"Symbol":"NI","Name":"NiSource Inc.","Sector":"Utilities","Description":"NiSource Inc. (NiSource) is an energy holding company whose subsidiaries provide natural gas, electricity and other products and services to approximately 3.8 million customers located within a corridor that runs from the Gulf Coast through the Midwest to New England. NiSource operates in three business segments: Gas Distribution Operations; Gas Transmission and Storage Operations, and Electric Operations. NiSource's principal subsidiaries include Columbia Energy Group (Columbia), a vertically-integrated natural gas distribution, transmission and storage holding company whose subsidiaries provide service to customers in the Midwest, the Mid-Atlantic and the Northeast; Northern Indiana Public Service Company (Northern Indiana), a vertically-integrated gas and electric company providing service to customers in northern Indiana, and Bay State Gas Company (Columbia of Massachusetts), a natural gas distribution company serving customers in Massachusetts."},{"Symbol":"NBL","Name":"Noble Energy Inc","Sector":"Energy","Description":"Noble Energy, Inc. (Noble Energy) is an independent energy company engaged in worldwide oil and gas exploration and production. Noble Energy has operations in five core areas: the DJ Basin (onshore United States), the Marcellus Shale (onshore United States), the deepwater Gulf of Mexico (offshore United States), offshore West Africa and offshore Eastern Mediterranean. The areas provide most of its crude oil and natural gas production; visible growth from development projects, and numerous exploration opportunities. In August 2012, it sold the Dumbarton and Lochranza properties in the North Sea to Maersk Oil North Sea Limited. In September 2012, it sold certain oil and natural gas properties in the Permian Basin to Sheridan Holding Company II, LLC. In September 2012, Unit Corporation's wholly owned subsidiary, Unit Petroleum Company, acquired certain oil and natural gas assets from the Company."},{"Symbol":"JWN","Name":"Nordstrom","Sector":"Consumer Discretionary","Description":"Nordstrom, Inc. is a fashion specialty retailer, with 225 the United States stores located in 30 states as of March 16, 2012. The Company operates in two segments: Retail and Credit. As of March 16, 2012, the Retail segment includes its 116 Nordstrom branded full-line stores and its online store at www.nordstrom.com, its 105 off-price Nordstrom Rack stores and its other retail channels, including its online private sale subsidiary HauteLook, its two Jeffrey boutiques, one philanthropic treasure&bond store and one clearance store that operates under the name Last Chance. The Company's Credit segment includes its wholly owned federal savings bank, Nordstrom fsb, through which it provides a private label credit card, two Nordstrom VISA credit cards and a debit card."},{"Symbol":"NSC","Name":"Norfolk Southern Corp.","Sector":"Industrials","Description":"Norfolk Southern Corporation (Norfolk Southern) is a Virginia based company that controls a railroad, Norfolk Southern Railway Company. Norfolk Southern Railway Company is primarily engaged in the rail transportation of raw materials, intermediate products, and finished goods primarily in the Southeast, East, and Midwest and, via interchange with rail carriers, to and from the rest of the United States. Norfolk Southern also transports overseas freight through several Atlantic and Gulf Coast ports. It provides logistics services and offers intermodal network in the eastern half of the United States."},{"Symbol":"NTRS","Name":"Northern Trust Corp.","Sector":"Financials","Description":"Northern Trust Corporation (Corporation) is a financial holding company that is a provider of asset servicing, fund administration, asset management, fiduciary and banking solutions for corporations, institutions, families and individuals worldwide. The Company conducts business through various United States and non-United States subsidiaries, including The Northern Trust Company (the Bank). The Company has a network of offices in 18 United States, Washington, District of Columbia, and 16 international locations in North America, Europe, the Middle East, and the Asia Pacific region. Northern Trust organizes its services globally around its two client-focused principal business units: Corporate and Institutional Services and Personal Financial Services (PFS). Two other business units provide services to the two principal business units: Northern Trust Global Investments, which provides investment management, and Operations and Technology, which provides operating and systems support."},{"Symbol":"NOC","Name":"Northrop Grumman Corp.","Sector":"Industrials","Description":"Northrop Grumman Corporation (Northrop Grumman) provides products, services, and integrated solutions in aerospace, electronics, information and services to its global customers. As of December 31, 2011, the Company operated in four segments: Aerospace Systems, Electronic Systems, Information Systems and Technical Services. The Company conducts most of its business with the United States Government, principally the Department of Defense (DoD) and intelligence community. It also conducts business with local, state, and foreign Governments and domestic and international commercial customers. Effective as of March 31, 2011, the company completed the spin-off of Huntington Ingalls Industries, Inc. (HII). HII operates the Company's former shipbuilding business. In September 2012, it acquired M5 Network Security Pty Ltd."},{"Symbol":"NRG","Name":"NRG Energy","Sector":"Utilities","Description":"NRG Energy, Inc. (NRG) is an integrated wholesale power generation and retail electricity company in the United States. NRG is a wholesale power generator engaged in the ownership and operation of power generation facilities; the trading of energy, capacity and related products; and the transacting in and trading of fuel and transportation services. NRG is engaged in the supply of energy, services, and sustainable products to retail customers in competitive markets through multiple channels and brands like Reliant Energy, Green Mountain Energy, and Energy Plus. Finally, NRG is focused on the deployment and commercialization of potentially disruptive technologies, like electric vehicles, Distributed Solar and smart meter technology, which have the potential to change the nature of the power supply industry. In August 2013, NRG acquired the Gregory cogeneration plant in Corpus Christi, Texas. Effective August 22, 2013, NRG Energy Inc acquired Energy Curtailment Specialists Inc."},{"Symbol":"NUE","Name":"Nucor Corp.","Sector":"Materials","Description":"Nucor Corporation and its affiliates (Nucor) manufactures steel and steel products. The Company also produces direct reduced iron (DRI) for use in the Company's steel mills. The Company's operations include several international trading companies that buy and sell steel and steel products manufactured by the Company and others. In 2012, it recycled approximately 19.2 million tons of scrap steel. In May 2012, ArcelorMittal announced the sale of its steel foundation distribution business in NAFTA, namely Skyline Steel and Astralloy (Skyline Steel) to Nucor. The transaction includes 100% of ArcelorMittal's interest in Skyline Steel's operations in the NAFTA countries and the Caribbean.In June 2012, the Company acquired Skyline Steel LLC and its subsidiaries. In August 2012, the Company completed the sale of the assets of their Nucor Wire Products Pennsylvania facility located in New Salem, Pennsylvania, to an affiliate of Wire Mesh Corporation."},{"Symbol":"NVDA","Name":"Nvidia Corporation","Sector":"Information Technology","Description":"NVIDIA Corporation (NVIDIA) is engaged in creating the graphics chips used in personal computers (PCs). The Company operates in three segments: graphics processing unit (GPU) Business, professional solutions business (PSB) and consumer products business (CPB). Its mobile processors are used in cell phones, tablets and auto infotainment systems. Designers use GPUs to create visual effects in movies and create everything from golf clubs to jumbo jets. NVIDIA solutions are based on two technologies: the GPU and the mobile processor. GPUs are the engines of visual computing, the science and art of using computers to understand, create and enhance images. It has three GPU product brands: GeForce, Quadro and Tesla. During the fiscal year ended January 29, 2012 (fiscal 2012), it acquired Icera Inc. In fiscal 2012, it launched Project Maximus. Effective July 29, 2013, NVIDIA Corp acquired Portland Group Inc, a wholesaler of parallel computing software, from STMicroelectronics NV."},{"Symbol":"ORLY","Name":"O'Reilly Automotive","Sector":"Consumer Discretionary","Description":"O'Reilly Automotive, Inc. (O'Reilly) is a specialty retailer of automotive aftermarket parts, tools, supplies, equipment and accessories in the United States, selling its products to both do-it-yourself (DIY) customers and professional service providers. As of December 31, 2012, O'Reilly operated 3,976 stores in 42 states. The Company's stores product line includes products, such as new and remanufactured automotive hard parts, such as alternators, starters, fuel pumps, water pumps, brake system components, batteries, belts, hoses, temperature control, chassis parts and engine parts; maintenance items, such as oil, antifreeze, fluids, filters, wiper blades, lighting, engine additives and appearance products, and accessories, such as floor mats, seat covers and truck accessories. Its stores offer a number of services and programs to its customers, such as used oil and battery recycling; battery diagnostic testing; professional paint shop mixing and related materials, and machine shops."},{"Symbol":"OXY","Name":"Occidental Petroleum","Sector":"Energy","Description":"Occidental Petroleum Corporation (Occidental) conducts its operations through various subsidiaries and affiliates. The Company operates in three segments: oil and gas segment; chemical segment, and midstream, marketing and other segment. The oil and gas segment explores for, develops and produces oil and condensate, natural gas liquids (NGLs) and natural gas. The chemical segment (OxyChem) mainly manufactures and markets basic chemicals and vinyls. The midstream, marketing and other segment (midstream and marketing) gathers, processes, transports, stores, purchases and markets oil, condensate, NGLs, natural gas, carbon dioxide (CO2) and power. It also trades around its assets, including transportation and storage capacity, and trades oil, NGLs, gas and other commodities. The segment also invests in entities that conduct similar activities. On December 31, 2012, it acquired Eagle Ford Shale."},{"Symbol":"OMC","Name":"Omnicom Group","Sector":"Consumer Discretionary","Description":"Omnicom Group Inc. (Omnicom) is a holding company, providing professional services to clients through multiple agencies. Omnicom is a global advertising, marketing and corporate communications company. Its agencies operate in markets worldwide and provide a range of services, which the Company group into four disciplines: advertising, customer relationship management (CRM), public relations and specialty communications. The services provided by the Company include advertising, brand consultancy, corporate social responsibility consulting, data analytics, entertainment marketing, healthcare communications and promotional marketing. In June 2013, Ketchum, a division of Omnicom Group Inc, announced its acquisition of Brandzeichen. In November 2013, the Company announced its acquisition of ICON International Communications, Singapore's independently owned public relations consultancy."},{"Symbol":"OKE","Name":"ONEOK","Sector":"Energy","Description":"ONEOK, Inc., is a diversified energy company. The Company's segments include ONEOK Partners, Natural Gas Distribution and Energy Services. As of December 31, 2012, the Company was the sole general partner and own 43.4 % of ONEOK Partners, L.P. ONEOK Partners is engaged in the gathering, processing, storage and transportation of natural gas in the United States. In addition, ONEOK Partners owns natural gas liquids systems, connecting natural gas liquids (NGL) supply in the Mid-Continent and Rocky Mountain regions with key market centers. The Company's distribution markets include Oklahoma City and Tulsa, Oklahoma; Kansas City, Wichita, and Topeka, Kansas, and Austin and El Paso, Texas. Its energy services operation is engaged in providing natural gas marketing services to its customers across the United States."},{"Symbol":"ORCL","Name":"Oracle Corp.","Sector":"Information Technology","Description":"Oracle Corporation is a provider of enterprise software and computer hardware products and services. The Company's software, hardware systems, and services businesses develops, manufactures, markets, hosts and supports database and middleware software, applications software, and hardware systems, with the latter consisting primarily of computer server and storage products. It is organized into three businesses: software, hardware systems and services. Its software business consists of two segments: new software licenses and software license updates and product support. Its hardware systems business consists of two segments: hardware systems products and hardware systems support. The Company's services business consists of the remainder of its segments and offers consulting services, managed cloud services, and education services. On April 5, 2012, the Company acquired Taleo Corporation (Taleo). Effective March 13, 2013, it acquired Nimbula Inc."},{"Symbol":"PCAR","Name":"PACCAR Inc.","Sector":"Industrials","Description":"PACCAR Inc (PACCAR) is engaged in the design, manufacture and customer support of light, medium- and heavy-duty trucks under the Kenworth, Peterbilt and DAF nameplates. The company also provides customized financial services, information technology and truck parts related to its principal business. The Company operates in three segments: design, manufacture and distribution of light-, medium- and heavy-duty trucks, distribution of parts for the truck aftermarket and related commercial vehicles, and finance and leasing products and services provided to customers and dealers. The Company's finance and leasing activities are principally related to Company products and associated equipment. The Company's other business is the manufacturing and marketing of industrial winches."},{"Symbol":"PH","Name":"Parker-Hannifin","Sector":"Industrials","Description":"Parker-Hannifin Corporation (Parker) is a full-line diversified manufacturer of motion and control technologies and systems, including fluid power systems, electromechanical controls and related components. The Company also is a worldwide producer of fluid purification, fluid and fuel control, process instrumentation, air conditioning, refrigeration, electromagnetic shielding and thermal management products and systems. The Company's motion and control technologies and systems are used in the products of its three business segments: Industrial, Aerospace, and Climate & Industrial Controls. In July 2012, the Company acquired Olaer Group. In July 2012, the Company acquired the filtration business of John Fowler (India) Private Limited. In July 2012, the Company acquired the hydraulics manufacturing division of PIX Transmissions Ltd. In July 2012, it acquired Kittiwake Developments Limited. In November 2012, The Sterling Group sold Velcon Filters, LLC to the Company."},{"Symbol":"PDCO","Name":"Patterson Companies","Sector":"Health Care","Description":"Patterson Companies, Inc. (Patterson) is a distributor serving three markets: the United States companion animal (dogs, cats and other common household pets) and equine veterinary supply, and the worldwide rehabilitation and assistive products supply market. The Company operates in three segments: dental supply, veterinary supply and rehabilitation supply. As Patterson's business, Patterson Dental is a distributor of dental products in North America. Webster Veterinary (Webster) is a distributor of veterinary supplies primarily to companion-pet (dogs, cats and other common household pets) and equine veterinary clinics across the United States. Effective August 2, 2013, it acquired Mercer Mastery, a developer of dental practice software, from Lovell Minnick Partners LLC's Mercer Advisors Inc subsidiary. In August 2013, Patterson Companies Inc completed acquisition of the stock of National Veterinary Services Limited, a wholly owned subsidiary of Dechra Pharmaceuticals PLC."},{"Symbol":"PAYX","Name":"Paychex Inc.","Sector":"Information Technology","Description":"Paychex, Inc. is a provider of payroll, human resource, and benefits outsourcing solutions for small to medium-sized businesses. As of May 31, 2012, the Company serviced approximately 567,000 clients, including approximately 2,000 clients through four offices in Germany. The Company offers a portfolio of services and products that allows its clients to meet their diverse payroll and human resource needs. These include payroll processing; payroll tax administration services; employee payment services; regulatory compliance services (new-hire reporting and garnishment processing); Paychex HR Solutions; retirement services administration; insurance services; eServices, and other human resource services and products. In January 2012, the Company acquired Icon Time Systems, Inc. In December 2012, the Company acquired ExpenseWire from Rearden Commerce Inc. In June 2013, Paychex Inc announced that it has acquired HR Services, Inc. and myStaffingPro."},{"Symbol":"PYPL","Name":"PayPal","Sector":"Information Technology","Description":"PayPal Holdings, Inc. operates as a technology platform company that enables digital and mobile payments on behalf of consumers and merchants worldwide. It enables businesses of various sizes to accept payments from merchant Websites, mobile devices, and applications, as well as at offline retail locations through a range of payment solutions across companys payments platform, including PayPal, PayPal Credit, Venmo, and Braintree products. The companys platform allows customers to pay and get paid, withdraw funds to their bank accounts, and hold balances in their PayPal accounts in various currencies. The company was founded in 1998 and is based in San Jose, California. PayPal Holdings, Inc. operates independently of eBay Inc. as of July 17, 2015."},{"Symbol":"PNR","Name":"Pentair Ltd.","Sector":"Industrials","Description":"No Description Available"},{"Symbol":"PBCT","Name":"People's United Financial","Sector":"Financials","Description":"People's United Financial, Inc. (People's United Financial) is a savings and loan holding company. The principal business of People's United Financial is to provide, through People's United Bank and its subsidiaries, commercial banking, retail and business banking, and wealth management services to individual, corporate and municipal customers. Traditional banking activities are conducted primarily within New England and southeastern New York, and include extending secured and unsecured commercial and consumer loans, originating mortgage loans secured by residential and commercial properties, and accepting consumer, commercial and municipal deposits. In addition to traditional banking activities, People's United Bank provides specialized financial services tailored to specific markets including: personal, institutional and employee benefit trust; cash management; and municipal banking and finance."},{"Symbol":"PEP","Name":"PepsiCo Inc.","Sector":"Consumer Staples","Description":"PepsiCo, Inc. (PepsiCo) is a global food and beverage company. Through the Company's bottlers, contract manufacturers and other partners, it makes, markets, sells and distributes a range of foods and beverages in more than 200 countries and territories. PepsiCo is organized into four business units: PepsiCo Americas Foods (PAF), which includes Frito-Lay North America (FLNA), Quaker Foods North America (QFNA) and all of its Latin American food and snack businesses (LAF); PepsiCo Americas Beverages (PAB), which includes all of its North American and Latin American beverage businesses; PepsiCo Europe, which includes all beverage, food and snack businesses in Europe and South Africa, and PepsiCo Asia, Middle East and Africa (AMEA), which includes all beverage, food and snack businesses in AMEA, excluding South Africa. It manufactures markets and sells a range of salty, sweet and grain-based snacks, carbonated and non-carbonated beverages, dairy products and other foods."},{"Symbol":"PKI","Name":"PerkinElmer","Sector":"Health Care","Description":"PerkinElmer, Inc. is a provider of technology, services and solutions to the diagnostics, research, environmental, industrial and laboratory services markets. Through the Company's advanced technologies, solutions, and services, it addresses issues related to health and safety of people and their environment. It operates in two segments: Human Health and Environmental Health. In February 2011, it acquired chemagen Biopolymer-Technologie AG (chemagen). In March 2011, it acquired ArtusLabs, Inc. (ArtusLabs). In March 2011, it acquired specified assets and assumed specified liabilities of ID Biological Systems, Inc. (IDB). In April 2011, it acquired CambridgeSoft Corporation (CambridgeSoft). In May 2011, it acquired Geospiza, Inc. (Geospiza). In May 2011, it acquired Labtronics, Inc. (Labtronics). In June 2011, it acquired Dexela Limited (Dexela). In November 2011, it acquired Caliper Life Sciences, Inc. (Caliper)."},{"Symbol":"PRGO","Name":"Perrigo","Sector":"Health Care","Description":"Perrigo Company is a global healthcare supplier that develops, manufactures and distributes over-the-counter (OTC) and generic prescription (Rx) pharmaceuticals, infant formulas, nutritional products and active pharmaceutical ingredients (API). The Company is the store brand manufacturer of OTC pharmaceutical products and infant formulas. The Company has four segments, aligned primarily by type of product: Consumer Healthcare, Nutritionals, Rx Pharmaceuticals and API. In addition, the Company has an Other category that consists of the Israel Pharmaceutical and Diagnostic Products operating segment. Its primary markets and locations of manufacturing and logistics operations are the United States, Israel, Mexico, the United Kingdom and Australia. In April 2013, it closed the acquisition of Velcera, Inc. In June 2013, Perrigo Company announced that it has completed the acquisition of an ophthalmic sterile ointment and solution product portfolio from Fera Pharmaceuticals, LLC."},{"Symbol":"PFE","Name":"Pfizer Inc.","Sector":"Health Care","Description":"Pfizer Inc. (Pfizer) is a research-based, global biopharmaceutical company. The Company manages its operations through five segments: Primary Care; Specialty Care and Oncology; Established Products and Emerging Markets; Animal Health, and Consumer Healthcare. The Company's diversified global healthcare portfolio includes human and animal biologic and small molecule medicines and vaccines, as well as nutritional products and consumer healthcare products. Its Animal Health business unit discovers, develops and sells products for the prevention and treatment of diseases in livestock and companion animals. Primary Care operating segment includes revenues from human prescription pharmaceutical products primarily prescribed by primary-care physicians. In November 2012, the Company acquired NextWave Pharmaceuticals, Inc. On November 30, 2012, the Company completed the sale of its Nutrition business."},{"Symbol":"PCG","Name":"PG&E Corp.","Sector":"Utilities","Description":"PG&E Corporation is a holding company that conducts its business through Pacific Gas and Electric Company (Utility). The Utility's revenues are generated mainly through the sale and delivery of electricity and natural gas to customers. The Utility served approximately 5.2 million electricity distribution customers and approximately 4.4 million natural gas distribution customers at December 31, 2012. The Utility's rates for electricity and natural gas utility services are based on its costs of providing service (cost-of-service ratemaking). The Utility is regulated primarily by the California Public Utilities Commission (CPUC) and the Federal Energy Regulatory Commission (FERC). In addition, the Nuclear Regulatory Commission (NRC) oversees the licensing, construction, operation, and decommissioning of the Utility's nuclear generation facilities. During the year ended December 31, 2012, the Company delivered 76,205 gigawatts per hour of Actual Electricity."},{"Symbol":"PM","Name":"Philip Morris International","Sector":"Consumer Staples","Description":"Philip Morris International Inc. (PMI) is a holding company. PMI's subsidiaries and affiliates and their licensees are engaged in the manufacture and sale of cigarettes and other tobacco products in markets outside of the United States of America. Its products are sold in approximately 180 countries. The Company divides its markets into four geographic segments: The European Union (EU) Region , The Eastern Europe, Middle East & Africa (EEMA) Region , The Asia Region and The Latin America & Canada Region. In June 2011, it completed the acquisition of a cigarette business in Jordan, consisting primarily of cigarette manufacturing assets and inventories. January 1, 2011, it established a business structure with Vietnam National Tobacco Corporation (Vinataba) in Vietnam, further developing its joint venture with Vinataba through the licensing of Marlboro and establishing a PMI-controlled branch for the building of its brands."},{"Symbol":"PSX","Name":"Phillips 66","Sector":"Energy","Description":"Phillips 66 is a holding company. The Company is engaged in producing natural gas liquids (NGL) and petrochemicals. The Company operates in three segments: the Refining and Marketing (R&M) segment, the Midstream segment and the Chemicals segment. The Refining and Marketing (R&M) segment purchases, refines, markets and transports crude oil and petroleum products, mainly in the United States, Europe and Asia, and also engages in power generation activities. The Midstream segment gathers, processes, transports and markets natural gas, and fractionates and markets NGL, predominantly in the United States. The Chemicals segment manufactures and markets petrochemicals and plastics on a worldwide basis. The Company's operations encompass 15 refineries with a gross crude oil capacity of 2.8 million barrels per day, 10,000 branded marketing outlets and 7.2 billion cubic feet per day of gross natural gas processing capacity."},{"Symbol":"PNW","Name":"Pinnacle West Capital","Sector":"Utilities","Description":"Pinnacle West Capital Corporation (Pinnacle West) is a holding company that conducts business through its subsidiaries. Pinnacle West derives its revenues and earnings from its wholly owned subsidiary, Arizona Public Service Company (APS). APS is a vertically-integrated electric utility that provides either retail or wholesale electric service to most of the State of Arizona. APS provides electric service to approximately 1.1 million customers. The Company owns or leases approximately 6,340 megawatts of regulated generation capacity and it holds a mix of both long-term and short-term purchased power agreements for additional capacity, including a variety of agreements for the purchase of renewable energy. The Company's subsidiaries include El Dorado Investment Company (El Dorado) and SunCor Development Company (SunCor). On August 19, 2011, the Company sold APS Energy Services Company, Inc., a subsidiary of the Company."},{"Symbol":"PXD","Name":"Pioneer Natural Resources","Sector":"Energy","Description":"Pioneer Natural Resources Company (Pioneer) is an independent oil and gas exploration and production company with operations in the United States and South Africa. Pioneer is a holding company whose assets consist of direct and indirect ownership interests in, and whose business is conducted substantially through, its subsidiaries. It sells homogenous oil, natural gas liquid (NGL) and gas units. The Company provides administrative, financial, legal and management support to United States and South Africa subsidiaries that explore for, develop and produce proved reserves. The Company's continuing operations are principally located in the United States in the states of Texas, Kansas, Colorado and Alaska. In April 2012, it acquired Carmeuse Industrial Sands (CIS). In August 2012, the Company sold its South Africa business to The Petroleum Oil and Gas Corporation of South Africa (SOC) Ltd. (PetroSA)."},{"Symbol":"PNC","Name":"PNC Financial Services","Sector":"Financials","Description":"The PNC Financial Services Group, Inc. (PNC) is a financial service company. The Company has businesses engaged in retail banking, corporate and institutional banking, asset management, and residential mortgage banking, providing its products and services nationally and others in its markets located in Pennsylvania, Ohio, New Jersey, Michigan, Illinois, Maryland, Indiana, Kentucky, Florida, Washington, D.C., Delaware, Virginia, Missouri, Wisconsin and Georgia. It also provides certain products and services internationally. As of December 31, 2011, its corporate legal structure consisted of one domestic subsidiary bank, including its subsidiaries, and approximately 141 active non-bank subsidiaries. On March 2, 2012, it acquired RBC Bank (USA). Effective October 26, 2012, PNC divested certain deposits and assets of the Smartstreet business unit, which was acquired by PNC as part of the RBC Bank (USA) acquisition, to Union Bank, N.A."},{"Symbol":"RL","Name":"Polo Ralph Lauren Corp.","Sector":"Consumer Discretionary","Description":"Ralph Lauren Corporation is engaged in the design, marketing and distribution of products, including men's, women's and children's apparel, accessories (including footwear), fragrances and home furnishings. The Company operates in three segments: Wholesale, Retail and Licensing. Its apparel products include a range of men's, women's and children's clothing. Accessories include a range of footwear, eyewear, watches, jewelry, hats, belts and leather goods, including handbags and luggage. The Company's coordinated home products include bedding and bath products, furniture, fabric and wallpaper, paint, tabletop and giftware. Fragrance products are sold under its Big Pony, Romance, Polo, Lauren, Safari, Ralph and Black Label brands, among others."},{"Symbol":"PPG","Name":"PPG Industries","Sector":"Materials","Description":"PPG Industries, Inc. (PPG) is a global supplier of protective and decorative coatings. PPG operates in six business segments. The Performance Coatings, Industrial Coatings and Architectural Coatings-EMEA segments supply protective and decorative finishes for customers in a range of end use markets, including industrial equipment, appliances and packaging; factory-finished aluminum extrusions and steel and aluminum coils; marine and aircraft equipment; automotive original equipment; and other industrial and consumer products. The Optical and Specialty Materials segment consist of the optical products and silicas businesses. It is a producer and supplier of basic chemicals. Glass segment produces flat glass and continuous-strand fiber glass. The Glass business segment consists of the flat glass and fiber glass businesses. In January 2013, the combined company formed by uniting Georgia Gulf with PPG's former commodity chemicals business is named Axiall Corporation."},{"Symbol":"PPL","Name":"PPL Corp.","Sector":"Utilities","Description":"PPL Corporation (PPL) is an energy and utility holding company. The Company operates in four segments: Kentucky Regulated, U.K. Regulated, Pennsylvania Regulated and Supply. Through its subsidiaries, PPL generates electricity from power plants in the northeastern, northwestern and southeastern United States; markets wholesale or retail energy primarily in the northeastern and northwestern portions of the United States; delivers electricity to customers in Pennsylvania, Kentucky, Virginia, Tennessee and the United Kingdom, and natural gas to customers in Kentucky. As of December 31, 2012, the Company's subsidiaries were PPL Energy Supply, LLC (PPL Energy Supply), PPL Electric Utilities Corporation (PPL Electric), LG&E and KU Energy LLC (LKE), PPL Global, LLC (PPL Global), PPL EnergyPlus LLC (PPL EnergyPlus), PPL Generation LLC (PPL Generation), Louisville Gas and Electric Company (LG&E) and Kentucky Utilities Company (KU)."},{"Symbol":"PX","Name":"Praxair Inc.","Sector":"Materials","Description":"Praxair, Inc. (Praxair) is an industrial gases supplier. The Company's products are oxygen, hydrogen, nitrogen, argon, carbon dioxide, helium, electronic gases and a range of specialty gases. Praxair Surface Technologies supplies coatings, which protect metal parts from wear, corrosion and heat. Praxair's industrial gas operations are managed on a geographical basis. During the year ended December 31, 2012, 94% of sales were generated in four geographic segments (North America, Europe, South America, and Asia). In November 2012, the Company had acquired Harlingen. In March 2013, Praxair Inc completed the acquisition of NuCO2 Inc. In April 2013, it announced the acquisition of Tri-State Carbonic's carbon dioxide (CO2) plant in Lawrenceburg, Indiana. In May 2013, the Company's subsidiary acquired Aberdeen, Scotland-based Dominion Technology Gases Investment Limited. In June 2013, Praxair Inc announced that it has acquired Volgograd Oxygen Factory (VOF)."},{"Symbol":"PCLN","Name":"Priceline.com Inc","Sector":"Consumer Discretionary","Description":"Priceline Com Incorporated, is an online travel company that offers its customers hotel room reservations at over 295,000 hotels worldwide through the Booking.com, priceline.com and Agoda brands. In the United States, it also offers its customers reservations for car rentals, airline tickets, vacation packages, destination services and cruises through the priceline.com brand. It offers car rental reservations worldwide through rentalcars.com. As of December 31, 2012, its international business (the majority of which is generated by Booking.com) represented approximately 82% of its gross bookings, and approximately 92% of its consolidated operating income. In 2012, the Company launched Express Deals, a merchant semi-opaque price-disclosed hotel reservation service at priceline.com, which allows customers to see the price of the reservation prior to purchase but not the identity of the hotel. On May 2013, the Company acquired Kayak Software Corp."},{"Symbol":"PFG","Name":"Principal Financial Group","Sector":"Financials","Description":"Principal Financial Group, Inc. (PFG) is a provider of retirement savings, investment and insurance products and services. As of December 31, 2011, the Company had approximately 18 million customers. PFG's United States and international operations concentrate primarily on asset accumulation and asset management. PFG offers a range of individual and group life insurance, individual and group disability insurance, and group dental and vision insurance. It focuses on small and medium-sized businesses providing an array of retirement and employee benefit solutions. The Company operates in four segments: retirement and investor services, principal global investors, principal international, and United States insurance solutions. PFG's corporate segment consists of the assets and activities that have not been allocated to any other segment. As of December 31, 2011, it owned 26 properties in Des Moines, Iowa, and in various other locations. In February 2013, it acquired AFP Cuprum S.A."},{"Symbol":"PG","Name":"Procter & Gamble","Sector":"Consumer Staples","Description":"The Procter & Gamble Company (P&G) is focused on providing consumer packaged goods. The Company's products are sold in more than 180 countries and territories worldwide primarily through mass merchandisers, grocery stores, membership club stores, drug stores, department stores, salons, e-commerce and high-frequency stores, and the neighborhood stores, which serve many consumers in developing markets. As of June 30, 2013, the Company had five reportable segments: Beauty; Grooming; Health Care; Fabric Care and Home Care, and Baby Care and Family Care. In beauty care, the Company offers a variety of products, ranging from deodorants to cosmetics to skin care, such as its Olay brand, which is the facial skin care brand in the world. The Company's grooming products include Shave Care (Blades and Razors, Pre- and Post-Shave Products); Braun and Appliances. The Baby Care and Family Care products include baby Wipes, diapers and pants, paper towels, tissues and toilet paper."},{"Symbol":"PGR","Name":"Progressive Corp.","Sector":"Financials","Description":"The Progressive Corporation is an insurance holding company. The Company's insurance subsidiaries and mutual insurance company affiliate provide personal and commercial automobile insurance and other specialty property-casualty insurance and related services. Its personal lines business includes insurance for personal autos and special lines products (such as motorcycles, all terrain vehicles (ATVs), recreational vehicles (RVs), mobile homes, watercraft and snowmobiles). Its Commercial Auto business offers products in 49 states. Its Claims business area is organized into four groups. Three of the groups are based on geographic region, and one is a nationwide group that provides various claims-related services, including catastrophe response and special investigations. Its non-insurance subsidiaries and limited partnership investment affiliate generally support its insurance and investment operations."},{"Symbol":"PLD","Name":"Prologis","Sector":"Real Estate","Description":"Prologis, Inc. (Prologis) is a real estate investment trust (REIT) and the general partner of the Prologis, L.P. As of December 31, 2012, Prologis, Inc. owned an approximate 99.59% common general partnership interest in the Prologis, L.P. and 100% of the preferred units in the Prologis, L.P. It operates the REIT and the Operating Partnership as one enterprise. As of December 31, 2012, it owned and managed properties and development projects totaling 554 million square feet (51.5 million square meters) in 21 countries. countries. These properties are leased to approximately 4,500 customers, including third-party logistics providers, manufacturers, retailers, transportation companies and other enterprises. The Company operates in two segments: segments: real estate operations and private capital. In May 2013, Prologis Inc acquired DocData distribution centre."},{"Symbol":"PRU","Name":"Prudential Financial","Sector":"Financials","Description":"Prudential Financial, Inc. (Prudential Financial) is a financial services company. Prudential Financial has operations in the United States, Asia, Europe and Latin America. Through its subsidiaries and affiliates, the Company offers an array of financial products and services, including life insurance, annuities, retirement-related services, mutual funds and investment management. Prudential Financial has two businesses: the Financial Services Businesses and the Closed Block Business. The Financial Services Businesses consists of its United States Retirement Solutions and Investment Management division, United States Individual Life and Group Insurance division, and International Insurance division, as well as its Corporate and Other operations. The Closed Block Business consists of the assets and related liabilities of the Closed Block described below and certain related assets and liabilities. On January 1, 2012, it merged with Gibraltar Life Insurance Company, Ltd (Gibraltar Life)."},{"Symbol":"PEG","Name":"Public Serv. Enterprise Inc.","Sector":"Utilities","Description":"Public Service Enterprise Group Incorporated, through its subsidiaries, operates as an energy company primarily in the northeastern and Mid Atlantic United States. The company operates nuclear, coal, gas, oil-fired, and renewable generation facilities with a generation capacity of approximately 13,146 megawatts. It sells electricity, natural gas, emissions credits, and a series of energy-related products that are used to optimize the operation of the energy grid. The company also transmits electricity; and distributes electricity and gas to residential, commercial, and industrial customers, as well as invests in solar generation projects, and implements energy efficiency and demand response programs. In addition, it offers appliance services and repairs to customers. As of December 31, 2014, it owned and operated 17,792 miles of gas mains; and owned 12 gas distribution headquarters and 2 sub-headquarters, as well as operated 62 natural gas metering and regulating stations. Public Service Enterprise Group Incorporated was founded in 1985 and is headquartered in Newark, New Jersey."},{"Symbol":"PSA","Name":"Public Storage","Sector":"Real Estate","Description":"Public Storage (the Trust) is a real estate investment trust (REIT). As of December 31, 2012, the Trust's principal business activities included: Domestic Self-Storage, European Self-Storage and Commercial. The Trust acquires, develops, owns, and operates self-storage facilities which offer storage spaces for lease, on a month-to-month basis, for personal and business use. It is a owner and operator of self-storage facilities in the United States. It has direct and indirect equity interests in 2,078 self-storage facilities (132 million net rentable square feet of space) located in 38 states within the United States operating under the Public Storage brand name. The Trust has a 49% equity interest in Shurgard Europe, with an institutional investor owning the remaining 51% interest. It has a 41% equity interest in PS Business Parks, Inc. (PSB), which owns and operates 28.3 million net rentable square feet of commercial space."},{"Symbol":"PHM","Name":"Pulte Homes Inc.","Sector":"Consumer Discretionary","Description":"PulteGroup, Inc. (PulteGroup) is a homebuilder in the United States. The Company's subsidiaries engage primarily in the homebuilding business. PulteGroup also has mortgage banking operations, conducted principally through Pulte Mortgage LLC (Pulte Mortgage), and title operations. Homebuilding, its core business, includes the acquisition and development of land primarily for residential purposes within the United States and the construction of housing on such land. Homebuilding offers a product line to meet the needs of home buyers in its targeted markets. The Company also has one segment for its financial services operations, which consist principally of mortgage banking and title operations. Its Financial Services segment operates generally in the same geographic markets as its Homebuilding segments. During the year ended December 31, 2011, it originated mortgage loans for 62%. Centex Corporation (Centex) and Pulte Mortgage are the wholly owned subsidiary of the Company."},{"Symbol":"PVH","Name":"PVH Corp.","Sector":"Consumer Discretionary","Description":"PVH Corp. operates as an apparel company in the United States and internationally. It designs, markets, and retails mens and womens apparel and accessories, branded dress shirts, neckwear, sportswear, jeanswear, intimate apparel, swim products, handbags, footwear, golf apparel, fragrances, cosmetics, eyewear, hosiery, socks, jewelry, watches, outerwear, small leather goods, and home furnishings, as well as other related products. The company offers its products under its own brands, such as Calvin Klein, Tommy Hilfiger, Van Heusen, IZOD, ARROW, Warners, Olga, and Eagle; licensed brands comprising Speedo, Geoffrey Beene, Kenneth Cole New York, Kenneth Cole Reaction, Sean John, MICHAEL Michael Kors, Michael Kors Collection, Chaps, Donald J. Trump Signature Collection, DKNY, Nautica, Ted Baker, J. Garcia, Claiborne, Ike Behar, Jones New York, and Ryan Seacrest; and trademarks, as well as various other licensed and private label brands. It also licenses its own brands over a range of products. The company distributes its products at wholesale in department, chain, specialty, mass market, club, off-price, and independent stores; and through company-operated full-price specialty and outlet stores, as well as through e-commerce Websites. PVH Corp. was founded in 1881 and is based in New York, New York."},{"Symbol":"QRVO","Name":"Qorvo","Sector":"Information Technology","Description":"Qorvo, Inc. provides technologies and radio frequency (RF) solutions for mobile, infrastructure, defense, and aerospace applications in the United States and internationally. The company operates through Mobile Products, and Infrastructure and Defense Products segments. The Mobile Products segment offers complete RF front end modules that combine high-performance filters, power amplifiers (PAs) and switches, PA modules, transmit modules, antenna control solutions, antenna switch modules, diversity receive modules, and envelope tracking power management devices. This segment supplies its RF solutions into various mobile devices, including smartphones, handsets, notebook computers, wearables, and tablets. The Infrastructure and Defense Products segment provides high power gallium arsenide and gallium nitride PAs, amplifiers, switches, fixed frequency and voltage-controlled oscillators, filters, attenuators, modulators, driver and transimpedance amplifiers, and various multichip and hybrid assemblies. This segment offers its RF solutions to wireless network infrastructure, defense, and aerospace markets; and connectivity applications for commercial, consumer, industrial, and automotive markets. The company sells its products directly, as well as through a network of sales representative firms and distributors to original equipment manufacturers and original design manufacturers of mobile products, and infrastructure and defense products. Qorvo, Inc. is headquartered in Greensboro, North Carolina."},{"Symbol":"QCOM","Name":"QUALCOMM Inc.","Sector":"Information Technology","Description":"QUALCOMM Incorporated (Qualcomm) is engaged in designing and manufacturing of digital communications products and services based on code division multiple access (CDMA), Orthogonal Frequency Division Multiplexing (OFDMA) and other technologies. The Company operates in four segments: Qualcomm CDMA Technologies (QCT); Qualcomm Technology Licensing (QTL); Qualcomm Wireless & Internet (QWI), and Qualcomm Strategic Initiatives (QSI). The Company develops and supply integrated circuits and system software based on CDMA, OFDMA and other technologies for uses in voice and data communications, networking, application processing, multimedia and global positioning system products. Effective July 4, 2013, Bharti Airtel Ltd raised its interest to 51% from 49% by acquiring a 2% interest in Qualcomm India Pvt Ltd, from Qualcomm Inc. In November 2013, the Company sold its subsidiary, Omnitracs, Inc to Vista Equity Partners."},{"Symbol":"PWR","Name":"Quanta Services Inc.","Sector":"Industrials","Description":"Quanta Services, Inc. (Quanta) is a provider of specialty contracting services, offering infrastructure solutions primarily to the electric power and natural gas and oil pipeline industries. The services the Company provides include the design, installation, upgrade, repair and maintenance of infrastructure within each of the industries the Company serves, such as electric power transmission and distribution networks, substation facilities, renewable energy facilities and pipelines transmission, gathering and distribution systems and facilities. It operates in three segments: electric power infrastructure services, natural gas and pipeline infrastructure services and fiber optic licensing and other. Effective August 14, 2013, Quanta Services Inc acquired JW Didado Electric Inc, an electric utility company. Effective July 29, 2013, Quanta Services Inc acquired Nacap Australia Pty Ltd."},{"Symbol":"DGX","Name":"Quest Diagnostics","Sector":"Health Care","Description":"Quest Diagnostics Incorporated (Quest Diagnostics), is a provider of diagnostic testing, information and services, providing insights that enable patients and physicians to make healthcare decisions. Quest Diagnostics offers United States patients and physicians the access to diagnostic testing services through its nationwide network of laboratories and Company-owned patient service centers. It provides interpretive consultation through the medical and scientific staff. It is a provider of clinical testing, including gene-based and esoteric testing and anatomic pathology services, and the provider of risk assessment services for the life insurance industry. On September 30, 2013, it sold its Enterix colorectal cancer screening test business to Clinical Genomics Technologies Pty Ltd. In October 2013, Quest Diagnostics Incorporated acquired ConVerge Diagnostic Services, LLC from Water Street Healthcare Partners."},{"Symbol":"RRC","Name":"Range Resources Corp.","Sector":"Energy","Description":"Range Resources Corporation (Range) is an independent natural gas, natural gas liquids and oil company, engaged in the exploration, development and acquisition of natural gas and oil properties, mostly in the Appalachian and Southwestern regions of the United States. Range operates in two regions: the Appalachian (which includes shale tight gas, coal bed methane and conventional natural gas, natural gas liquids, condensate and oil production in Pennsylvania, Virginia, and West Virginia), and Southwestern (which includes the Permian Basin of West Texas and the Delaware Basin of New Mexico, the Texas Panhandle, the Ardmore Basin in Southern Oklahoma, the Nemaha Uplift in Northern Oklahoma and the Anadarko Basin of Western Oklahoma). As of Decmbeer 31, 2011, the Company has approximately 8,600 proven and unproven drilling locations in inventory. During the year ended December 31, 2011, the Company discontinued its Barnett Shale assets that were sold in April 2011."},{"Symbol":"RTN","Name":"Raytheon Co.","Sector":"Industrials","Description":"Raytheon Company together with its subsidiaries, is a technology company specializing in defense, homeland security and other government markets worldwide. The Company provides electronics, mission systems integration and other capabilities in the areas of sensing, effects, and command, control, communications and intelligence systems (C3I), as well as a range of mission support services. It serves both domestic and international customers, principally as a prime contractor on a portfolio of defense and related programs for government customers. The Company operates in six business segments: Integrated Defense Systems (IDS); Intelligence and Information Systems (IIS); Missile Systems (MS); Network Centric Systems (NCS); Space and Airborne Systems (SAS), and Technical Services (TS). On January 31, 2011, the Company acquired Raytheon Applied Signal Technology, Inc. (RAST). Effective June 27, 2013, Raytheon Co acquired Visual Analytics Inc."},{"Symbol":"O","Name":"Realty Income Corporation","Sector":"Real Estate","Description":"Realty Income Corporation (Realty Income) is an equity real estate investment trust (REIT). The Company is engaged in acquiring and owning freestanding retail and other properties that generate rental revenue under long-term lease agreements (primarily 10 to 20 years). The Company has in-house acquisition, leasing, legal, credit research, real estate research, portfolio management and capital markets. At December 31, 2011, it owned a diversified portfolio of 2,634 properties with an occupancy rate of 96.7%, or 2,547 properties leased and only 87 properties available for lease. It leased properties to 136 different retail and other commercial enterprises doing business in 38 separate industries. It properties are located in 49 states, with over 27.3 million square feet of leasable space, and with an average leasable space per property of approximately 10,400 square feet. In January 2013, it acquired American Realty Capital Trust."},{"Symbol":"RHT","Name":"Red Hat Inc.","Sector":"Information Technology","Description":"Red Hat, Inc. (Red Hat) is a global provider of open source software solutions, using a community-powered approach to develop and offer operating system, middleware, virtualization, storage and cloud technologies. The Company offerings include Red Hat Enterprise Linux, Red Hat JBoss Middleware, Red Hat Enterprise Virtualization and Red Hat Storage Server. Red Hat Enterprise Linux is an operating system, which runs on a range of hardware, including mainframes, servers and work stations. Red Hat JBoss Middleware is a range of technologies used for developing, deploying and managing distributed applications. Red Hat Enterprise Virtualization includes standalone virtualization functionality and management tools for both server and desktop deployments. Red Hat Storage Server is software, which enables users to treat storage as a virtualized resource, and is available for deployment both on-premise and in public or hybrid clouds."},{"Symbol":"REG","Name":"Regency Centers Corporation","Sector":"Real Estate","Description":"Regency Centers Corporation is a real estate investment trust (REIT) and is the managing general partner in Regency Centers, L.P. It endeavors to be the preeminent national shopping center company distinguished by sustaining growth in shareholder value and compounding total shareholder return in excess of its peers. All of its operating, investing, and financing activities are performed through the Operating Partnership, its wholly-owned subsidiaries, and through its investments in real estate partnerships with third parties. In October 2013, Charter Realty & Development Corp. and Regency Centers Corporation closed on the acquisition of Fellsway Plaza, a 150,000-square-foot neighhood center anchored by a constructed Stop & Shop, located in Medford, Mass."},{"Symbol":"REGN","Name":"Regeneron","Sector":"Health Care","Description":"Regeneron Pharmaceuticals, Inc. (Regeneron) is an integrated biopharmaceutical company, which discovers, invents, develops, manufactures, and commercializes medicines for the treatment of serious medical conditions. As of December 31, 2011, the Company had two marketed products: EYLEA (aflibercept) Injection and ARCALYST (rilonacept) Injection for Subcutaneous Use. As of December 31, 2011, the Company had 13 product candidates in clinical development. Its Trap-based, late-stage programs are EYLEA, which is being developed for the treatment of additional serious eye diseases; ZALTRAP (aflibercept), known in the scientific literature as vascular endothelial growth factor (VEGF) trap, which is being developed in oncology in collaboration with Sanofi; and ARCALYST, which is being developed for the prevention of gout flares in patients initiating uric acid-lowering treatment."},{"Symbol":"RF","Name":"Regions Financial Corp.","Sector":"Financials","Description":"Regions Financial Corporation (Regions) is a financial holding company. Regions operate throughout the South, Midwest and Texas. The Company provides traditional commercial, retail and mortgage banking services, as well as other financial services in the fields of investment banking, asset management, trust, mutual funds, securities brokerage, insurance and other specialty financing. Regions conduct its banking operations through Regions Bank, a commercial bank. As of December 31, 2011, Regions operated approximately 2,100 automated teller machines (ATMs) and 1,726 banking offices in Alabama, Arkansas, Florida, Georgia, Illinois, Indiana, Iowa, Kentucky, Louisiana, Mississippi, Missouri, North Carolina, South Carolina, Tennessee, Texas and Virginia. It provides additional financial services through its subsidiaries, which includes Morgan Keegan & Company, Inc. and Regions Insurance Group, Inc. In April 2012, it sold Morgan Keegan & Company, Inc. and related affiliates to Raymond James"},{"Symbol":"RSG","Name":"Republic Services Inc","Sector":"Industrials","Description":"Republic Services, Inc. (Republic) is a provider of services in the domestic non-hazardous solid waste industry. Republic provides non-hazardous solid waste collection services for commercial, industrial, municipal and residential customers through 334 collection operations in 39 states and Puerto Rico. The Company owns or operates 194 transfer stations, 191 active solid waste landfills and 74 materials recovery facilities. It also operates 69 landfill gas and renewable energy projects. The Company operates in four geographical segments: Eastern, Midwestern, Southern and Western. Its residential collection operations involve the curbside collection of refuse from small containers into collection vehicles for transport to transfer stations or directly to landfills. Its commercial and industrial collection operations supply the customers with waste containers of varying sizes."},{"Symbol":"RAI","Name":"Reynolds American Inc.","Sector":"Consumer Staples","Description":"Reynolds American Inc. (RAI) is a holding company. The Company's operating subsidiaries include cigarette manufacturer in the United States, R. J. Reynolds Tobacco Company; the smokeless tobacco products manufacturer in the United States, American Snuff Company, LLC (American Snuff Co); the manufacturer of cigarette brand, Santa Fe Natural Tobacco Company, Inc. (SFNTC), and Niconovum AB. RAI operates in three segments: RJR Tobacco, American Snuff and Santa Fe. The RJR Tobacco segment consists of the primary operations of R. J. Reynolds Tobacco Company. The American Snuff segment consists of the primary operations of American Snuff Co. Santa Fe manufactures and markets cigarettes and other tobacco products under the NATURAL AMERICAN SPIRIT brand."},{"Symbol":"RHI","Name":"Robert Half International","Sector":"Industrials","Description":"Robert Half International Inc. provides specialized staffing and risk consulting services. The Company operates in three segments: temporary and consultant staffing, permanent placement staffing, and risk consulting and internal audit services. The Company, through its Accountemps, Robert Half Finance & Accounting, and Robert Half Management Resources divisions, is a specialized provider of temporary, full-time, and project professionals in the fields of accounting and finance. OfficeTeam specializes in skilled temporary administrative support personnel. Robert Half Technology provides information technology professionals. Robert Half Legal provides temporary, project, and full-time staffing of attorneys and specialized support personnel within law firms and corporate legal departments. The Creative Group provides project staffing in the advertising, marketing, and Web design fields. Protiviti is a global business consulting and internal audit firm."},{"Symbol":"ROK","Name":"Rockwell Automation Inc.","Sector":"Industrials","Description":"Rockwell Automation, Inc. (Rockwell Automation) is a provider of industrial automation power, control and information solutions that help manufacturers achieve a competitive advantage for their businesses. The Company operates in two segments: Architecture & Software and controls Products & Solutions. In the United States, Canada and certain other countries, the Company sells primarily through the independent distributors in conjunction with its direct sales force. In the remaining countries, the Company sells through a combination of its direct sales force. In March 2012, the Company purchased SoftSwitching Technologies."},{"Symbol":"COL","Name":"Rockwell Collins","Sector":"Industrials","Description":"Rockwell Collins, Inc. (Rockwell Collins) is engaged in design, production and support of communications and aviation electronics for commercial and military customers worldwide. The Company's products and systems are primarily focused on aviation applications, The integrated system solutions and products it provide to its served markets include communications, navigation, automated flight control, displays/surveillance, simulation and training, integrated electronics and information management systems. It also provides a range of services and support to its customers through a network of service centers, including equipment repair and overhaul, service parts, field service engineering, training, technical information services and aftermarket used equipment sales. It operates in two segments: Government Systems and Commercial Systems. In November 2013, Rockwell Collins, Inc completed the sale of its subsidiary, Kaiser Optical Systems, Inc. to Endress+Hauser (International) Holding AG."},{"Symbol":"ROP","Name":"Roper Industries","Sector":"Industrials","Description":"Roper Industries, Inc. (Roper) designs, manufactures and distributes radio frequency (RF) products, services and application software, industrial technology products, energy systems and controls and medical and scientific imaging products and software. The Company markets these products and services to a range of markets, including RF applications, medical, water, energy, research, education, software-as-a-service (SaaS)-based information networks, security and other niche markets. The Company operates in four segments: Medical and Scientific Imaging, Energy Systems and Controls, Industrial Technology and RF Technology. On August 22, 2012, the Company acquired Sunquest Information Systems, Inc. (Sunquest), a provider of diagnostic and laboratory software solutions to healthcare providers. In May 2013, Roper Industries Inc acquired Managed Health Care Associates Inc."},{"Symbol":"ROST","Name":"Ross Stores","Sector":"Consumer Discretionary","Description":"Ross Stores, Inc. is an off-price apparel and home fashion chain in the United States, with 1,091 locations in 33 states, the District of Columbia and Guam. The Company operates two brands of off-price retail apparel and home fashion stores: Ross Dress for Less (Ross) and dd's DISCOUNTS. It offers designer apparel, accessories, footwear, and home fashions for the entire family at everyday savings of 20% to 60% off department and specialty store regular prices. As of February 2, 2013, it operated 108 dd's DISCOUNTS stores in eight states. dd's DISCOUNTS features brand apparel, accessories, footwear, and home fashions for the entire family at everyday savings of 20% to 70% off moderate department and discount store regular prices."},{"Symbol":"RCL","Name":"Royal Caribbean Cruises Ltd","Sector":"Consumer Discretionary","Description":"Royal Caribbean Cruises Ltd. (Royal Caribbean) is a cruise company. As of December 31, 2012, the Company operated 41 ships in the cruise vacation industry across six brands with an aggregate capacity of approximately 98,650 berths. The Company's ships operate on a range of global itineraries, which call on approximately 455 destinations on all seven continents. Its global brands include Royal Caribbean International, Celebrity Cruises, Pullmantur, Azamara Club Cruises and CDF Croisieres de France. These brands are complemented by its Pullmantur brand, which has been custom tailored to serve the cruise markets in Spain, Portugal and Latin America, and its CDF Croisieres de France brand, which provides it with a custom tailored product targeted at the French market. In addition, it has a 50% investment in a joint venture, which operates the brand TUI Cruises, tailored for the German market."},{"Symbol":"R","Name":"Ryder System","Sector":"Industrials","Description":"Ryder System, Inc. (Ryder) is engaged in transportation and supply chain management solutions. Ryder operates in three business segments: Fleet Management Solutions (FMS), which provides full service leasing, contract maintenance, contract-related maintenance and commercial rental of trucks, tractors and trailers to customers principally in the United States, Canada and the United Kingdom; Supply Chain Solutions (SCS), which provides supply chain solutions, including distribution and transportation services throughout North America and Asia, and Dedicated Contract Carriage (DCC), which provides vehicles and drivers as part of a dedicated transportation solution in the United States. On June 8, 2011, it acquired all of the common stock of Hill Hire plc (Hill Hire). On August 1, 2012, it acquired Euroway Group Ltd. In September 2012, it opened its new Ryder Vehicle Sales center, offering used trucks for sale in the Greater Vancouver Area."},{"Symbol":"SPGI","Name":"S&P Global, Inc.","Sector":"Financials","Description":"S&P Global Inc. (prior to April 2016 McGraw Hill Financial, Inc., and prior to 2013 McGraw Hill Companies) is an American publicly traded corporation headquartered in New York City. Its primary areas of business are financial information and analytics. It is the parent company of S&P Global Ratings, S&P Global Market Intelligence, and S&P Global Platts, and is the majority owner of the S&P Dow Jones Indices joint venture."},{"Symbol":"CRM","Name":"Salesforce.com","Sector":"Information Technology","Description":"salesforce.com, inc. is a provider of enterprise cloud computing and social enterprise solutions. The Company provides a customer and collaboration relationship management (CRM), applications through the Internet or cloud. Cloud computing refers to the use of Internet-based computing, storage and connectivity technology to deliver a variety of different services. The Company delivers its service through Internet browsers and mobile devices. It markets its social enterprise applications and platforms to businesses on a subscription basis, primarily through its direct sales efforts and indirectly through partners. In May 2013, salesForce.com Inc acquired Clipboard Inc. In July 2013, salesforce.com, Inc. completed its acquisition of ExactTarget Inc."},{"Symbol":"SCG","Name":"SCANA Corp","Sector":"Utilities","Description":"SCANA Corporation, through its subsidiaries, is engaged in the generation, transmission, distribution, and sale of electricity to retail and wholesale customers in South Carolina. It owns nuclear, coal, hydro, natural gas and oil, and biomass generating facilities. The company also purchases, sells, and transports natural gas; offers energy-related risk management services; and provides service contracts on home appliances, and heating and air conditioning units. In addition, it owns two liquefied natural gas plants in Charleston and Salley, South Carolina; and offers tower site construction, management, and rental services, as well as sells towers in South Carolina and North Carolina. As of December 31, 2013, the company supplied electricity to approximately 678,000 customers; and provided natural gas to approximately 509,000 residential, commercial, and industrial customers in North Carolina and South Carolina, as well as markets natural gas to approximately 454,000 customers in Georgia. Further, SCANA Corporation owns and operates a 1,125 mile fiber optic telecommunications network and Ethernet network, as well as data center facilities in South Carolina. Additionally, it builds, manages, and leases communications towers with interests in 2,280 miles of fiber in South Carolina, North Carolina, and Georgia through a joint venture. The companys customers comprise municipalities, electric cooperatives, other investor-owned utilities, registered marketers, and federal and state electric agencies. It also serves chemical, educational service, paper product, food product, lumber and wood product, health service, textile manufacturing, rubber and miscellaneous plastic product, and fabricated metal product industries. The company was founded in 1924 and is based in Cayce, South Carolina."},{"Symbol":"SLB","Name":"Schlumberger Ltd.","Sector":"Energy","Description":"Schlumberger Limited (Schlumberger N.V.) is the supplier of technology, integrated project management and information solutions to the international oil and gas exploration and production industry. The Company's segments include Reservoir Characterization Group, which consists of the principal technologies involved in finding and defining hydrocarbon deposits; Drilling Group, which consists of the principal technologies involved in the drilling and positioning of oil and gas wells, and Production Group consists of the principal technologies involved in the lifetime production of oil and gas reservoirs and includes Well Services, Completions, Artificial Lift, Well Intervention, Subsea, Water Services, Carbon Services and the Schlumberger Production Management field production projects."},{"Symbol":"SNI","Name":"Scripps Networks Interactive Inc.","Sector":"Consumer Discretionary","Description":"Scripps Networks Interactive, Inc. is a developer of lifestyle-oriented content for television and the Internet with television and interactive brands. The Company operates through its Lifestyle Media segment. Lifestyle Media includes the Company's national television networks, Food Network, Home and Garden Television (HGTV), Travel Channel, DIY Network (DIY), Cooking Channel and Great American Country (GAC). Lifestyle Media also includes Websites that are associated with the aforementioned television brands and other Internet-based businesses serving food, home and travel related categories. The Company's lifestyle-oriented channels are available in the United Kingdom, other European markets, the Middle East, Africa and Asia-Pacific. In April 2012, it acquired Travel Channel International, Ltd. (TCI). In April 2013, it announced the acquisition of Asian Food Channel."},{"Symbol":"STX","Name":"Seagate Technology","Sector":"Information Technology","Description":"Seagate Technology plc (Seagate) is the provider of electronic data storage products. The Company's principal products are hard disk drives, commonly referred to as disk drives, hard drives or HDDs. The Company produces a range of disk drive products addressing enterprise applications, where its products are designed for enterprise servers, mainframes and workstations; client compute applications, desktop and notebook computers, and client non-compute applications, for a range of end user devices, such as digital video recorders (DVRs), personal data backup systems, portable external storage systems and digital media systems. In addition to manufacturing and selling disk drives, it provides data storage services for small- to medium-sized businesses, including online backup, data protection and recovery solutions. On December 19, 2011, it completed the acquisition of Samsung Electronics Co., Ltd's (Samsung) hard disk drive business. In August 3, 2012, it acquired 64.5% of LaCie S.A."},{"Symbol":"SEE","Name":"Sealed Air","Sector":"Materials","Description":"Sealed Air Corporation is engaged in food safety and security, facility hygiene and product protection business. The Company serves a range of end markets, including food and beverage processing, food service, retail, health care and industrial, commercial and consumer applications. The Company's brands include bubbles Wrap brand cushioning, Cryovac brand food packaging solutions and Diversey brand cleaning and hygiene solutions. The Company operates in four segments: food and beverage, institutional and laundry and protective packaging, and other category, which includes its medical applications and new venture businesses. On November 14, 2012, the Company completed the sale Diversey G.K. (Diversey Japan)."},{"Symbol":"SRE","Name":"Sempra Energy","Sector":"Utilities","Description":"Sempra Energy is a holding company. During the year ended December 31, 2011, Sempra Energy's business was organized in five segments consisting of San Diego Gas & Electric Company (SDG&E), Southern California Gas Company (SoCalGas), Sempra Generation, Sempra Pipelines & Storage and Sempra LNG (liquefied natural gas). Sempra Generation, Sempra Pipelines & Storage and Sempra LNG are subsidiaries of Sempra Global. Sempra Global is a holding company for most of its subsidiaries. In September 2013, Sempra Energy's Sempra United States Gas & Power acquired and will develop the Broken Bow 2 wind project in Nebraska."},{"Symbol":"SHW","Name":"Sherwin-Williams","Sector":"Materials","Description":"The Sherwin-Williams Company (Sherwin-Williams) is engaged in the development, manufacture, distribution and sale of paint, coatings and related products to professional, industrial, commercial and retail customers primarily in North and South America with additional operations in the Caribbean region, Europe and Asia. The Company has four segments: Paint Stores Group, Consumer Group, Global Finishes Group and Latin America Coatings Group. In September 2013, Sherwin-Williams Co announced that it has completed the acquisition of the United States/Canada business of Consorcio Comex, S.A. de C.V."},{"Symbol":"SIG","Name":"Signet Jewelers","Sector":"Consumer Discretionary","Description":"Signet Jewelers Limited is engaged in the retail sale of jewelry and watches in the United States, the United Kingdom, the Republic of Ireland, and the Channel Islands. The company operates through US and UK divisions. As of February 1, 2014, the US division operated a network of 1,471 stores in 50 states, including stores that trade nationally in malls and off-mall locations under the Kay Jewelers brand, and regionally under the mall-based brands; and destination superstores under the Jared The Galleria Of Jewelry brand, as well as Ultra stores. As of February 1, 2014, the UK division operated a network of 493 stores, including 14 stores in the Republic of Ireland and 3 in the Channel Islands under the H.Samuel, Ernest Jones, and Leslie Davis brands in regional shopping malls and high street locations. The company also operates a diamond polishing factory, which is involved in rough diamond sourcing and manufacturing activities. Signet Jewelers Limited was founded in 1950 and is based in Hamilton, Bermuda."},{"Symbol":"SPG","Name":"Simon Property Group Inc","Sector":"Real Estate","Description":"Simon Property Group, Inc. is an equity real estate investment trust. The firm invests in the real estate markets across the globe. It engages in investment, ownership, and management of properties. It primarily invests in regional malls, Premium Outlets, The Mills, and community/lifestyle centers to create its portfolio. Simon Property Group, Inc. was founded in 1960 and is based in Indianapolis, Indiana, with additional offices in Delaware, United States; and New York, New York."},{"Symbol":"SWKS","Name":"Skyworks Solutions","Sector":"Information Technology","Description":"Skyworks Solutions, Inc. (Skyworks) offers analog and mixed signal semiconductors. Skyworks offers custom linear products supporting automotive, broadband, cellular infrastructure, energy management, industrial, medical, military and cellular handset applications. The Company's portfolio includes amplifiers, attenuators, circulators, detectors, diodes, directional couplers, front-end modules, hybrids, infrastructure radio frequency (RF) subsystems, isolators, mixers/demodulators, optocouplers, optoisolators, phase shifters, phase locked loops (PLLs)/synthesizers/VCOs, power dividers/combiners, receivers, switches and technical ceramics. Its portfolio includes customized power amplifiers and front-end solutions. On June 10, 2011, the Company completed the acquisition of SiGe Semiconductor, Inc. (SiGe), a semiconductor provider. On April 27, 2011, the Company acquired 100% ownership of a private company engaged in the design and manufacturing of optical components."},{"Symbol":"SLG","Name":"SL Green Realty","Sector":"Real Estate","Description":"SL Green Realty Corp., incorporated on June, 10, 1997, is a self-managed real estate investment trust (REIT), with in-house capabilities in property management, acquisitions, financing, development, construction and leasing. As of December 31, 2012, its Manhattan office properties were comprised of 21 fee owned properties, including ownership in commercial condominium units, and six leasehold owned properties. In July 2012, the Company and its joint venture partners sold One Court Square in Long Island City, New York. On November 22, 2012, the Company and its partner Westcore Properties sold Jersey Property Unit Trust (JPUT). In December 2012, the Company acquired the non-performing mortgage loan secured by the property at 315 Park Avenue South, New York. During 2012, the Company acquired 12 properties. During 2012, the Company sold its fee interest at 292 Madison Avenue."},{"Symbol":"SNA","Name":"Snap-On Inc.","Sector":"Consumer Discretionary","Description":"Snap-on Incorporated (Snap-on) is a manufacturer and marketer of tools, equipment, diagnostics, repair information and systems solutions for professional users. Snap-on's products and services include hand and power tools, tool storage, diagnostics software, information and management systems, shop equipment and other solutions for vehicle dealerships and repair centers, as well as customers in industries, including aviation, aerospace, agriculture, construction, Government and military, mining, natural resources, power generation and technical education. Snap-on also derives income from various financing programs to facilitate the sales of its products. Snap-on markets its products and brands through a number of distribution sales channels in approximately 130 countries. Its business segments include the Commercial & Industrial Group; the Snap-on Tools Group; the Repair Systems & Information Group, and Financial Services. In May 2013, the Company acquired Challenger Lifts, Inc."},{"Symbol":"SO","Name":"Southern Co.","Sector":"Utilities","Description":"The Southern Company (Southern Company)is a holding company, which owns all of the common stock of the traditional operating companies, including Alabama Power Company (Alabama Power), Georgia Power Company (Georgia Power), Gulf Power Company (Gulf Power), and Mississippi Power Company (Mississippi Power) ,and Southern Power Company (Southern Power), and other direct and indirect subsidiaries (together, the Southern Company system). The primary business of the Southern Company system is electricity sales by the traditional operating companies and Southern Power. The four traditional operating companies are vertically integrated utilities providing electric service in four Southeastern states. Southern Power constructs, acquires, owns, and manages generation assets. In July 2012, the Company and Turner Renewable Energy acquired a 20 megawatts solar photovoltaic power plant in Nevada from SunEdison, a subsidiary of MEMC Electronic Materials, Inc."},{"Symbol":"LUV","Name":"Southwest Airlines","Sector":"Industrials","Description":"Southwest Airlines Co. operates Southwest Airlines, a passenger airline, which provides scheduled air transportation in the United States. As of December 31, 2011, the Company was serving 72 cities in 37 states throughout the United States. During the year ended December 31, 2011, the Company added addition services in two new states and three new cities: Charleston, South Carolina; Greenville-Spartanburg, South Carolina; and Newark, New Jersey. Southwest provides point-to-point. On May 2, 2011, the Company acquired AirTran Holdings, Inc. (AirTran). In December 2013, Southwest Airlines Co acquired 12 takeoff and landing slots at New York's LaGuardia Airport being divested by American Airlines as part of its merger with US Airways."},{"Symbol":"SWN","Name":"Southwestern Energy","Sector":"Energy","Description":"Southwestern Energy Company is an independent energy company engaged in natural gas and oil exploration, development and production. It is focused on creating and capturing additional value through its natural gas gathering and marketing businesses, which it refers to as Midstream Services. Its primary business is the exploration for and production of natural gas and oil, with operations being focused within the United States on development of an unconventional gas reservoir located on the Arkansas side of the Arkoma Basin, which it refers to as the Fayetteville Shale play. It is also engaged in exploration and production activities in Pennsylvania, and Texas and in Arkansas and Oklahoma in the Arkoma Basin. It conducts its exploration and production operations through its wholly owned subsidiaries, SEECO, Inc., and Southwestern Energy Production Company. In May 2011, it sold the producing rights to the Haynesville and Middle Bossier Shale intervals in approximately 9,717 net acres."},{"Symbol":"SWK","Name":"Stanley Black & Decker","Sector":"Consumer Discretionary","Description":"Stanley Black & Decker Inc. is a diversified global provider of power and hand tools, mechanical access solutions (automatic doors, commercial and residential locking systems), electronic security and monitoring systems and products and services for various industrial applications. The Company's operations are classified into three business segments: Construction & Do-It-Yourself (CDIY), Security, and Industrial. In September 2011, Stanley Black & Decker acquired Niscayah Group AB. In September 2011, the Company acquired Microtec Enterprises, Inc. In January 2011, the Company acquired InfoLogix, Inc. In December 2012, Spectrum Brands Holdings Inc acquired Hardware & Home Improvement Group (HHI) of the Company. In February 2013, the Company completed its acquisition of Infastech."},{"Symbol":"SPLS","Name":"Staples Inc.","Sector":"Consumer Discretionary","Description":"Staples, Inc. (Staples) is an office products company. The Company operates in three business segments: North American Stores & Online, North American Commercial and International Operations. As of February 02, 2013, the Company served businesses of all sizes and consumers in North America, Europe, Australia, South America and Asia. The Company's North American Commercial segment consists of the United States and Canadian businesses that sell and deliver office products and services directly to businesses and includes Staples Advantage and Quill.com. The Company's International Operations segment consists of businesses in 23 countries in Europe, Australia, South America and Asia. The Company offers more than 10,000 own brand products and services, including an assortment of products with various environmental attributes, which includes its Sustainable Earth brand products. In October 2013, Staples Inc completed the acquisition of Runa."},{"Symbol":"SBUX","Name":"Starbucks Corp.","Sector":"Consumer Discretionary","Description":"Starbucks Corporation is a roaster, marketer and retailer of coffee operating in 60 countries. The Company purchases and roasts coffees that it sells, along with handcrafted coffee, tea and other beverages and a variety of fresh food items, through Company-operated stores. It also sells a variety of coffee and tea products and licenses its trademarks through other channels, such as licensed stores and national foodservice accounts. As of September 30, 2012, it operated 9,405 Company-operated stores and 8,661 licensed stores. It has four segments: Americas; Europe, Middle East and Africa (EMEA); China/Asia Pacific (CAP), and Channel Development. In addition to its flagship Starbucks brand, the Company's portfolio also includes Tazo Tea, Seattle's Best Coffee, Starbucks VIA Ready Brew, Starbucks Refreshers beverages and the Verismo System by Starbucks. In February 2013, Tata Coffee Ltd and the Company inaugurated a roasting and packaging plant in Karnataka."},{"Symbol":"STT","Name":"State Street Corp.","Sector":"Financials","Description":"State Street Corporation (State Street) is a financial holding company. Through its subsidiaries, including its principal banking subsidiary, State Street Bank and Trust Company (State Street Bank), the Company provides a range of financial products and services to institutional investors worldwide. The Company has two lines of business: Investment Servicing and Investment Management. At December 31, 2011, it had consolidated total deposits of $157.29 billion. Its clients include mutual funds, collective investment funds and other investment pools, corporate and public retirement plans, insurance companies, foundations, endowments and investment managers. State Street operates in 29 countries and in more than 100 geographic markets worldwide. On November 3, 2011, the Company acquired Pulse Trading, Inc. On October 3, 2011, the Company acquired Complementa Investment-Controlling AG. On January 10, 2011, it acquired Bank of Ireland's asset management business (BIAM)."},{"Symbol":"SRCL","Name":"Stericycle Inc","Sector":"Industrials","Description":"Stericycle, Inc., is in the business of managing regulated waste and providing an array of related and complementary services. The Company operates in the United States, Argentina, Brazil, Canada, Chile, Ireland, Japan, Mexico, Portugal, Romania, Spain, and the United Kingdom. The regulated waste services the Company provides include medical waste disposal, its Steri-Safe medical waste and compliance program, its Clinical Services program, its Bio Systems reusable sharps disposal management services, pharmaceutical waste disposal, and hazardous waste disposal. In addition to the Company's regulated waste services, the Company offers regulated recall and returns management services, patient communication services, and medical safety products. In August 2013, Stericycle Inc acquired Eclipse Marketing."},{"Symbol":"SYK","Name":"Stryker Corp.","Sector":"Health Care","Description":"Stryker Corporation (Stryker) is a medical technology company. Stryker offers a diverse array of medical technologies, including reconstructive, medical and surgical, and neurotechnology and spine products. The Company operates in three business segments: Reconstructive, MedSurg, and Neurotechnology and Spine. Its products include implants used in joint replacement, trauma, and spinal surgeries; surgical equipment and surgical navigation systems; endoscopic and communications systems; patient handling and emergency medical equipment, as well as other medical device products used in a variety of medical specialties. Internationally, its products are sold in over 100 countries through Company-owned sales subsidiaries and branches, as well as third-party dealers and distributors. In 2012, the Company completed the acquisition of Surpass Medical, Ltd. (Surpass). Effective March 1, 2013, Stryker Corp acquired the share capital of Trauson Holdings Co Ltd."},{"Symbol":"STI","Name":"SunTrust Banks","Sector":"Financials","Description":"SunTrust Banks, Inc. (SunTrust) is a commercial banking organization. The Company is a diversified financial services holding company whose businesses provide a range of financial services to consumer and corporate clients. The Company operates in three segments: Consumer Banking and Private Wealth Management, Wholesale Banking, and Mortgage Banking. Through its principal subsidiary, SunTrust Bank, the Company offers a full line of financial services for consumers and businesses including deposit, credit, and trust and investment services. Additional subsidiaries provide mortgage banking, asset management, securities brokerage, and capital market services. SunTrust operates primarily within Florida, Georgia, Maryland, North Carolina, South Carolina, Tennessee, Virginia, and the District of Columbia. SunTrust provides clients with a selection of branch-based and technology-based banking channels, including the Internet, automatic teller machine (ATMs), and twenty-four hour telebanking."},{"Symbol":"SYMC","Name":"Symantec Corp.","Sector":"Information Technology","Description":"Symantec Corporation is a security, backup and availability solutions. The Company's products and services protect people and information in any digital environment from the smallest mobile device, to the enterprise data center, to cloud-based systems. The Company's software and services protect against advanced threats independent of the device and environment in which information is used or stored. The Company operated in five segments: Consumer, Security and Compliance, Storage and Server Management, Services, and Other. The Company's segment provides identity protection and digital consumer data, such as photos, music, and videos. The Security and Compliance solutions help businesses protect their information and systems. The Company delivers consulting, education and dedicated support services."},{"Symbol":"SYF","Name":"Synchrony Financial","Sector":"Financials","Description":"Synchrony Financial operates as a consumer financial services company in the United States. The company offers private label credit cards, dual cards, and small and medium-sized business credit products; and promotional financing for consumer purchases, such as private label credit cards and installment loans. It also provides promotional financing to consumers for elective healthcare procedures or services, such as dental, veterinary, cosmetic, vision, and audiology; debt cancellation products; and deposit products, including certificates of deposit, individual retirement accounts, money market accounts, and savings accounts under the Optimizer+Plus brand. The company offers its credit products through programs established with a group of national and regional retailers, local merchants, manufacturers, buying groups, industry associations, and healthcare service providers; and deposit products through multiple channels, including online, print, and radio advertising. Synchrony Financial was incorporated in 2003 and is headquartered in Stamford, Connecticut. Synchrony Financial operates as a subsidiary of GE Consumer Finance, Inc."},{"Symbol":"SYY","Name":"Sysco Corp.","Sector":"Consumer Staples","Description":"Sysco Corporation (Sysco), along with its subsidiaries and divisions, is a North American distributor of food and related products primarily to the foodservice or food-away-from-home industry. The Company provides products and related services to approximately 425,000 customers, including restaurants, healthcare and educational facilities, lodging establishments and other foodservice customers. Sysco provides food and related products to the foodservice or food-away-from-home industry. The Company has aggregated its operating companies into a number of segments, of which only Broadline and SYGMA are the main segments. Broadline operating companies distribute a line of food products and a variety of non-food products to their customers. SYGMA operating companies distribute a line of food products and a variety of non-food products to chain restaurant customer locations. On October 3, 2012, the Company acquired Keelings Foods."},{"Symbol":"TROW","Name":"T. Rowe Price Group","Sector":"Financials","Description":"T. Rowe Price Group, Inc. is a financial services holding company, which provides global investment management services through its subsidiaries to individual and institutional investors in the sponsored T. Rowe Price mutual funds and other investment portfolios, including separately managed accounts, sub-advised funds, and other sponsored investment funds offered to investors outside the United States and through variable annuity life insurance plans in the United States. The Company derives revenue from investment advisory services provided by its subsidiaries, such as T. Rowe Price Associates, Inc. and T. Rowe Price International Ltd. Its revenues depend on the total value and composition of assets under its management. Its assets under management are accumulated from a client base across four distribution channels. Effective August 20, 2013, T Rowe Price Group Inc acquired an undisclosed interest in GrubHub Inc, a provider of online food delivery services."},{"Symbol":"TGT","Name":"Target Corp.","Sector":"Consumer Discretionary","Description":"Target Corporation sells a range of assortment of general merchandise and food in its stores. The Company's general merchandise and CityTarget stores offer a food assortment on a smaller scale and its SuperTarget stores offer a line of food items comparable to traditional supermarkets. The Company operates in three segments: U.S. Retail, U.S. Credit Card and Canadian. The Company's U.S. Retail Segment includes all of its United States merchandising operations. The Company's U.S. Credit Card Segment offers credit to qualified guests through its credit cards: the Target Credit Card and the Target Visa. Its Canadian Segment includes costs incurred in the United States and Canada related to its Canadian retail market entry. As of February 2, 2013, the Company had 1,778 stores in 49 states and the District of Columbia. It also owns three distribution centers in Canada, with a total of 3,963 thousand square feet."},{"Symbol":"TEL","Name":"TE Connectivity Ltd.","Sector":"Information Technology","Description":"TE Connectivity Ltd., together with its subsidiaries, designs and manufactures connectivity and sensors solutions. It operates through four segments: Transportation Solutions, Industrial Solutions, Network Solutions, and Consumer Solutions. The Transportation Solutions segment offers electronic components, including terminals and connectors, relays, and sensors, as well as application tooling, wire and heat shrink tubing, and other custom-engineered solutions for the automotive market, such as industrial and commercial vehicle, and hybrid and electric vehicle markets. The Industrial Solutions segment supplies products that connect and distribute power and data, which consists of connectors, heat shrink tubing, relays, and wire and cable, as well as custom-engineered solutions used primarily in the industrial equipment; aerospace, defense, marine, oil, and gas; and energy markets. The Network Solutions segment supplies infrastructure components and systems for the telecommunications market and electronic components for the data communications market. This segments products include connectors, fiber optics, wire and cable, racks and panels, and wireless products. It also develops, manufactures, installs, and maintains subsea fiber optic communications systems. The Consumer Solutions segment supplies electronic components, including connectors, circuit protection devices, relays, antennas, and heat shrink tubing for the consumer devices and appliances markets. TE Connectivity Ltd. sells its products in approximately 150 countries primarily through direct sales to manufacturers, as well as indirectly via third-party distributors. The company was formerly known as Tyco Electronics Ltd. and changed its name to TE Connectivity Ltd. in March 2011. TE Connectivity Ltd. is based in Schaffhausen, Switzerland."},{"Symbol":"TGNA","Name":"Tegna, Inc.","Sector":"Consumer Discretionary","Description":"TEGNA Inc. engages in media and digital businesses in the United States. The company operates 46 television stations that produce local programming, such as news, sports, and entertainment; and affiliated online sites. It also operates Cars.com that provides information about car shopping, selling, and servicing; CareerBuilder, which provides human capital solutions, such as labor market intelligence, talent management software, and other recruitment solutions; and G/O Digital that acts as a one-stop shop for local businesses looking to connect with consumers through digital marketing. In addition, the company offers advertising and marketing solutions comprising digital and print options; and news, information, and marketing solutions in the military, defense, federal technology, and C4ISR markets. As of June 29, 2015, it served 90 million customers. The company was formerly known as Gannett Co., Inc. and changed its name to TEGNA Inc. in June 2015. TEGNA Inc. was founded in 1906 and is headquartered in McLean, Virginia."},{"Symbol":"TDC","Name":"Teradata Corp.","Sector":"Information Technology","Description":"Teradata Corporation (Teradata) is engaged in analytic data solutions, including integrated data warehousing, big data analytics and business applications. The Company's data data warehousing solutions are consisted of software, hardware, and related business consulting and support services. Its solutions integrate an organization's departmental and enterprise-wide data about customers, financials and operations into a single integrated data warehouse. Its analytic technologies then transform that data into actionable information. The Company serves customers across a range of industries globally ranging from small departmental and corporate implementations to data warehouses and marketing applications. Teradata operates from four main locations in the United States: Dayton, Ohio; Johns Creek (Atlanta), Georgia; Rancho Bernardo (San Diego), California; and Indianapolis, Indiana. In June 2012, the Company acquired eCircle."},{"Symbol":"TSO","Name":"Tesoro Petroleum Co.","Sector":"Energy","Description":"Tesoro Corporation (Tesoro), is an independent petroleum refiners and marketers in the United States. The Company's subsidiaries, operating through two business segments: manufacture and sell transportation fuels. Its refining operating segment (refining), which operates seven refineries in the western United States, refines crude oil and other feedstocks into transportation fuels, such as gasoline, gasoline blendstocks, jet fuel and diesel fuel, as well as other products, including heavy fuel oils, liquefied petroleum gas, petroleum coke and asphalt. Its retail operating segment (retail) sells transportation fuels and convenience products In September 2013, the Company announced that it has completed the sale of all of its interests in Tesoro Hawaii, LLC to Hawaii Pacific Energy, LLC. In December 2013, Tesoro Corp closed the acquisition of the majority of the remaining Los Angeles logistics assets."},{"Symbol":"TXN","Name":"Texas Instruments","Sector":"Information Technology","Description":"Texas Instruments Inc. (TI) designs and makes semiconductors that the Company sells to electronics designers and manufacturers all over the world. The Company has four segments: Analog, Embedded Processing, Wireless and Other. The Company's products, more than 100,000 orderable parts, are integrated circuits that are used to accomplish many different things, such as converting and amplifying signals, interfacing with other devices, managing and distributing power, processing data, canceling noise and improving signal resolution. The Company sells catalog and, to a lesser extent, custom semiconductor products. The life cycles of catalog products generally span multiple years, with some products continuing to sell for decades after their initial release. The life cycles of custom products are generally determined by end-equipment upgrade cycles and can be as short as 12 to 24 months. In December 2013, TI acquired a building in the Chengdu Hi-Tech Zone from UTAC Chengdu Ltd."},{"Symbol":"TXT","Name":"Textron Inc.","Sector":"Industrials","Description":"Textron Inc. is a multi-industry company engaged in aircraft, defense, industrial and finance businesses to provide customers with products and services worldwide. It operates in five segments: Cessna, Bell, Textron Systems and Industrial, which represent its manufacturing businesses, and Finance, which represents its finance business. Cessna is a general aviation company with two principal lines of business: Aircraft sales and aftermarket services. Bell Helicopter is a supplier of military and commercial helicopters, tiltrotor aircraft, and related spare parts and services in the world. Textron Systems is a supplier to the defense, aerospace, homeland security and general aviation markets. Industrial segment designs and manufactures a range of products under three principal product lines. The Company's Finance segment, or the Finance group, is a commercial finance business that consists of Textron Financial Corporation (TFC) and its consolidated subsidiaries."},{"Symbol":"BK","Name":"The Bank of New York Mellon Corp.","Sector":"Financials","Description":"The Bank of New York Mellon Corporation provides various financial products and services in the United States and internationally. Its Investment Management segment provides institutional, intermediary, retirement and retail investment management, distribution, and related services. This segment offers various equity, fixed income, cash, and alternative/overlay products; and investment management, wealth and estate planning, and private banking solutions to high-net-worth individuals and families, family offices, charitable gift programs, endowments, and foundations. The companys Investment Services segment provides custody and related services, broker-dealer services, collateral services, corporate trust and depositary receipt, and clearing services, as well as payment/working capital solutions to financial institutional clients. This segments financial solutions include custody, fund services, securities lending, investment manager outsourcing, performance and risk analytics, alternative investment services, securities clearance, collateral management, corporate trust, depositary receipt programs, cash management solutions, payment services, liquidity services and other linked revenues, foreign exchange, clearing and execution, managed account services, and prime brokerage solutions. This segment serves corporations, public funds and government agencies, foundations, and endowments; financial institutions, including banks, broker-dealers, asset managers, insurance companies, and central banks; financial intermediaries and independent registered investment advisors; and hedge fund managers. The company is also involved in credit-related activities, business exits, leasing operations, and corporate treasury activities; and the provision of global markets and institutional banking services. The Bank of New York Mellon Corporation was founded in 1784 and is headquartered in New York, New York."},{"Symbol":"CLX","Name":"The Clorox Company","Sector":"Consumer Staples","Description":"The Clorox Company (Clorox) is a manufacturer and marketer of consumer and professional products. Clorox operates in four segments: Cleaning, Household, Lifestyle and International. Clorox sells its products primarily through merchandisers, grocery stores, other retail outlets, distributors and medical supply providers. Clorox markets some of the brand names, including its namesake bleach and cleaning products, Clorox Healthcare, HealthLink, Aplicare and Dispatch products, Green Works naturally derived home care products, Pine-Sol cleaners, Poett home care products, Fresh Step cat litter, Glad bags, wraps and containers, Kingsford charcoal, Hidden Valley and K C Masterpiece dressings and sauces, Brita water-filtration products, and Burt's Bees and gud natural personal care products. During the fiscal year ended June 30, 2012 (fiscal 2012), Clorox acquired HealthLink, Aplicare, Inc., and Soy Vay Enterprises, Inc."},{"Symbol":"COO","Name":"The Cooper Companies","Sector":"Health Care","Description":"The Cooper Companies, Inc. (Cooper) is a global medical products company that serves the specialty healthcare market through its two business units, CooperVision, Inc. (CVI) and CooperSurgical, Inc. (CSI). CVI develops, manufactures and markets a range of contact lenses for the global vision correction market. CVI specializes in lenses for astigmatism, presbyopia and ocular dryness. CVI is a manufacturer of toric lenses, which correct astigmatism, multifocal lenses for presbyopia (blurring near vision due to advancing age) and spherical lenses that correct the common visual defects. CVI's products are manufactured at its facilities located in the United Kingdom, Puerto Rico and New York. Effective October 31, 2013, the Company completed the sale of Aime, its rigid gas permeable contact lens and solutions business in Japan, to Nippon Contact Lens Inc."},{"Symbol":"HSY","Name":"The Hershey Company","Sector":"Consumer Staples","Description":"The Hershey Company is a producer of chocolate in North America and a provider in chocolate and sugar confectionery. The Company's principal product groups include chocolate and sugar confectionery products; pantry items, such as baking ingredients, toppings and beverages, and gum and mint refreshment products. It manufactures, markets, sells and distributes its products under more than 80 brand names. The Company markets its products in approximately 70 countries worldwide. The Company operates in United States, the Americas, and Asia, Europe, the Middle East and Africa (AEMEA). The Company's key regions include the United States; the Americas, including Canada, Mexico, Brazil, Central America, Puerto Rico and global exports and AEMEA, including Asia, Europe, the Middle East, Africa and exports to these geographical areas In January 2012, the Company acquired Brookside Foods Ltd. (Brookside)."},{"Symbol":"MOS","Name":"The Mosaic Company","Sector":"Materials","Description":"The Mosaic Company (Mosaic) is a producer and marketer of combined concentrated phosphate and potash crop nutrients. It is a single source supplier of phosphate-and potash-based crops nutrients and animal feed ingredients. It operates in two segments: Phosphates and Potash. Its Phosphates segment owns and operates mines and production facilities in Florida. Its Potash segment owns and operates potash mines and production facilities in Canada and the United States, which produce potash-based crop nutrients, animal feed ingredients and industrial products. The Company mines phosphate rock in Florida and processes rock into finished phosphate products at facilities in Florida and Louisiana. It mines potash in Saskatchewan, New Mexico and Michigan. The Company has other production, blending or distribution operations in Brazil, China, India, Argentina, and Chile, and an equity investment in a new phosphate rock mine in the Bayovar region in Peru."},{"Symbol":"TRV","Name":"The Travelers Companies Inc.","Sector":"Financials","Description":"The Travelers Companies, Inc. (TRV) is a holding company. The Company, through its subsidiaries, is engaged in providing a range of commercial and personal property and casualty insurance products and services to businesses, Government units, associations and individuals. The Company is organized into three business segments: Business Insurance; Financial, Professional and International Insurance, and Personal Insurance. The Business Insurance segment offers an array of property and casualty insurance and insurance-related services to its clients primarily in the United States. The Financial, Professional and International Insurance segment includes surety and financial liability coverage's, which primarily use credit-based underwriting processes, as well as property and casualty products that are marketed on a domestic basis. In November 2013, the Company completed the sale of its wholly owned subsidiary The Dominion of Canada General Insurance Company to The Travelers Companies, Inc."},{"Symbol":"DIS","Name":"The Walt Disney Company","Sector":"Consumer Discretionary","Description":"The Walt Disney Company, together with its subsidiaries, is a diversified worldwide entertainment company. The Company operates in five business segments: Media Networks, Parks and Resorts, Studio Entertainment, Consumer Products and Interactive. The Company has a 51% effective ownership interest in Disneyland Paris, a 5,510-acre development located in Marne-la-Vallee, approximately 20 miles east of Paris, France. The Company manages and has a 40% equity interest in Euro Disney S.C.A. The Company owns a 48% interest in Hong Kong Disneyland Resort through Hongkong International Theme Parks Limited. On November 7, 2012, the Company sold its 50% equity interest in ESPN STAR Sports (ESS). On December 21, 2012, the Company acquired Lucasfilm Ltd. LLC."},{"Symbol":"TMO","Name":"Thermo Fisher Scientific","Sector":"Health Care","Description":"Thermo Fisher Scientific Inc. (Thermo Fisher) is engaged in serving science. It operates in three segments: Analytical Technologies, Specialty Diagnostics and Laboratory Products and Services. It serves its customers through three brands: Thermo Scientific, Fisher Scientific and Unity Lab Services. Thermo Scientific is its technology brand. Fisher Scientific is its channels brand. Its Unity Lab Services offers portfolio of enterprise services for instruments and laboratory equipment. Unity Lab Services offers a network of service and support personnel. In April 2012, it opened a new demonstration laboratory and training center in Seoul, South Korea. In May 2012, it acquired Doe & Ingalls Management, LLC. In September 2012, it acquired One Lambda, Inc. In September 2012, Thermo Fisher opened its Molecular Biology Center of Excellence in Vilnius, Lithuania. In October 2012, OpenGate Capital, LLC acquired the Laboratory (Lab) Workstations business from Thermo Fisher."},{"Symbol":"TIF","Name":"Tiffany & Co.","Sector":"Consumer Discretionary","Description":"Tiffany & Co. (Tiffany) is a holding company that operates through its subsidiary companies. The Company operates in five segments: Americas, Asia-Pacific, Japan, Europe and other. The Company's principal product category is jewelry, which represented 90% of worldwide net sales during the fiscal year ended January 31, 2013 (fiscal 2012). The Company offers a selection of TIFFANY & CO. brand jewelry. The Company also sells timepieces, leather goods, sterling silver goods (other than jewelry), china, crystal, stationery, fragrances and accessories, which represented, in total, 8% of worldwide net sales in 2012. The Company operates e-commerce enabled Websites in 13 countries. The Company produces jewelry in New York, Rhode Island and Kentucky, and silver hollowware in New Jersey."},{"Symbol":"TWX","Name":"Time Warner Inc.","Sector":"Consumer Discretionary","Description":"Time Warner Inc. (Time Warner) is a media and entertainment company. The Company operates in three reporting segments: Networks, Film and TV Entertainment and Publishing. Networks consist of television networks and premium pay and basic tier television services and digital media properties. Film and TV Entertainment consists of feature film, television, home video and videogame production and distribution. Publishing consists of magazine publishing. In August 2012, Turner Broadcasting System, Inc. acquired Bleacher Report."},{"Symbol":"TJX","Name":"TJX Companies Inc.","Sector":"Consumer Discretionary","Description":"The TJX Companies, Inc. (TJX) is the off-price apparel and home fashions retailer in the United States and worldwide. As of January 28, 2012, the Company operated in four business segments. It has two segments in the United States, Marmaxx (T.J. Maxx and Marshalls) and HomeGoods; one in Canada, TJX Canada (Winners, Marshalls and HomeSense) and one in Europe, TJX Europe (T.K. Maxx and HomeSense). As a result of the consolidation of the A.J. Wright chain, all A.J. Wright stores ceased operations by the end of February 2011. It completed the consolidation of A.J. Wright, converting 90 of the A.J. Wright stores to T.J. Maxx, Marshalls or HomeGoods banners and closed the remaining 72 stores, two distribution centers and home office. In December 2012, the Company acquired Sierra Trading Post, an off-price Internet retailer."},{"Symbol":"TMK","Name":"Torchmark Corp.","Sector":"Financials","Description":"Torchmark Corporation is an insurance holding company. The Company is financial services holding company whose affiliate Companies market life insurance and supplemental health insurance to middle-income Americans. The Company operates in life insurance, health insurance, and annuities segment. The Company's primary subsidiaries are American Income Life Insurance Company (American Income), Liberty National Life Insurance Company (Liberty), Globe Life And Accident Insurance Company (Globe), United American Insurance Company (United American), and Family Heritage Life Insurance Company of America (Family Heritage)."},{"Symbol":"TSS","Name":"Total System Services","Sector":"Information Technology","Description":"Total System Services, Inc. (TSYS), is a global payment solutions provider that provides services to financial and nonfinancial institutions. The Company operates in three segments: North America Services, International Services and Merchant Services. Through the Company's North America Services and International Services segments, TSYS processes information through its cardholder systems to financial institutions throughout the United States and internationally. Its North America Services segment provides these services to clients in the United States, Canada, Mexico and the Caribbean. The Company's International Services segment provides services to clients in Europe, India, Middle East, Africa, Asia Pacific and Brazil. In July 2013, Total System Services Inc completed its acquisition of NetSpend."},{"Symbol":"TSCO","Name":"Tractor Supply Company","Sector":"Consumer Discretionary","Description":"Tractor Supply Company is an operator of retail farm and ranch stores in the United States. The Company operates retail stores under the names Tractor Supply Company and Del's Farm Supply and operate a Website under the name TractorSupply.com. The Company's stores are located in towns outlying metropolitan markets and in rural communities, and offer a selection of merchandise, which include equine, pet and small animal products, including items necessary for their health, care, growth and containment; hardware, truck, towing and tool products; seasonal products, including lawn and garden items, power equipment, gifts and toys; maintenance products for agricultural and rural use, and work/recreational clothing and footwear. The Company operates at farm and ranch retail sales segment, both at its retail locations and online."},{"Symbol":"TDG","Name":"TransDigm Group","Sector":"Industrials","Description":"TransDigm Group Incorporated (TD Group), is a global designer, producer and supplier of aircraft components for use on commercial and military aircraft in service. Once its parts are designed into and sold on a new aircraft, it generates sales from aftermarket consumption over the life of that aircraft. On December 6, 2010, the Company's wholly owned subsidiary, TransDigm Inc., completed the acquisition of McKechnie Aerospace Holdings Inc. On December 31, 2010, the Company acquired the actuation business of Telair International, Inc. On March 9, 2011, the Company divested its fastener business. On April 7, 2011, the Company completed the divestiture of Aero Quality Sales (AQS) to Satair A/S. On August 31, 2011, the Company acquired Schneller Holdings LLC. In July 2013, TransDigm Group Inc acquired the assets of GE Aviation's Electromechanical Actuation Division."},{"Symbol":"RIG","Name":"Transocean","Sector":"Energy","Description":"Transocean Ltd. (Transocean) is an international provider of offshore contract drilling services for oil and gas wells. The Company operates in two segments: contract drilling services and drilling management services. Contract drilling services, the Company's primary business, involves contracting its mobile offshore drilling fleet, related equipment and work crews primarily on a dayrate basis to drill oil and gas wells. Its drilling management services segment provides oil and gas drilling management services on either a dayrate basis or a completed-project, fixed-price (or turnkey) basis, as well as drilling engineering and drilling project management services. As of February 14, 2012, it owned or had partial ownership interests in and operated 134 mobile offshore drilling units. On October 4, 2011, the Company acquired Aker Drilling ASA (Aker Drilling). In February 2011, it sold the subsidiary that owns the High-Specification Jackup Trident 20."},{"Symbol":"TRIP","Name":"TripAdvisor","Sector":"Consumer Discretionary","Description":"TripAdvisor, Inc. (TripAdvisor) is an online travel research company, enabling users to plan and have a trip. TripAdvisor features reviews and advice on hotels, resorts, flights, vacation rentals, vacation packages and travel guides. TripAdvisor's travel research platform features reviews and opinions from its community of travelers about destinations, accommodations, restaurants and activities worldwide, through its TripAdvisor brand. TripAdvisor Websites include tripadvisor.com in the United States and versions of the Website in 30 countries, including in China under the brand daodao.com. TripAdvisor Websites also include links to the Websites of its travel advertisers allowing travelers to directly book their travel arrangements. In May 2013, TripAdvisor Inc acquired key technology and talent from CruiseWise Inc. In May 2013, TripAdvisor Inc acquired Guia de Apartamentos Niumba SL. In June 2013, the Company announced that it has acquired GateGuru."},{"Symbol":"FOXA","Name":"Twenty-First Century Fox Class A","Sector":"Consumer Discretionary","Description":"Twenty-First Century Fox, Inc., formerly News Corporation, has a portfolio of cable, broadcast, film, pay television and satellite assets spanning six continents across the globe. The Company is home to a global portfolio of cable and broadcasting networks and properties, including FOX, FX, FXX, FS1, Fox News Channel, Fox Business Network, Fox Sports, Fox Sports Network, National Geographic Channels, Fox Pan American Sports, MundoFox, STAR and 28 local television stations; film studio Twentieth Century Fox Film; and television production studios Twentieth Century Fox Television and Shine Group. The Company also provides content to millions of subscribers through its pay-television services in Europe and Asia, including Sky Deutschland, Sky Italia and its equity interests in BSkyB and Tata Sky"},{"Symbol":"FOX","Name":"Twenty-First Century Fox Class B","Sector":"Consumer Discretionary","Description":"Twenty-First Century Fox, Inc., formerly News Corporation, has a portfolio of cable, broadcast, film, pay television and satellite assets spanning six continents across the globe. The Company is home to a global portfolio of cable and broadcasting networks and properties, including FOX, FX, FXX, FS1, Fox News Channel, Fox Business Network, Fox Sports, Fox Sports Network, National Geographic Channels, Fox Pan American Sports, MundoFox, STAR and 28 local television stations; film studio Twentieth Century Fox Film; and television production studios Twentieth Century Fox Television and Shine Group. The Company also provides content to millions of subscribers through its pay-television services in Europe and Asia, including Sky Deutschland, Sky Italia and its equity interests in BSkyB and Tata Sky"},{"Symbol":"TSN","Name":"Tyson Foods","Sector":"Consumer Staples","Description":"Tyson Foods, Inc. is a food production company. The Company produces, distributes and markets chicken, beef, pork, prepared foods and related allied products. The Company's operates in four segments: Chicken, Beef, Pork and Prepared Foods. The Company operates an integrated poultry production process. The Company's integrated operations consist of breeding stock, contract growers, feed production, processing, further-processing, marketing and transportation of chicken and related allied products, including animal and pet food ingredients. Through Cobb-Vantress, Inc. (Cobb), the Company supplies poultry breeding stock. The Company also processes live fed cattle and hogs and fabricate dressed beef and pork carcasses into primal and sub-primal meat cuts, case ready beef and pork and fully-cooked meats. In June 2013, Tyson Foods, Inc. announced the acquisition of assets of Circle Foods, LLC."},{"Symbol":"USB","Name":"U.S. Bancorp","Sector":"Financials","Description":"U.S. Bancorp (U.S. Bancorp) is a multi-state financial services holding company. It provides a range of financial services, including lending and depository services, cash management, foreign exchange and trust and investment management services. It also engages in credit card services, merchant and automated teller machine (ATM) processing, mortgage banking, insurance, brokerage and leasing. The Company operates in five segments: Wholesale Banking and Commercial Real Estate, Consumer and Small Business Banking, Wealth Management and Securities Services, Payment Services and Treasury and Corporate Support.In January 2012, the Company's bank, U.S. Bank National Association, acquired the banking operations of BankEast. In February 2013, Elavon, global payments provider and wholly owned subsidiary of the Company acquired Collective Point of Sale Solutions Ltd."},{"Symbol":"UDR","Name":"UDR Inc","Sector":"Real Estate","Description":"UDR, Inc. (UDR) is a self administered real estate investment trust (REIT), which owns, operates, acquires, renovates, develops, redevelops, and manages multifamily apartment communities located throughout the United States. UDR holds interests in other operating partnerships, subsidiaries and joint ventures, owns and operates properties, issues securities from time to time and guarantees debt of certain of its subsidiaries. As of December 31, 2012, UDR owned approximately 94.9% of the limited partnership interests of the Operating Partnership (the OP Units). During the year ended December 31, 2012, the Company acquired the remaining 80% ownership interests in two apartment communities (633 homes) in Austin, Texas. As of December 31, 2012, the Company is developing eight wholly owned communities with 2,622 apartment homes, 76 of which have been completed."},{"Symbol":"ULTA","Name":"Ulta Salon Cosmetics & Fragrance Inc","Sector":"Consumer Discretionary","Description":"Ulta Salon, Cosmetics & Fragrance, Inc. (Ulta) is a beauty retailer, which provides one-stop shopping for prestige, mass and salon products and salon services in the United States. During the year ended January 28, 2012 (fiscal 2011), the Company opened 61 new stores. It operates full-service salons in all of its stores. Its Ulta store format includes an open and modern salon area with approximately eight to 10 stations. The entire salon area is approximately 950 square feet with a concierge desk, skin treatment room, semi-private shampoo and hair color processing areas. Each salon is a full-service salon offering hair cuts, hair coloring and permanent texture, with salons also providing facials and waxing."},{"Symbol":"UA","Name":"Under Armour","Sector":"Consumer Discretionary","Description":"Under Armour, Inc. (Under Armour) is engaged in the development, marketing and distribution of apparel, footwear and accessories for men, women and youth. The Company's products are sold worldwide and are worn by athletes at all levels, from youth to professional, on playing fields worldwide. Most of its products are sold in North America. Internationally, Under Armour sells its products in certain countries in Europe, a third party licensee sells its products in Japan, and distributors sell the Company's products in other foreign countries. In addition, it opened it store in China during the year ended December 31, 2012. The Company's product offerings consist of apparel, footwear and accessories for men, women and youth. In November 2013, the Company acquired MapMyFitness."},{"Symbol":"UAA","Name":"Under Armour","Sector":"Consumer Discretionary","Description":""},{"Symbol":"UNP","Name":"Union Pacific","Sector":"Industrials","Description":"Union Pacific Corporation (UPC) owns transportation companies. Its principal operating company, Union Pacific Railroad Company, links 23 states in the western 66% of the country. Union Pacific Railroad Company's business mix includes agricultural products, automotive, chemicals, energy, industrial products and intermodal. Union Pacific Railroad Company connects with Canada's rail systems and is the railroad serving six gateways to Mexico. Union Pacific Railroad Company (UPRR) is a Class I railroad operating in the United States. In June 2012, the Company's wholly owned subsidiary, PS Technology (PST), acquired the Yard Control Systems division of Ansaldo STS USA."},{"Symbol":"UAL","Name":"United Continental Holdings","Sector":"Industrials","Description":"United Continental Holdings, Inc., together with its subsidiaries, provides air transportation services in North America, the Asia-Pacific, Europe, the Middle East, Africa, and Latin America. It transports people and cargo through its mainline operations, which use jet aircraft with at least 118 seats, and its regional operations. As of December 31, 2014, the company operated a fleet of 1,257 aircraft. It also sells fuel; and provides maintenance, ground handling, and catering services for third parties. The company was formerly known as UAL Corporation and changed its name to United Continental Holdings, Inc. in October 2010. United Continental Holdings, Inc. was founded in 1934 and is headquartered in Chicago, Illinois."},{"Symbol":"UNH","Name":"United Health Group Inc.","Sector":"Health Care","Description":"UnitedHealth Group Incorporated (UnitedHealth Group) diversified health and well-being company. The Company operates in four segments: UnitedHealthcare, which includes UnitedHealthcare Employer & Individual, UnitedHealthcare Medicare & Retirement and UnitedHealthcare Community & State; UnitedHealthcare Community & State; OptumHealth; OptumInsight, and OptumRx. The Company operates these businesses across eight markets: integrated care delivery, care management, consumer engagement and support, distribution of benefits and services, health financial services, operational services and support, health care information technology and pharmacy."},{"Symbol":"UPS","Name":"United Parcel Service","Sector":"Industrials","Description":"United Parcel Service, Inc. (UPS) is a package delivery company. The Company delivers packages each business day for 1.1 million shipping customers to 7.7 million consignees in over 220 countries and territories. During the year ended December 31, 2012, it delivered an average of 16.3 million pieces per day worldwide, or a total of 4.1 billion packages. It serves the global market for logistics services, which include transportation, distribution, forwarding, ground, ocean and air freight, brokerage and financing. The Company has three segments: U.S. Domestic Package, International Package and Supply Chain & Freight. In February 2012, it acquired Kiala S.A."},{"Symbol":"URI","Name":"United Rentals, Inc.","Sector":"Industrials","Description":"United Rentals, Inc. is a holding company. The Company primarily conducts its operations through its wholly owned subsidiary, United Rentals (North America), Inc., and its subsidiaries. The Company is an equipment rental company and its network consists of 836 rental locations in the United States and Canada. The Company operates in two segments: general rentals and trench safety, power and HVAC. The general rentals segment includes the rental of construction, aerial and industrial equipment, general tools and light equipment, and related services and activities. The trench safety, power and HVAC segment includes the rental of specialty construction products and related services. The trench safety, power and HVAC segment's customers include construction companies involved in infrastructure projects, municipalities and industrial companies. This segment operates throughout the United States and in Canada. On April 30, 2012, the Company acquired RSC Holdings Inc."},{"Symbol":"UTX","Name":"United Technologies","Sector":"Industrials","Description":"United Technologies Corporation (UTC) provides high technology products and services to the building systems and aerospace industries worldwide. The Company operates in six segments: Otis, Carrier, UTC Fire & Security, Pratt & Whitney, Hamilton Sundstrand and Sikorsky. Otis, Carrier and UTC Fire & Security serve customers in the commercial, government infrastructure and residential property sectors worldwide. Carrier also serves commercial, industrial, transport refrigeration and food service equipment customers. Pratt & Whitney, Hamilton Sundstrand and Sikorsky primarily serves commercial and government customers. In May 2013, the Company announced that it has completed the divestiture of its Pratt & Whitney Power Systems unit to Mitsubishi Heavy Industries Ltd (MHI). In June 2013, United Technologies Corp announced it has closed on the sale of substantially all operations of its Pratt & Whitney Rocketdyne unit to GenCorp."},{"Symbol":"UHS","Name":"Universal Health Services, Inc.","Sector":"Health Care","Description":"Universal Health Services, Inc., through its subsidiaries, owns and operates acute care hospitals, behavioral health centers, surgical hospitals, ambulatory surgery centers, and radiation oncology centers. The companys hospitals offer various services, including general and specialty surgery, internal medicine, obstetrics, emergency room care, radiology, oncology, diagnostic care, coronary care, pediatric services, pharmacy services, and/or behavioral health services. As of February 26, 2015, it owned and/or operated 24 acute care hospitals and 216 behavioral health centers located in 37 states, Washington, D.C.; the United Kingdom; Puerto Rico; and the U.S. Virgin Islands. Universal Health Services, Inc. was founded in 1978 and is headquartered in King of Prussia, Pennsylvania."},{"Symbol":"UNM","Name":"Unum Group","Sector":"Financials","Description":"Unum Group is a provider of disability insurance products in the United States and the United Kingdom. The Company also provides a portfolio of other insurance products, including employer- and employee-paid group benefits, life insurance, and other related services. The Company operates in five segments: Unum US, Unum UK, Colonial Life, Closed Block and Corporate. The principal operating subsidiaries in the United States are Unum Life Insurance Company of America (Unum America), Provident Life and Accident Insurance Company (Provident), The Paul Revere Life Insurance Company (Paul Revere Life), and Colonial Life & Accident Insurance Company, and in the United Kingdom, Unum Limited."},{"Symbol":"URBN","Name":"Urban Outfitters","Sector":"Consumer Discretionary","Description":"Urban Outfitters, Inc. (Urban Outfitters) is a lifestyle specialty retail company, which operates under the Urban Outfitters, Anthropologie, Free People, Terrain and BHLDN brands. The Company also operates a wholesale segment under the Free People brand. In addition to its retail stores, it offers its products and markets its brands directly to the consumer through its e-commerce Websites, www.urbanoutfitters.com, www.anthropologie.com,www.freepeople.com, www.urbanoutfitters.co.uk,www.urbanoutfitters.de, www.urbanoutfitters.fr, www.anthropologie.eu, www.shopterrain.com and www.bhldn.com and also through its Urban Outfitters, Anthropologie and Free People catalogs. Its Urban Outfitters stores, Websites and catalogs offer a range of eclectic merchandise, including women's and men's fashion apparel, footwear and accessories and an eclectic mix of apartment wares and gifts."},{"Symbol":"VFC","Name":"V.F. Corp.","Sector":"Consumer Discretionary","Description":"V.F. Corporation (VF) is a global apparel company based in the United States. The Company designs and manufactures or sources from independent contractors a variety of apparel and footwear for all ages, including jeanswear, outerwear, footwear, packs, luggage, sportswear, and occupational and performance apparel. Products are marketed primarily under VF-owned brand names. It is a diversified apparel company across brands, product categories, channels of distribution and geographies. These products are marketed to consumers shopping in specialty stores, upscale and traditional department stores, national chains and mass merchants. These groupings of businesses are called coalitions and consist of the following: Outdoor & Action Sports, Jeanswear, Imagewear, Sportswear and Contemporary Brands. On April 30, 2012, the Company sold its 80% ownership in John Varvatos Enterprises, Inc."},{"Symbol":"VLO","Name":"Valero Energy","Sector":"Energy","Description":"Valero Energy Corporation (Valero) is an independent petroleum refining and marketing company. Valero's refineries can produce conventional gasoline's, distillates, jet fuel, asphalt, petrochemicals, lubricants, and other refined products, as well as a slate of premium products, including conventional blendstock for oxygenate blending and reformulated gasoline blendstock for oxygenate blending, gasoline meeting the specifications of the California Air Resources Board, a diesel fuel, and low-sulfur and ultra-low-sulfur diesel fuel. It also owns 10 ethanol plants in the central plains region of the United States with a combined ethanol nameplate production capacity of about 1.1 billion gallons per year. It operates in three business segments: refining, ethanol, and retail. In May 2013, CST Brands Inc announced that the Company which includes Corner Store and Depanneur du Coin, spun off from Valero Energy Corporation."},{"Symbol":"VAR","Name":"Varian Medical Systems","Sector":"Health Care","Description":"Varian Medical Systems, Inc. is engaged in the design, manufacture, sale and service of equipment and software products for treating cancer with radiotherapy, stereotactic radiotherapy, stereotactic body radiotherapy (SBRT), stereotactic radiosurgery (SRS) and brachytherapy. The Company also designs, manufactures, sells and services x-ray tubes for original equipment manufacturers (OEMs); replacement x-ray tubes, and flat panel digital image detectors for filmless x-ray imaging (flat panel detectors or digital image detectors) in medical, dental, veterinary, scientific and industrial applications. It designs, manufactures, sells and services linear accelerators, digital image detectors, image processing software and image detection products for security and inspection purposes. In March 2011, it acquired a privately-held supplier of devices for delivery of brachytherapy treatment of cancer. In August 2012, the Company established a subsidiary, Varian Medical Systems Korea."},{"Symbol":"VTR","Name":"Ventas Inc","Sector":"Real Estate","Description":"Ventas, Inc. is a real estate investment trust (REIT) with a geographically diverse portfolio of seniors housing and healthcare properties throughout the United States and Canada. As of December 31, 2011, the Company operated through three business segments: triple-net leased properties, senior living operations and MOB operations. As of December 31, 2011, the Company owned 1,378 properties located in 46 states, the District of Columbia and two Canadian provinces, consisting of 678 seniors housing communities; 396 skilled nursing facilities; 47 hospitals; 249 medical office buildings (MOBs), and eight personal care facilities. The Company was in the process of developing three properties as of December 31, 2011. In July 2011, it acquired Nationwide Health Properties, Inc. (NHP). In June 2012, the Company sold 12 seniors housing communities to Assisted Living Concepts, Inc."},{"Symbol":"VRSN","Name":"Verisign Inc.","Sector":"Information Technology","Description":"VeriSign, Inc. (VeriSign) is a provider of Internet infrastructure services. The Company provides network confidence and availability for mission-critical Internet services, such as domain name registry services and infrastructure assurance services. Its service capabilities enable real-time name resolution for a number of global top level domains (TLDs), enable domain name registration through registrars, and provide security intelligence and cloud-based network availability services to enterprise customers. It has one reportable segment is Naming Services, which consists of Registry Services and Network Intelligence and Availability (NIA) Services. It has operations inside as well as outside the United States (U.S.). Registry Services operates the authoritative directory of all .com, .net, .cc, .tv, and .name domain names and the back-end systems for all .gov, .jobs and .edu domain names."},{"Symbol":"VRSK","Name":"Verisk Analytics","Sector":"Industrials","Description":"Verisk Analytics, Inc. (Verisk) is a provider of information about risk to professionals in insurance, healthcare, mortgage, government, supply chain, and risk management. Verisk enable risk-bearing businesses to understand and manage their risks. The Company provides its customers by supplying data that, combined with its analytic methods, creates embedded decision support solutions. Verisk organizes its business in two segments: Risk Assessment and Decision Analytics. Its Risk Assessment segment provides statistical, actuarial and underwriting data for the United States property and casualty (P&C) insurance industry. Its Decision Analytics segment provides solutions its customers use to analyze the processes of the Verisk Risk Analysis Framework: Prediction of Loss, Detection and Prevention of Fraud, and Quantification of Loss. On June 17, 2011, it acquired the net assets of Health Risk Partners, LLC. On April 27, 2011, it acquired 100% interest of Bloodhound Technologies, Inc."},{"Symbol":"VZ","Name":"Verizon Communications","Sector":"Telecommunications Services","Description":"Verizon Communications Inc. (Verizon) is a holding company. The Company is a provider of communications, information and entertainment products and services to consumers, businesses and governmental agencies. It operates in two primary segments: Verizon Wireless and Wireline. Verizon Wireless' communications products and services include wireless voice and data services and equipment sales, which are provided to consumer, business and government customers across the United States. Wireline's communications products and services include voice, Internet access, broadband video and data, Internet protocol network services, network access, long distance and other services. In November 2013, Verizon Communications Inc's Verizon Digital Media Services acquired upLynk, a technology and television cloud company."},{"Symbol":"VRTX","Name":"Vertex Pharmaceuticals Inc","Sector":"Health Care","Description":"Vertex Pharmaceuticals Incorporated (Vertex) is in the business of discovering, developing, manufacturing and commercializing small molecule drugs for the treatment of serious diseases. The Company's two products are INCIVEK (telaprevir), which is approved for the treatment of patients with genotype 1 hepatitis C virus (HCV), infection, and KALYDECO (ivacaftor), which is approved in the United States for the treatment of patients six years of age and older with cystic fibrosis (CF), who have at least one copy of the G551D mutation in the cystic fibrosis transmembrane conductance regulator (CFTR), gene. The Company has ongoing clinical programs involving drug candidates intended for the treatment of HCV infection, CF, rheumatoid arthritis, influenza and epilepsy. INCIVEK (telaprevir) achieved initial commercial acceptance following its approval in May 2011. It started marketing KALYDECO in the United States in January 2012."},{"Symbol":"VIAB","Name":"Viacom Inc.","Sector":"Consumer Discretionary","Description":"Viacom Inc. (Viacom) is an entertainment content company that connects with audiences through compelling content across television, motion picture, online and mobile platforms in over 160 countries and territories. The Company operates in two segments: Media Networks and Filmed Entertainment. The Company's Media Networks segment provides entertainment content and related branded products for consumers in targeted demographics attractive to advertisers, content distributors and retailers. The Company's Filmed Entertainment segment produces finances and distributes motion pictures and other entertainment content under the Paramount Pictures, Paramount Vantage, Paramount Classics, Insurge Pictures, MTV Films and Nickelodeon Movies brands. In September 2013, Telecom Italia Media SpA announced that the sale of the 51% stake of MTV Italia Srl to Viacom Inc. has been completed."},{"Symbol":"V","Name":"Visa Inc.","Sector":"Information Technology","Description":"Visa Inc. (Visa) is a global payments technology company that connects consumers, businesses, banks and governments in more than 200 countries and territories to fast, secure and reliable electronic payments. The Company operates processing networks, VisaNet, offering fraud protection for consumers and assured payment for merchants. The Company operates an open-loop payments network, a multi-party system in which Visa connects issuing financial institutions, or issuers, that issue cards to cardholders, and acquiring financial institutions, or acquirers, that have the banking relationship with merchants-and manage the exchange of information and value between them. The Company derives revenues primarily from fees paid by its clients based on payments volume, transactions that it processes and other related services the Company provides. Its clients deliver Visa products and payment services to consumers and merchants based on product platforms it defines and manages."},{"Symbol":"VNO","Name":"Vornado Realty Trust","Sector":"Real Estate","Description":"Vornado Realty Trust (Vornado) is an integrated real estate investment trust (REIT). Vornado conducts its business through, and substantially all of its interests in properties are held by, Vornado Realty L.P., a limited partnership (the Operating Partnership). As of December 31, 2011, the Company was the sole general partner of, and owned approximately 93.5% of the common limited partnership interest in the Operating Partnership. Vornado operates in five business segments: New York Office Properties, Washington, DC Office Properties, Retail Properties, Merchandise Mart Properties and Toys R Us (Toys). In April 2013, it completed the sale of The Plant, a power strip shopping center in San Jose, California. In April 2013, the Company announced that the sale of a site located in the Downtown Crossing district of Boston. In October 2013, the Company sold a parcel of land known as Harlem Park located at 1800 Park Avenue (at 125th Street) in New York City."},{"Symbol":"VMC","Name":"Vulcan Materials","Sector":"Materials","Description":"Vulcan Materials Company is a producer of construction aggregates primarily crushed stone, sand, and gravel. The Company is a producer of aggregates-based construction materials including asphalt and ready-mixed concrete. The Company produces these materials from natural deposits such as granite, limestone and trap rock. The Company operates in four segments: Aggregates, Concrete, Asphalt Mix, And Cement. The Company has 341 active aggregates facilities. The Company also is a producer of asphalt mix and ready-mixed concrete, as well as a producer of cement in Florida. The Company is a construction materials business in the country with aggregates operations. Its construction aggregates are used in water filtration, purification and erosion control, as base material underneath highways, walkways, airport runways, parking lots and railroads."},{"Symbol":"WMT","Name":"Wal-Mart Stores","Sector":"Consumer Staples","Description":"Wal-Mart Stores, Inc. (Walmart) operates retail stores in various formats globally. The Company operates in three segments: the Walmart U.S., the Walmart International and the Sam's Club. During the fiscal year ended January 31, 2013 (fiscal 2013), its Walmart U.S. segment accounted for approximately 59% of its net sales and operated retail stores in various formats in all 50 states in the United States and Puerto Rico, as well as Walmart's online retail operations, walmart.com. Its Walmart International segment consists of retail operations in 26 countries. In fiscal 2013, this segment generated approximately 29% of its net sales. The Walmart International segment includes a range of formats of retail stores, restaurants, Sam's Clubs and online retail operations, which operate outside the United States. Sam's Club segment consists of membership warehouse clubs operated in 47 states in the United States and Puerto Rico, as well as the segment's online retail operations, samsclub.com."},{"Symbol":"WBA","Name":"Walgreens Boots Alliance","Sector":"Consumer Staples","Description":"Walgreens Boots Alliance, Inc., together with its subsidiaries, operates a network of drugstores in the United States. It provides consumer goods and services, pharmacy, and health and wellness services through drugstores, as well as through mail, and by telephone and online. The company sells prescription and non-prescription drugs; and general merchandise, including convenience and fresh foods, household items, personal care, photofinishing and candy, and beauty care. It also provides specialty pharmacy services for managing complex and chronic health conditions; customers infusion therapy services consisting of administration of intravenous medications for cancer treatments, chronic pain, heart failure, and other infections and disorders; and clinical services, such as laboratory monitoring, medication profile review, nutritional assessments, and patient and caregiver education. In addition, the company manages in-store convenient care clinics (Healthcare Clinics). As of October 20, 2014, it operated 8,207 locations in 50 states, the District of Columbia, Puerto Rico, and the U.S. Virgin Islands. The company also managed approximately 400 Healthcare Clinics and provider practice locations. The company was founded in 1901 and is based in Deerfield, Illinois."},{"Symbol":"WM","Name":"Waste Management Inc.","Sector":"Industrials","Description":"Waste Management, Inc. (WM) is a provider of waste management services in North America. WM's subsidiaries provide collection, transfer, recycling, and disposal services. WM is a developer, operator and owner of waste-to-energy and landfill gas-to-energy facilities in the United States. Its customers include residential, commercial, industrial and municipal customers throughout North America. Its segments include Eastern, Midwest, Southern, Western and Wheelabrator Groups. The Oakleaf operations are included in other. The services the Company provides include collection, landfill, transfer, waste-to-energy facilities and independent power production plants, recycling and other services. In January 2013, its subsidiary, WM Recycle America, L.L.C., acquired Greenstar, LLC. Effective August 1, 2013, Waste Management Inc acquired Summit Energy Services, and concurrently, WM acquired Liquid Logistics. Effective August 1, 2013, Waste Management Inc acquired Oak Grove Disposal Co."},{"Symbol":"WAT","Name":"Waters Corporation","Sector":"Health Care","Description":"Waters Corporation (Waters) is an analytical instrument manufacturer that primarily designs, manufactures, sells and services, through its Waters Division, high performance liquid chromatography (HPLC), ultra performance liquid chromatography (UPLC and together with HPLC, referred to as LC) and mass spectrometry (MS) technology systems and support products, including chromatography columns, other consumable products and post-warranty service plans. Through its TA Division, the Company primarily designs, manufactures, sells and services thermal analysis, rheometry and calorimetry instruments. The Company is also a developer and supplier of software-based products that interface with the Company's instruments and are typically purchased by customers as part of the instrument system. The Company operates in two segments: Waters Division and TA Division. In January 2012, the Company acquired Baehr Thermoanalyse GmbH. In July 2012, the Company acquired Blue Reference, Inc."},{"Symbol":"WEC","Name":"Wec Energy Group Inc","Sector":"Utilities","Description":"Wisconsin Energy Corporation is a diversified holding company. The Company operates primarily through two segments: a utility energy segment and a non-utility energy segment. Its primary subsidiaries are Wisconsin Electric Power Company (Wisconsin Electric), Wisconsin Gas LLC (Wisconsin Gas) and W.E. Power, LLC (We Power). Its utility energy segment consists of Wisconsin Electric and Wisconsin Gas, operating together under the trade name of We Energies. Its non-utility energy segment derives its revenues primarily from the ownership of electric power generating facilities for long-term lease to Wisconsin Electric. Its non-utility energy segment derives its revenues primarily from the ownership of electric power generating facilities for long-term lease to Wisconsin Electric. As of December 31, 2012, the Company have a 26.2% interest in ATC."},{"Symbol":"WFC","Name":"Wells Fargo","Sector":"Financials","Description":"Wells Fargo & Company is a bank holding company. It has three operating segments: Community Banking, Wholesale Banking and Wealth, and Brokerage and Retirement. It provides retail, commercial and corporate banking services through banking stores and offices, the Internet and other distribution channels to individuals, businesses and institutions in all 50 states, the District of Columbia and in other countries. The Company provides other financial services through subsidiaries engaged in various businesses, principally wholesale banking, mortgage banking, consumer finance, equipment leasing, agricultural finance, commercial finance, securities brokerage and investment banking, insurance agency and brokerage services, computer and data processing services, trust services, investment advisory services, mortgage-backed securities servicing and venture capital investment. Effective November 21, 2013, Wells Fargo & Co acquired an undisclosed minority interest in Grameen America Inc."},{"Symbol":"HCN","Name":"Welltower Inc.","Sector":"Real Estate","Description":"Health Care REIT, Inc. is a real estate investment trust (REIT). The Company's portfolio spans the full spectrum of seniors housing and health care real estate, including seniors housing communities, skilled nursing/post-acute facilities, medical office buildings, inpatient and outpatient medical centers and life science facilities. The Company operates in three segments: seniors housing triple-net, seniors housing operating and medical facilities. Its properties are primarily comprised of land, building, improvements and related rights. The Company's hospitals and seniors housing triple-net properties are leased to operators under long-term operating leases. Its medical office building portfolio is primarily self-managed and consists principally of multi-tenant properties leased to health care providers. In October 2013, the Company announced the acquisition of the Willows at Hamburg from Health Care REIT, Inc."},{"Symbol":"WDC","Name":"Western Digital","Sector":"Information Technology","Description":"Western Digital Corporation (Western Digital) is a developer and manufacturer of storage solutions, which enables people to create, manage, experience and preserve digital content. The Company designs and makes storage devices and home entertainment products under the HGST, WD and G-Technology brands. The Company's principal products are hard drives that use one or more rotating magnetic disks (magnetic media) to store and allow fast access to data. Hard drives are primary storage medium for digital content. The Company operates its global business through two independent subsidiaries: Hitachi Global Storage Technologies Holdings Pte. Ltd. (HGST) and Western Digital Corporation (WD). In September 2013, the Company announced that it has completed the acquisition of sTec, Inc. In October 2013, Western Digital Corporation completed the acquisition of Virident Systems, Inc."},{"Symbol":"WU","Name":"Western Union Co","Sector":"Information Technology","Description":"The Western Union Company (Western Union) is engaged in money movement and payment services. The Company's business payments service provides consumers and businesses with options for making one-time or recurring bill payments, including business-to-business payment transactions, which are primarily cross-border, cross currency transactions. Its segments are consumer-to-consumer and global business payments. Its other businesses not included in these segments primarily consist of Western Union money order and prepaid services available through a network of third-party agents. In April 2011, the Company acquired Angelo Costa, S.r.l. In August 2011, the Company formed Western Union Ventures. In October 2011, the Company acquired Finint S.r.l. In November 2011, the Company acquired the business-to-business payment business of Travelex Holdings Limited, known as Travelex Global Business Payments."},{"Symbol":"WRK","Name":"WestRock Company","Sector":"Materials","Description":"WestRock Company manufactures and sells paper and packaging solutions for consumer and corrugated markets in North America, South America, Europe, and the Asia-Pacific. It offers folding cartons for use in various food and non-food applications; superior pumps, sprayers, and dispensing closures for home cleaning, healthcare, and beauty and personal care products; and corrugated containers for home appliances, electric motors, small machinery, produce, books, furniture, and other products. The company also provides beverage multipacks for beer, carbonated soft drink, and other beverage markets; merchandising displays; chipboard partitions and other protective packaging, such as custom partitions, book cover board, single ply chip, and gypsum; and coated white top linerboard, white top linerboard, virgin and recycled linerboard, corrugated medium, kraft paper, and pulp products. In addition, it offers various paperboard products, including solid bleached sulfate, coated and uncoated recycled board, and coated and uncoated unbleached kraft. Further, the company is involved in recovering, processing, and selling recycled paperboard; developing master planned communities, and industrial and business campuses, as well as recreational/investment land sales in South Carolina and Georgia; and supplying specialty chemicals products and distinctive technologies in asphalt innovations, oilfield and pine chemicals, and activated carbon. WestRock Company is based in Richmond, Virginia."},{"Symbol":"WY","Name":"Weyerhaeuser Corp.","Sector":"Real Estate","Description":"Weyerhaeuser Company, formerly Weyerhaeuser Timber Company, is a forest products company. The Company is engaged in growing and harvesting trees, builds homes and making a range of forest products. As of December 31, 2010, it had offices or operations in 11 countries and have customers worldwide. It manages 20.3 million acres of forests, of which it owns 5.7 million acres, lease 0.7 million acres and has renewable, long-term licenses on 13.9 million acres. The Company operates in five business segments: Timberlands, Wood Products, Cellulose Fibers, Real Estate and Corporate and Other. In August 1, 2011, the Company sold its hardwoods business to American Industrial Partners. On September 30, 2011, the Company sold its Westwood Shipping Lines. Effective July 23, 2013, Weyerhaeuser Co acquired the entire share capital of Longview Timber LLC, a Longview-based owner and operator of timberlands, from Brookfield Asset Management Inc."},{"Symbol":"WHR","Name":"Whirlpool Corp.","Sector":"Consumer Discretionary","Description":"Whirlpool Corporation (Whirlpool) is a manufacturer and marketer of home appliances. Whirlpool operates in four segments: North America, Latin America, EMEA (Europe, Middle East and Africa) and Asia. Whirlpool manufactures and markets a line of home appliances and related products. Its principal products are laundry appliances, refrigerators and freezers, cooking appliances, dishwashers, mixers and other portable household appliances. The Company also produces hermetic compressors for refrigeration systems. It is a producer of home appliances in North America and Latin America and has a presence in markets throughout Europe and India. Its portfolio of brands includes Whirlpool, Maytag, KitchenAid, Brastemp and Consul."},{"Symbol":"WFM","Name":"Whole Foods Market","Sector":"Consumer Staples","Description":"Whole Foods Market, Inc. (Whole Foods Market) is a natural and organic foods supermarkets. As of September 25, 2011, Whole Foods Market operated 311 stores in the United States, Canada, and the United Kingdom. The Company's stores average 38,000 square feet in size and 10 years in age, and are supported by its Austin headquarters, regional offices, distribution centers, bakehouse facilities, commissary kitchens, seafood-processing facilities, meat and produce procurement centers, and a specialty coffee, tea procurement and roasting operation. As of September 25, 2011, it operated 311 stores, of which 299 stores operated in 38 United States and the District of Columbia; seven stores in Canada; and five stores in the United Kingdom. It owns 12 stores, two distribution facilities and land for one store in development, including the adjacent property. It also owns a building on leased land, which is leased to third parties, and has one store in development on leased land."},{"Symbol":"WMB","Name":"Williams Cos.","Sector":"Energy","Description":"The Williams Companies, Inc. (Williams) is an energy infrastructure company focused on connecting North America's hydrocarbon resource plays to markets for natural gas, natural gas liquids (NGLs), and olefins. Its operations span from the deepwater Gulf of Mexico to the Canadian oil sands. It operates in three segments: Williams Partners, Midstream Canada & Olefins and Other. Its interstate gas pipeline and domestic midstream interests are held through its investment in Williams Partners L.P. (WPZ). It owns the general-partner interest and a 70% limited-partner interest in WPZ. Williams also owns a Canadian midstream and domestic olefins production business, which processes oil sands off-gas and produces olefins for petrochemical feedstocks. In November 2012, Williams Partners LP acquired Williams Companies Inc's approximately 83% interest in the Geismar olefins production facility In December 2012, it acquired Access Midstream Partners GP, L.L.C. and Access Midstream Partners LP."},{"Symbol":"WLTW","Name":"Willis Towers Watson","Sector":"Financials","Description":"Willis Towers Watson (NASDAQ:WLTW ) is a leading global advisory, broking and solutions company that helps clients around the world turn risk into a path for growth. With roots dating to 1828, Willis Towers Watson has 39,000 employees in more than 120 territories. We design and deliver solutions that manage risk, optimize benefits, cultivate talent, and expand the power of capital to protect and strengthen institutions and individuals. Our unique perspective allows us to see the critical intersections between talent, assets and ideas — the dynamic formula that drives business performance. Together, we unlock potential. Learn more at http://www.willistowerswatson.com."},{"Symbol":"WYN","Name":"Wyndham Worldwide","Sector":"Consumer Discretionary","Description":"Wyndham Worldwide Corporation is a hospitality company. The Company offers individual consumers and business customers an array of hospitality services and products across various accommodation alternatives and price ranges through its portfolio of brands. It operates in three segments of the hospitality industry: lodging, vacation exchange and rentals and vacation ownership. Its brands include Wyndham Hotels and Resorts, Tryp by Wyndham, Ramada, Days Inn, Super 8, Landal GreenParks, Novasol, Hoseasons, cottages4you, James Villa Holidays, ResortQuest by Wyndham Vacation Rentals, The Resort Company by Wyndham Vacation Rentals, Wyndham Vacation Resorts and WorldMark by Wyndham. In September 2012, its subsidiary, Wyndham Vacation Ownership, acquired Shell Vacations LLC (Shell) and its subsidiaries. In October 2012, the Company's Wyndham Hotel Group announced the opening of the newly constructed, 250-room TRYP by Wyndham Bogota Embajada, the newest TRYP by Wyndham(SM) hotel in Colombia."},{"Symbol":"WYNN","Name":"Wynn Resorts Ltd","Sector":"Consumer Discretionary","Description":"Wynn Resorts, Limited is a developer, owner and operator of destination casino resorts. The Company owns and operates two destination casino resorts. In Las Vegas, Nevada, the Company owns and operates Wynn Las Vegas, which includes Encore at Wynn Las Vegas. In the Macau Special Administrative Region of the People's Republic of China (Macau) the Company owns and operates Wynn Macau, which includes Encore at Wynn Macau. The Company has two segments: Las Vegas Operations and Macau Operations. The Company's Macau Operations feature approximately 1,008 hotel rooms and suites, 495 table games, 835 slot machines. Company's Las Vegas Operations feature approximately 4,750 hotel rooms and suites, 240 table games, 2,195 slot machines."},{"Symbol":"XEL","Name":"Xcel Energy Inc","Sector":"Utilities","Description":"Xcel Energy Inc. is a holding company with subsidiaries engaged primarily in the utility business. During the year ended December 31, 2012, the Company's operations included the activity of four wholly owned utility subsidiaries that serve electric and natural gas customers in eight states. These utility subsidiaries are NSP-Minnesota, NSP-Wisconsin, PSCo and SPS, and serve customers in portions of Colorado, Michigan, Minnesota, New Mexico, North Dakota, South Dakota, Texas and Wisconsin. Along with WYCO, a joint venture formed with CIG to develop and lease natural gas pipelines, storage, and compression facilities, and WGI, an interstate natural gas pipeline company, these companies comprise the continuing regulated utility operations."},{"Symbol":"XRX","Name":"Xerox Corp.","Sector":"Information Technology","Description":"Xerox Corporation provides services and technology to enable its customers from small businesses to large global enterprises to focus on their core business. The Company is a diversified business process outsourcing company managing transaction-intensive processes. This includes services which support all enterprises through offerings, such as customer care, finance and accounting and human resources, as well as vertically focused offerings in areas, such as healthcare, transportation, retail and telecommunications, among others. It is engaged in designing, developing and delivering information technology (IT) solutions that leverage its secure data centers, help desks and managed storage facilities around the world to provide IT infrastructure. The Company operates in three segments: Services, Document Technology and Other. Effective August 13, 2013, Xerox Corp acquired CPAS Systems Inc."},{"Symbol":"XLNX","Name":"Xilinx Inc","Sector":"Information Technology","Description":"Xilinx, Inc. (Xilinx) designs and develops programmable devices and associated technologies. The associated technologies, the Company develops includes integrated circuits (ICs) in the form of programmable logic devices (PLDs), including programmable System on Chips (SoCs) and three dimensional ICs (3D) ICs; software design tools to program the PLDs; targeted reference designs; printed circuit boards, and intellectual property (IP), which consists of Xilinx and various third-party verification and IP cores. In addition to its programmable platforms, the Company provides design services, customer training, field engineering and technical support. The Company sells its products and services through independent domestic and foreign distributors and through direct sales to original equipment manufacturers (OEMs) and electronic manufacturing service providers (EMS)."},{"Symbol":"XL","Name":"XL Capital","Sector":"Financials","Description":"XL Group plc, through its subsidiaries, is a global insurance and reinsurance company engaged in providing property, casualty and specialty products to industrial, commercial and professional firms, insurance companies and other enterprises on a worldwide basis. The Company is organized into three operating segments: Insurance, Reinsurance and Life operations."},{"Symbol":"XYL","Name":"Xylem Inc.","Sector":"Industrials","Description":"Xylem Inc. (Xylem), formerly ITT WCO, Inc., is a provider of equipment and service for water and wastewater applications with a portfolio of products and services addressing the full cycle of water, from collection, distribution and use to the return of water to the environment. It operates in two segments: Water Infrastructure and Applied Water. The Water Infrastructure segment focuses on the transportation, treatment and testing of water, offering a range of products, including water and wastewater pumps, treatment and testing equipment, and controls and systems. The Applied Water segment encompasses the uses of water and focuses on the residential, commercial, industrial and agricultural markets. The segment's products include pumps, valves, heat exchangers, controls and dispensing equipment. In March 2013, it acquired MultiTrode Pty Ltd."},{"Symbol":"YHOO","Name":"Yahoo Inc.","Sector":"Information Technology","Description":"Yahoo! Inc. (Yahoo!) is a digital media company. Through the Company's technology and insights, Yahoo! delivers digital content and experiences, across devices and globally. The Company provides online properties and services (Yahoo! Properties) to users, as well as a range of marketing services designed to reach and connect with those users on Yahoo! and through a distribution network of third-party entities (Affiliates). These Affiliates integrate its advertising offerings into their Websites or other offerings (those Websites and other offerings, Affiliate sites). Its offerings to users on Yahoo! Properties fall into three categories: Communications and Communities, Search and Marketplaces, and Media. In October 2013, Yahoo! Inc acquired Hitpost Inc. In October 2013, Yahoo! Inc acquired Bread Labs Inc."},{"Symbol":"YUM","Name":"Yum! Brands Inc","Sector":"Consumer Discretionary","Description":"YUM! Brands, Inc. (YUM) is a quick service restaurant company based on number of system units, with over 39,000 units in more than 125 countries and territories. The Company, through three concepts of KFC, Pizza Hut and Taco Bell (Concepts) develops, operates, franchises and licenses a worldwide system of restaurants, which prepare, package and sell a menu of priced food items. The Company operates in six segments: YUM Restaurants China (China or China Division), YUM Restaurants International (YRI or International Division), Taco Bell U.S., KFC U.S., Pizza Hut U.S. and YUM Restaurants India (India or India Division). The China Division includes mainland China, and the India Division includes India, Bangladesh, Mauritius, Nepal and Sri Lanka. YRI includes the remainder of its international operations."},{"Symbol":"ZBH","Name":"Zimmer Biomet Holdings","Sector":"Health Care","Description":"Zimmer Biomet Holdings, Inc., together with its subsidiaries, designs, develops, manufactures, and markets orthopaedic reconstructive devices, spinal and trauma devices, biologics, dental implants, and related surgical products in the Americas, Europe, and the Asia Pacific. It offers orthopaedic reconstructive devices that restore function lost due to disease or trauma in joints comprising knees, hips, shoulders, and elbows; dental reconstructive implants, which restore function and aesthetics in patients who have lost teeth due to trauma or disease; spinal devices that are utilized by orthopedic surgeons and neurosurgeons for the treatment of degenerative diseases, deformities, and trauma in various regions of the spine; and trauma devices used primarily to reattach or stabilize damaged bone and tissue to support the bodys natural healing process. The company also provides related surgical products, such as surgical supplies and instruments to aid in orthopedic surgical procedures and post-operation rehabilitation; and other healthcare related services. It primarily serves orthopedic surgeons, neurosurgeons, oral surgeons, dentists, hospitals, stocking distributors, and healthcare dealers, as well as agents, healthcare purchasing organizations, or buying groups. The company was formerly known as Zimmer Holdings, Inc. and changed its name to Zimmer Biomet Holdings, Inc. in June 2015. Zimmer Biomet Holdings, Inc. was founded in 1927 and is headquartered in Warsaw, Indiana."},{"Symbol":"ZION","Name":"Zions Bancorp","Sector":"Financials","Description":"Zions Bancorporation is a financial holding company. The Company focuses on providing community banking services by continuously strengthening its core business lines of small and medium-sized business and corporate banking; commercial and residential development, construction and term lending; retail banking; treasury cash management and related products and services; residential mortgage; trust and wealth management, and investment activities. The Company is a bank holding company. The Company owns and operates eight commercial banks with a total of 480 domestic branches in ten western and southwestern states as of December 31, 2012. The Company provides a range of banking and related services through its banking and other subsidiaries, primarily in Utah, California, Texas, Arizona, Nevada, Colorado, Idaho, Washington, and Oregon. As of December 31, 2012, net loans and leases accounted for 67.9% of total assets."},{"Symbol":"ZTS","Name":"Zoetis","Sector":"Health Care","Description":"Zoetis Inc, is engaged in the discovery, development, manufacture and commercialization of animal health medicines and vaccines, with a focus on both livestock and companion animals. The primary livestock species are cattle (both beef and dairy), swine, poultry, sheep and fish, and the primary companion animal species are dogs, cats and horses. The Company's more than 300 product lines include vaccines, parasiticides, anti-infectives, medicated feed additives and other pharmaceutical products. The Company's product portfolio also includes businesses, such as diagnostics, genetics, devices and services, such as dairy data management, e-learning and professional consulting. The Company operates in North America, Europe, Africa, Asia, Australia and Latin America."}];

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/vector-apps/part1",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/vector-apps/part1"+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var emptyObject = __webpack_require__(23);
var _invariant = __webpack_require__(0);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 88 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

module.exports = function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(92);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(102);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(0);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(5);

var createArrayFromMixed = __webpack_require__(95);
var getMarkupWrap = __webpack_require__(97);
var invariant = __webpack_require__(0);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(5);

var invariant = __webpack_require__(0);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(99);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(101);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.1.2
 * Copyright (C) 2017 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.1.2"
/*!
 * lunr.utils
 * Copyright (C) 2017 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf Utils
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf Utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}
lunr.FieldRef = function (docRef, fieldName) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = fieldName + lunr.FieldRef.joiner + docRef
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef)
}

lunr.FieldRef.prototype.toString = function () {
  return this._stringValue
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2017 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @returns {lunr.Token[]}
 */
lunr.tokenizer = function (obj) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(lunr.utils.asString(t).toLowerCase())
    })
  }

  var str = obj.toString().trim().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        tokens.push(
          new lunr.Token (str.slice(sliceStart, sliceEnd), {
            position: [sliceStart, sliceLength],
            index: tokens.length
          })
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2017 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null. This token will not be passed to any downstream pipeline functions and will not be
 * added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]

    tokens = tokens.reduce(function (memo, token, j) {
      var result = fn(token, j, tokens)

      if (result === void 0 || result === '') return memo

      return memo.concat(result)
    }, [])
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str) {
  var token = new lunr.Token (str)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2017 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the cosine similarity between this vector and another
 * vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / (this.magnitude() * otherVector.magnitude())
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2017 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2017 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2017 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2017 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      } else {
        stack.push({
          node: noEditNode,
          editsRemaining: frame.editsRemaining,
          str: frame.str.slice(1)
        })
      }
    }

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.editsRemaining > 0 && frame.str.length > 1) {
      var char = frame.str.charAt(1),
          deletionNode

      if (char in frame.node.edges) {
        deletionNode = frame.node.edges[char]
      } else {
        deletionNode = new lunr.TokenSet
        frame.node.edges[char] = deletionNode
      }

      if (frame.str.length <= 2) {
        deletionNode.final = true
      } else {
        stack.push({
          node: deletionNode,
          editsRemaining: frame.editsRemaining - 1,
          str: frame.str.slice(2)
        })
      }
    }

    // deletion
    // just removing the last character from the str
    if (frame.editsRemaining > 0 && frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.editsRemaining > 0 && frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      } else {
        stack.push({
          node: substitutionNode,
          editsRemaining: frame.editsRemaining - 1,
          str: frame.str.slice(1)
        })
      }
    }

    // insertion
    // can only do insertion if there are edits remaining
    if (frame.editsRemaining > 0) {
      if ("*" in frame.node.edges) {
        var insertionNode = frame.node.edges["*"]
      } else {
        var insertionNode = new lunr.TokenSet
        frame.node.edges["*"] = insertionNode
      }

      if (frame.str.length == 0) {
        insertionNode.final = true
      } else {
        stack.push({
          node: insertionNode,
          editsRemaining: frame.editsRemaining - 1,
          str: frame.str
        })
      }
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.editsRemaining > 0 && frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      } else {
        stack.push({
          node: transposeNode,
          editsRemaining: frame.editsRemaining - 1,
          str: charA + frame.str.slice(2)
        })
      }
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node,
      wildcardFound = false

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * As soon as a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      wildcardFound = true
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next

      // TODO: is this needed anymore?
      if (wildcardFound) {
        node.edges["*"] = root
      }
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2017 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.documentVectors - Document vectors keyed by document reference.
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null)

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term)
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting)

          /*
           * To support field level boosts a query vector is created per
           * field. This vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           *
           * If the query vector for this field does not exist yet it needs
           * to be created.
           */
          if (!(field in queryVectors)) {
            queryVectors[field] = new lunr.Vector
          }

          /*
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, 1 * clause.boost, function (a, b) { return a + b })

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                documentMetadata, matchData

            documentMetadata = fieldPosting[matchingDocumentRef]
            matchData = new lunr.MatchData (expandedTerm, field, documentMetadata)

            if (matchingFieldRef in matchingFields) {
              matchingFields[matchingFieldRef].combine(matchData)
            } else {
              matchingFields[matchingFieldRef] = matchData
            }

          }
        }
      }
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = {}

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef,
        fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector)

    if (docRef in results) {
      results[docRef].score += score
      results[docRef].matchData.combine(matchingFields[fieldRef])
    } else {
      results[docRef] = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
    }
  }

  /*
   * The results object needs to be converted into a list
   * of results, sorted by score before being returned.
   */
  return Object.keys(results)
    .map(function (key) {
      return results[key]
    })
    .sort(function (a, b) {
      return b.score - a.score
    })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = {},
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2017 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = []
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * @param {string} field - The name of a field to index in all documents.
 */
lunr.Builder.prototype.field = function (field) {
  this._fields.push(field)
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * @param {object} doc - The document to add to the index.
 */
lunr.Builder.prototype.add = function (doc) {
  var docRef = doc[this._ref]

  this.documentCount += 1

  for (var i = 0; i < this._fields.length; i++) {
    var fieldName = this._fields[i],
        field = doc[fieldName],
        tokens = this.tokenizer(field),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < this._fields.length; k++) {
          posting[this._fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  for (var i = 0; i < this._fields.length; i++) {
    var field = this._fields[i]
    accumulator[field] = accumulator[field] / documentsWithField[field]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf = lunr.idf(this.invertedIndex[term], this.documentCount),
          score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[field])) + tf),
          scoreWithPrecision = Math.round(score * 1000) / 1000
          // Converts 1.23456789 to 1.234.
          // Reducing the precision so that the vectors take up less
          // space when serialised. Doing it now so that they behave
          // the same before and after serialisation. Also, this is
          // the fastest approach to reducing a number's precision in
          // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @private
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: this._fields,
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata)

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)
  this.metadata[term] = Object.create(null)
  this.metadata[term][field] = clonedMetadata
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */
lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=0] - Whether the term should have wildcards appended or prepended.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  this.clauses.push(clause)

  return this
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * @param {string} term - The term to add to the query.
 * @param {Object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 */
lunr.Query.prototype.term = function (term, options) {
  var clause = options || {}
  clause.term = term

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseFieldOrTerm

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseFieldOrTerm = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(50);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(50);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(6);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var ReactPropTypesSecret = __webpack_require__(109);
var checkPropTypes = __webpack_require__(107);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(124);


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(4);

var focusNode = __webpack_require__(47);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(19);
var ExecutionEnvironment = __webpack_require__(5);
var FallbackCompositionState = __webpack_require__(119);
var SyntheticCompositionEvent = __webpack_require__(156);
var SyntheticInputEvent = __webpack_require__(159);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(52);
var ExecutionEnvironment = __webpack_require__(5);
var ReactInstrumentation = __webpack_require__(7);

var camelizeStyleName = __webpack_require__(93);
var dangerousStyleValue = __webpack_require__(165);
var hyphenateStyleName = __webpack_require__(100);
var memoizeStringOnly = __webpack_require__(103);
var warning = __webpack_require__(1);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(18);
var EventPropagators = __webpack_require__(19);
var ExecutionEnvironment = __webpack_require__(5);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(8);
var SyntheticEvent = __webpack_require__(9);

var inputValueTracking = __webpack_require__(68);
var getEventTarget = __webpack_require__(42);
var isEventSupported = __webpack_require__(43);
var isTextInputElement = __webpack_require__(70);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMLazyTree = __webpack_require__(12);
var ExecutionEnvironment = __webpack_require__(5);

var createNodesFromMarkup = __webpack_require__(96);
var emptyFunction = __webpack_require__(6);
var invariant = __webpack_require__(0);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(19);
var ReactDOMComponentTree = __webpack_require__(4);
var SyntheticMouseEvent = __webpack_require__(25);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(11);

var getTextContentAccessor = __webpack_require__(67);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(13);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(14);

var instantiateReactComponent = __webpack_require__(69);
var KeyEscapeUtils = __webpack_require__(34);
var shouldUpdateReactComponent = __webpack_require__(44);
var traverseAllChildren = __webpack_require__(72);
var warning = __webpack_require__(1);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/vector-apps/part1"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(74);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(30);
var ReactDOMIDOperations = __webpack_require__(129);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var React = __webpack_require__(15);
var ReactComponentEnvironment = __webpack_require__(36);
var ReactCurrentOwner = __webpack_require__(10);
var ReactErrorUtils = __webpack_require__(37);
var ReactInstanceMap = __webpack_require__(20);
var ReactInstrumentation = __webpack_require__(7);
var ReactNodeTypes = __webpack_require__(62);
var ReactReconciler = __webpack_require__(14);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(23);
var invariant = __webpack_require__(0);
var shallowEqual = __webpack_require__(29);
var shouldUpdateReactComponent = __webpack_require__(44);
var warning = __webpack_require__(1);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(4);
var ReactDefaultInjection = __webpack_require__(137);
var ReactMount = __webpack_require__(61);
var ReactReconciler = __webpack_require__(14);
var ReactUpdates = __webpack_require__(8);
var ReactVersion = __webpack_require__(150);

var findDOMNode = __webpack_require__(166);
var getHostComponentFromComposite = __webpack_require__(66);
var renderSubtreeIntoContainer = __webpack_require__(173);
var warning = __webpack_require__(1);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var AutoFocusUtils = __webpack_require__(112);
var CSSPropertyOperations = __webpack_require__(114);
var DOMLazyTree = __webpack_require__(12);
var DOMNamespaces = __webpack_require__(31);
var DOMProperty = __webpack_require__(13);
var DOMPropertyOperations = __webpack_require__(54);
var EventPluginHub = __webpack_require__(18);
var EventPluginRegistry = __webpack_require__(32);
var ReactBrowserEventEmitter = __webpack_require__(24);
var ReactDOMComponentFlags = __webpack_require__(55);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMInput = __webpack_require__(130);
var ReactDOMOption = __webpack_require__(131);
var ReactDOMSelect = __webpack_require__(56);
var ReactDOMTextarea = __webpack_require__(134);
var ReactInstrumentation = __webpack_require__(7);
var ReactMultiChild = __webpack_require__(143);
var ReactServerRenderingTransaction = __webpack_require__(148);

var emptyFunction = __webpack_require__(6);
var escapeTextContentForBrowser = __webpack_require__(27);
var invariant = __webpack_require__(0);
var isEventSupported = __webpack_require__(43);
var shallowEqual = __webpack_require__(29);
var inputValueTracking = __webpack_require__(68);
var validateDOMNesting = __webpack_require__(45);
var warning = __webpack_require__(1);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(45);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var DOMLazyTree = __webpack_require__(12);
var ReactDOMComponentTree = __webpack_require__(4);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(30);
var ReactDOMComponentTree = __webpack_require__(4);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var DOMPropertyOperations = __webpack_require__(54);
var LinkedValueUtils = __webpack_require__(35);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(8);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var React = __webpack_require__(15);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMSelect = __webpack_require__(56);

var warning = __webpack_require__(1);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);

var getNodeForCharacterOffset = __webpack_require__(170);
var getTextContentAccessor = __webpack_require__(67);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var DOMChildrenOperations = __webpack_require__(30);
var DOMLazyTree = __webpack_require__(12);
var ReactDOMComponentTree = __webpack_require__(4);

var escapeTextContentForBrowser = __webpack_require__(27);
var invariant = __webpack_require__(0);
var validateDOMNesting = __webpack_require__(45);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var LinkedValueUtils = __webpack_require__(35);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(8);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var ReactUpdates = __webpack_require__(8);
var Transaction = __webpack_require__(26);

var emptyFunction = __webpack_require__(6);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(111);
var BeforeInputEventPlugin = __webpack_require__(113);
var ChangeEventPlugin = __webpack_require__(115);
var DefaultEventPluginOrder = __webpack_require__(117);
var EnterLeaveEventPlugin = __webpack_require__(118);
var HTMLDOMPropertyConfig = __webpack_require__(120);
var ReactComponentBrowserEnvironment = __webpack_require__(122);
var ReactDOMComponent = __webpack_require__(125);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMEmptyComponent = __webpack_require__(127);
var ReactDOMTreeTraversal = __webpack_require__(135);
var ReactDOMTextComponent = __webpack_require__(133);
var ReactDefaultBatchingStrategy = __webpack_require__(136);
var ReactEventListener = __webpack_require__(140);
var ReactInjection = __webpack_require__(141);
var ReactReconcileTransaction = __webpack_require__(146);
var SVGDOMPropertyConfig = __webpack_require__(151);
var SelectEventPlugin = __webpack_require__(152);
var SimpleEventPlugin = __webpack_require__(153);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(18);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var EventListener = __webpack_require__(46);
var ExecutionEnvironment = __webpack_require__(5);
var PooledClass = __webpack_require__(11);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(8);

var getEventTarget = __webpack_require__(42);
var getUnboundedScrollPosition = __webpack_require__(98);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(13);
var EventPluginHub = __webpack_require__(18);
var EventPluginUtils = __webpack_require__(33);
var ReactComponentEnvironment = __webpack_require__(36);
var ReactEmptyComponent = __webpack_require__(57);
var ReactBrowserEventEmitter = __webpack_require__(24);
var ReactHostComponent = __webpack_require__(59);
var ReactUpdates = __webpack_require__(8);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(164);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactComponentEnvironment = __webpack_require__(36);
var ReactInstanceMap = __webpack_require__(20);
var ReactInstrumentation = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(10);
var ReactReconciler = __webpack_require__(14);
var ReactChildReconciler = __webpack_require__(121);

var emptyFunction = __webpack_require__(6);
var flattenChildren = __webpack_require__(167);
var invariant = __webpack_require__(0);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var CallbackQueue = __webpack_require__(53);
var PooledClass = __webpack_require__(11);
var ReactBrowserEventEmitter = __webpack_require__(24);
var ReactInputSelection = __webpack_require__(60);
var ReactInstrumentation = __webpack_require__(7);
var Transaction = __webpack_require__(26);
var ReactUpdateQueue = __webpack_require__(38);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(144);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(11);
var Transaction = __webpack_require__(26);
var ReactInstrumentation = __webpack_require__(7);
var ReactServerUpdateQueue = __webpack_require__(149);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(38);

var warning = __webpack_require__(1);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(19);
var ExecutionEnvironment = __webpack_require__(5);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInputSelection = __webpack_require__(60);
var SyntheticEvent = __webpack_require__(9);

var getActiveElement = __webpack_require__(48);
var isTextInputElement = __webpack_require__(70);
var shallowEqual = __webpack_require__(29);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var EventListener = __webpack_require__(46);
var EventPropagators = __webpack_require__(19);
var ReactDOMComponentTree = __webpack_require__(4);
var SyntheticAnimationEvent = __webpack_require__(154);
var SyntheticClipboardEvent = __webpack_require__(155);
var SyntheticEvent = __webpack_require__(9);
var SyntheticFocusEvent = __webpack_require__(158);
var SyntheticKeyboardEvent = __webpack_require__(160);
var SyntheticMouseEvent = __webpack_require__(25);
var SyntheticDragEvent = __webpack_require__(157);
var SyntheticTouchEvent = __webpack_require__(161);
var SyntheticTransitionEvent = __webpack_require__(162);
var SyntheticUIEvent = __webpack_require__(21);
var SyntheticWheelEvent = __webpack_require__(163);

var emptyFunction = __webpack_require__(6);
var getEventCharCode = __webpack_require__(40);
var invariant = __webpack_require__(0);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(9);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(9);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(9);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(25);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(21);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(9);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(21);

var getEventCharCode = __webpack_require__(40);
var getEventKey = __webpack_require__(168);
var getEventModifierState = __webpack_require__(41);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(21);

var getEventModifierState = __webpack_require__(41);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(9);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(25);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(52);
var warning = __webpack_require__(1);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(10);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInstanceMap = __webpack_require__(20);

var getHostComponentFromComposite = __webpack_require__(66);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(34);
var traverseAllChildren = __webpack_require__(72);
var warning = __webpack_require__(1);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/vector-apps/part1"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(74);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(40);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(27);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(61);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Highlighter = __webpack_require__(2);
	
	var _Highlighter2 = _interopRequireDefault(_Highlighter);

	exports['default'] = _Highlighter2['default'];
	module.exports = exports['default'];

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Highlighter;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _highlightWordsCore = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(13);
	
	var _react2 = _interopRequireDefault(_react);
	
	Highlighter.propTypes = {
	  activeClassName: _propTypes2['default'].string,
	  activeIndex: _propTypes2['default'].number,
	  autoEscape: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  highlightClassName: _propTypes2['default'].string,
	  highlightStyle: _propTypes2['default'].object,
	  highlightTag: _propTypes2['default'].string,
	  sanitize: _propTypes2['default'].func,
	  searchWords: _propTypes2['default'].arrayOf(_propTypes2['default'].string).isRequired,
	  textToHighlight: _propTypes2['default'].string.isRequired,
	  unhighlightClassName: _propTypes2['default'].string,
	  unhighlightStyle: _propTypes2['default'].object
	};
	
	/**
	 * Highlights all occurrences of search terms (searchText) within a string (textToHighlight).
	 * This function returns an array of strings and <span>s (wrapping highlighted words).
	 */
	
	function Highlighter(_ref) {
	  var _ref$activeClassName = _ref.activeClassName;
	  var activeClassName = _ref$activeClassName === undefined ? '' : _ref$activeClassName;
	  var _ref$activeIndex = _ref.activeIndex;
	  var activeIndex = _ref$activeIndex === undefined ? -1 : _ref$activeIndex;
	  var autoEscape = _ref.autoEscape;
	  var className = _ref.className;
	  var _ref$highlightClassName = _ref.highlightClassName;
	  var highlightClassName = _ref$highlightClassName === undefined ? '' : _ref$highlightClassName;
	  var _ref$highlightStyle = _ref.highlightStyle;
	  var highlightStyle = _ref$highlightStyle === undefined ? {} : _ref$highlightStyle;
	  var _ref$highlightTag = _ref.highlightTag;
	  var highlightTag = _ref$highlightTag === undefined ? 'mark' : _ref$highlightTag;
	  var sanitize = _ref.sanitize;
	  var searchWords = _ref.searchWords;
	  var textToHighlight = _ref.textToHighlight;
	  var _ref$unhighlightClassName = _ref.unhighlightClassName;
	  var unhighlightClassName = _ref$unhighlightClassName === undefined ? '' : _ref$unhighlightClassName;
	  var unhighlightStyle = _ref.unhighlightStyle;
	
	  var chunks = (0, _highlightWordsCore.findAll)({
	    autoEscape: autoEscape,
	    sanitize: sanitize,
	    searchWords: searchWords,
	    textToHighlight: textToHighlight
	  });
	  var HighlightTag = highlightTag;
	  var highlightCount = -1;
	  var highlightClassNames = '';
	
	  return _react2['default'].createElement(
	    'span',
	    { className: className },
	    chunks.map(function (chunk, index) {
	      var text = textToHighlight.substr(chunk.start, chunk.end - chunk.start);
	
	      if (chunk.highlight) {
	        highlightCount++;
	        highlightClassNames = highlightClassName + ' ' + (highlightCount === +activeIndex ? activeClassName : '');
	
	        return _react2['default'].createElement(
	          HighlightTag,
	          {
	            className: highlightClassNames,
	            key: index,
	            style: highlightStyle
	          },
	          text
	        );
	      } else {
	        return _react2['default'].createElement(
	          'span',
	          {
	            className: unhighlightClassName,
	            key: index,
	            style: unhighlightStyle
	          },
	          text
	        );
	      }
	    })
	  );
	}
	
	module.exports = exports['default'];

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1);
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _utils = __webpack_require__(2);
		
		Object.defineProperty(exports, 'combineChunks', {
		  enumerable: true,
		  get: function get() {
		    return _utils.combineChunks;
		  }
		});
		Object.defineProperty(exports, 'fillInChunks', {
		  enumerable: true,
		  get: function get() {
		    return _utils.fillInChunks;
		  }
		});
		Object.defineProperty(exports, 'findAll', {
		  enumerable: true,
		  get: function get() {
		    return _utils.findAll;
		  }
		});
		Object.defineProperty(exports, 'findChunks', {
		  enumerable: true,
		  get: function get() {
		    return _utils.findChunks;
		  }
		});
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		/**
		 * Creates an array of chunk objects representing both higlightable and non highlightable pieces of text that match each search word.
		 * @return Array of "chunks" (where a Chunk is { start:number, end:number, highlight:boolean })
		 */
		var findAll = exports.findAll = function findAll(_ref) {
		  var autoEscape = _ref.autoEscape;
		  var sanitize = _ref.sanitize;
		  var searchWords = _ref.searchWords;
		  var textToHighlight = _ref.textToHighlight;
		  return fillInChunks({
		    chunksToHighlight: combineChunks({
		      chunks: findChunks({
		        autoEscape: autoEscape,
		        sanitize: sanitize,
		        searchWords: searchWords,
		        textToHighlight: textToHighlight
		      })
		    }),
		    totalLength: textToHighlight.length
		  });
		};
		
		/**
		 * Takes an array of {start:number, end:number} objects and combines chunks that overlap into single chunks.
		 * @return {start:number, end:number}[]
		 */
		var combineChunks = exports.combineChunks = function combineChunks(_ref2) {
		  var chunks = _ref2.chunks;
		
		  chunks = chunks.sort(function (first, second) {
		    return first.start - second.start;
		  }).reduce(function (processedChunks, nextChunk) {
		    // First chunk just goes straight in the array...
		    if (processedChunks.length === 0) {
		      return [nextChunk];
		    } else {
		      // ... subsequent chunks get checked to see if they overlap...
		      var prevChunk = processedChunks.pop();
		      if (nextChunk.start <= prevChunk.end) {
		        // It may be the case that prevChunk completely surrounds nextChunk, so take the
		        // largest of the end indeces.
		        var endIndex = Math.max(prevChunk.end, nextChunk.end);
		        processedChunks.push({ start: prevChunk.start, end: endIndex });
		      } else {
		        processedChunks.push(prevChunk, nextChunk);
		      }
		      return processedChunks;
		    }
		  }, []);
		
		  return chunks;
		};
		
		/**
		 * Examine text for any matches.
		 * If we find matches, add them to the returned array as a "chunk" object ({start:number, end:number}).
		 * @return {start:number, end:number}[]
		 */
		var findChunks = exports.findChunks = function findChunks(_ref3) {
		  var autoEscape = _ref3.autoEscape;
		  var _ref3$sanitize = _ref3.sanitize;
		  var sanitize = _ref3$sanitize === undefined ? identity : _ref3$sanitize;
		  var searchWords = _ref3.searchWords;
		  var textToHighlight = _ref3.textToHighlight;
		
		  textToHighlight = sanitize(textToHighlight);
		
		  return searchWords.filter(function (searchWord) {
		    return searchWord;
		  }) // Remove empty words
		  .reduce(function (chunks, searchWord) {
		    searchWord = sanitize(searchWord);
		
		    if (autoEscape) {
		      searchWord = escapeRegExpFn(searchWord);
		    }
		
		    var regex = new RegExp(searchWord, 'gi');
		
		    var match = void 0;
		    while (match = regex.exec(textToHighlight)) {
		      chunks.push({
		        start: match.index,
		        end: regex.lastIndex
		      });
		    }
		
		    return chunks;
		  }, []);
		};
		
		/**
		 * Given a set of chunks to highlight, create an additional set of chunks
		 * to represent the bits of text between the highlighted text.
		 * @param chunksToHighlight {start:number, end:number}[]
		 * @param totalLength number
		 * @return {start:number, end:number, highlight:boolean}[]
		 */
		var fillInChunks = exports.fillInChunks = function fillInChunks(_ref4) {
		  var chunksToHighlight = _ref4.chunksToHighlight;
		  var totalLength = _ref4.totalLength;
		
		  var allChunks = [];
		  var append = function append(start, end, highlight) {
		    if (end - start > 0) {
		      allChunks.push({
		        start: start,
		        end: end,
		        highlight: highlight
		      });
		    }
		  };
		
		  if (chunksToHighlight.length === 0) {
		    append(0, totalLength, false);
		  } else {
		    (function () {
		      var lastIndex = 0;
		      chunksToHighlight.forEach(function (chunk) {
		        append(lastIndex, chunk.start, false);
		        append(chunk.start, chunk.end, true);
		        lastIndex = chunk.end;
		      });
		      append(lastIndex, totalLength, false);
		    })();
		  }
		  return allChunks;
		};
		
		function identity(value) {
		  return value;
		}
		
		function escapeRegExpFn(str) {
		  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
		}
	
	/***/ }
	/******/ ]);
	//# sourceMappingURL=index.js.map

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(6)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(12)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 5 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	var invariant = __webpack_require__(8);
	var warning = __webpack_require__(9);
	
	var ReactPropTypesSecret = __webpack_require__(10);
	var checkPropTypes = __webpack_require__(11);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 10 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (process.env.NODE_ENV !== 'production') {
	  var invariant = __webpack_require__(8);
	  var warning = __webpack_require__(9);
	  var ReactPropTypesSecret = __webpack_require__(10);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	var invariant = __webpack_require__(8);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(17);

/***/ }
/******/ ]);
//# sourceMappingURL=main.js.map

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

var invariant = __webpack_require__(0);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(176);
var ReactElement = __webpack_require__(16);

var emptyFunction = __webpack_require__(6);
var traverseAllChildren = __webpack_require__(186);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(16);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(16),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(51);

module.exports = factory(isValidElement);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(73),
    Component = _require.Component;

var _require2 = __webpack_require__(16),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(76);
var factory = __webpack_require__(87);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(22);

var ReactElement = __webpack_require__(16);

var invariant = __webpack_require__(0);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var ReactCurrentOwner = __webpack_require__(10);
var REACT_ELEMENT_TYPE = __webpack_require__(75);

var getIteratorFn = __webpack_require__(182);
var invariant = __webpack_require__(0);
var KeyEscapeUtils = __webpack_require__(175);
var warning = __webpack_require__(1);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 187 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79);
module.exports = __webpack_require__(78);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.65fb3923.js